var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var jquery$1 = { exports: {} };
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
var jquery = jquery$1.exports;
var hasRequiredJquery;
function requireJquery() {
  if (hasRequiredJquery) return jquery$1.exports;
  hasRequiredJquery = 1;
  (function(module) {
    (function(global, factory) {
      {
        module.exports = global.document ? factory(global, true) : function(w) {
          if (!w.document) {
            throw new Error("jQuery requires a window with a document");
          }
          return factory(w);
        };
      }
    })(typeof window !== "undefined" ? window : jquery, function(window2, noGlobal) {
      var arr = [];
      var getProto = Object.getPrototypeOf;
      var slice = arr.slice;
      var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
      } : function(array) {
        return arr.concat.apply([], array);
      };
      var push = arr.push;
      var indexOf = arr.indexOf;
      var class2type = {};
      var toString = class2type.toString;
      var hasOwn = class2type.hasOwnProperty;
      var fnToString = hasOwn.toString;
      var ObjectFunctionString = fnToString.call(Object);
      var support = {};
      var isFunction = function isFunction2(obj) {
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
      };
      var isWindow = function isWindow2(obj) {
        return obj != null && obj === obj.window;
      };
      var document2 = window2.document;
      var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
      };
      function DOMEval(code, node, doc) {
        doc = doc || document2;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) {
          for (i in preservedScriptAttributes) {
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) {
              script.setAttribute(i, val);
            }
          }
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
      }
      function toType(obj) {
        if (obj == null) {
          return obj + "";
        }
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
      }
      var version = "3.7.1", rhtmlSuffix = /HTML$/i, jQuery2 = function(selector, context) {
        return new jQuery2.fn.init(selector, context);
      };
      jQuery2.fn = jQuery2.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery2,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
          return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
          if (num == null) {
            return slice.call(this);
          }
          return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
          var ret = jQuery2.merge(this.constructor(), elems);
          ret.prevObject = this;
          return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
          return jQuery2.each(this, callback);
        },
        map: function(callback) {
          return this.pushStack(jQuery2.map(this, function(elem, i) {
            return callback.call(elem, i, elem);
          }));
        },
        slice: function() {
          return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
          return this.eq(0);
        },
        last: function() {
          return this.eq(-1);
        },
        even: function() {
          return this.pushStack(jQuery2.grep(this, function(_elem, i) {
            return (i + 1) % 2;
          }));
        },
        odd: function() {
          return this.pushStack(jQuery2.grep(this, function(_elem, i) {
            return i % 2;
          }));
        },
        eq: function(i) {
          var len = this.length, j = +i + (i < 0 ? len : 0);
          return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
        },
        end: function() {
          return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push,
        sort: arr.sort,
        splice: arr.splice
      };
      jQuery2.extend = jQuery2.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        if (typeof target === "boolean") {
          deep = target;
          target = arguments[i] || {};
          i++;
        }
        if (typeof target !== "object" && !isFunction(target)) {
          target = {};
        }
        if (i === length) {
          target = this;
          i--;
        }
        for (; i < length; i++) {
          if ((options = arguments[i]) != null) {
            for (name in options) {
              copy = options[name];
              if (name === "__proto__" || target === copy) {
                continue;
              }
              if (deep && copy && (jQuery2.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                src = target[name];
                if (copyIsArray && !Array.isArray(src)) {
                  clone = [];
                } else if (!copyIsArray && !jQuery2.isPlainObject(src)) {
                  clone = {};
                } else {
                  clone = src;
                }
                copyIsArray = false;
                target[name] = jQuery2.extend(deep, clone, copy);
              } else if (copy !== void 0) {
                target[name] = copy;
              }
            }
          }
        }
        return target;
      };
      jQuery2.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
          throw new Error(msg);
        },
        noop: function() {
        },
        isPlainObject: function(obj) {
          var proto, Ctor;
          if (!obj || toString.call(obj) !== "[object Object]") {
            return false;
          }
          proto = getProto(obj);
          if (!proto) {
            return true;
          }
          Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
          return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
          var name;
          for (name in obj) {
            return false;
          }
          return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
          DOMEval(code, { nonce: options && options.nonce }, doc);
        },
        each: function(obj, callback) {
          var length, i = 0;
          if (isArrayLike(obj)) {
            length = obj.length;
            for (; i < length; i++) {
              if (callback.call(obj[i], i, obj[i]) === false) {
                break;
              }
            }
          } else {
            for (i in obj) {
              if (callback.call(obj[i], i, obj[i]) === false) {
                break;
              }
            }
          }
          return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
          var node, ret = "", i = 0, nodeType = elem.nodeType;
          if (!nodeType) {
            while (node = elem[i++]) {
              ret += jQuery2.text(node);
            }
          }
          if (nodeType === 1 || nodeType === 11) {
            return elem.textContent;
          }
          if (nodeType === 9) {
            return elem.documentElement.textContent;
          }
          if (nodeType === 3 || nodeType === 4) {
            return elem.nodeValue;
          }
          return ret;
        },
        // results is for internal usage only
        makeArray: function(arr2, results) {
          var ret = results || [];
          if (arr2 != null) {
            if (isArrayLike(Object(arr2))) {
              jQuery2.merge(
                ret,
                typeof arr2 === "string" ? [arr2] : arr2
              );
            } else {
              push.call(ret, arr2);
            }
          }
          return ret;
        },
        inArray: function(elem, arr2, i) {
          return arr2 == null ? -1 : indexOf.call(arr2, elem, i);
        },
        isXMLDoc: function(elem) {
          var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
          return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
          var len = +second.length, j = 0, i = first.length;
          for (; j < len; j++) {
            first[i++] = second[j];
          }
          first.length = i;
          return first;
        },
        grep: function(elems, callback, invert) {
          var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
          for (; i < length; i++) {
            callbackInverse = !callback(elems[i], i);
            if (callbackInverse !== callbackExpect) {
              matches.push(elems[i]);
            }
          }
          return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
          var length, value, i = 0, ret = [];
          if (isArrayLike(elems)) {
            length = elems.length;
            for (; i < length; i++) {
              value = callback(elems[i], i, arg);
              if (value != null) {
                ret.push(value);
              }
            }
          } else {
            for (i in elems) {
              value = callback(elems[i], i, arg);
              if (value != null) {
                ret.push(value);
              }
            }
          }
          return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support
      });
      if (typeof Symbol === "function") {
        jQuery2.fn[Symbol.iterator] = arr[Symbol.iterator];
      }
      jQuery2.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
        function(_i, name) {
          class2type["[object " + name + "]"] = name.toLowerCase();
        }
      );
      function isArrayLike(obj) {
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) {
          return false;
        }
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
      }
      function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
      }
      var pop = arr.pop;
      var sort = arr.sort;
      var splice = arr.splice;
      var whitespace = "[\\x20\\t\\r\\n\\f]";
      var rtrimCSS = new RegExp(
        "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
        "g"
      );
      jQuery2.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
      };
      var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
      function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
          if (ch === "\0") {
            return "�";
          }
          return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        return "\\" + ch;
      }
      jQuery2.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
      };
      var preferredDoc = document2, pushNative = push;
      (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push2 = pushNative, document3, documentElement2, documentIsHTML, rbuggyQSA, matches, expando = jQuery2.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
          if (a === b) {
            hasDuplicate = true;
          }
          return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + attributes + ")*)|.*)\\)|)", rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
          ID: new RegExp("^#(" + identifier + ")"),
          CLASS: new RegExp("^\\.(" + identifier + ")"),
          TAG: new RegExp("^(" + identifier + "|[*])"),
          ATTR: new RegExp("^" + attributes),
          PSEUDO: new RegExp("^" + pseudos),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + booleans + ")$", "i"),
          // For use in libraries implementing .is()
          // We use this for POS matching in `select`
          needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rquickExpr2 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
          var high = "0x" + escape.slice(1) - 65536;
          if (nonHex) {
            return nonHex;
          }
          return high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
        }, unloadHandler = function() {
          setDocument();
        }, inDisabledFieldset = addCombinator(
          function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
          },
          { dir: "parentNode", next: "legend" }
        );
        function safeActiveElement() {
          try {
            return document3.activeElement;
          } catch (err) {
          }
        }
        try {
          push2.apply(
            arr = slice.call(preferredDoc.childNodes),
            preferredDoc.childNodes
          );
          arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
          push2 = {
            apply: function(target, els) {
              pushNative.apply(target, slice.call(els));
            },
            call: function(target) {
              pushNative.apply(target, slice.call(arguments, 1));
            }
          };
        }
        function find(selector, context, results, seed) {
          var m, i2, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, nodeType = context ? context.nodeType : 9;
          results = results || [];
          if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
            return results;
          }
          if (!seed) {
            setDocument(context);
            context = context || document3;
            if (documentIsHTML) {
              if (nodeType !== 11 && (match = rquickExpr2.exec(selector))) {
                if (m = match[1]) {
                  if (nodeType === 9) {
                    if (elem = context.getElementById(m)) {
                      if (elem.id === m) {
                        push2.call(results, elem);
                        return results;
                      }
                    } else {
                      return results;
                    }
                  } else {
                    if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                      push2.call(results, elem);
                      return results;
                    }
                  }
                } else if (match[2]) {
                  push2.apply(results, context.getElementsByTagName(selector));
                  return results;
                } else if ((m = match[3]) && context.getElementsByClassName) {
                  push2.apply(results, context.getElementsByClassName(m));
                  return results;
                }
              }
              if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                newSelector = selector;
                newContext = context;
                if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                  newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                  if (newContext != context || !support.scope) {
                    if (nid = context.getAttribute("id")) {
                      nid = jQuery2.escapeSelector(nid);
                    } else {
                      context.setAttribute("id", nid = expando);
                    }
                  }
                  groups = tokenize(selector);
                  i2 = groups.length;
                  while (i2--) {
                    groups[i2] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i2]);
                  }
                  newSelector = groups.join(",");
                }
                try {
                  push2.apply(
                    results,
                    newContext.querySelectorAll(newSelector)
                  );
                  return results;
                } catch (qsaError) {
                  nonnativeSelectorCache(selector, true);
                } finally {
                  if (nid === expando) {
                    context.removeAttribute("id");
                  }
                }
              }
            }
          }
          return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        function createCache() {
          var keys = [];
          function cache(key, value) {
            if (keys.push(key + " ") > Expr.cacheLength) {
              delete cache[keys.shift()];
            }
            return cache[key + " "] = value;
          }
          return cache;
        }
        function markFunction(fn) {
          fn[expando] = true;
          return fn;
        }
        function assert(fn) {
          var el = document3.createElement("fieldset");
          try {
            return !!fn(el);
          } catch (e) {
            return false;
          } finally {
            if (el.parentNode) {
              el.parentNode.removeChild(el);
            }
            el = null;
          }
        }
        function createInputPseudo(type) {
          return function(elem) {
            return nodeName(elem, "input") && elem.type === type;
          };
        }
        function createButtonPseudo(type) {
          return function(elem) {
            return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
          };
        }
        function createDisabledPseudo(disabled) {
          return function(elem) {
            if ("form" in elem) {
              if (elem.parentNode && elem.disabled === false) {
                if ("label" in elem) {
                  if ("label" in elem.parentNode) {
                    return elem.parentNode.disabled === disabled;
                  } else {
                    return elem.disabled === disabled;
                  }
                }
                return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
              }
              return elem.disabled === disabled;
            } else if ("label" in elem) {
              return elem.disabled === disabled;
            }
            return false;
          };
        }
        function createPositionalPseudo(fn) {
          return markFunction(function(argument) {
            argument = +argument;
            return markFunction(function(seed, matches2) {
              var j, matchIndexes = fn([], seed.length, argument), i2 = matchIndexes.length;
              while (i2--) {
                if (seed[j = matchIndexes[i2]]) {
                  seed[j] = !(matches2[j] = seed[j]);
                }
              }
            });
          });
        }
        function testContext(context) {
          return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        function setDocument(node) {
          var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
          if (doc == document3 || doc.nodeType !== 9 || !doc.documentElement) {
            return document3;
          }
          document3 = doc;
          documentElement2 = document3.documentElement;
          documentIsHTML = !jQuery2.isXMLDoc(document3);
          matches = documentElement2.matches || documentElement2.webkitMatchesSelector || documentElement2.msMatchesSelector;
          if (documentElement2.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq
          preferredDoc != document3 && (subWindow = document3.defaultView) && subWindow.top !== subWindow) {
            subWindow.addEventListener("unload", unloadHandler);
          }
          support.getById = assert(function(el) {
            documentElement2.appendChild(el).id = jQuery2.expando;
            return !document3.getElementsByName || !document3.getElementsByName(jQuery2.expando).length;
          });
          support.disconnectedMatch = assert(function(el) {
            return matches.call(el, "*");
          });
          support.scope = assert(function() {
            return document3.querySelectorAll(":scope");
          });
          support.cssHas = assert(function() {
            try {
              document3.querySelector(":has(*,:jqfake)");
              return false;
            } catch (e) {
              return true;
            }
          });
          if (support.getById) {
            Expr.filter.ID = function(id) {
              var attrId = id.replace(runescape, funescape);
              return function(elem) {
                return elem.getAttribute("id") === attrId;
              };
            };
            Expr.find.ID = function(id, context) {
              if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                var elem = context.getElementById(id);
                return elem ? [elem] : [];
              }
            };
          } else {
            Expr.filter.ID = function(id) {
              var attrId = id.replace(runescape, funescape);
              return function(elem) {
                var node2 = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                return node2 && node2.value === attrId;
              };
            };
            Expr.find.ID = function(id, context) {
              if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                var node2, i2, elems, elem = context.getElementById(id);
                if (elem) {
                  node2 = elem.getAttributeNode("id");
                  if (node2 && node2.value === id) {
                    return [elem];
                  }
                  elems = context.getElementsByName(id);
                  i2 = 0;
                  while (elem = elems[i2++]) {
                    node2 = elem.getAttributeNode("id");
                    if (node2 && node2.value === id) {
                      return [elem];
                    }
                  }
                }
                return [];
              }
            };
          }
          Expr.find.TAG = function(tag, context) {
            if (typeof context.getElementsByTagName !== "undefined") {
              return context.getElementsByTagName(tag);
            } else {
              return context.querySelectorAll(tag);
            }
          };
          Expr.find.CLASS = function(className, context) {
            if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
              return context.getElementsByClassName(className);
            }
          };
          rbuggyQSA = [];
          assert(function(el) {
            var input;
            documentElement2.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a><select id='" + expando + "-\r\\' disabled='disabled'><option selected=''></option></select>";
            if (!el.querySelectorAll("[selected]").length) {
              rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
            }
            if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
              rbuggyQSA.push("~=");
            }
            if (!el.querySelectorAll("a#" + expando + "+*").length) {
              rbuggyQSA.push(".#.+[+~]");
            }
            if (!el.querySelectorAll(":checked").length) {
              rbuggyQSA.push(":checked");
            }
            input = document3.createElement("input");
            input.setAttribute("type", "hidden");
            el.appendChild(input).setAttribute("name", "D");
            documentElement2.appendChild(el).disabled = true;
            if (el.querySelectorAll(":disabled").length !== 2) {
              rbuggyQSA.push(":enabled", ":disabled");
            }
            input = document3.createElement("input");
            input.setAttribute("name", "");
            el.appendChild(input);
            if (!el.querySelectorAll("[name='']").length) {
              rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + `*(?:''|"")`);
            }
          });
          if (!support.cssHas) {
            rbuggyQSA.push(":has");
          }
          rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
          sortOrder = function(a, b) {
            if (a === b) {
              hasDuplicate = true;
              return 0;
            }
            var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
            if (compare) {
              return compare;
            }
            compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : (
              // Otherwise we know they are disconnected
              1
            );
            if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
              if (a === document3 || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) {
                return -1;
              }
              if (b === document3 || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) {
                return 1;
              }
              return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
            }
            return compare & 4 ? -1 : 1;
          };
          return document3;
        }
        find.matches = function(expr, elements) {
          return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
          setDocument(elem);
          if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
            try {
              var ret = matches.call(elem, expr);
              if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
              // fragment in IE 9
              elem.document && elem.document.nodeType !== 11) {
                return ret;
              }
            } catch (e) {
              nonnativeSelectorCache(expr, true);
            }
          }
          return find(expr, document3, null, [elem]).length > 0;
        };
        find.contains = function(context, elem) {
          if ((context.ownerDocument || context) != document3) {
            setDocument(context);
          }
          return jQuery2.contains(context, elem);
        };
        find.attr = function(elem, name) {
          if ((elem.ownerDocument || elem) != document3) {
            setDocument(elem);
          }
          var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : void 0;
          if (val !== void 0) {
            return val;
          }
          return elem.getAttribute(name);
        };
        find.error = function(msg) {
          throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        jQuery2.uniqueSort = function(results) {
          var elem, duplicates = [], j = 0, i2 = 0;
          hasDuplicate = !support.sortStable;
          sortInput = !support.sortStable && slice.call(results, 0);
          sort.call(results, sortOrder);
          if (hasDuplicate) {
            while (elem = results[i2++]) {
              if (elem === results[i2]) {
                j = duplicates.push(i2);
              }
            }
            while (j--) {
              splice.call(results, duplicates[j], 1);
            }
          }
          sortInput = null;
          return results;
        };
        jQuery2.fn.uniqueSort = function() {
          return this.pushStack(jQuery2.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery2.expr = {
          // Can be adjusted by the user
          cacheLength: 50,
          createPseudo: markFunction,
          match: matchExpr,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: true },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: true },
            "~": { dir: "previousSibling" }
          },
          preFilter: {
            ATTR: function(match) {
              match[1] = match[1].replace(runescape, funescape);
              match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
              if (match[2] === "~=") {
                match[3] = " " + match[3] + " ";
              }
              return match.slice(0, 4);
            },
            CHILD: function(match) {
              match[1] = match[1].toLowerCase();
              if (match[1].slice(0, 3) === "nth") {
                if (!match[3]) {
                  find.error(match[0]);
                }
                match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                match[5] = +(match[7] + match[8] || match[3] === "odd");
              } else if (match[3]) {
                find.error(match[0]);
              }
              return match;
            },
            PSEUDO: function(match) {
              var excess, unquoted = !match[6] && match[2];
              if (matchExpr.CHILD.test(match[0])) {
                return null;
              }
              if (match[3]) {
                match[2] = match[4] || match[5] || "";
              } else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
              (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
              (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                match[0] = match[0].slice(0, excess);
                match[2] = unquoted.slice(0, excess);
              }
              return match.slice(0, 3);
            }
          },
          filter: {
            TAG: function(nodeNameSelector) {
              var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
              return nodeNameSelector === "*" ? function() {
                return true;
              } : function(elem) {
                return nodeName(elem, expectedNodeName);
              };
            },
            CLASS: function(className) {
              var pattern = classCache[className + " "];
              return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function(elem) {
                return pattern.test(
                  typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || ""
                );
              });
            },
            ATTR: function(name, operator, check) {
              return function(elem) {
                var result = find.attr(elem, name);
                if (result == null) {
                  return operator === "!=";
                }
                if (!operator) {
                  return true;
                }
                result += "";
                if (operator === "=") {
                  return result === check;
                }
                if (operator === "!=") {
                  return result !== check;
                }
                if (operator === "^=") {
                  return check && result.indexOf(check) === 0;
                }
                if (operator === "*=") {
                  return check && result.indexOf(check) > -1;
                }
                if (operator === "$=") {
                  return check && result.slice(-check.length) === check;
                }
                if (operator === "~=") {
                  return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                }
                if (operator === "|=") {
                  return result === check || result.slice(0, check.length + 1) === check + "-";
                }
                return false;
              };
            },
            CHILD: function(type, what, _argument, first, last) {
              var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
              return first === 1 && last === 0 ? (
                // Shortcut for :nth-*(n)
                function(elem) {
                  return !!elem.parentNode;
                }
              ) : function(elem, _context, xml) {
                var cache, outerCache, node, nodeIndex, start, dir2 = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                if (parent) {
                  if (simple) {
                    while (dir2) {
                      node = elem;
                      while (node = node[dir2]) {
                        if (ofType ? nodeName(node, name) : node.nodeType === 1) {
                          return false;
                        }
                      }
                      start = dir2 = type === "only" && !start && "nextSibling";
                    }
                    return true;
                  }
                  start = [forward ? parent.firstChild : parent.lastChild];
                  if (forward && useCache) {
                    outerCache = parent[expando] || (parent[expando] = {});
                    cache = outerCache[type] || [];
                    nodeIndex = cache[0] === dirruns && cache[1];
                    diff = nodeIndex && cache[2];
                    node = nodeIndex && parent.childNodes[nodeIndex];
                    while (node = ++nodeIndex && node && node[dir2] || // Fallback to seeking `elem` from the start
                    (diff = nodeIndex = 0) || start.pop()) {
                      if (node.nodeType === 1 && ++diff && node === elem) {
                        outerCache[type] = [dirruns, nodeIndex, diff];
                        break;
                      }
                    }
                  } else {
                    if (useCache) {
                      outerCache = elem[expando] || (elem[expando] = {});
                      cache = outerCache[type] || [];
                      nodeIndex = cache[0] === dirruns && cache[1];
                      diff = nodeIndex;
                    }
                    if (diff === false) {
                      while (node = ++nodeIndex && node && node[dir2] || (diff = nodeIndex = 0) || start.pop()) {
                        if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                          if (useCache) {
                            outerCache = node[expando] || (node[expando] = {});
                            outerCache[type] = [dirruns, diff];
                          }
                          if (node === elem) {
                            break;
                          }
                        }
                      }
                    }
                  }
                  diff -= last;
                  return diff === first || diff % first === 0 && diff / first >= 0;
                }
              };
            },
            PSEUDO: function(pseudo, argument) {
              var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
              if (fn[expando]) {
                return fn(argument);
              }
              if (fn.length > 1) {
                args = [pseudo, pseudo, "", argument];
                return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches2) {
                  var idx, matched = fn(seed, argument), i2 = matched.length;
                  while (i2--) {
                    idx = indexOf.call(seed, matched[i2]);
                    seed[idx] = !(matches2[idx] = matched[i2]);
                  }
                }) : function(elem) {
                  return fn(elem, 0, args);
                };
              }
              return fn;
            }
          },
          pseudos: {
            // Potentially complex pseudos
            not: markFunction(function(selector) {
              var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
              return matcher[expando] ? markFunction(function(seed, matches2, _context, xml) {
                var elem, unmatched = matcher(seed, null, xml, []), i2 = seed.length;
                while (i2--) {
                  if (elem = unmatched[i2]) {
                    seed[i2] = !(matches2[i2] = elem);
                  }
                }
              }) : function(elem, _context, xml) {
                input[0] = elem;
                matcher(input, null, xml, results);
                input[0] = null;
                return !results.pop();
              };
            }),
            has: markFunction(function(selector) {
              return function(elem) {
                return find(selector, elem).length > 0;
              };
            }),
            contains: markFunction(function(text) {
              text = text.replace(runescape, funescape);
              return function(elem) {
                return (elem.textContent || jQuery2.text(elem)).indexOf(text) > -1;
              };
            }),
            // "Whether an element is represented by a :lang() selector
            // is based solely on the element's language value
            // being equal to the identifier C,
            // or beginning with the identifier C immediately followed by "-".
            // The matching of C against the element's language value is performed case-insensitively.
            // The identifier C does not have to be a valid language name."
            // https://www.w3.org/TR/selectors/#lang-pseudo
            lang: markFunction(function(lang) {
              if (!ridentifier.test(lang || "")) {
                find.error("unsupported lang: " + lang);
              }
              lang = lang.replace(runescape, funescape).toLowerCase();
              return function(elem) {
                var elemLang;
                do {
                  if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                    elemLang = elemLang.toLowerCase();
                    return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                  }
                } while ((elem = elem.parentNode) && elem.nodeType === 1);
                return false;
              };
            }),
            // Miscellaneous
            target: function(elem) {
              var hash = window2.location && window2.location.hash;
              return hash && hash.slice(1) === elem.id;
            },
            root: function(elem) {
              return elem === documentElement2;
            },
            focus: function(elem) {
              return elem === safeActiveElement() && document3.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
            },
            // Boolean properties
            enabled: createDisabledPseudo(false),
            disabled: createDisabledPseudo(true),
            checked: function(elem) {
              return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
            },
            selected: function(elem) {
              if (elem.parentNode) {
                elem.parentNode.selectedIndex;
              }
              return elem.selected === true;
            },
            // Contents
            empty: function(elem) {
              for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                if (elem.nodeType < 6) {
                  return false;
                }
              }
              return true;
            },
            parent: function(elem) {
              return !Expr.pseudos.empty(elem);
            },
            // Element/input types
            header: function(elem) {
              return rheader.test(elem.nodeName);
            },
            input: function(elem) {
              return rinputs.test(elem.nodeName);
            },
            button: function(elem) {
              return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
            },
            text: function(elem) {
              var attr;
              return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
              // New HTML5 attribute values (e.g., "search") appear
              // with elem.type === "text"
              ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
            },
            // Position-in-collection
            first: createPositionalPseudo(function() {
              return [0];
            }),
            last: createPositionalPseudo(function(_matchIndexes, length) {
              return [length - 1];
            }),
            eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
              return [argument < 0 ? argument + length : argument];
            }),
            even: createPositionalPseudo(function(matchIndexes, length) {
              var i2 = 0;
              for (; i2 < length; i2 += 2) {
                matchIndexes.push(i2);
              }
              return matchIndexes;
            }),
            odd: createPositionalPseudo(function(matchIndexes, length) {
              var i2 = 1;
              for (; i2 < length; i2 += 2) {
                matchIndexes.push(i2);
              }
              return matchIndexes;
            }),
            lt: createPositionalPseudo(function(matchIndexes, length, argument) {
              var i2;
              if (argument < 0) {
                i2 = argument + length;
              } else if (argument > length) {
                i2 = length;
              } else {
                i2 = argument;
              }
              for (; --i2 >= 0; ) {
                matchIndexes.push(i2);
              }
              return matchIndexes;
            }),
            gt: createPositionalPseudo(function(matchIndexes, length, argument) {
              var i2 = argument < 0 ? argument + length : argument;
              for (; ++i2 < length; ) {
                matchIndexes.push(i2);
              }
              return matchIndexes;
            })
          }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
          Expr.pseudos[i] = createInputPseudo(i);
        }
        for (i in { submit: true, reset: true }) {
          Expr.pseudos[i] = createButtonPseudo(i);
        }
        function setFilters() {
        }
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
          var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
          if (cached) {
            return parseOnly ? 0 : cached.slice(0);
          }
          soFar = selector;
          groups = [];
          preFilters = Expr.preFilter;
          while (soFar) {
            if (!matched || (match = rcomma.exec(soFar))) {
              if (match) {
                soFar = soFar.slice(match[0].length) || soFar;
              }
              groups.push(tokens = []);
            }
            matched = false;
            if (match = rleadingCombinator.exec(soFar)) {
              matched = match.shift();
              tokens.push({
                value: matched,
                // Cast descendant combinators to space
                type: match[0].replace(rtrimCSS, " ")
              });
              soFar = soFar.slice(matched.length);
            }
            for (type in Expr.filter) {
              if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                matched = match.shift();
                tokens.push({
                  value: matched,
                  type,
                  matches: match
                });
                soFar = soFar.slice(matched.length);
              }
            }
            if (!matched) {
              break;
            }
          }
          if (parseOnly) {
            return soFar.length;
          }
          return soFar ? find.error(selector) : (
            // Cache the tokens
            tokenCache(selector, groups).slice(0)
          );
        }
        function toSelector(tokens) {
          var i2 = 0, len = tokens.length, selector = "";
          for (; i2 < len; i2++) {
            selector += tokens[i2].value;
          }
          return selector;
        }
        function addCombinator(matcher, combinator, base) {
          var dir2 = combinator.dir, skip = combinator.next, key = skip || dir2, checkNonElements = base && key === "parentNode", doneName = done++;
          return combinator.first ? (
            // Check against closest ancestor/preceding element
            function(elem, context, xml) {
              while (elem = elem[dir2]) {
                if (elem.nodeType === 1 || checkNonElements) {
                  return matcher(elem, context, xml);
                }
              }
              return false;
            }
          ) : (
            // Check against all ancestor/preceding elements
            function(elem, context, xml) {
              var oldCache, outerCache, newCache = [dirruns, doneName];
              if (xml) {
                while (elem = elem[dir2]) {
                  if (elem.nodeType === 1 || checkNonElements) {
                    if (matcher(elem, context, xml)) {
                      return true;
                    }
                  }
                }
              } else {
                while (elem = elem[dir2]) {
                  if (elem.nodeType === 1 || checkNonElements) {
                    outerCache = elem[expando] || (elem[expando] = {});
                    if (skip && nodeName(elem, skip)) {
                      elem = elem[dir2] || elem;
                    } else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                      return newCache[2] = oldCache[2];
                    } else {
                      outerCache[key] = newCache;
                      if (newCache[2] = matcher(elem, context, xml)) {
                        return true;
                      }
                    }
                  }
                }
              }
              return false;
            }
          );
        }
        function elementMatcher(matchers) {
          return matchers.length > 1 ? function(elem, context, xml) {
            var i2 = matchers.length;
            while (i2--) {
              if (!matchers[i2](elem, context, xml)) {
                return false;
              }
            }
            return true;
          } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
          var i2 = 0, len = contexts.length;
          for (; i2 < len; i2++) {
            find(selector, contexts[i2], results);
          }
          return results;
        }
        function condense(unmatched, map, filter, context, xml) {
          var elem, newUnmatched = [], i2 = 0, len = unmatched.length, mapped = map != null;
          for (; i2 < len; i2++) {
            if (elem = unmatched[i2]) {
              if (!filter || filter(elem, context, xml)) {
                newUnmatched.push(elem);
                if (mapped) {
                  map.push(i2);
                }
              }
            }
          }
          return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
          if (postFilter && !postFilter[expando]) {
            postFilter = setMatcher(postFilter);
          }
          if (postFinder && !postFinder[expando]) {
            postFinder = setMatcher(postFinder, postSelector);
          }
          return markFunction(function(seed, results, context, xml) {
            var temp, i2, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(
              selector || "*",
              context.nodeType ? [context] : context,
              []
            ), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
            if (matcher) {
              matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? (
                // ...intermediate processing is necessary
                []
              ) : (
                // ...otherwise use results directly
                results
              );
              matcher(matcherIn, matcherOut, context, xml);
            } else {
              matcherOut = matcherIn;
            }
            if (postFilter) {
              temp = condense(matcherOut, postMap);
              postFilter(temp, [], context, xml);
              i2 = temp.length;
              while (i2--) {
                if (elem = temp[i2]) {
                  matcherOut[postMap[i2]] = !(matcherIn[postMap[i2]] = elem);
                }
              }
            }
            if (seed) {
              if (postFinder || preFilter) {
                if (postFinder) {
                  temp = [];
                  i2 = matcherOut.length;
                  while (i2--) {
                    if (elem = matcherOut[i2]) {
                      temp.push(matcherIn[i2] = elem);
                    }
                  }
                  postFinder(null, matcherOut = [], temp, xml);
                }
                i2 = matcherOut.length;
                while (i2--) {
                  if ((elem = matcherOut[i2]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i2]) > -1) {
                    seed[temp] = !(results[temp] = elem);
                  }
                }
              }
            } else {
              matcherOut = condense(
                matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut
              );
              if (postFinder) {
                postFinder(null, results, matcherOut, xml);
              } else {
                push2.apply(results, matcherOut);
              }
            }
          });
        }
        function matcherFromTokens(tokens) {
          var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i2 = leadingRelative ? 1 : 0, matchContext = addCombinator(function(elem) {
            return elem === checkContext;
          }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
            return indexOf.call(checkContext, elem) > -1;
          }, implicitRelative, true), matchers = [function(elem, context, xml) {
            var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
            checkContext = null;
            return ret;
          }];
          for (; i2 < len; i2++) {
            if (matcher = Expr.relative[tokens[i2].type]) {
              matchers = [addCombinator(elementMatcher(matchers), matcher)];
            } else {
              matcher = Expr.filter[tokens[i2].type].apply(null, tokens[i2].matches);
              if (matcher[expando]) {
                j = ++i2;
                for (; j < len; j++) {
                  if (Expr.relative[tokens[j].type]) {
                    break;
                  }
                }
                return setMatcher(
                  i2 > 1 && elementMatcher(matchers),
                  i2 > 1 && toSelector(
                    // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i2 - 1).concat({ value: tokens[i2 - 2].type === " " ? "*" : "" })
                  ).replace(rtrimCSS, "$1"),
                  matcher,
                  i2 < j && matcherFromTokens(tokens.slice(i2, j)),
                  j < len && matcherFromTokens(tokens = tokens.slice(j)),
                  j < len && toSelector(tokens)
                );
              }
              matchers.push(matcher);
            }
          }
          return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
          var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
            var elem, j, matcher, matchedCount = 0, i2 = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG("*", outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
            if (outermost) {
              outermostContext = context == document3 || context || outermost;
            }
            for (; i2 !== len && (elem = elems[i2]) != null; i2++) {
              if (byElement && elem) {
                j = 0;
                if (!context && elem.ownerDocument != document3) {
                  setDocument(elem);
                  xml = !documentIsHTML;
                }
                while (matcher = elementMatchers[j++]) {
                  if (matcher(elem, context || document3, xml)) {
                    push2.call(results, elem);
                    break;
                  }
                }
                if (outermost) {
                  dirruns = dirrunsUnique;
                }
              }
              if (bySet) {
                if (elem = !matcher && elem) {
                  matchedCount--;
                }
                if (seed) {
                  unmatched.push(elem);
                }
              }
            }
            matchedCount += i2;
            if (bySet && i2 !== matchedCount) {
              j = 0;
              while (matcher = setMatchers[j++]) {
                matcher(unmatched, setMatched, context, xml);
              }
              if (seed) {
                if (matchedCount > 0) {
                  while (i2--) {
                    if (!(unmatched[i2] || setMatched[i2])) {
                      setMatched[i2] = pop.call(results);
                    }
                  }
                }
                setMatched = condense(setMatched);
              }
              push2.apply(results, setMatched);
              if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
                jQuery2.uniqueSort(results);
              }
            }
            if (outermost) {
              dirruns = dirrunsUnique;
              outermostContext = contextBackup;
            }
            return unmatched;
          };
          return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match) {
          var i2, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
          if (!cached) {
            if (!match) {
              match = tokenize(selector);
            }
            i2 = match.length;
            while (i2--) {
              cached = matcherFromTokens(match[i2]);
              if (cached[expando]) {
                setMatchers.push(cached);
              } else {
                elementMatchers.push(cached);
              }
            }
            cached = compilerCache(
              selector,
              matcherFromGroupMatchers(elementMatchers, setMatchers)
            );
            cached.selector = selector;
          }
          return cached;
        }
        function select(selector, context, results, seed) {
          var i2, tokens, token, type, find2, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
          results = results || [];
          if (match.length === 1) {
            tokens = match[0] = match[0].slice(0);
            if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
              context = (Expr.find.ID(
                token.matches[0].replace(runescape, funescape),
                context
              ) || [])[0];
              if (!context) {
                return results;
              } else if (compiled) {
                context = context.parentNode;
              }
              selector = selector.slice(tokens.shift().value.length);
            }
            i2 = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
            while (i2--) {
              token = tokens[i2];
              if (Expr.relative[type = token.type]) {
                break;
              }
              if (find2 = Expr.find[type]) {
                if (seed = find2(
                  token.matches[0].replace(runescape, funescape),
                  rsibling.test(tokens[0].type) && testContext(context.parentNode) || context
                )) {
                  tokens.splice(i2, 1);
                  selector = seed.length && toSelector(tokens);
                  if (!selector) {
                    push2.apply(results, seed);
                    return results;
                  }
                  break;
                }
              }
            }
          }
          (compiled || compile(selector, match))(
            seed,
            context,
            !documentIsHTML,
            results,
            !context || rsibling.test(selector) && testContext(context.parentNode) || context
          );
          return results;
        }
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        setDocument();
        support.sortDetached = assert(function(el) {
          return el.compareDocumentPosition(document3.createElement("fieldset")) & 1;
        });
        jQuery2.find = find;
        jQuery2.expr[":"] = jQuery2.expr.pseudos;
        jQuery2.unique = jQuery2.uniqueSort;
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery2.escapeSelector;
        find.getText = jQuery2.text;
        find.isXML = jQuery2.isXMLDoc;
        find.selectors = jQuery2.expr;
        find.support = jQuery2.support;
        find.uniqueSort = jQuery2.uniqueSort;
      })();
      var dir = function(elem, dir2, until) {
        var matched = [], truncate = until !== void 0;
        while ((elem = elem[dir2]) && elem.nodeType !== 9) {
          if (elem.nodeType === 1) {
            if (truncate && jQuery2(elem).is(until)) {
              break;
            }
            matched.push(elem);
          }
        }
        return matched;
      };
      var siblings = function(n, elem) {
        var matched = [];
        for (; n; n = n.nextSibling) {
          if (n.nodeType === 1 && n !== elem) {
            matched.push(n);
          }
        }
        return matched;
      };
      var rneedsContext = jQuery2.expr.match.needsContext;
      var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
      function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) {
          return jQuery2.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
          });
        }
        if (qualifier.nodeType) {
          return jQuery2.grep(elements, function(elem) {
            return elem === qualifier !== not;
          });
        }
        if (typeof qualifier !== "string") {
          return jQuery2.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
          });
        }
        return jQuery2.filter(qualifier, elements, not);
      }
      jQuery2.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) {
          expr = ":not(" + expr + ")";
        }
        if (elems.length === 1 && elem.nodeType === 1) {
          return jQuery2.find.matchesSelector(elem, expr) ? [elem] : [];
        }
        return jQuery2.find.matches(expr, jQuery2.grep(elems, function(elem2) {
          return elem2.nodeType === 1;
        }));
      };
      jQuery2.fn.extend({
        find: function(selector) {
          var i, ret, len = this.length, self2 = this;
          if (typeof selector !== "string") {
            return this.pushStack(jQuery2(selector).filter(function() {
              for (i = 0; i < len; i++) {
                if (jQuery2.contains(self2[i], this)) {
                  return true;
                }
              }
            }));
          }
          ret = this.pushStack([]);
          for (i = 0; i < len; i++) {
            jQuery2.find(selector, self2[i], ret);
          }
          return len > 1 ? jQuery2.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
          return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
          return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
          return !!winnow(
            this,
            // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery2(selector) : selector || [],
            false
          ).length;
        }
      });
      var rootjQuery, rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery2.fn.init = function(selector, context, root) {
        var match, elem;
        if (!selector) {
          return this;
        }
        root = root || rootjQuery;
        if (typeof selector === "string") {
          if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
            match = [null, selector, null];
          } else {
            match = rquickExpr.exec(selector);
          }
          if (match && (match[1] || !context)) {
            if (match[1]) {
              context = context instanceof jQuery2 ? context[0] : context;
              jQuery2.merge(this, jQuery2.parseHTML(
                match[1],
                context && context.nodeType ? context.ownerDocument || context : document2,
                true
              ));
              if (rsingleTag.test(match[1]) && jQuery2.isPlainObject(context)) {
                for (match in context) {
                  if (isFunction(this[match])) {
                    this[match](context[match]);
                  } else {
                    this.attr(match, context[match]);
                  }
                }
              }
              return this;
            } else {
              elem = document2.getElementById(match[2]);
              if (elem) {
                this[0] = elem;
                this.length = 1;
              }
              return this;
            }
          } else if (!context || context.jquery) {
            return (context || root).find(selector);
          } else {
            return this.constructor(context).find(selector);
          }
        } else if (selector.nodeType) {
          this[0] = selector;
          this.length = 1;
          return this;
        } else if (isFunction(selector)) {
          return root.ready !== void 0 ? root.ready(selector) : (
            // Execute immediately if ready is not present
            selector(jQuery2)
          );
        }
        return jQuery2.makeArray(selector, this);
      };
      init.prototype = jQuery2.fn;
      rootjQuery = jQuery2(document2);
      var rparentsprev = /^(?:parents|prev(?:Until|All))/, guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
      };
      jQuery2.fn.extend({
        has: function(target) {
          var targets = jQuery2(target, this), l = targets.length;
          return this.filter(function() {
            var i = 0;
            for (; i < l; i++) {
              if (jQuery2.contains(this, targets[i])) {
                return true;
              }
            }
          });
        },
        closest: function(selectors, context) {
          var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery2(selectors);
          if (!rneedsContext.test(selectors)) {
            for (; i < l; i++) {
              for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : (
                  // Don't pass non-elements to jQuery#find
                  cur.nodeType === 1 && jQuery2.find.matchesSelector(cur, selectors)
                ))) {
                  matched.push(cur);
                  break;
                }
              }
            }
          }
          return this.pushStack(matched.length > 1 ? jQuery2.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
          if (!elem) {
            return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
          }
          if (typeof elem === "string") {
            return indexOf.call(jQuery2(elem), this[0]);
          }
          return indexOf.call(
            this,
            // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem
          );
        },
        add: function(selector, context) {
          return this.pushStack(
            jQuery2.uniqueSort(
              jQuery2.merge(this.get(), jQuery2(selector, context))
            )
          );
        },
        addBack: function(selector) {
          return this.add(
            selector == null ? this.prevObject : this.prevObject.filter(selector)
          );
        }
      });
      function sibling(cur, dir2) {
        while ((cur = cur[dir2]) && cur.nodeType !== 1) {
        }
        return cur;
      }
      jQuery2.each({
        parent: function(elem) {
          var parent = elem.parentNode;
          return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
          return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
          return dir(elem, "parentNode", until);
        },
        next: function(elem) {
          return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
          return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
          return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
          return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
          return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
          return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
          return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
          return siblings(elem.firstChild);
        },
        contents: function(elem) {
          if (elem.contentDocument != null && // Support: IE 11+
          // <object> elements with no `data` attribute has an object
          // `contentDocument` with a `null` prototype.
          getProto(elem.contentDocument)) {
            return elem.contentDocument;
          }
          if (nodeName(elem, "template")) {
            elem = elem.content || elem;
          }
          return jQuery2.merge([], elem.childNodes);
        }
      }, function(name, fn) {
        jQuery2.fn[name] = function(until, selector) {
          var matched = jQuery2.map(this, fn, until);
          if (name.slice(-5) !== "Until") {
            selector = until;
          }
          if (selector && typeof selector === "string") {
            matched = jQuery2.filter(selector, matched);
          }
          if (this.length > 1) {
            if (!guaranteedUnique[name]) {
              jQuery2.uniqueSort(matched);
            }
            if (rparentsprev.test(name)) {
              matched.reverse();
            }
          }
          return this.pushStack(matched);
        };
      });
      var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
      function createOptions(options) {
        var object = {};
        jQuery2.each(options.match(rnothtmlwhite) || [], function(_, flag) {
          object[flag] = true;
        });
        return object;
      }
      jQuery2.Callbacks = function(options) {
        options = typeof options === "string" ? createOptions(options) : jQuery2.extend({}, options);
        var firing, memory, fired, locked, list = [], queue = [], firingIndex = -1, fire = function() {
          locked = locked || options.once;
          fired = firing = true;
          for (; queue.length; firingIndex = -1) {
            memory = queue.shift();
            while (++firingIndex < list.length) {
              if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                firingIndex = list.length;
                memory = false;
              }
            }
          }
          if (!options.memory) {
            memory = false;
          }
          firing = false;
          if (locked) {
            if (memory) {
              list = [];
            } else {
              list = "";
            }
          }
        }, self2 = {
          // Add a callback or a collection of callbacks to the list
          add: function() {
            if (list) {
              if (memory && !firing) {
                firingIndex = list.length - 1;
                queue.push(memory);
              }
              (function add(args) {
                jQuery2.each(args, function(_, arg) {
                  if (isFunction(arg)) {
                    if (!options.unique || !self2.has(arg)) {
                      list.push(arg);
                    }
                  } else if (arg && arg.length && toType(arg) !== "string") {
                    add(arg);
                  }
                });
              })(arguments);
              if (memory && !firing) {
                fire();
              }
            }
            return this;
          },
          // Remove a callback from the list
          remove: function() {
            jQuery2.each(arguments, function(_, arg) {
              var index;
              while ((index = jQuery2.inArray(arg, list, index)) > -1) {
                list.splice(index, 1);
                if (index <= firingIndex) {
                  firingIndex--;
                }
              }
            });
            return this;
          },
          // Check if a given callback is in the list.
          // If no argument is given, return whether or not list has callbacks attached.
          has: function(fn) {
            return fn ? jQuery2.inArray(fn, list) > -1 : list.length > 0;
          },
          // Remove all callbacks from the list
          empty: function() {
            if (list) {
              list = [];
            }
            return this;
          },
          // Disable .fire and .add
          // Abort any current/pending executions
          // Clear all callbacks and values
          disable: function() {
            locked = queue = [];
            list = memory = "";
            return this;
          },
          disabled: function() {
            return !list;
          },
          // Disable .fire
          // Also disable .add unless we have memory (since it would have no effect)
          // Abort any pending executions
          lock: function() {
            locked = queue = [];
            if (!memory && !firing) {
              list = memory = "";
            }
            return this;
          },
          locked: function() {
            return !!locked;
          },
          // Call all callbacks with the given context and arguments
          fireWith: function(context, args) {
            if (!locked) {
              args = args || [];
              args = [context, args.slice ? args.slice() : args];
              queue.push(args);
              if (!firing) {
                fire();
              }
            }
            return this;
          },
          // Call all the callbacks with the given arguments
          fire: function() {
            self2.fireWith(this, arguments);
            return this;
          },
          // To know if the callbacks have already been called at least once
          fired: function() {
            return !!fired;
          }
        };
        return self2;
      };
      function Identity(v) {
        return v;
      }
      function Thrower(ex) {
        throw ex;
      }
      function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
          if (value && isFunction(method = value.promise)) {
            method.call(value).done(resolve).fail(reject);
          } else if (value && isFunction(method = value.then)) {
            method.call(value, resolve, reject);
          } else {
            resolve.apply(void 0, [value].slice(noValue));
          }
        } catch (value2) {
          reject.apply(void 0, [value2]);
        }
      }
      jQuery2.extend({
        Deferred: function(func) {
          var tuples = [
            // action, add listener, callbacks,
            // ... .then handlers, argument index, [final state]
            [
              "notify",
              "progress",
              jQuery2.Callbacks("memory"),
              jQuery2.Callbacks("memory"),
              2
            ],
            [
              "resolve",
              "done",
              jQuery2.Callbacks("once memory"),
              jQuery2.Callbacks("once memory"),
              0,
              "resolved"
            ],
            [
              "reject",
              "fail",
              jQuery2.Callbacks("once memory"),
              jQuery2.Callbacks("once memory"),
              1,
              "rejected"
            ]
          ], state = "pending", promise = {
            state: function() {
              return state;
            },
            always: function() {
              deferred.done(arguments).fail(arguments);
              return this;
            },
            "catch": function(fn) {
              return promise.then(null, fn);
            },
            // Keep pipe for back-compat
            pipe: function() {
              var fns = arguments;
              return jQuery2.Deferred(function(newDefer) {
                jQuery2.each(tuples, function(_i, tuple) {
                  var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                  deferred[tuple[1]](function() {
                    var returned = fn && fn.apply(this, arguments);
                    if (returned && isFunction(returned.promise)) {
                      returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                    } else {
                      newDefer[tuple[0] + "With"](
                        this,
                        fn ? [returned] : arguments
                      );
                    }
                  });
                });
                fns = null;
              }).promise();
            },
            then: function(onFulfilled, onRejected, onProgress) {
              var maxDepth = 0;
              function resolve(depth, deferred2, handler, special) {
                return function() {
                  var that = this, args = arguments, mightThrow = function() {
                    var returned, then;
                    if (depth < maxDepth) {
                      return;
                    }
                    returned = handler.apply(that, args);
                    if (returned === deferred2.promise()) {
                      throw new TypeError("Thenable self-resolution");
                    }
                    then = returned && // Support: Promises/A+ section 2.3.4
                    // https://promisesaplus.com/#point-64
                    // Only check objects and functions for thenability
                    (typeof returned === "object" || typeof returned === "function") && returned.then;
                    if (isFunction(then)) {
                      if (special) {
                        then.call(
                          returned,
                          resolve(maxDepth, deferred2, Identity, special),
                          resolve(maxDepth, deferred2, Thrower, special)
                        );
                      } else {
                        maxDepth++;
                        then.call(
                          returned,
                          resolve(maxDepth, deferred2, Identity, special),
                          resolve(maxDepth, deferred2, Thrower, special),
                          resolve(
                            maxDepth,
                            deferred2,
                            Identity,
                            deferred2.notifyWith
                          )
                        );
                      }
                    } else {
                      if (handler !== Identity) {
                        that = void 0;
                        args = [returned];
                      }
                      (special || deferred2.resolveWith)(that, args);
                    }
                  }, process = special ? mightThrow : function() {
                    try {
                      mightThrow();
                    } catch (e) {
                      if (jQuery2.Deferred.exceptionHook) {
                        jQuery2.Deferred.exceptionHook(
                          e,
                          process.error
                        );
                      }
                      if (depth + 1 >= maxDepth) {
                        if (handler !== Thrower) {
                          that = void 0;
                          args = [e];
                        }
                        deferred2.rejectWith(that, args);
                      }
                    }
                  };
                  if (depth) {
                    process();
                  } else {
                    if (jQuery2.Deferred.getErrorHook) {
                      process.error = jQuery2.Deferred.getErrorHook();
                    } else if (jQuery2.Deferred.getStackHook) {
                      process.error = jQuery2.Deferred.getStackHook();
                    }
                    window2.setTimeout(process);
                  }
                };
              }
              return jQuery2.Deferred(function(newDefer) {
                tuples[0][3].add(
                  resolve(
                    0,
                    newDefer,
                    isFunction(onProgress) ? onProgress : Identity,
                    newDefer.notifyWith
                  )
                );
                tuples[1][3].add(
                  resolve(
                    0,
                    newDefer,
                    isFunction(onFulfilled) ? onFulfilled : Identity
                  )
                );
                tuples[2][3].add(
                  resolve(
                    0,
                    newDefer,
                    isFunction(onRejected) ? onRejected : Thrower
                  )
                );
              }).promise();
            },
            // Get a promise for this deferred
            // If obj is provided, the promise aspect is added to the object
            promise: function(obj) {
              return obj != null ? jQuery2.extend(obj, promise) : promise;
            }
          }, deferred = {};
          jQuery2.each(tuples, function(i, tuple) {
            var list = tuple[2], stateString = tuple[5];
            promise[tuple[1]] = list.add;
            if (stateString) {
              list.add(
                function() {
                  state = stateString;
                },
                // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable,
                // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable,
                // progress_callbacks.lock
                tuples[0][2].lock,
                // progress_handlers.lock
                tuples[0][3].lock
              );
            }
            list.add(tuple[3].fire);
            deferred[tuple[0]] = function() {
              deferred[tuple[0] + "With"](this === deferred ? void 0 : this, arguments);
              return this;
            };
            deferred[tuple[0] + "With"] = list.fireWith;
          });
          promise.promise(deferred);
          if (func) {
            func.call(deferred, deferred);
          }
          return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
          var remaining = arguments.length, i = remaining, resolveContexts = Array(i), resolveValues = slice.call(arguments), primary = jQuery2.Deferred(), updateFunc = function(i2) {
            return function(value) {
              resolveContexts[i2] = this;
              resolveValues[i2] = arguments.length > 1 ? slice.call(arguments) : value;
              if (!--remaining) {
                primary.resolveWith(resolveContexts, resolveValues);
              }
            };
          };
          if (remaining <= 1) {
            adoptValue(
              singleValue,
              primary.done(updateFunc(i)).resolve,
              primary.reject,
              !remaining
            );
            if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
              return primary.then();
            }
          }
          while (i--) {
            adoptValue(resolveValues[i], updateFunc(i), primary.reject);
          }
          return primary.promise();
        }
      });
      var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
      jQuery2.Deferred.exceptionHook = function(error, asyncError) {
        if (window2.console && window2.console.warn && error && rerrorNames.test(error.name)) {
          window2.console.warn(
            "jQuery.Deferred exception: " + error.message,
            error.stack,
            asyncError
          );
        }
      };
      jQuery2.readyException = function(error) {
        window2.setTimeout(function() {
          throw error;
        });
      };
      var readyList = jQuery2.Deferred();
      jQuery2.fn.ready = function(fn) {
        readyList.then(fn).catch(function(error) {
          jQuery2.readyException(error);
        });
        return this;
      };
      jQuery2.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
          if (wait === true ? --jQuery2.readyWait : jQuery2.isReady) {
            return;
          }
          jQuery2.isReady = true;
          if (wait !== true && --jQuery2.readyWait > 0) {
            return;
          }
          readyList.resolveWith(document2, [jQuery2]);
        }
      });
      jQuery2.ready.then = readyList.then;
      function completed() {
        document2.removeEventListener("DOMContentLoaded", completed);
        window2.removeEventListener("load", completed);
        jQuery2.ready();
      }
      if (document2.readyState === "complete" || document2.readyState !== "loading" && !document2.documentElement.doScroll) {
        window2.setTimeout(jQuery2.ready);
      } else {
        document2.addEventListener("DOMContentLoaded", completed);
        window2.addEventListener("load", completed);
      }
      var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        if (toType(key) === "object") {
          chainable = true;
          for (i in key) {
            access(elems, fn, i, key[i], true, emptyGet, raw);
          }
        } else if (value !== void 0) {
          chainable = true;
          if (!isFunction(value)) {
            raw = true;
          }
          if (bulk) {
            if (raw) {
              fn.call(elems, value);
              fn = null;
            } else {
              bulk = fn;
              fn = function(elem, _key, value2) {
                return bulk.call(jQuery2(elem), value2);
              };
            }
          }
          if (fn) {
            for (; i < len; i++) {
              fn(
                elems[i],
                key,
                raw ? value : value.call(elems[i], i, fn(elems[i], key))
              );
            }
          }
        }
        if (chainable) {
          return elems;
        }
        if (bulk) {
          return fn.call(elems);
        }
        return len ? fn(elems[0], key) : emptyGet;
      };
      var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
      function fcamelCase(_all, letter) {
        return letter.toUpperCase();
      }
      function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
      }
      var acceptData = function(owner) {
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
      };
      function Data() {
        this.expando = jQuery2.expando + Data.uid++;
      }
      Data.uid = 1;
      Data.prototype = {
        cache: function(owner) {
          var value = owner[this.expando];
          if (!value) {
            value = {};
            if (acceptData(owner)) {
              if (owner.nodeType) {
                owner[this.expando] = value;
              } else {
                Object.defineProperty(owner, this.expando, {
                  value,
                  configurable: true
                });
              }
            }
          }
          return value;
        },
        set: function(owner, data, value) {
          var prop, cache = this.cache(owner);
          if (typeof data === "string") {
            cache[camelCase(data)] = value;
          } else {
            for (prop in data) {
              cache[camelCase(prop)] = data[prop];
            }
          }
          return cache;
        },
        get: function(owner, key) {
          return key === void 0 ? this.cache(owner) : (
            // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)]
          );
        },
        access: function(owner, key, value) {
          if (key === void 0 || key && typeof key === "string" && value === void 0) {
            return this.get(owner, key);
          }
          this.set(owner, key, value);
          return value !== void 0 ? value : key;
        },
        remove: function(owner, key) {
          var i, cache = owner[this.expando];
          if (cache === void 0) {
            return;
          }
          if (key !== void 0) {
            if (Array.isArray(key)) {
              key = key.map(camelCase);
            } else {
              key = camelCase(key);
              key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
            }
            i = key.length;
            while (i--) {
              delete cache[key[i]];
            }
          }
          if (key === void 0 || jQuery2.isEmptyObject(cache)) {
            if (owner.nodeType) {
              owner[this.expando] = void 0;
            } else {
              delete owner[this.expando];
            }
          }
        },
        hasData: function(owner) {
          var cache = owner[this.expando];
          return cache !== void 0 && !jQuery2.isEmptyObject(cache);
        }
      };
      var dataPriv = new Data();
      var dataUser = new Data();
      var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
      function getData(data) {
        if (data === "true") {
          return true;
        }
        if (data === "false") {
          return false;
        }
        if (data === "null") {
          return null;
        }
        if (data === +data + "") {
          return +data;
        }
        if (rbrace.test(data)) {
          return JSON.parse(data);
        }
        return data;
      }
      function dataAttr(elem, key, data) {
        var name;
        if (data === void 0 && elem.nodeType === 1) {
          name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
          data = elem.getAttribute(name);
          if (typeof data === "string") {
            try {
              data = getData(data);
            } catch (e) {
            }
            dataUser.set(elem, key, data);
          } else {
            data = void 0;
          }
        }
        return data;
      }
      jQuery2.extend({
        hasData: function(elem) {
          return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
          return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
          dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
          return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
          dataPriv.remove(elem, name);
        }
      });
      jQuery2.fn.extend({
        data: function(key, value) {
          var i, name, data, elem = this[0], attrs = elem && elem.attributes;
          if (key === void 0) {
            if (this.length) {
              data = dataUser.get(elem);
              if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                i = attrs.length;
                while (i--) {
                  if (attrs[i]) {
                    name = attrs[i].name;
                    if (name.indexOf("data-") === 0) {
                      name = camelCase(name.slice(5));
                      dataAttr(elem, name, data[name]);
                    }
                  }
                }
                dataPriv.set(elem, "hasDataAttrs", true);
              }
            }
            return data;
          }
          if (typeof key === "object") {
            return this.each(function() {
              dataUser.set(this, key);
            });
          }
          return access(this, function(value2) {
            var data2;
            if (elem && value2 === void 0) {
              data2 = dataUser.get(elem, key);
              if (data2 !== void 0) {
                return data2;
              }
              data2 = dataAttr(elem, key);
              if (data2 !== void 0) {
                return data2;
              }
              return;
            }
            this.each(function() {
              dataUser.set(this, key, value2);
            });
          }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
          return this.each(function() {
            dataUser.remove(this, key);
          });
        }
      });
      jQuery2.extend({
        queue: function(elem, type, data) {
          var queue;
          if (elem) {
            type = (type || "fx") + "queue";
            queue = dataPriv.get(elem, type);
            if (data) {
              if (!queue || Array.isArray(data)) {
                queue = dataPriv.access(elem, type, jQuery2.makeArray(data));
              } else {
                queue.push(data);
              }
            }
            return queue || [];
          }
        },
        dequeue: function(elem, type) {
          type = type || "fx";
          var queue = jQuery2.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery2._queueHooks(elem, type), next = function() {
            jQuery2.dequeue(elem, type);
          };
          if (fn === "inprogress") {
            fn = queue.shift();
            startLength--;
          }
          if (fn) {
            if (type === "fx") {
              queue.unshift("inprogress");
            }
            delete hooks.stop;
            fn.call(elem, next, hooks);
          }
          if (!startLength && hooks) {
            hooks.empty.fire();
          }
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
          var key = type + "queueHooks";
          return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
            empty: jQuery2.Callbacks("once memory").add(function() {
              dataPriv.remove(elem, [type + "queue", key]);
            })
          });
        }
      });
      jQuery2.fn.extend({
        queue: function(type, data) {
          var setter = 2;
          if (typeof type !== "string") {
            data = type;
            type = "fx";
            setter--;
          }
          if (arguments.length < setter) {
            return jQuery2.queue(this[0], type);
          }
          return data === void 0 ? this : this.each(function() {
            var queue = jQuery2.queue(this, type, data);
            jQuery2._queueHooks(this, type);
            if (type === "fx" && queue[0] !== "inprogress") {
              jQuery2.dequeue(this, type);
            }
          });
        },
        dequeue: function(type) {
          return this.each(function() {
            jQuery2.dequeue(this, type);
          });
        },
        clearQueue: function(type) {
          return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
          var tmp, count = 1, defer = jQuery2.Deferred(), elements = this, i = this.length, resolve = function() {
            if (!--count) {
              defer.resolveWith(elements, [elements]);
            }
          };
          if (typeof type !== "string") {
            obj = type;
            type = void 0;
          }
          type = type || "fx";
          while (i--) {
            tmp = dataPriv.get(elements[i], type + "queueHooks");
            if (tmp && tmp.empty) {
              count++;
              tmp.empty.add(resolve);
            }
          }
          resolve();
          return defer.promise(obj);
        }
      });
      var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
      var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
      var cssExpand = ["Top", "Right", "Bottom", "Left"];
      var documentElement = document2.documentElement;
      var isAttached = function(elem) {
        return jQuery2.contains(elem.ownerDocument, elem);
      }, composed = { composed: true };
      if (documentElement.getRootNode) {
        isAttached = function(elem) {
          return jQuery2.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
        };
      }
      var isHiddenWithinTree = function(elem, el) {
        elem = el || elem;
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery2.css(elem, "display") === "none";
      };
      function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
          return tween.cur();
        } : function() {
          return jQuery2.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery2.cssNumber[prop] ? "" : "px"), initialInUnit = elem.nodeType && (jQuery2.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery2.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
          initial = initial / 2;
          unit = unit || initialInUnit[3];
          initialInUnit = +initial || 1;
          while (maxIterations--) {
            jQuery2.style(elem, prop, initialInUnit + unit);
            if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
              maxIterations = 0;
            }
            initialInUnit = initialInUnit / scale;
          }
          initialInUnit = initialInUnit * 2;
          jQuery2.style(elem, prop, initialInUnit + unit);
          valueParts = valueParts || [];
        }
        if (valueParts) {
          initialInUnit = +initialInUnit || +initial || 0;
          adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
          if (tween) {
            tween.unit = unit;
            tween.start = initialInUnit;
            tween.end = adjusted;
          }
        }
        return adjusted;
      }
      var defaultDisplayMap = {};
      function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName2 = elem.nodeName, display = defaultDisplayMap[nodeName2];
        if (display) {
          return display;
        }
        temp = doc.body.appendChild(doc.createElement(nodeName2));
        display = jQuery2.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") {
          display = "block";
        }
        defaultDisplayMap[nodeName2] = display;
        return display;
      }
      function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        for (; index < length; index++) {
          elem = elements[index];
          if (!elem.style) {
            continue;
          }
          display = elem.style.display;
          if (show) {
            if (display === "none") {
              values[index] = dataPriv.get(elem, "display") || null;
              if (!values[index]) {
                elem.style.display = "";
              }
            }
            if (elem.style.display === "" && isHiddenWithinTree(elem)) {
              values[index] = getDefaultDisplay(elem);
            }
          } else {
            if (display !== "none") {
              values[index] = "none";
              dataPriv.set(elem, "display", display);
            }
          }
        }
        for (index = 0; index < length; index++) {
          if (values[index] != null) {
            elements[index].style.display = values[index];
          }
        }
        return elements;
      }
      jQuery2.fn.extend({
        show: function() {
          return showHide(this, true);
        },
        hide: function() {
          return showHide(this);
        },
        toggle: function(state) {
          if (typeof state === "boolean") {
            return state ? this.show() : this.hide();
          }
          return this.each(function() {
            if (isHiddenWithinTree(this)) {
              jQuery2(this).show();
            } else {
              jQuery2(this).hide();
            }
          });
        }
      });
      var rcheckableType = /^(?:checkbox|radio)$/i;
      var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
      var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
      (function() {
        var fragment = document2.createDocumentFragment(), div = fragment.appendChild(document2.createElement("div")), input = document2.createElement("input");
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
      })();
      var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
      };
      wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
      wrapMap.th = wrapMap.td;
      if (!support.option) {
        wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
      }
      function getAll(context, tag) {
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") {
          ret = context.getElementsByTagName(tag || "*");
        } else if (typeof context.querySelectorAll !== "undefined") {
          ret = context.querySelectorAll(tag || "*");
        } else {
          ret = [];
        }
        if (tag === void 0 || tag && nodeName(context, tag)) {
          return jQuery2.merge([context], ret);
        }
        return ret;
      }
      function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for (; i < l; i++) {
          dataPriv.set(
            elems[i],
            "globalEval",
            !refElements || dataPriv.get(refElements[i], "globalEval")
          );
        }
      }
      var rhtml = /<|&#?\w+;/;
      function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for (; i < l; i++) {
          elem = elems[i];
          if (elem || elem === 0) {
            if (toType(elem) === "object") {
              jQuery2.merge(nodes, elem.nodeType ? [elem] : elem);
            } else if (!rhtml.test(elem)) {
              nodes.push(context.createTextNode(elem));
            } else {
              tmp = tmp || fragment.appendChild(context.createElement("div"));
              tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
              wrap = wrapMap[tag] || wrapMap._default;
              tmp.innerHTML = wrap[1] + jQuery2.htmlPrefilter(elem) + wrap[2];
              j = wrap[0];
              while (j--) {
                tmp = tmp.lastChild;
              }
              jQuery2.merge(nodes, tmp.childNodes);
              tmp = fragment.firstChild;
              tmp.textContent = "";
            }
          }
        }
        fragment.textContent = "";
        i = 0;
        while (elem = nodes[i++]) {
          if (selection && jQuery2.inArray(elem, selection) > -1) {
            if (ignored) {
              ignored.push(elem);
            }
            continue;
          }
          attached = isAttached(elem);
          tmp = getAll(fragment.appendChild(elem), "script");
          if (attached) {
            setGlobalEval(tmp);
          }
          if (scripts) {
            j = 0;
            while (elem = tmp[j++]) {
              if (rscriptType.test(elem.type || "")) {
                scripts.push(elem);
              }
            }
          }
        }
        return fragment;
      }
      var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
      function returnTrue() {
        return true;
      }
      function returnFalse() {
        return false;
      }
      function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        if (typeof types === "object") {
          if (typeof selector !== "string") {
            data = data || selector;
            selector = void 0;
          }
          for (type in types) {
            on(elem, type, selector, data, types[type], one);
          }
          return elem;
        }
        if (data == null && fn == null) {
          fn = selector;
          data = selector = void 0;
        } else if (fn == null) {
          if (typeof selector === "string") {
            fn = data;
            data = void 0;
          } else {
            fn = data;
            data = selector;
            selector = void 0;
          }
        }
        if (fn === false) {
          fn = returnFalse;
        } else if (!fn) {
          return elem;
        }
        if (one === 1) {
          origFn = fn;
          fn = function(event) {
            jQuery2().off(event);
            return origFn.apply(this, arguments);
          };
          fn.guid = origFn.guid || (origFn.guid = jQuery2.guid++);
        }
        return elem.each(function() {
          jQuery2.event.add(this, types, fn, data, selector);
        });
      }
      jQuery2.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
          var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
          if (!acceptData(elem)) {
            return;
          }
          if (handler.handler) {
            handleObjIn = handler;
            handler = handleObjIn.handler;
            selector = handleObjIn.selector;
          }
          if (selector) {
            jQuery2.find.matchesSelector(documentElement, selector);
          }
          if (!handler.guid) {
            handler.guid = jQuery2.guid++;
          }
          if (!(events = elemData.events)) {
            events = elemData.events = /* @__PURE__ */ Object.create(null);
          }
          if (!(eventHandle = elemData.handle)) {
            eventHandle = elemData.handle = function(e) {
              return typeof jQuery2 !== "undefined" && jQuery2.event.triggered !== e.type ? jQuery2.event.dispatch.apply(elem, arguments) : void 0;
            };
          }
          types = (types || "").match(rnothtmlwhite) || [""];
          t = types.length;
          while (t--) {
            tmp = rtypenamespace.exec(types[t]) || [];
            type = origType = tmp[1];
            namespaces = (tmp[2] || "").split(".").sort();
            if (!type) {
              continue;
            }
            special = jQuery2.event.special[type] || {};
            type = (selector ? special.delegateType : special.bindType) || type;
            special = jQuery2.event.special[type] || {};
            handleObj = jQuery2.extend({
              type,
              origType,
              data,
              handler,
              guid: handler.guid,
              selector,
              needsContext: selector && jQuery2.expr.match.needsContext.test(selector),
              namespace: namespaces.join(".")
            }, handleObjIn);
            if (!(handlers = events[type])) {
              handlers = events[type] = [];
              handlers.delegateCount = 0;
              if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                if (elem.addEventListener) {
                  elem.addEventListener(type, eventHandle);
                }
              }
            }
            if (special.add) {
              special.add.call(elem, handleObj);
              if (!handleObj.handler.guid) {
                handleObj.handler.guid = handler.guid;
              }
            }
            if (selector) {
              handlers.splice(handlers.delegateCount++, 0, handleObj);
            } else {
              handlers.push(handleObj);
            }
            jQuery2.event.global[type] = true;
          }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
          var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
          if (!elemData || !(events = elemData.events)) {
            return;
          }
          types = (types || "").match(rnothtmlwhite) || [""];
          t = types.length;
          while (t--) {
            tmp = rtypenamespace.exec(types[t]) || [];
            type = origType = tmp[1];
            namespaces = (tmp[2] || "").split(".").sort();
            if (!type) {
              for (type in events) {
                jQuery2.event.remove(elem, type + types[t], handler, selector, true);
              }
              continue;
            }
            special = jQuery2.event.special[type] || {};
            type = (selector ? special.delegateType : special.bindType) || type;
            handlers = events[type] || [];
            tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
            origCount = j = handlers.length;
            while (j--) {
              handleObj = handlers[j];
              if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                handlers.splice(j, 1);
                if (handleObj.selector) {
                  handlers.delegateCount--;
                }
                if (special.remove) {
                  special.remove.call(elem, handleObj);
                }
              }
            }
            if (origCount && !handlers.length) {
              if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
                jQuery2.removeEvent(elem, type, elemData.handle);
              }
              delete events[type];
            }
          }
          if (jQuery2.isEmptyObject(events)) {
            dataPriv.remove(elem, "handle events");
          }
        },
        dispatch: function(nativeEvent) {
          var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), event = jQuery2.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || /* @__PURE__ */ Object.create(null))[event.type] || [], special = jQuery2.event.special[event.type] || {};
          args[0] = event;
          for (i = 1; i < arguments.length; i++) {
            args[i] = arguments[i];
          }
          event.delegateTarget = this;
          if (special.preDispatch && special.preDispatch.call(this, event) === false) {
            return;
          }
          handlerQueue = jQuery2.event.handlers.call(this, event, handlers);
          i = 0;
          while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
            event.currentTarget = matched.elem;
            j = 0;
            while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
              if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                event.handleObj = handleObj;
                event.data = handleObj.data;
                ret = ((jQuery2.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                if (ret !== void 0) {
                  if ((event.result = ret) === false) {
                    event.preventDefault();
                    event.stopPropagation();
                  }
                }
              }
            }
          }
          if (special.postDispatch) {
            special.postDispatch.call(this, event);
          }
          return event.result;
        },
        handlers: function(event, handlers) {
          var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
          if (delegateCount && // Support: IE <=9
          // Black-hole SVG <use> instance trees (trac-13180)
          cur.nodeType && // Support: Firefox <=42
          // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
          // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
          // Support: IE 11 only
          // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
          !(event.type === "click" && event.button >= 1)) {
            for (; cur !== this; cur = cur.parentNode || this) {
              if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                matchedHandlers = [];
                matchedSelectors = {};
                for (i = 0; i < delegateCount; i++) {
                  handleObj = handlers[i];
                  sel = handleObj.selector + " ";
                  if (matchedSelectors[sel] === void 0) {
                    matchedSelectors[sel] = handleObj.needsContext ? jQuery2(sel, this).index(cur) > -1 : jQuery2.find(sel, this, null, [cur]).length;
                  }
                  if (matchedSelectors[sel]) {
                    matchedHandlers.push(handleObj);
                  }
                }
                if (matchedHandlers.length) {
                  handlerQueue.push({ elem: cur, handlers: matchedHandlers });
                }
              }
            }
          }
          cur = this;
          if (delegateCount < handlers.length) {
            handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) });
          }
          return handlerQueue;
        },
        addProp: function(name, hook) {
          Object.defineProperty(jQuery2.Event.prototype, name, {
            enumerable: true,
            configurable: true,
            get: isFunction(hook) ? function() {
              if (this.originalEvent) {
                return hook(this.originalEvent);
              }
            } : function() {
              if (this.originalEvent) {
                return this.originalEvent[name];
              }
            },
            set: function(value) {
              Object.defineProperty(this, name, {
                enumerable: true,
                configurable: true,
                writable: true,
                value
              });
            }
          });
        },
        fix: function(originalEvent) {
          return originalEvent[jQuery2.expando] ? originalEvent : new jQuery2.Event(originalEvent);
        },
        special: {
          load: {
            // Prevent triggered image.load events from bubbling to window.load
            noBubble: true
          },
          click: {
            // Utilize native event to ensure correct state for checkable inputs
            setup: function(data) {
              var el = this || data;
              if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
                leverageNative(el, "click", true);
              }
              return false;
            },
            trigger: function(data) {
              var el = this || data;
              if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
                leverageNative(el, "click");
              }
              return true;
            },
            // For cross-browser consistency, suppress native .click() on links
            // Also prevent it if we're currently inside a leveraged native-event stack
            _default: function(event) {
              var target = event.target;
              return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
            }
          },
          beforeunload: {
            postDispatch: function(event) {
              if (event.result !== void 0 && event.originalEvent) {
                event.originalEvent.returnValue = event.result;
              }
            }
          }
        }
      };
      function leverageNative(el, type, isSetup) {
        if (!isSetup) {
          if (dataPriv.get(el, type) === void 0) {
            jQuery2.event.add(el, type, returnTrue);
          }
          return;
        }
        dataPriv.set(el, type, false);
        jQuery2.event.add(el, type, {
          namespace: false,
          handler: function(event) {
            var result, saved = dataPriv.get(this, type);
            if (event.isTrigger & 1 && this[type]) {
              if (!saved) {
                saved = slice.call(arguments);
                dataPriv.set(this, type, saved);
                this[type]();
                result = dataPriv.get(this, type);
                dataPriv.set(this, type, false);
                if (saved !== result) {
                  event.stopImmediatePropagation();
                  event.preventDefault();
                  return result;
                }
              } else if ((jQuery2.event.special[type] || {}).delegateType) {
                event.stopPropagation();
              }
            } else if (saved) {
              dataPriv.set(this, type, jQuery2.event.trigger(
                saved[0],
                saved.slice(1),
                this
              ));
              event.stopPropagation();
              event.isImmediatePropagationStopped = returnTrue;
            }
          }
        });
      }
      jQuery2.removeEvent = function(elem, type, handle) {
        if (elem.removeEventListener) {
          elem.removeEventListener(type, handle);
        }
      };
      jQuery2.Event = function(src, props) {
        if (!(this instanceof jQuery2.Event)) {
          return new jQuery2.Event(src, props);
        }
        if (src && src.type) {
          this.originalEvent = src;
          this.type = src.type;
          this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === void 0 && // Support: Android <=2.3 only
          src.returnValue === false ? returnTrue : returnFalse;
          this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
          this.currentTarget = src.currentTarget;
          this.relatedTarget = src.relatedTarget;
        } else {
          this.type = src;
        }
        if (props) {
          jQuery2.extend(this, props);
        }
        this.timeStamp = src && src.timeStamp || Date.now();
        this[jQuery2.expando] = true;
      };
      jQuery2.Event.prototype = {
        constructor: jQuery2.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
          var e = this.originalEvent;
          this.isDefaultPrevented = returnTrue;
          if (e && !this.isSimulated) {
            e.preventDefault();
          }
        },
        stopPropagation: function() {
          var e = this.originalEvent;
          this.isPropagationStopped = returnTrue;
          if (e && !this.isSimulated) {
            e.stopPropagation();
          }
        },
        stopImmediatePropagation: function() {
          var e = this.originalEvent;
          this.isImmediatePropagationStopped = returnTrue;
          if (e && !this.isSimulated) {
            e.stopImmediatePropagation();
          }
          this.stopPropagation();
        }
      };
      jQuery2.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
      }, jQuery2.event.addProp);
      jQuery2.each({ focus: "focusin", blur: "focusout" }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
          if (document2.documentMode) {
            var handle = dataPriv.get(this, "handle"), event = jQuery2.event.fix(nativeEvent);
            event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
            event.isSimulated = true;
            handle(nativeEvent);
            if (event.target === event.currentTarget) {
              handle(event);
            }
          } else {
            jQuery2.event.simulate(
              delegateType,
              nativeEvent.target,
              jQuery2.event.fix(nativeEvent)
            );
          }
        }
        jQuery2.event.special[type] = {
          // Utilize native event if possible so blur/focus sequence is correct
          setup: function() {
            var attaches;
            leverageNative(this, type, true);
            if (document2.documentMode) {
              attaches = dataPriv.get(this, delegateType);
              if (!attaches) {
                this.addEventListener(delegateType, focusMappedHandler);
              }
              dataPriv.set(this, delegateType, (attaches || 0) + 1);
            } else {
              return false;
            }
          },
          trigger: function() {
            leverageNative(this, type);
            return true;
          },
          teardown: function() {
            var attaches;
            if (document2.documentMode) {
              attaches = dataPriv.get(this, delegateType) - 1;
              if (!attaches) {
                this.removeEventListener(delegateType, focusMappedHandler);
                dataPriv.remove(this, delegateType);
              } else {
                dataPriv.set(this, delegateType, attaches);
              }
            } else {
              return false;
            }
          },
          // Suppress native focus or blur if we're currently inside
          // a leveraged native-event stack
          _default: function(event) {
            return dataPriv.get(event.target, type);
          },
          delegateType
        };
        jQuery2.event.special[delegateType] = {
          setup: function() {
            var doc = this.ownerDocument || this.document || this, dataHolder = document2.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
            if (!attaches) {
              if (document2.documentMode) {
                this.addEventListener(delegateType, focusMappedHandler);
              } else {
                doc.addEventListener(type, focusMappedHandler, true);
              }
            }
            dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
          },
          teardown: function() {
            var doc = this.ownerDocument || this.document || this, dataHolder = document2.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
            if (!attaches) {
              if (document2.documentMode) {
                this.removeEventListener(delegateType, focusMappedHandler);
              } else {
                doc.removeEventListener(type, focusMappedHandler, true);
              }
              dataPriv.remove(dataHolder, delegateType);
            } else {
              dataPriv.set(dataHolder, delegateType, attaches);
            }
          }
        };
      });
      jQuery2.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
      }, function(orig, fix) {
        jQuery2.event.special[orig] = {
          delegateType: fix,
          bindType: fix,
          handle: function(event) {
            var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
            if (!related || related !== target && !jQuery2.contains(target, related)) {
              event.type = handleObj.origType;
              ret = handleObj.handler.apply(this, arguments);
              event.type = fix;
            }
            return ret;
          }
        };
      });
      jQuery2.fn.extend({
        on: function(types, selector, data, fn) {
          return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
          return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
          var handleObj, type;
          if (types && types.preventDefault && types.handleObj) {
            handleObj = types.handleObj;
            jQuery2(types.delegateTarget).off(
              handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
              handleObj.selector,
              handleObj.handler
            );
            return this;
          }
          if (typeof types === "object") {
            for (type in types) {
              this.off(type, selector, types[type]);
            }
            return this;
          }
          if (selector === false || typeof selector === "function") {
            fn = selector;
            selector = void 0;
          }
          if (fn === false) {
            fn = returnFalse;
          }
          return this.each(function() {
            jQuery2.event.remove(this, types, fn, selector);
          });
        }
      });
      var rnoInnerhtml = /<script|<style|<link/i, rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
      function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
          return jQuery2(elem).children("tbody")[0] || elem;
        }
        return elem;
      }
      function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
      }
      function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") {
          elem.type = elem.type.slice(5);
        } else {
          elem.removeAttribute("type");
        }
        return elem;
      }
      function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) {
          return;
        }
        if (dataPriv.hasData(src)) {
          pdataOld = dataPriv.get(src);
          events = pdataOld.events;
          if (events) {
            dataPriv.remove(dest, "handle events");
            for (type in events) {
              for (i = 0, l = events[type].length; i < l; i++) {
                jQuery2.event.add(dest, type, events[type][i]);
              }
            }
          }
        }
        if (dataUser.hasData(src)) {
          udataOld = dataUser.access(src);
          udataCur = jQuery2.extend({}, udataOld);
          dataUser.set(dest, udataCur);
        }
      }
      function fixInput(src, dest) {
        var nodeName2 = dest.nodeName.toLowerCase();
        if (nodeName2 === "input" && rcheckableType.test(src.type)) {
          dest.checked = src.checked;
        } else if (nodeName2 === "input" || nodeName2 === "textarea") {
          dest.defaultValue = src.defaultValue;
        }
      }
      function domManip(collection, args, callback, ignored) {
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
          return collection.each(function(index) {
            var self2 = collection.eq(index);
            if (valueIsFunction) {
              args[0] = value.call(this, index, self2.html());
            }
            domManip(self2, args, callback, ignored);
          });
        }
        if (l) {
          fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
          first = fragment.firstChild;
          if (fragment.childNodes.length === 1) {
            fragment = first;
          }
          if (first || ignored) {
            scripts = jQuery2.map(getAll(fragment, "script"), disableScript);
            hasScripts = scripts.length;
            for (; i < l; i++) {
              node = fragment;
              if (i !== iNoClone) {
                node = jQuery2.clone(node, true, true);
                if (hasScripts) {
                  jQuery2.merge(scripts, getAll(node, "script"));
                }
              }
              callback.call(collection[i], node, i);
            }
            if (hasScripts) {
              doc = scripts[scripts.length - 1].ownerDocument;
              jQuery2.map(scripts, restoreScript);
              for (i = 0; i < hasScripts; i++) {
                node = scripts[i];
                if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery2.contains(doc, node)) {
                  if (node.src && (node.type || "").toLowerCase() !== "module") {
                    if (jQuery2._evalUrl && !node.noModule) {
                      jQuery2._evalUrl(node.src, {
                        nonce: node.nonce || node.getAttribute("nonce")
                      }, doc);
                    }
                  } else {
                    DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                  }
                }
              }
            }
          }
        }
        return collection;
      }
      function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery2.filter(selector, elem) : elem, i = 0;
        for (; (node = nodes[i]) != null; i++) {
          if (!keepData && node.nodeType === 1) {
            jQuery2.cleanData(getAll(node));
          }
          if (node.parentNode) {
            if (keepData && isAttached(node)) {
              setGlobalEval(getAll(node, "script"));
            }
            node.parentNode.removeChild(node);
          }
        }
        return elem;
      }
      jQuery2.extend({
        htmlPrefilter: function(html) {
          return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
          var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
          if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery2.isXMLDoc(elem)) {
            destElements = getAll(clone);
            srcElements = getAll(elem);
            for (i = 0, l = srcElements.length; i < l; i++) {
              fixInput(srcElements[i], destElements[i]);
            }
          }
          if (dataAndEvents) {
            if (deepDataAndEvents) {
              srcElements = srcElements || getAll(elem);
              destElements = destElements || getAll(clone);
              for (i = 0, l = srcElements.length; i < l; i++) {
                cloneCopyEvent(srcElements[i], destElements[i]);
              }
            } else {
              cloneCopyEvent(elem, clone);
            }
          }
          destElements = getAll(clone, "script");
          if (destElements.length > 0) {
            setGlobalEval(destElements, !inPage && getAll(elem, "script"));
          }
          return clone;
        },
        cleanData: function(elems) {
          var data, elem, type, special = jQuery2.event.special, i = 0;
          for (; (elem = elems[i]) !== void 0; i++) {
            if (acceptData(elem)) {
              if (data = elem[dataPriv.expando]) {
                if (data.events) {
                  for (type in data.events) {
                    if (special[type]) {
                      jQuery2.event.remove(elem, type);
                    } else {
                      jQuery2.removeEvent(elem, type, data.handle);
                    }
                  }
                }
                elem[dataPriv.expando] = void 0;
              }
              if (elem[dataUser.expando]) {
                elem[dataUser.expando] = void 0;
              }
            }
          }
        }
      });
      jQuery2.fn.extend({
        detach: function(selector) {
          return remove(this, selector, true);
        },
        remove: function(selector) {
          return remove(this, selector);
        },
        text: function(value) {
          return access(this, function(value2) {
            return value2 === void 0 ? jQuery2.text(this) : this.empty().each(function() {
              if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                this.textContent = value2;
              }
            });
          }, null, value, arguments.length);
        },
        append: function() {
          return domManip(this, arguments, function(elem) {
            if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
              var target = manipulationTarget(this, elem);
              target.appendChild(elem);
            }
          });
        },
        prepend: function() {
          return domManip(this, arguments, function(elem) {
            if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
              var target = manipulationTarget(this, elem);
              target.insertBefore(elem, target.firstChild);
            }
          });
        },
        before: function() {
          return domManip(this, arguments, function(elem) {
            if (this.parentNode) {
              this.parentNode.insertBefore(elem, this);
            }
          });
        },
        after: function() {
          return domManip(this, arguments, function(elem) {
            if (this.parentNode) {
              this.parentNode.insertBefore(elem, this.nextSibling);
            }
          });
        },
        empty: function() {
          var elem, i = 0;
          for (; (elem = this[i]) != null; i++) {
            if (elem.nodeType === 1) {
              jQuery2.cleanData(getAll(elem, false));
              elem.textContent = "";
            }
          }
          return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
          dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
          deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
          return this.map(function() {
            return jQuery2.clone(this, dataAndEvents, deepDataAndEvents);
          });
        },
        html: function(value) {
          return access(this, function(value2) {
            var elem = this[0] || {}, i = 0, l = this.length;
            if (value2 === void 0 && elem.nodeType === 1) {
              return elem.innerHTML;
            }
            if (typeof value2 === "string" && !rnoInnerhtml.test(value2) && !wrapMap[(rtagName.exec(value2) || ["", ""])[1].toLowerCase()]) {
              value2 = jQuery2.htmlPrefilter(value2);
              try {
                for (; i < l; i++) {
                  elem = this[i] || {};
                  if (elem.nodeType === 1) {
                    jQuery2.cleanData(getAll(elem, false));
                    elem.innerHTML = value2;
                  }
                }
                elem = 0;
              } catch (e) {
              }
            }
            if (elem) {
              this.empty().append(value2);
            }
          }, null, value, arguments.length);
        },
        replaceWith: function() {
          var ignored = [];
          return domManip(this, arguments, function(elem) {
            var parent = this.parentNode;
            if (jQuery2.inArray(this, ignored) < 0) {
              jQuery2.cleanData(getAll(this));
              if (parent) {
                parent.replaceChild(elem, this);
              }
            }
          }, ignored);
        }
      });
      jQuery2.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
      }, function(name, original) {
        jQuery2.fn[name] = function(selector) {
          var elems, ret = [], insert = jQuery2(selector), last = insert.length - 1, i = 0;
          for (; i <= last; i++) {
            elems = i === last ? this : this.clone(true);
            jQuery2(insert[i])[original](elems);
            push.apply(ret, elems.get());
          }
          return this.pushStack(ret);
        };
      });
      var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
      var rcustomProp = /^--/;
      var getStyles = function(elem) {
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) {
          view = window2;
        }
        return view.getComputedStyle(elem);
      };
      var swap = function(elem, options, callback) {
        var ret, name, old = {};
        for (name in options) {
          old[name] = elem.style[name];
          elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        for (name in options) {
          elem.style[name] = old[name];
        }
        return ret;
      };
      var rboxStyle = new RegExp(cssExpand.join("|"), "i");
      (function() {
        function computeStyleTests() {
          if (!div) {
            return;
          }
          container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
          div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
          documentElement.appendChild(container).appendChild(div);
          var divStyle = window2.getComputedStyle(div);
          pixelPositionVal = divStyle.top !== "1%";
          reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
          div.style.right = "60%";
          pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
          boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
          div.style.position = "absolute";
          scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
          documentElement.removeChild(container);
          div = null;
        }
        function roundPixelMeasures(measure) {
          return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document2.createElement("div"), div = document2.createElement("div");
        if (!div.style) {
          return;
        }
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery2.extend(support, {
          boxSizingReliable: function() {
            computeStyleTests();
            return boxSizingReliableVal;
          },
          pixelBoxStyles: function() {
            computeStyleTests();
            return pixelBoxStylesVal;
          },
          pixelPosition: function() {
            computeStyleTests();
            return pixelPositionVal;
          },
          reliableMarginLeft: function() {
            computeStyleTests();
            return reliableMarginLeftVal;
          },
          scrollboxSize: function() {
            computeStyleTests();
            return scrollboxSizeVal;
          },
          // Support: IE 9 - 11+, Edge 15 - 18+
          // IE/Edge misreport `getComputedStyle` of table rows with width/height
          // set in CSS while `offset*` properties report correct values.
          // Behavior in IE 9 is more subtle than in newer versions & it passes
          // some versions of this test; make sure not to make it pass there!
          //
          // Support: Firefox 70+
          // Only Firefox includes border widths
          // in computed dimensions. (gh-4529)
          reliableTrDimensions: function() {
            var table, tr, trChild, trStyle;
            if (reliableTrDimensionsVal == null) {
              table = document2.createElement("table");
              tr = document2.createElement("tr");
              trChild = document2.createElement("div");
              table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
              tr.style.cssText = "box-sizing:content-box;border:1px solid";
              tr.style.height = "1px";
              trChild.style.height = "9px";
              trChild.style.display = "block";
              documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
              trStyle = window2.getComputedStyle(tr);
              reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
              documentElement.removeChild(table);
            }
            return reliableTrDimensionsVal;
          }
        });
      })();
      function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), style = elem.style;
        computed = computed || getStyles(elem);
        if (computed) {
          ret = computed.getPropertyValue(name) || computed[name];
          if (isCustomProp && ret) {
            ret = ret.replace(rtrimCSS, "$1") || void 0;
          }
          if (ret === "" && !isAttached(elem)) {
            ret = jQuery2.style(elem, name);
          }
          if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
            width = style.width;
            minWidth = style.minWidth;
            maxWidth = style.maxWidth;
            style.minWidth = style.maxWidth = style.width = ret;
            ret = computed.width;
            style.width = width;
            style.minWidth = minWidth;
            style.maxWidth = maxWidth;
          }
        }
        return ret !== void 0 ? (
          // Support: IE <=9 - 11 only
          // IE returns zIndex value as an integer.
          ret + ""
        ) : ret;
      }
      function addGetHookIf(conditionFn, hookFn) {
        return {
          get: function() {
            if (conditionFn()) {
              delete this.get;
              return;
            }
            return (this.get = hookFn).apply(this, arguments);
          }
        };
      }
      var cssPrefixes = ["Webkit", "Moz", "ms"], emptyStyle = document2.createElement("div").style, vendorProps = {};
      function vendorPropName(name) {
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while (i--) {
          name = cssPrefixes[i] + capName;
          if (name in emptyStyle) {
            return name;
          }
        }
      }
      function finalPropName(name) {
        var final = jQuery2.cssProps[name] || vendorProps[name];
        if (final) {
          return final;
        }
        if (name in emptyStyle) {
          return name;
        }
        return vendorProps[name] = vendorPropName(name) || name;
      }
      var rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = { position: "absolute", visibility: "hidden", display: "block" }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
      };
      function setPositiveNumber(_elem, value, subtract) {
        var matches = rcssNum.exec(value);
        return matches ? (
          // Guard against undefined "subtract", e.g., when used as in cssHooks
          Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
        ) : value;
      }
      function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        if (box === (isBorderBox ? "border" : "content")) {
          return 0;
        }
        for (; i < 4; i += 2) {
          if (box === "margin") {
            marginDelta += jQuery2.css(elem, box + cssExpand[i], true, styles);
          }
          if (!isBorderBox) {
            delta += jQuery2.css(elem, "padding" + cssExpand[i], true, styles);
            if (box !== "padding") {
              delta += jQuery2.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            } else {
              extra += jQuery2.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
          } else {
            if (box === "content") {
              delta -= jQuery2.css(elem, "padding" + cssExpand[i], true, styles);
            }
            if (box !== "margin") {
              delta -= jQuery2.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
          }
        }
        if (!isBorderBox && computedVal >= 0) {
          delta += Math.max(0, Math.ceil(
            elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5
            // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
            // Use an explicit zero to avoid NaN (gh-3964)
          )) || 0;
        }
        return delta + marginDelta;
      }
      function getWidthOrHeight(elem, dimension, extra) {
        var styles = getStyles(elem), boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery2.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        if (rnumnonpx.test(val)) {
          if (!extra) {
            return val;
          }
          val = "auto";
        }
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery2.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
          isBorderBox = jQuery2.css(elem, "boxSizing", false, styles) === "border-box";
          valueIsBorderBox = offsetProp in elem;
          if (valueIsBorderBox) {
            val = elem[offsetProp];
          }
        }
        val = parseFloat(val) || 0;
        return val + boxModelAdjustment(
          elem,
          dimension,
          extra || (isBorderBox ? "border" : "content"),
          valueIsBorderBox,
          styles,
          // Provide the current computed size to request scroll gutter calculation (gh-3589)
          val
        ) + "px";
      }
      jQuery2.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
          opacity: {
            get: function(elem, computed) {
              if (computed) {
                var ret = curCSS(elem, "opacity");
                return ret === "" ? "1" : ret;
              }
            }
          }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
          animationIterationCount: true,
          aspectRatio: true,
          borderImageSlice: true,
          columnCount: true,
          flexGrow: true,
          flexShrink: true,
          fontWeight: true,
          gridArea: true,
          gridColumn: true,
          gridColumnEnd: true,
          gridColumnStart: true,
          gridRow: true,
          gridRowEnd: true,
          gridRowStart: true,
          lineHeight: true,
          opacity: true,
          order: true,
          orphans: true,
          scale: true,
          widows: true,
          zIndex: true,
          zoom: true,
          // SVG-related
          fillOpacity: true,
          floodOpacity: true,
          stopOpacity: true,
          strokeMiterlimit: true,
          strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
          if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
            return;
          }
          var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
          if (!isCustomProp) {
            name = finalPropName(origName);
          }
          hooks = jQuery2.cssHooks[name] || jQuery2.cssHooks[origName];
          if (value !== void 0) {
            type = typeof value;
            if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
              value = adjustCSS(elem, name, ret);
              type = "number";
            }
            if (value == null || value !== value) {
              return;
            }
            if (type === "number" && !isCustomProp) {
              value += ret && ret[3] || (jQuery2.cssNumber[origName] ? "" : "px");
            }
            if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
              style[name] = "inherit";
            }
            if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== void 0) {
              if (isCustomProp) {
                style.setProperty(name, value);
              } else {
                style[name] = value;
              }
            }
          } else {
            if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== void 0) {
              return ret;
            }
            return style[name];
          }
        },
        css: function(elem, name, extra, styles) {
          var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
          if (!isCustomProp) {
            name = finalPropName(origName);
          }
          hooks = jQuery2.cssHooks[name] || jQuery2.cssHooks[origName];
          if (hooks && "get" in hooks) {
            val = hooks.get(elem, true, extra);
          }
          if (val === void 0) {
            val = curCSS(elem, name, styles);
          }
          if (val === "normal" && name in cssNormalTransform) {
            val = cssNormalTransform[name];
          }
          if (extra === "" || extra) {
            num = parseFloat(val);
            return extra === true || isFinite(num) ? num || 0 : val;
          }
          return val;
        }
      });
      jQuery2.each(["height", "width"], function(_i, dimension) {
        jQuery2.cssHooks[dimension] = {
          get: function(elem, computed, extra) {
            if (computed) {
              return rdisplayswap.test(jQuery2.css(elem, "display")) && // Support: Safari 8+
              // Table columns in Safari have non-zero offsetWidth & zero
              // getBoundingClientRect().width unless display is changed.
              // Support: IE <=11 only
              // Running getBoundingClientRect on a disconnected node
              // in IE throws an error.
              (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                return getWidthOrHeight(elem, dimension, extra);
              }) : getWidthOrHeight(elem, dimension, extra);
            }
          },
          set: function(elem, value, extra) {
            var matches, styles = getStyles(elem), scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery2.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(
              elem,
              dimension,
              extra,
              isBorderBox,
              styles
            ) : 0;
            if (isBorderBox && scrollboxSizeBuggy) {
              subtract -= Math.ceil(
                elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5
              );
            }
            if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
              elem.style[dimension] = value;
              value = jQuery2.css(elem, dimension);
            }
            return setPositiveNumber(elem, value, subtract);
          }
        };
      });
      jQuery2.cssHooks.marginLeft = addGetHookIf(
        support.reliableMarginLeft,
        function(elem, computed) {
          if (computed) {
            return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function() {
              return elem.getBoundingClientRect().left;
            })) + "px";
          }
        }
      );
      jQuery2.each({
        margin: "",
        padding: "",
        border: "Width"
      }, function(prefix, suffix) {
        jQuery2.cssHooks[prefix + suffix] = {
          expand: function(value) {
            var i = 0, expanded = {}, parts = typeof value === "string" ? value.split(" ") : [value];
            for (; i < 4; i++) {
              expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
            }
            return expanded;
          }
        };
        if (prefix !== "margin") {
          jQuery2.cssHooks[prefix + suffix].set = setPositiveNumber;
        }
      });
      jQuery2.fn.extend({
        css: function(name, value) {
          return access(this, function(elem, name2, value2) {
            var styles, len, map = {}, i = 0;
            if (Array.isArray(name2)) {
              styles = getStyles(elem);
              len = name2.length;
              for (; i < len; i++) {
                map[name2[i]] = jQuery2.css(elem, name2[i], false, styles);
              }
              return map;
            }
            return value2 !== void 0 ? jQuery2.style(elem, name2, value2) : jQuery2.css(elem, name2);
          }, name, value, arguments.length > 1);
        }
      });
      function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
      }
      jQuery2.Tween = Tween;
      Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
          this.elem = elem;
          this.prop = prop;
          this.easing = easing || jQuery2.easing._default;
          this.options = options;
          this.start = this.now = this.cur();
          this.end = end;
          this.unit = unit || (jQuery2.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
          var hooks = Tween.propHooks[this.prop];
          return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
          var eased, hooks = Tween.propHooks[this.prop];
          if (this.options.duration) {
            this.pos = eased = jQuery2.easing[this.easing](
              percent,
              this.options.duration * percent,
              0,
              1,
              this.options.duration
            );
          } else {
            this.pos = eased = percent;
          }
          this.now = (this.end - this.start) * eased + this.start;
          if (this.options.step) {
            this.options.step.call(this.elem, this.now, this);
          }
          if (hooks && hooks.set) {
            hooks.set(this);
          } else {
            Tween.propHooks._default.set(this);
          }
          return this;
        }
      };
      Tween.prototype.init.prototype = Tween.prototype;
      Tween.propHooks = {
        _default: {
          get: function(tween) {
            var result;
            if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
              return tween.elem[tween.prop];
            }
            result = jQuery2.css(tween.elem, tween.prop, "");
            return !result || result === "auto" ? 0 : result;
          },
          set: function(tween) {
            if (jQuery2.fx.step[tween.prop]) {
              jQuery2.fx.step[tween.prop](tween);
            } else if (tween.elem.nodeType === 1 && (jQuery2.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
              jQuery2.style(tween.elem, tween.prop, tween.now + tween.unit);
            } else {
              tween.elem[tween.prop] = tween.now;
            }
          }
        }
      };
      Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
          if (tween.elem.nodeType && tween.elem.parentNode) {
            tween.elem[tween.prop] = tween.now;
          }
        }
      };
      jQuery2.easing = {
        linear: function(p) {
          return p;
        },
        swing: function(p) {
          return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
      };
      jQuery2.fx = Tween.prototype.init;
      jQuery2.fx.step = {};
      var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
      function schedule() {
        if (inProgress) {
          if (document2.hidden === false && window2.requestAnimationFrame) {
            window2.requestAnimationFrame(schedule);
          } else {
            window2.setTimeout(schedule, jQuery2.fx.interval);
          }
          jQuery2.fx.tick();
        }
      }
      function createFxNow() {
        window2.setTimeout(function() {
          fxNow = void 0;
        });
        return fxNow = Date.now();
      }
      function genFx(type, includeWidth) {
        var which, i = 0, attrs = { height: type };
        includeWidth = includeWidth ? 1 : 0;
        for (; i < 4; i += 2 - includeWidth) {
          which = cssExpand[i];
          attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) {
          attrs.opacity = attrs.width = type;
        }
        return attrs;
      }
      function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for (; index < length; index++) {
          if (tween = collection[index].call(animation, prop, value)) {
            return tween;
          }
        }
      }
      function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        if (!opts.queue) {
          hooks = jQuery2._queueHooks(elem, "fx");
          if (hooks.unqueued == null) {
            hooks.unqueued = 0;
            oldfire = hooks.empty.fire;
            hooks.empty.fire = function() {
              if (!hooks.unqueued) {
                oldfire();
              }
            };
          }
          hooks.unqueued++;
          anim.always(function() {
            anim.always(function() {
              hooks.unqueued--;
              if (!jQuery2.queue(elem, "fx").length) {
                hooks.empty.fire();
              }
            });
          });
        }
        for (prop in props) {
          value = props[prop];
          if (rfxtypes.test(value)) {
            delete props[prop];
            toggle = toggle || value === "toggle";
            if (value === (hidden ? "hide" : "show")) {
              if (value === "show" && dataShow && dataShow[prop] !== void 0) {
                hidden = true;
              } else {
                continue;
              }
            }
            orig[prop] = dataShow && dataShow[prop] || jQuery2.style(elem, prop);
          }
        }
        propTween = !jQuery2.isEmptyObject(props);
        if (!propTween && jQuery2.isEmptyObject(orig)) {
          return;
        }
        if (isBox && elem.nodeType === 1) {
          opts.overflow = [style.overflow, style.overflowX, style.overflowY];
          restoreDisplay = dataShow && dataShow.display;
          if (restoreDisplay == null) {
            restoreDisplay = dataPriv.get(elem, "display");
          }
          display = jQuery2.css(elem, "display");
          if (display === "none") {
            if (restoreDisplay) {
              display = restoreDisplay;
            } else {
              showHide([elem], true);
              restoreDisplay = elem.style.display || restoreDisplay;
              display = jQuery2.css(elem, "display");
              showHide([elem]);
            }
          }
          if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
            if (jQuery2.css(elem, "float") === "none") {
              if (!propTween) {
                anim.done(function() {
                  style.display = restoreDisplay;
                });
                if (restoreDisplay == null) {
                  display = style.display;
                  restoreDisplay = display === "none" ? "" : display;
                }
              }
              style.display = "inline-block";
            }
          }
        }
        if (opts.overflow) {
          style.overflow = "hidden";
          anim.always(function() {
            style.overflow = opts.overflow[0];
            style.overflowX = opts.overflow[1];
            style.overflowY = opts.overflow[2];
          });
        }
        propTween = false;
        for (prop in orig) {
          if (!propTween) {
            if (dataShow) {
              if ("hidden" in dataShow) {
                hidden = dataShow.hidden;
              }
            } else {
              dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
            }
            if (toggle) {
              dataShow.hidden = !hidden;
            }
            if (hidden) {
              showHide([elem], true);
            }
            anim.done(function() {
              if (!hidden) {
                showHide([elem]);
              }
              dataPriv.remove(elem, "fxshow");
              for (prop in orig) {
                jQuery2.style(elem, prop, orig[prop]);
              }
            });
          }
          propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
          if (!(prop in dataShow)) {
            dataShow[prop] = propTween.start;
            if (hidden) {
              propTween.end = propTween.start;
              propTween.start = 0;
            }
          }
        }
      }
      function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        for (index in props) {
          name = camelCase(index);
          easing = specialEasing[name];
          value = props[index];
          if (Array.isArray(value)) {
            easing = value[1];
            value = props[index] = value[0];
          }
          if (index !== name) {
            props[name] = value;
            delete props[index];
          }
          hooks = jQuery2.cssHooks[name];
          if (hooks && "expand" in hooks) {
            value = hooks.expand(value);
            delete props[name];
            for (index in value) {
              if (!(index in props)) {
                props[index] = value[index];
                specialEasing[index] = easing;
              }
            }
          } else {
            specialEasing[name] = easing;
          }
        }
      }
      function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery2.Deferred().always(function() {
          delete tick.elem;
        }), tick = function() {
          if (stopped) {
            return false;
          }
          var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), temp = remaining / animation.duration || 0, percent = 1 - temp, index2 = 0, length2 = animation.tweens.length;
          for (; index2 < length2; index2++) {
            animation.tweens[index2].run(percent);
          }
          deferred.notifyWith(elem, [animation, percent, remaining]);
          if (percent < 1 && length2) {
            return remaining;
          }
          if (!length2) {
            deferred.notifyWith(elem, [animation, 1, 0]);
          }
          deferred.resolveWith(elem, [animation]);
          return false;
        }, animation = deferred.promise({
          elem,
          props: jQuery2.extend({}, properties),
          opts: jQuery2.extend(true, {
            specialEasing: {},
            easing: jQuery2.easing._default
          }, options),
          originalProperties: properties,
          originalOptions: options,
          startTime: fxNow || createFxNow(),
          duration: options.duration,
          tweens: [],
          createTween: function(prop, end) {
            var tween = jQuery2.Tween(
              elem,
              animation.opts,
              prop,
              end,
              animation.opts.specialEasing[prop] || animation.opts.easing
            );
            animation.tweens.push(tween);
            return tween;
          },
          stop: function(gotoEnd) {
            var index2 = 0, length2 = gotoEnd ? animation.tweens.length : 0;
            if (stopped) {
              return this;
            }
            stopped = true;
            for (; index2 < length2; index2++) {
              animation.tweens[index2].run(1);
            }
            if (gotoEnd) {
              deferred.notifyWith(elem, [animation, 1, 0]);
              deferred.resolveWith(elem, [animation, gotoEnd]);
            } else {
              deferred.rejectWith(elem, [animation, gotoEnd]);
            }
            return this;
          }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for (; index < length; index++) {
          result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
          if (result) {
            if (isFunction(result.stop)) {
              jQuery2._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
            }
            return result;
          }
        }
        jQuery2.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) {
          animation.opts.start.call(elem, animation);
        }
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery2.fx.timer(
          jQuery2.extend(tick, {
            elem,
            anim: animation,
            queue: animation.opts.queue
          })
        );
        return animation;
      }
      jQuery2.Animation = jQuery2.extend(Animation, {
        tweeners: {
          "*": [function(prop, value) {
            var tween = this.createTween(prop, value);
            adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
            return tween;
          }]
        },
        tweener: function(props, callback) {
          if (isFunction(props)) {
            callback = props;
            props = ["*"];
          } else {
            props = props.match(rnothtmlwhite);
          }
          var prop, index = 0, length = props.length;
          for (; index < length; index++) {
            prop = props[index];
            Animation.tweeners[prop] = Animation.tweeners[prop] || [];
            Animation.tweeners[prop].unshift(callback);
          }
        },
        prefilters: [defaultPrefilter],
        prefilter: function(callback, prepend) {
          if (prepend) {
            Animation.prefilters.unshift(callback);
          } else {
            Animation.prefilters.push(callback);
          }
        }
      });
      jQuery2.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery2.extend({}, speed) : {
          complete: fn || !fn && easing || isFunction(speed) && speed,
          duration: speed,
          easing: fn && easing || easing && !isFunction(easing) && easing
        };
        if (jQuery2.fx.off) {
          opt.duration = 0;
        } else {
          if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery2.fx.speeds) {
              opt.duration = jQuery2.fx.speeds[opt.duration];
            } else {
              opt.duration = jQuery2.fx.speeds._default;
            }
          }
        }
        if (opt.queue == null || opt.queue === true) {
          opt.queue = "fx";
        }
        opt.old = opt.complete;
        opt.complete = function() {
          if (isFunction(opt.old)) {
            opt.old.call(this);
          }
          if (opt.queue) {
            jQuery2.dequeue(this, opt.queue);
          }
        };
        return opt;
      };
      jQuery2.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
          return this.filter(isHiddenWithinTree).css("opacity", 0).show().end().animate({ opacity: to }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
          var empty = jQuery2.isEmptyObject(prop), optall = jQuery2.speed(speed, easing, callback), doAnimation = function() {
            var anim = Animation(this, jQuery2.extend({}, prop), optall);
            if (empty || dataPriv.get(this, "finish")) {
              anim.stop(true);
            }
          };
          doAnimation.finish = doAnimation;
          return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
          var stopQueue = function(hooks) {
            var stop = hooks.stop;
            delete hooks.stop;
            stop(gotoEnd);
          };
          if (typeof type !== "string") {
            gotoEnd = clearQueue;
            clearQueue = type;
            type = void 0;
          }
          if (clearQueue) {
            this.queue(type || "fx", []);
          }
          return this.each(function() {
            var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery2.timers, data = dataPriv.get(this);
            if (index) {
              if (data[index] && data[index].stop) {
                stopQueue(data[index]);
              }
            } else {
              for (index in data) {
                if (data[index] && data[index].stop && rrun.test(index)) {
                  stopQueue(data[index]);
                }
              }
            }
            for (index = timers.length; index--; ) {
              if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                timers[index].anim.stop(gotoEnd);
                dequeue = false;
                timers.splice(index, 1);
              }
            }
            if (dequeue || !gotoEnd) {
              jQuery2.dequeue(this, type);
            }
          });
        },
        finish: function(type) {
          if (type !== false) {
            type = type || "fx";
          }
          return this.each(function() {
            var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery2.timers, length = queue ? queue.length : 0;
            data.finish = true;
            jQuery2.queue(this, type, []);
            if (hooks && hooks.stop) {
              hooks.stop.call(this, true);
            }
            for (index = timers.length; index--; ) {
              if (timers[index].elem === this && timers[index].queue === type) {
                timers[index].anim.stop(true);
                timers.splice(index, 1);
              }
            }
            for (index = 0; index < length; index++) {
              if (queue[index] && queue[index].finish) {
                queue[index].finish.call(this);
              }
            }
            delete data.finish;
          });
        }
      });
      jQuery2.each(["toggle", "show", "hide"], function(_i, name) {
        var cssFn = jQuery2.fn[name];
        jQuery2.fn[name] = function(speed, easing, callback) {
          return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
      });
      jQuery2.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" }
      }, function(name, props) {
        jQuery2.fn[name] = function(speed, easing, callback) {
          return this.animate(props, speed, easing, callback);
        };
      });
      jQuery2.timers = [];
      jQuery2.fx.tick = function() {
        var timer, i = 0, timers = jQuery2.timers;
        fxNow = Date.now();
        for (; i < timers.length; i++) {
          timer = timers[i];
          if (!timer() && timers[i] === timer) {
            timers.splice(i--, 1);
          }
        }
        if (!timers.length) {
          jQuery2.fx.stop();
        }
        fxNow = void 0;
      };
      jQuery2.fx.timer = function(timer) {
        jQuery2.timers.push(timer);
        jQuery2.fx.start();
      };
      jQuery2.fx.interval = 13;
      jQuery2.fx.start = function() {
        if (inProgress) {
          return;
        }
        inProgress = true;
        schedule();
      };
      jQuery2.fx.stop = function() {
        inProgress = null;
      };
      jQuery2.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
      };
      jQuery2.fn.delay = function(time, type) {
        time = jQuery2.fx ? jQuery2.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
          var timeout = window2.setTimeout(next, time);
          hooks.stop = function() {
            window2.clearTimeout(timeout);
          };
        });
      };
      (function() {
        var input = document2.createElement("input"), select = document2.createElement("select"), opt = select.appendChild(document2.createElement("option"));
        input.type = "checkbox";
        support.checkOn = input.value !== "";
        support.optSelected = opt.selected;
        input = document2.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
      })();
      var boolHook, attrHandle = jQuery2.expr.attrHandle;
      jQuery2.fn.extend({
        attr: function(name, value) {
          return access(this, jQuery2.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
          return this.each(function() {
            jQuery2.removeAttr(this, name);
          });
        }
      });
      jQuery2.extend({
        attr: function(elem, name, value) {
          var ret, hooks, nType = elem.nodeType;
          if (nType === 3 || nType === 8 || nType === 2) {
            return;
          }
          if (typeof elem.getAttribute === "undefined") {
            return jQuery2.prop(elem, name, value);
          }
          if (nType !== 1 || !jQuery2.isXMLDoc(elem)) {
            hooks = jQuery2.attrHooks[name.toLowerCase()] || (jQuery2.expr.match.bool.test(name) ? boolHook : void 0);
          }
          if (value !== void 0) {
            if (value === null) {
              jQuery2.removeAttr(elem, name);
              return;
            }
            if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== void 0) {
              return ret;
            }
            elem.setAttribute(name, value + "");
            return value;
          }
          if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
            return ret;
          }
          ret = jQuery2.find.attr(elem, name);
          return ret == null ? void 0 : ret;
        },
        attrHooks: {
          type: {
            set: function(elem, value) {
              if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                var val = elem.value;
                elem.setAttribute("type", value);
                if (val) {
                  elem.value = val;
                }
                return value;
              }
            }
          }
        },
        removeAttr: function(elem, value) {
          var name, i = 0, attrNames = value && value.match(rnothtmlwhite);
          if (attrNames && elem.nodeType === 1) {
            while (name = attrNames[i++]) {
              elem.removeAttribute(name);
            }
          }
        }
      });
      boolHook = {
        set: function(elem, value, name) {
          if (value === false) {
            jQuery2.removeAttr(elem, name);
          } else {
            elem.setAttribute(name, name);
          }
          return name;
        }
      };
      jQuery2.each(jQuery2.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery2.find.attr;
        attrHandle[name] = function(elem, name2, isXML) {
          var ret, handle, lowercaseName = name2.toLowerCase();
          if (!isXML) {
            handle = attrHandle[lowercaseName];
            attrHandle[lowercaseName] = ret;
            ret = getter(elem, name2, isXML) != null ? lowercaseName : null;
            attrHandle[lowercaseName] = handle;
          }
          return ret;
        };
      });
      var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
      jQuery2.fn.extend({
        prop: function(name, value) {
          return access(this, jQuery2.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
          return this.each(function() {
            delete this[jQuery2.propFix[name] || name];
          });
        }
      });
      jQuery2.extend({
        prop: function(elem, name, value) {
          var ret, hooks, nType = elem.nodeType;
          if (nType === 3 || nType === 8 || nType === 2) {
            return;
          }
          if (nType !== 1 || !jQuery2.isXMLDoc(elem)) {
            name = jQuery2.propFix[name] || name;
            hooks = jQuery2.propHooks[name];
          }
          if (value !== void 0) {
            if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== void 0) {
              return ret;
            }
            return elem[name] = value;
          }
          if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
            return ret;
          }
          return elem[name];
        },
        propHooks: {
          tabIndex: {
            get: function(elem) {
              var tabindex = jQuery2.find.attr(elem, "tabindex");
              if (tabindex) {
                return parseInt(tabindex, 10);
              }
              if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
                return 0;
              }
              return -1;
            }
          }
        },
        propFix: {
          "for": "htmlFor",
          "class": "className"
        }
      });
      if (!support.optSelected) {
        jQuery2.propHooks.selected = {
          get: function(elem) {
            var parent = elem.parentNode;
            if (parent && parent.parentNode) {
              parent.parentNode.selectedIndex;
            }
            return null;
          },
          set: function(elem) {
            var parent = elem.parentNode;
            if (parent) {
              parent.selectedIndex;
              if (parent.parentNode) {
                parent.parentNode.selectedIndex;
              }
            }
          }
        };
      }
      jQuery2.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
      ], function() {
        jQuery2.propFix[this.toLowerCase()] = this;
      });
      function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
      }
      function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
      }
      function classesToArray(value) {
        if (Array.isArray(value)) {
          return value;
        }
        if (typeof value === "string") {
          return value.match(rnothtmlwhite) || [];
        }
        return [];
      }
      jQuery2.fn.extend({
        addClass: function(value) {
          var classNames, cur, curValue, className, i, finalValue;
          if (isFunction(value)) {
            return this.each(function(j) {
              jQuery2(this).addClass(value.call(this, j, getClass(this)));
            });
          }
          classNames = classesToArray(value);
          if (classNames.length) {
            return this.each(function() {
              curValue = getClass(this);
              cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
              if (cur) {
                for (i = 0; i < classNames.length; i++) {
                  className = classNames[i];
                  if (cur.indexOf(" " + className + " ") < 0) {
                    cur += className + " ";
                  }
                }
                finalValue = stripAndCollapse(cur);
                if (curValue !== finalValue) {
                  this.setAttribute("class", finalValue);
                }
              }
            });
          }
          return this;
        },
        removeClass: function(value) {
          var classNames, cur, curValue, className, i, finalValue;
          if (isFunction(value)) {
            return this.each(function(j) {
              jQuery2(this).removeClass(value.call(this, j, getClass(this)));
            });
          }
          if (!arguments.length) {
            return this.attr("class", "");
          }
          classNames = classesToArray(value);
          if (classNames.length) {
            return this.each(function() {
              curValue = getClass(this);
              cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
              if (cur) {
                for (i = 0; i < classNames.length; i++) {
                  className = classNames[i];
                  while (cur.indexOf(" " + className + " ") > -1) {
                    cur = cur.replace(" " + className + " ", " ");
                  }
                }
                finalValue = stripAndCollapse(cur);
                if (curValue !== finalValue) {
                  this.setAttribute("class", finalValue);
                }
              }
            });
          }
          return this;
        },
        toggleClass: function(value, stateVal) {
          var classNames, className, i, self2, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
          if (isFunction(value)) {
            return this.each(function(i2) {
              jQuery2(this).toggleClass(
                value.call(this, i2, getClass(this), stateVal),
                stateVal
              );
            });
          }
          if (typeof stateVal === "boolean" && isValidValue) {
            return stateVal ? this.addClass(value) : this.removeClass(value);
          }
          classNames = classesToArray(value);
          return this.each(function() {
            if (isValidValue) {
              self2 = jQuery2(this);
              for (i = 0; i < classNames.length; i++) {
                className = classNames[i];
                if (self2.hasClass(className)) {
                  self2.removeClass(className);
                } else {
                  self2.addClass(className);
                }
              }
            } else if (value === void 0 || type === "boolean") {
              className = getClass(this);
              if (className) {
                dataPriv.set(this, "__className__", className);
              }
              if (this.setAttribute) {
                this.setAttribute(
                  "class",
                  className || value === false ? "" : dataPriv.get(this, "__className__") || ""
                );
              }
            }
          });
        },
        hasClass: function(selector) {
          var className, elem, i = 0;
          className = " " + selector + " ";
          while (elem = this[i++]) {
            if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
              return true;
            }
          }
          return false;
        }
      });
      var rreturn = /\r/g;
      jQuery2.fn.extend({
        val: function(value) {
          var hooks, ret, valueIsFunction, elem = this[0];
          if (!arguments.length) {
            if (elem) {
              hooks = jQuery2.valHooks[elem.type] || jQuery2.valHooks[elem.nodeName.toLowerCase()];
              if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== void 0) {
                return ret;
              }
              ret = elem.value;
              if (typeof ret === "string") {
                return ret.replace(rreturn, "");
              }
              return ret == null ? "" : ret;
            }
            return;
          }
          valueIsFunction = isFunction(value);
          return this.each(function(i) {
            var val;
            if (this.nodeType !== 1) {
              return;
            }
            if (valueIsFunction) {
              val = value.call(this, i, jQuery2(this).val());
            } else {
              val = value;
            }
            if (val == null) {
              val = "";
            } else if (typeof val === "number") {
              val += "";
            } else if (Array.isArray(val)) {
              val = jQuery2.map(val, function(value2) {
                return value2 == null ? "" : value2 + "";
              });
            }
            hooks = jQuery2.valHooks[this.type] || jQuery2.valHooks[this.nodeName.toLowerCase()];
            if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === void 0) {
              this.value = val;
            }
          });
        }
      });
      jQuery2.extend({
        valHooks: {
          option: {
            get: function(elem) {
              var val = jQuery2.find.attr(elem, "value");
              return val != null ? val : (
                // Support: IE <=10 - 11 only
                // option.text throws exceptions (trac-14686, trac-14858)
                // Strip and collapse whitespace
                // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                stripAndCollapse(jQuery2.text(elem))
              );
            }
          },
          select: {
            get: function(elem) {
              var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
              if (index < 0) {
                i = max;
              } else {
                i = one ? index : 0;
              }
              for (; i < max; i++) {
                option = options[i];
                if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                  value = jQuery2(option).val();
                  if (one) {
                    return value;
                  }
                  values.push(value);
                }
              }
              return values;
            },
            set: function(elem, value) {
              var optionSet, option, options = elem.options, values = jQuery2.makeArray(value), i = options.length;
              while (i--) {
                option = options[i];
                if (option.selected = jQuery2.inArray(jQuery2.valHooks.option.get(option), values) > -1) {
                  optionSet = true;
                }
              }
              if (!optionSet) {
                elem.selectedIndex = -1;
              }
              return values;
            }
          }
        }
      });
      jQuery2.each(["radio", "checkbox"], function() {
        jQuery2.valHooks[this] = {
          set: function(elem, value) {
            if (Array.isArray(value)) {
              return elem.checked = jQuery2.inArray(jQuery2(elem).val(), value) > -1;
            }
          }
        };
        if (!support.checkOn) {
          jQuery2.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
          };
        }
      });
      var location = window2.location;
      var nonce = { guid: Date.now() };
      var rquery = /\?/;
      jQuery2.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") {
          return null;
        }
        try {
          xml = new window2.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {
        }
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) {
          jQuery2.error("Invalid XML: " + (parserErrorElem ? jQuery2.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
          }).join("\n") : data));
        }
        return xml;
      };
      var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
      };
      jQuery2.extend(jQuery2.event, {
        trigger: function(event, data, elem, onlyHandlers) {
          var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [elem || document2], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
          cur = lastElement = tmp = elem = elem || document2;
          if (elem.nodeType === 3 || elem.nodeType === 8) {
            return;
          }
          if (rfocusMorph.test(type + jQuery2.event.triggered)) {
            return;
          }
          if (type.indexOf(".") > -1) {
            namespaces = type.split(".");
            type = namespaces.shift();
            namespaces.sort();
          }
          ontype = type.indexOf(":") < 0 && "on" + type;
          event = event[jQuery2.expando] ? event : new jQuery2.Event(type, typeof event === "object" && event);
          event.isTrigger = onlyHandlers ? 2 : 3;
          event.namespace = namespaces.join(".");
          event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
          event.result = void 0;
          if (!event.target) {
            event.target = elem;
          }
          data = data == null ? [event] : jQuery2.makeArray(data, [event]);
          special = jQuery2.event.special[type] || {};
          if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
            return;
          }
          if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
            bubbleType = special.delegateType || type;
            if (!rfocusMorph.test(bubbleType + type)) {
              cur = cur.parentNode;
            }
            for (; cur; cur = cur.parentNode) {
              eventPath.push(cur);
              tmp = cur;
            }
            if (tmp === (elem.ownerDocument || document2)) {
              eventPath.push(tmp.defaultView || tmp.parentWindow || window2);
            }
          }
          i = 0;
          while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
            lastElement = cur;
            event.type = i > 1 ? bubbleType : special.bindType || type;
            handle = (dataPriv.get(cur, "events") || /* @__PURE__ */ Object.create(null))[event.type] && dataPriv.get(cur, "handle");
            if (handle) {
              handle.apply(cur, data);
            }
            handle = ontype && cur[ontype];
            if (handle && handle.apply && acceptData(cur)) {
              event.result = handle.apply(cur, data);
              if (event.result === false) {
                event.preventDefault();
              }
            }
          }
          event.type = type;
          if (!onlyHandlers && !event.isDefaultPrevented()) {
            if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
              if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                tmp = elem[ontype];
                if (tmp) {
                  elem[ontype] = null;
                }
                jQuery2.event.triggered = type;
                if (event.isPropagationStopped()) {
                  lastElement.addEventListener(type, stopPropagationCallback);
                }
                elem[type]();
                if (event.isPropagationStopped()) {
                  lastElement.removeEventListener(type, stopPropagationCallback);
                }
                jQuery2.event.triggered = void 0;
                if (tmp) {
                  elem[ontype] = tmp;
                }
              }
            }
          }
          return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
          var e = jQuery2.extend(
            new jQuery2.Event(),
            event,
            {
              type,
              isSimulated: true
            }
          );
          jQuery2.event.trigger(e, null, elem);
        }
      });
      jQuery2.fn.extend({
        trigger: function(type, data) {
          return this.each(function() {
            jQuery2.event.trigger(type, data, this);
          });
        },
        triggerHandler: function(type, data) {
          var elem = this[0];
          if (elem) {
            return jQuery2.event.trigger(type, data, elem, true);
          }
        }
      });
      var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
      function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) {
          jQuery2.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) {
              add(prefix, v);
            } else {
              buildParams(
                prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]",
                v,
                traditional,
                add
              );
            }
          });
        } else if (!traditional && toType(obj) === "object") {
          for (name in obj) {
            buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
          }
        } else {
          add(prefix, obj);
        }
      }
      jQuery2.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
          var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
          s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) {
          return "";
        }
        if (Array.isArray(a) || a.jquery && !jQuery2.isPlainObject(a)) {
          jQuery2.each(a, function() {
            add(this.name, this.value);
          });
        } else {
          for (prefix in a) {
            buildParams(prefix, a[prefix], traditional, add);
          }
        }
        return s.join("&");
      };
      jQuery2.fn.extend({
        serialize: function() {
          return jQuery2.param(this.serializeArray());
        },
        serializeArray: function() {
          return this.map(function() {
            var elements = jQuery2.prop(this, "elements");
            return elements ? jQuery2.makeArray(elements) : this;
          }).filter(function() {
            var type = this.type;
            return this.name && !jQuery2(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
          }).map(function(_i, elem) {
            var val = jQuery2(this).val();
            if (val == null) {
              return null;
            }
            if (Array.isArray(val)) {
              return jQuery2.map(val, function(val2) {
                return { name: elem.name, value: val2.replace(rCRLF, "\r\n") };
              });
            }
            return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
          }).get();
        }
      });
      var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, prefilters = {}, transports = {}, allTypes = "*/".concat("*"), originAnchor = document2.createElement("a");
      originAnchor.href = location.href;
      function addToPrefiltersOrTransports(structure) {
        return function(dataTypeExpression, func) {
          if (typeof dataTypeExpression !== "string") {
            func = dataTypeExpression;
            dataTypeExpression = "*";
          }
          var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
          if (isFunction(func)) {
            while (dataType = dataTypes[i++]) {
              if (dataType[0] === "+") {
                dataType = dataType.slice(1) || "*";
                (structure[dataType] = structure[dataType] || []).unshift(func);
              } else {
                (structure[dataType] = structure[dataType] || []).push(func);
              }
            }
          }
        };
      }
      function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
          var selected;
          inspected[dataType] = true;
          jQuery2.each(structure[dataType] || [], function(_, prefilterOrFactory) {
            var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
            if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
              options.dataTypes.unshift(dataTypeOrTransport);
              inspect(dataTypeOrTransport);
              return false;
            } else if (seekingTransport) {
              return !(selected = dataTypeOrTransport);
            }
          });
          return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
      }
      function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery2.ajaxSettings.flatOptions || {};
        for (key in src) {
          if (src[key] !== void 0) {
            (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
          }
        }
        if (deep) {
          jQuery2.extend(true, target, deep);
        }
        return target;
      }
      function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        while (dataTypes[0] === "*") {
          dataTypes.shift();
          if (ct === void 0) {
            ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
          }
        }
        if (ct) {
          for (type in contents) {
            if (contents[type] && contents[type].test(ct)) {
              dataTypes.unshift(type);
              break;
            }
          }
        }
        if (dataTypes[0] in responses) {
          finalDataType = dataTypes[0];
        } else {
          for (type in responses) {
            if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
              finalDataType = type;
              break;
            }
            if (!firstDataType) {
              firstDataType = type;
            }
          }
          finalDataType = finalDataType || firstDataType;
        }
        if (finalDataType) {
          if (finalDataType !== dataTypes[0]) {
            dataTypes.unshift(finalDataType);
          }
          return responses[finalDataType];
        }
      }
      function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, dataTypes = s.dataTypes.slice();
        if (dataTypes[1]) {
          for (conv in s.converters) {
            converters[conv.toLowerCase()] = s.converters[conv];
          }
        }
        current = dataTypes.shift();
        while (current) {
          if (s.responseFields[current]) {
            jqXHR[s.responseFields[current]] = response;
          }
          if (!prev && isSuccess && s.dataFilter) {
            response = s.dataFilter(response, s.dataType);
          }
          prev = current;
          current = dataTypes.shift();
          if (current) {
            if (current === "*") {
              current = prev;
            } else if (prev !== "*" && prev !== current) {
              conv = converters[prev + " " + current] || converters["* " + current];
              if (!conv) {
                for (conv2 in converters) {
                  tmp = conv2.split(" ");
                  if (tmp[1] === current) {
                    conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                    if (conv) {
                      if (conv === true) {
                        conv = converters[conv2];
                      } else if (converters[conv2] !== true) {
                        current = tmp[0];
                        dataTypes.unshift(tmp[1]);
                      }
                      break;
                    }
                  }
                }
              }
              if (conv !== true) {
                if (conv && s.throws) {
                  response = conv(response);
                } else {
                  try {
                    response = conv(response);
                  } catch (e) {
                    return {
                      state: "parsererror",
                      error: conv ? e : "No conversion from " + prev + " to " + current
                    };
                  }
                }
              }
            }
          }
        }
        return { state: "success", data: response };
      }
      jQuery2.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: location.href,
          type: "GET",
          isLocal: rlocalProtocol.test(location.protocol),
          global: true,
          processData: true,
          async: true,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          /*
          timeout: 0,
          data: null,
          dataType: null,
          username: null,
          password: null,
          cache: null,
          throws: false,
          traditional: false,
          headers: {},
          */
          accepts: {
            "*": allTypes,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript"
          },
          contents: {
            xml: /\bxml\b/,
            html: /\bhtml/,
            json: /\bjson\b/
          },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON"
          },
          // Data converters
          // Keys separate source (or catchall "*") and destination types with a single space
          converters: {
            // Convert anything to text
            "* text": String,
            // Text to html (true = no transformation)
            "text html": true,
            // Evaluate text as a json expression
            "text json": JSON.parse,
            // Parse text as xml
            "text xml": jQuery2.parseXML
          },
          // For options that shouldn't be deep extended:
          // you can add your own custom options here if
          // and when you create one that shouldn't be
          // deep extended (see ajaxExtend)
          flatOptions: {
            url: true,
            context: true
          }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
          return settings ? (
            // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery2.ajaxSettings), settings)
          ) : (
            // Extending ajaxSettings
            ajaxExtend(jQuery2.ajaxSettings, target)
          );
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
          if (typeof url === "object") {
            options = url;
            url = void 0;
          }
          options = options || {};
          var transport, cacheURL, responseHeadersString, responseHeaders, timeoutTimer, urlAnchor, completed2, fireGlobals, i, uncached, s = jQuery2.ajaxSetup({}, options), callbackContext = s.context || s, globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery2(callbackContext) : jQuery2.event, deferred = jQuery2.Deferred(), completeDeferred = jQuery2.Callbacks("once memory"), statusCode = s.statusCode || {}, requestHeaders = {}, requestHeadersNames = {}, strAbort = "canceled", jqXHR = {
            readyState: 0,
            // Builds headers hashtable if needed
            getResponseHeader: function(key) {
              var match;
              if (completed2) {
                if (!responseHeaders) {
                  responseHeaders = {};
                  while (match = rheaders.exec(responseHeadersString)) {
                    responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                  }
                }
                match = responseHeaders[key.toLowerCase() + " "];
              }
              return match == null ? null : match.join(", ");
            },
            // Raw string
            getAllResponseHeaders: function() {
              return completed2 ? responseHeadersString : null;
            },
            // Caches the header
            setRequestHeader: function(name, value) {
              if (completed2 == null) {
                name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                requestHeaders[name] = value;
              }
              return this;
            },
            // Overrides response content-type header
            overrideMimeType: function(type) {
              if (completed2 == null) {
                s.mimeType = type;
              }
              return this;
            },
            // Status-dependent callbacks
            statusCode: function(map) {
              var code;
              if (map) {
                if (completed2) {
                  jqXHR.always(map[jqXHR.status]);
                } else {
                  for (code in map) {
                    statusCode[code] = [statusCode[code], map[code]];
                  }
                }
              }
              return this;
            },
            // Cancel the request
            abort: function(statusText) {
              var finalText = statusText || strAbort;
              if (transport) {
                transport.abort(finalText);
              }
              done(0, finalText);
              return this;
            }
          };
          deferred.promise(jqXHR);
          s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
          s.type = options.method || options.type || s.method || s.type;
          s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
          if (s.crossDomain == null) {
            urlAnchor = document2.createElement("a");
            try {
              urlAnchor.href = s.url;
              urlAnchor.href = urlAnchor.href;
              s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
            } catch (e) {
              s.crossDomain = true;
            }
          }
          if (s.data && s.processData && typeof s.data !== "string") {
            s.data = jQuery2.param(s.data, s.traditional);
          }
          inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
          if (completed2) {
            return jqXHR;
          }
          fireGlobals = jQuery2.event && s.global;
          if (fireGlobals && jQuery2.active++ === 0) {
            jQuery2.event.trigger("ajaxStart");
          }
          s.type = s.type.toUpperCase();
          s.hasContent = !rnoContent.test(s.type);
          cacheURL = s.url.replace(rhash, "");
          if (!s.hasContent) {
            uncached = s.url.slice(cacheURL.length);
            if (s.data && (s.processData || typeof s.data === "string")) {
              cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
              delete s.data;
            }
            if (s.cache === false) {
              cacheURL = cacheURL.replace(rantiCache, "$1");
              uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
            }
            s.url = cacheURL + uncached;
          } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
            s.data = s.data.replace(r20, "+");
          }
          if (s.ifModified) {
            if (jQuery2.lastModified[cacheURL]) {
              jqXHR.setRequestHeader("If-Modified-Since", jQuery2.lastModified[cacheURL]);
            }
            if (jQuery2.etag[cacheURL]) {
              jqXHR.setRequestHeader("If-None-Match", jQuery2.etag[cacheURL]);
            }
          }
          if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
            jqXHR.setRequestHeader("Content-Type", s.contentType);
          }
          jqXHR.setRequestHeader(
            "Accept",
            s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]
          );
          for (i in s.headers) {
            jqXHR.setRequestHeader(i, s.headers[i]);
          }
          if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed2)) {
            return jqXHR.abort();
          }
          strAbort = "abort";
          completeDeferred.add(s.complete);
          jqXHR.done(s.success);
          jqXHR.fail(s.error);
          transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
          if (!transport) {
            done(-1, "No Transport");
          } else {
            jqXHR.readyState = 1;
            if (fireGlobals) {
              globalEventContext.trigger("ajaxSend", [jqXHR, s]);
            }
            if (completed2) {
              return jqXHR;
            }
            if (s.async && s.timeout > 0) {
              timeoutTimer = window2.setTimeout(function() {
                jqXHR.abort("timeout");
              }, s.timeout);
            }
            try {
              completed2 = false;
              transport.send(requestHeaders, done);
            } catch (e) {
              if (completed2) {
                throw e;
              }
              done(-1, e);
            }
          }
          function done(status, nativeStatusText, responses, headers) {
            var isSuccess, success, error, response, modified, statusText = nativeStatusText;
            if (completed2) {
              return;
            }
            completed2 = true;
            if (timeoutTimer) {
              window2.clearTimeout(timeoutTimer);
            }
            transport = void 0;
            responseHeadersString = headers || "";
            jqXHR.readyState = status > 0 ? 4 : 0;
            isSuccess = status >= 200 && status < 300 || status === 304;
            if (responses) {
              response = ajaxHandleResponses(s, jqXHR, responses);
            }
            if (!isSuccess && jQuery2.inArray("script", s.dataTypes) > -1 && jQuery2.inArray("json", s.dataTypes) < 0) {
              s.converters["text script"] = function() {
              };
            }
            response = ajaxConvert(s, response, jqXHR, isSuccess);
            if (isSuccess) {
              if (s.ifModified) {
                modified = jqXHR.getResponseHeader("Last-Modified");
                if (modified) {
                  jQuery2.lastModified[cacheURL] = modified;
                }
                modified = jqXHR.getResponseHeader("etag");
                if (modified) {
                  jQuery2.etag[cacheURL] = modified;
                }
              }
              if (status === 204 || s.type === "HEAD") {
                statusText = "nocontent";
              } else if (status === 304) {
                statusText = "notmodified";
              } else {
                statusText = response.state;
                success = response.data;
                error = response.error;
                isSuccess = !error;
              }
            } else {
              error = statusText;
              if (status || !statusText) {
                statusText = "error";
                if (status < 0) {
                  status = 0;
                }
              }
            }
            jqXHR.status = status;
            jqXHR.statusText = (nativeStatusText || statusText) + "";
            if (isSuccess) {
              deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
            } else {
              deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
            }
            jqXHR.statusCode(statusCode);
            statusCode = void 0;
            if (fireGlobals) {
              globalEventContext.trigger(
                isSuccess ? "ajaxSuccess" : "ajaxError",
                [jqXHR, s, isSuccess ? success : error]
              );
            }
            completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
            if (fireGlobals) {
              globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
              if (!--jQuery2.active) {
                jQuery2.event.trigger("ajaxStop");
              }
            }
          }
          return jqXHR;
        },
        getJSON: function(url, data, callback) {
          return jQuery2.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
          return jQuery2.get(url, void 0, callback, "script");
        }
      });
      jQuery2.each(["get", "post"], function(_i, method) {
        jQuery2[method] = function(url, data, callback, type) {
          if (isFunction(data)) {
            type = type || callback;
            callback = data;
            data = void 0;
          }
          return jQuery2.ajax(jQuery2.extend({
            url,
            type: method,
            dataType: type,
            data,
            success: callback
          }, jQuery2.isPlainObject(url) && url));
        };
      });
      jQuery2.ajaxPrefilter(function(s) {
        var i;
        for (i in s.headers) {
          if (i.toLowerCase() === "content-type") {
            s.contentType = s.headers[i] || "";
          }
        }
      });
      jQuery2._evalUrl = function(url, options, doc) {
        return jQuery2.ajax({
          url,
          // Make this explicit, since user can override this through ajaxSetup (trac-11264)
          type: "GET",
          dataType: "script",
          cache: true,
          async: false,
          global: false,
          // Only evaluate the response if it is successful (gh-4126)
          // dataFilter is not invoked for failure responses, so using it instead
          // of the default converter is kludgy but it works.
          converters: {
            "text script": function() {
            }
          },
          dataFilter: function(response) {
            jQuery2.globalEval(response, options, doc);
          }
        });
      };
      jQuery2.fn.extend({
        wrapAll: function(html) {
          var wrap;
          if (this[0]) {
            if (isFunction(html)) {
              html = html.call(this[0]);
            }
            wrap = jQuery2(html, this[0].ownerDocument).eq(0).clone(true);
            if (this[0].parentNode) {
              wrap.insertBefore(this[0]);
            }
            wrap.map(function() {
              var elem = this;
              while (elem.firstElementChild) {
                elem = elem.firstElementChild;
              }
              return elem;
            }).append(this);
          }
          return this;
        },
        wrapInner: function(html) {
          if (isFunction(html)) {
            return this.each(function(i) {
              jQuery2(this).wrapInner(html.call(this, i));
            });
          }
          return this.each(function() {
            var self2 = jQuery2(this), contents = self2.contents();
            if (contents.length) {
              contents.wrapAll(html);
            } else {
              self2.append(html);
            }
          });
        },
        wrap: function(html) {
          var htmlIsFunction = isFunction(html);
          return this.each(function(i) {
            jQuery2(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
          });
        },
        unwrap: function(selector) {
          this.parent(selector).not("body").each(function() {
            jQuery2(this).replaceWith(this.childNodes);
          });
          return this;
        }
      });
      jQuery2.expr.pseudos.hidden = function(elem) {
        return !jQuery2.expr.pseudos.visible(elem);
      };
      jQuery2.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
      };
      jQuery2.ajaxSettings.xhr = function() {
        try {
          return new window2.XMLHttpRequest();
        } catch (e) {
        }
      };
      var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
      }, xhrSupported = jQuery2.ajaxSettings.xhr();
      support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
      support.ajax = xhrSupported = !!xhrSupported;
      jQuery2.ajaxTransport(function(options) {
        var callback, errorCallback;
        if (support.cors || xhrSupported && !options.crossDomain) {
          return {
            send: function(headers, complete) {
              var i, xhr = options.xhr();
              xhr.open(
                options.type,
                options.url,
                options.async,
                options.username,
                options.password
              );
              if (options.xhrFields) {
                for (i in options.xhrFields) {
                  xhr[i] = options.xhrFields[i];
                }
              }
              if (options.mimeType && xhr.overrideMimeType) {
                xhr.overrideMimeType(options.mimeType);
              }
              if (!options.crossDomain && !headers["X-Requested-With"]) {
                headers["X-Requested-With"] = "XMLHttpRequest";
              }
              for (i in headers) {
                xhr.setRequestHeader(i, headers[i]);
              }
              callback = function(type) {
                return function() {
                  if (callback) {
                    callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                    if (type === "abort") {
                      xhr.abort();
                    } else if (type === "error") {
                      if (typeof xhr.status !== "number") {
                        complete(0, "error");
                      } else {
                        complete(
                          // File: protocol always yields status 0; see trac-8605, trac-14207
                          xhr.status,
                          xhr.statusText
                        );
                      }
                    } else {
                      complete(
                        xhrSuccessStatus[xhr.status] || xhr.status,
                        xhr.statusText,
                        // Support: IE <=9 only
                        // IE9 has no XHR2 but throws on binary (trac-11426)
                        // For XHR2 non-text, let the caller handle it (gh-2498)
                        (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText },
                        xhr.getAllResponseHeaders()
                      );
                    }
                  }
                };
              };
              xhr.onload = callback();
              errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
              if (xhr.onabort !== void 0) {
                xhr.onabort = errorCallback;
              } else {
                xhr.onreadystatechange = function() {
                  if (xhr.readyState === 4) {
                    window2.setTimeout(function() {
                      if (callback) {
                        errorCallback();
                      }
                    });
                  }
                };
              }
              callback = callback("abort");
              try {
                xhr.send(options.hasContent && options.data || null);
              } catch (e) {
                if (callback) {
                  throw e;
                }
              }
            },
            abort: function() {
              if (callback) {
                callback();
              }
            }
          };
        }
      });
      jQuery2.ajaxPrefilter(function(s) {
        if (s.crossDomain) {
          s.contents.script = false;
        }
      });
      jQuery2.ajaxSetup({
        accepts: {
          script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
          script: /\b(?:java|ecma)script\b/
        },
        converters: {
          "text script": function(text) {
            jQuery2.globalEval(text);
            return text;
          }
        }
      });
      jQuery2.ajaxPrefilter("script", function(s) {
        if (s.cache === void 0) {
          s.cache = false;
        }
        if (s.crossDomain) {
          s.type = "GET";
        }
      });
      jQuery2.ajaxTransport("script", function(s) {
        if (s.crossDomain || s.scriptAttrs) {
          var script, callback;
          return {
            send: function(_, complete) {
              script = jQuery2("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", callback = function(evt) {
                script.remove();
                callback = null;
                if (evt) {
                  complete(evt.type === "error" ? 404 : 200, evt.type);
                }
              });
              document2.head.appendChild(script[0]);
            },
            abort: function() {
              if (callback) {
                callback();
              }
            }
          };
        }
      });
      var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
      jQuery2.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
          var callback = oldCallbacks.pop() || jQuery2.expando + "_" + nonce.guid++;
          this[callback] = true;
          return callback;
        }
      });
      jQuery2.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        if (jsonProp || s.dataTypes[0] === "jsonp") {
          callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
          if (jsonProp) {
            s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
          } else if (s.jsonp !== false) {
            s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
          }
          s.converters["script json"] = function() {
            if (!responseContainer) {
              jQuery2.error(callbackName + " was not called");
            }
            return responseContainer[0];
          };
          s.dataTypes[0] = "json";
          overwritten = window2[callbackName];
          window2[callbackName] = function() {
            responseContainer = arguments;
          };
          jqXHR.always(function() {
            if (overwritten === void 0) {
              jQuery2(window2).removeProp(callbackName);
            } else {
              window2[callbackName] = overwritten;
            }
            if (s[callbackName]) {
              s.jsonpCallback = originalSettings.jsonpCallback;
              oldCallbacks.push(callbackName);
            }
            if (responseContainer && isFunction(overwritten)) {
              overwritten(responseContainer[0]);
            }
            responseContainer = overwritten = void 0;
          });
          return "script";
        }
      });
      support.createHTMLDocument = function() {
        var body = document2.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
      }();
      jQuery2.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") {
          return [];
        }
        if (typeof context === "boolean") {
          keepScripts = context;
          context = false;
        }
        var base, parsed, scripts;
        if (!context) {
          if (support.createHTMLDocument) {
            context = document2.implementation.createHTMLDocument("");
            base = context.createElement("base");
            base.href = document2.location.href;
            context.head.appendChild(base);
          } else {
            context = document2;
          }
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        if (parsed) {
          return [context.createElement(parsed[1])];
        }
        parsed = buildFragment([data], context, scripts);
        if (scripts && scripts.length) {
          jQuery2(scripts).remove();
        }
        return jQuery2.merge([], parsed.childNodes);
      };
      jQuery2.fn.load = function(url, params, callback) {
        var selector, type, response, self2 = this, off = url.indexOf(" ");
        if (off > -1) {
          selector = stripAndCollapse(url.slice(off));
          url = url.slice(0, off);
        }
        if (isFunction(params)) {
          callback = params;
          params = void 0;
        } else if (params && typeof params === "object") {
          type = "POST";
        }
        if (self2.length > 0) {
          jQuery2.ajax({
            url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
          }).done(function(responseText) {
            response = arguments;
            self2.html(selector ? (
              // If a selector was specified, locate the right elements in a dummy div
              // Exclude scripts to avoid IE 'Permission Denied' errors
              jQuery2("<div>").append(jQuery2.parseHTML(responseText)).find(selector)
            ) : (
              // Otherwise use the full result
              responseText
            ));
          }).always(callback && function(jqXHR, status) {
            self2.each(function() {
              callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
            });
          });
        }
        return this;
      };
      jQuery2.expr.pseudos.animated = function(elem) {
        return jQuery2.grep(jQuery2.timers, function(fn) {
          return elem === fn.elem;
        }).length;
      };
      jQuery2.offset = {
        setOffset: function(elem, options, i) {
          var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery2.css(elem, "position"), curElem = jQuery2(elem), props = {};
          if (position === "static") {
            elem.style.position = "relative";
          }
          curOffset = curElem.offset();
          curCSSTop = jQuery2.css(elem, "top");
          curCSSLeft = jQuery2.css(elem, "left");
          calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
          if (calculatePosition) {
            curPosition = curElem.position();
            curTop = curPosition.top;
            curLeft = curPosition.left;
          } else {
            curTop = parseFloat(curCSSTop) || 0;
            curLeft = parseFloat(curCSSLeft) || 0;
          }
          if (isFunction(options)) {
            options = options.call(elem, i, jQuery2.extend({}, curOffset));
          }
          if (options.top != null) {
            props.top = options.top - curOffset.top + curTop;
          }
          if (options.left != null) {
            props.left = options.left - curOffset.left + curLeft;
          }
          if ("using" in options) {
            options.using.call(elem, props);
          } else {
            curElem.css(props);
          }
        }
      };
      jQuery2.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
          if (arguments.length) {
            return options === void 0 ? this : this.each(function(i) {
              jQuery2.offset.setOffset(this, options, i);
            });
          }
          var rect, win, elem = this[0];
          if (!elem) {
            return;
          }
          if (!elem.getClientRects().length) {
            return { top: 0, left: 0 };
          }
          rect = elem.getBoundingClientRect();
          win = elem.ownerDocument.defaultView;
          return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
          };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
          if (!this[0]) {
            return;
          }
          var offsetParent, offset, doc, elem = this[0], parentOffset = { top: 0, left: 0 };
          if (jQuery2.css(elem, "position") === "fixed") {
            offset = elem.getBoundingClientRect();
          } else {
            offset = this.offset();
            doc = elem.ownerDocument;
            offsetParent = elem.offsetParent || doc.documentElement;
            while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery2.css(offsetParent, "position") === "static") {
              offsetParent = offsetParent.parentNode;
            }
            if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
              parentOffset = jQuery2(offsetParent).offset();
              parentOffset.top += jQuery2.css(offsetParent, "borderTopWidth", true);
              parentOffset.left += jQuery2.css(offsetParent, "borderLeftWidth", true);
            }
          }
          return {
            top: offset.top - parentOffset.top - jQuery2.css(elem, "marginTop", true),
            left: offset.left - parentOffset.left - jQuery2.css(elem, "marginLeft", true)
          };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
          return this.map(function() {
            var offsetParent = this.offsetParent;
            while (offsetParent && jQuery2.css(offsetParent, "position") === "static") {
              offsetParent = offsetParent.offsetParent;
            }
            return offsetParent || documentElement;
          });
        }
      });
      jQuery2.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery2.fn[method] = function(val) {
          return access(this, function(elem, method2, val2) {
            var win;
            if (isWindow(elem)) {
              win = elem;
            } else if (elem.nodeType === 9) {
              win = elem.defaultView;
            }
            if (val2 === void 0) {
              return win ? win[prop] : elem[method2];
            }
            if (win) {
              win.scrollTo(
                !top ? val2 : win.pageXOffset,
                top ? val2 : win.pageYOffset
              );
            } else {
              elem[method2] = val2;
            }
          }, method, val, arguments.length);
        };
      });
      jQuery2.each(["top", "left"], function(_i, prop) {
        jQuery2.cssHooks[prop] = addGetHookIf(
          support.pixelPosition,
          function(elem, computed) {
            if (computed) {
              computed = curCSS(elem, prop);
              return rnumnonpx.test(computed) ? jQuery2(elem).position()[prop] + "px" : computed;
            }
          }
        );
      });
      jQuery2.each({ Height: "height", Width: "width" }, function(name, type) {
        jQuery2.each({
          padding: "inner" + name,
          content: type,
          "": "outer" + name
        }, function(defaultExtra, funcName) {
          jQuery2.fn[funcName] = function(margin, value) {
            var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
            return access(this, function(elem, type2, value2) {
              var doc;
              if (isWindow(elem)) {
                return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
              }
              if (elem.nodeType === 9) {
                doc = elem.documentElement;
                return Math.max(
                  elem.body["scroll" + name],
                  doc["scroll" + name],
                  elem.body["offset" + name],
                  doc["offset" + name],
                  doc["client" + name]
                );
              }
              return value2 === void 0 ? (
                // Get width or height on the element, requesting but not forcing parseFloat
                jQuery2.css(elem, type2, extra)
              ) : (
                // Set width or height on the element
                jQuery2.style(elem, type2, value2, extra)
              );
            }, type, chainable ? margin : void 0, chainable);
          };
        });
      });
      jQuery2.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
      ], function(_i, type) {
        jQuery2.fn[type] = function(fn) {
          return this.on(type, fn);
        };
      });
      jQuery2.fn.extend({
        bind: function(types, data, fn) {
          return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
          return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
          return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
          return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
          return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
      });
      jQuery2.each(
        "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
        function(_i, name) {
          jQuery2.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
          };
        }
      );
      var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
      jQuery2.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
          tmp = fn[context];
          context = fn;
          fn = tmp;
        }
        if (!isFunction(fn)) {
          return void 0;
        }
        args = slice.call(arguments, 2);
        proxy = function() {
          return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        proxy.guid = fn.guid = fn.guid || jQuery2.guid++;
        return proxy;
      };
      jQuery2.holdReady = function(hold) {
        if (hold) {
          jQuery2.readyWait++;
        } else {
          jQuery2.ready(true);
        }
      };
      jQuery2.isArray = Array.isArray;
      jQuery2.parseJSON = JSON.parse;
      jQuery2.nodeName = nodeName;
      jQuery2.isFunction = isFunction;
      jQuery2.isWindow = isWindow;
      jQuery2.camelCase = camelCase;
      jQuery2.type = toType;
      jQuery2.now = Date.now;
      jQuery2.isNumeric = function(obj) {
        var type = jQuery2.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
      };
      jQuery2.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
      };
      var _jQuery = window2.jQuery, _$ = window2.$;
      jQuery2.noConflict = function(deep) {
        if (window2.$ === jQuery2) {
          window2.$ = _$;
        }
        if (deep && window2.jQuery === jQuery2) {
          window2.jQuery = _jQuery;
        }
        return jQuery2;
      };
      if (typeof noGlobal === "undefined") {
        window2.jQuery = window2.$ = jQuery2;
      }
      return jQuery2;
    });
  })(jquery$1);
  return jquery$1.exports;
}
var jqueryExports = requireJquery();
var jQuery$1 = /* @__PURE__ */ getDefaultExportFromCjs(jqueryExports);
window.jQuery = jQuery$1;
window.$ = jQuery$1;
var select2_full = { exports: {} };
/*!
 * Select2 4.1.0-rc.0
 * https://select2.github.io
 *
 * Released under the MIT license
 * https://github.com/select2/select2/blob/master/LICENSE.md
 */
var hasRequiredSelect2_full;
function requireSelect2_full() {
  if (hasRequiredSelect2_full) return select2_full.exports;
  hasRequiredSelect2_full = 1;
  (function(module, exports) {
    (function(factory) {
      if (module.exports) {
        module.exports = function(root, jQuery2) {
          if (jQuery2 === void 0) {
            if (typeof window !== "undefined") {
              jQuery2 = requireJquery();
            } else {
              jQuery2 = requireJquery()(root);
            }
          }
          factory(jQuery2);
          return jQuery2;
        };
      } else {
        factory(jQuery);
      }
    })(function(jQuery2) {
      var S2 = function() {
        if (jQuery2 && jQuery2.fn && jQuery2.fn.select2 && jQuery2.fn.select2.amd) {
          var S22 = jQuery2.fn.select2.amd;
        }
        var S22;
        (function() {
          if (!S22 || !S22.requirejs) {
            if (!S22) {
              S22 = {};
            } else {
              require2 = S22;
            }
            /**
             * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
             * Released under MIT license, http://github.com/requirejs/almond/LICENSE
             */
            var requirejs, require2, define;
            (function(undef) {
              var main, req, makeMap, handlers, defined = {}, waiting = {}, config = {}, defining = {}, hasOwn = Object.prototype.hasOwnProperty, aps = [].slice, jsSuffixRegExp = /\.js$/;
              function hasProp(obj, prop) {
                return hasOwn.call(obj, prop);
              }
              function normalize(name, baseName) {
                var nameParts, nameSegment, mapValue, foundMap, lastIndex, foundI, foundStarMap, starI, i, j, part, normalizedBaseParts, baseParts = baseName && baseName.split("/"), map = config.map, starMap = map && map["*"] || {};
                if (name) {
                  name = name.split("/");
                  lastIndex = name.length - 1;
                  if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, "");
                  }
                  if (name[0].charAt(0) === "." && baseParts) {
                    normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                    name = normalizedBaseParts.concat(name);
                  }
                  for (i = 0; i < name.length; i++) {
                    part = name[i];
                    if (part === ".") {
                      name.splice(i, 1);
                      i -= 1;
                    } else if (part === "..") {
                      if (i === 0 || i === 1 && name[2] === ".." || name[i - 1] === "..") {
                        continue;
                      } else if (i > 0) {
                        name.splice(i - 1, 2);
                        i -= 2;
                      }
                    }
                  }
                  name = name.join("/");
                }
                if ((baseParts || starMap) && map) {
                  nameParts = name.split("/");
                  for (i = nameParts.length; i > 0; i -= 1) {
                    nameSegment = nameParts.slice(0, i).join("/");
                    if (baseParts) {
                      for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join("/")];
                        if (mapValue) {
                          mapValue = mapValue[nameSegment];
                          if (mapValue) {
                            foundMap = mapValue;
                            foundI = i;
                            break;
                          }
                        }
                      }
                    }
                    if (foundMap) {
                      break;
                    }
                    if (!foundStarMap && starMap && starMap[nameSegment]) {
                      foundStarMap = starMap[nameSegment];
                      starI = i;
                    }
                  }
                  if (!foundMap && foundStarMap) {
                    foundMap = foundStarMap;
                    foundI = starI;
                  }
                  if (foundMap) {
                    nameParts.splice(0, foundI, foundMap);
                    name = nameParts.join("/");
                  }
                }
                return name;
              }
              function makeRequire(relName, forceSync) {
                return function() {
                  var args = aps.call(arguments, 0);
                  if (typeof args[0] !== "string" && args.length === 1) {
                    args.push(null);
                  }
                  return req.apply(undef, args.concat([relName, forceSync]));
                };
              }
              function makeNormalize(relName) {
                return function(name) {
                  return normalize(name, relName);
                };
              }
              function makeLoad(depName) {
                return function(value) {
                  defined[depName] = value;
                };
              }
              function callDep(name) {
                if (hasProp(waiting, name)) {
                  var args = waiting[name];
                  delete waiting[name];
                  defining[name] = true;
                  main.apply(undef, args);
                }
                if (!hasProp(defined, name) && !hasProp(defining, name)) {
                  throw new Error("No " + name);
                }
                return defined[name];
              }
              function splitPrefix(name) {
                var prefix, index = name ? name.indexOf("!") : -1;
                if (index > -1) {
                  prefix = name.substring(0, index);
                  name = name.substring(index + 1, name.length);
                }
                return [prefix, name];
              }
              function makeRelParts(relName) {
                return relName ? splitPrefix(relName) : [];
              }
              makeMap = function(name, relParts) {
                var plugin, parts = splitPrefix(name), prefix = parts[0], relResourceName = relParts[1];
                name = parts[1];
                if (prefix) {
                  prefix = normalize(prefix, relResourceName);
                  plugin = callDep(prefix);
                }
                if (prefix) {
                  if (plugin && plugin.normalize) {
                    name = plugin.normalize(name, makeNormalize(relResourceName));
                  } else {
                    name = normalize(name, relResourceName);
                  }
                } else {
                  name = normalize(name, relResourceName);
                  parts = splitPrefix(name);
                  prefix = parts[0];
                  name = parts[1];
                  if (prefix) {
                    plugin = callDep(prefix);
                  }
                }
                return {
                  f: prefix ? prefix + "!" + name : name,
                  //fullName
                  n: name,
                  pr: prefix,
                  p: plugin
                };
              };
              function makeConfig(name) {
                return function() {
                  return config && config.config && config.config[name] || {};
                };
              }
              handlers = {
                require: function(name) {
                  return makeRequire(name);
                },
                exports: function(name) {
                  var e = defined[name];
                  if (typeof e !== "undefined") {
                    return e;
                  } else {
                    return defined[name] = {};
                  }
                },
                module: function(name) {
                  return {
                    id: name,
                    uri: "",
                    exports: defined[name],
                    config: makeConfig(name)
                  };
                }
              };
              main = function(name, deps, callback, relName) {
                var cjsModule, depName, ret, map, i, relParts, args = [], callbackType = typeof callback, usingExports;
                relName = relName || name;
                relParts = makeRelParts(relName);
                if (callbackType === "undefined" || callbackType === "function") {
                  deps = !deps.length && callback.length ? ["require", "exports", "module"] : deps;
                  for (i = 0; i < deps.length; i += 1) {
                    map = makeMap(deps[i], relParts);
                    depName = map.f;
                    if (depName === "require") {
                      args[i] = handlers.require(name);
                    } else if (depName === "exports") {
                      args[i] = handlers.exports(name);
                      usingExports = true;
                    } else if (depName === "module") {
                      cjsModule = args[i] = handlers.module(name);
                    } else if (hasProp(defined, depName) || hasProp(waiting, depName) || hasProp(defining, depName)) {
                      args[i] = callDep(depName);
                    } else if (map.p) {
                      map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                      args[i] = defined[depName];
                    } else {
                      throw new Error(name + " missing " + depName);
                    }
                  }
                  ret = callback ? callback.apply(defined[name], args) : void 0;
                  if (name) {
                    if (cjsModule && cjsModule.exports !== undef && cjsModule.exports !== defined[name]) {
                      defined[name] = cjsModule.exports;
                    } else if (ret !== undef || !usingExports) {
                      defined[name] = ret;
                    }
                  }
                } else if (name) {
                  defined[name] = callback;
                }
              };
              requirejs = require2 = req = function(deps, callback, relName, forceSync, alt) {
                if (typeof deps === "string") {
                  if (handlers[deps]) {
                    return handlers[deps](callback);
                  }
                  return callDep(makeMap(deps, makeRelParts(callback)).f);
                } else if (!deps.splice) {
                  config = deps;
                  if (config.deps) {
                    req(config.deps, config.callback);
                  }
                  if (!callback) {
                    return;
                  }
                  if (callback.splice) {
                    deps = callback;
                    callback = relName;
                    relName = null;
                  } else {
                    deps = undef;
                  }
                }
                callback = callback || function() {
                };
                if (typeof relName === "function") {
                  relName = forceSync;
                  forceSync = alt;
                }
                if (forceSync) {
                  main(undef, deps, callback, relName);
                } else {
                  setTimeout(function() {
                    main(undef, deps, callback, relName);
                  }, 4);
                }
                return req;
              };
              req.config = function(cfg) {
                return req(cfg);
              };
              requirejs._defined = defined;
              define = function(name, deps, callback) {
                if (typeof name !== "string") {
                  throw new Error("See almond README: incorrect module build, no module name");
                }
                if (!deps.splice) {
                  callback = deps;
                  deps = [];
                }
                if (!hasProp(defined, name) && !hasProp(waiting, name)) {
                  waiting[name] = [name, deps, callback];
                }
              };
              define.amd = {
                jQuery: true
              };
            })();
            S22.requirejs = requirejs;
            S22.require = require2;
            S22.define = define;
          }
        })();
        S22.define("almond", function() {
        });
        S22.define("jquery", [], function() {
          var _$ = jQuery2 || $;
          if (_$ == null && console && console.error) {
            console.error(
              "Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."
            );
          }
          return _$;
        });
        S22.define("select2/utils", [
          "jquery"
        ], function($2) {
          var Utils = {};
          Utils.Extend = function(ChildClass, SuperClass) {
            var __hasProp = {}.hasOwnProperty;
            function BaseConstructor() {
              this.constructor = ChildClass;
            }
            for (var key in SuperClass) {
              if (__hasProp.call(SuperClass, key)) {
                ChildClass[key] = SuperClass[key];
              }
            }
            BaseConstructor.prototype = SuperClass.prototype;
            ChildClass.prototype = new BaseConstructor();
            ChildClass.__super__ = SuperClass.prototype;
            return ChildClass;
          };
          function getMethods(theClass) {
            var proto = theClass.prototype;
            var methods = [];
            for (var methodName in proto) {
              var m = proto[methodName];
              if (typeof m !== "function") {
                continue;
              }
              if (methodName === "constructor") {
                continue;
              }
              methods.push(methodName);
            }
            return methods;
          }
          Utils.Decorate = function(SuperClass, DecoratorClass) {
            var decoratedMethods = getMethods(DecoratorClass);
            var superMethods = getMethods(SuperClass);
            function DecoratedClass() {
              var unshift = Array.prototype.unshift;
              var argCount = DecoratorClass.prototype.constructor.length;
              var calledConstructor = SuperClass.prototype.constructor;
              if (argCount > 0) {
                unshift.call(arguments, SuperClass.prototype.constructor);
                calledConstructor = DecoratorClass.prototype.constructor;
              }
              calledConstructor.apply(this, arguments);
            }
            DecoratorClass.displayName = SuperClass.displayName;
            function ctr() {
              this.constructor = DecoratedClass;
            }
            DecoratedClass.prototype = new ctr();
            for (var m = 0; m < superMethods.length; m++) {
              var superMethod = superMethods[m];
              DecoratedClass.prototype[superMethod] = SuperClass.prototype[superMethod];
            }
            var calledMethod = function(methodName) {
              var originalMethod = function() {
              };
              if (methodName in DecoratedClass.prototype) {
                originalMethod = DecoratedClass.prototype[methodName];
              }
              var decoratedMethod2 = DecoratorClass.prototype[methodName];
              return function() {
                var unshift = Array.prototype.unshift;
                unshift.call(arguments, originalMethod);
                return decoratedMethod2.apply(this, arguments);
              };
            };
            for (var d = 0; d < decoratedMethods.length; d++) {
              var decoratedMethod = decoratedMethods[d];
              DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
            }
            return DecoratedClass;
          };
          var Observable = function() {
            this.listeners = {};
          };
          Observable.prototype.on = function(event, callback) {
            this.listeners = this.listeners || {};
            if (event in this.listeners) {
              this.listeners[event].push(callback);
            } else {
              this.listeners[event] = [callback];
            }
          };
          Observable.prototype.trigger = function(event) {
            var slice = Array.prototype.slice;
            var params = slice.call(arguments, 1);
            this.listeners = this.listeners || {};
            if (params == null) {
              params = [];
            }
            if (params.length === 0) {
              params.push({});
            }
            params[0]._type = event;
            if (event in this.listeners) {
              this.invoke(this.listeners[event], slice.call(arguments, 1));
            }
            if ("*" in this.listeners) {
              this.invoke(this.listeners["*"], arguments);
            }
          };
          Observable.prototype.invoke = function(listeners, params) {
            for (var i = 0, len = listeners.length; i < len; i++) {
              listeners[i].apply(this, params);
            }
          };
          Utils.Observable = Observable;
          Utils.generateChars = function(length) {
            var chars = "";
            for (var i = 0; i < length; i++) {
              var randomChar = Math.floor(Math.random() * 36);
              chars += randomChar.toString(36);
            }
            return chars;
          };
          Utils.bind = function(func, context) {
            return function() {
              func.apply(context, arguments);
            };
          };
          Utils._convertData = function(data) {
            for (var originalKey in data) {
              var keys = originalKey.split("-");
              var dataLevel = data;
              if (keys.length === 1) {
                continue;
              }
              for (var k = 0; k < keys.length; k++) {
                var key = keys[k];
                key = key.substring(0, 1).toLowerCase() + key.substring(1);
                if (!(key in dataLevel)) {
                  dataLevel[key] = {};
                }
                if (k == keys.length - 1) {
                  dataLevel[key] = data[originalKey];
                }
                dataLevel = dataLevel[key];
              }
              delete data[originalKey];
            }
            return data;
          };
          Utils.hasScroll = function(index, el) {
            var $el = $2(el);
            var overflowX = el.style.overflowX;
            var overflowY = el.style.overflowY;
            if (overflowX === overflowY && (overflowY === "hidden" || overflowY === "visible")) {
              return false;
            }
            if (overflowX === "scroll" || overflowY === "scroll") {
              return true;
            }
            return $el.innerHeight() < el.scrollHeight || $el.innerWidth() < el.scrollWidth;
          };
          Utils.escapeMarkup = function(markup) {
            var replaceMap = {
              "\\": "&#92;",
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;",
              "/": "&#47;"
            };
            if (typeof markup !== "string") {
              return markup;
            }
            return String(markup).replace(/[&<>"'\/\\]/g, function(match) {
              return replaceMap[match];
            });
          };
          Utils.__cache = {};
          var id = 0;
          Utils.GetUniqueElementId = function(element) {
            var select2Id = element.getAttribute("data-select2-id");
            if (select2Id != null) {
              return select2Id;
            }
            if (element.id) {
              select2Id = "select2-data-" + element.id;
            } else {
              select2Id = "select2-data-" + (++id).toString() + "-" + Utils.generateChars(4);
            }
            element.setAttribute("data-select2-id", select2Id);
            return select2Id;
          };
          Utils.StoreData = function(element, name, value) {
            var id2 = Utils.GetUniqueElementId(element);
            if (!Utils.__cache[id2]) {
              Utils.__cache[id2] = {};
            }
            Utils.__cache[id2][name] = value;
          };
          Utils.GetData = function(element, name) {
            var id2 = Utils.GetUniqueElementId(element);
            if (name) {
              if (Utils.__cache[id2]) {
                if (Utils.__cache[id2][name] != null) {
                  return Utils.__cache[id2][name];
                }
                return $2(element).data(name);
              }
              return $2(element).data(name);
            } else {
              return Utils.__cache[id2];
            }
          };
          Utils.RemoveData = function(element) {
            var id2 = Utils.GetUniqueElementId(element);
            if (Utils.__cache[id2] != null) {
              delete Utils.__cache[id2];
            }
            element.removeAttribute("data-select2-id");
          };
          Utils.copyNonInternalCssClasses = function(dest, src) {
            var destinationClasses = dest.getAttribute("class").trim().split(/\s+/);
            destinationClasses = destinationClasses.filter(function(clazz) {
              return clazz.indexOf("select2-") === 0;
            });
            var sourceClasses = src.getAttribute("class").trim().split(/\s+/);
            sourceClasses = sourceClasses.filter(function(clazz) {
              return clazz.indexOf("select2-") !== 0;
            });
            var replacements = destinationClasses.concat(sourceClasses);
            dest.setAttribute("class", replacements.join(" "));
          };
          return Utils;
        });
        S22.define("select2/results", [
          "jquery",
          "./utils"
        ], function($2, Utils) {
          function Results($element, options, dataAdapter) {
            this.$element = $element;
            this.data = dataAdapter;
            this.options = options;
            Results.__super__.constructor.call(this);
          }
          Utils.Extend(Results, Utils.Observable);
          Results.prototype.render = function() {
            var $results = $2(
              '<ul class="select2-results__options" role="listbox"></ul>'
            );
            if (this.options.get("multiple")) {
              $results.attr("aria-multiselectable", "true");
            }
            this.$results = $results;
            return $results;
          };
          Results.prototype.clear = function() {
            this.$results.empty();
          };
          Results.prototype.displayMessage = function(params) {
            var escapeMarkup = this.options.get("escapeMarkup");
            this.clear();
            this.hideLoading();
            var $message = $2(
              '<li role="alert" aria-live="assertive" class="select2-results__option"></li>'
            );
            var message = this.options.get("translations").get(params.message);
            $message.append(
              escapeMarkup(
                message(params.args)
              )
            );
            $message[0].className += " select2-results__message";
            this.$results.append($message);
          };
          Results.prototype.hideMessages = function() {
            this.$results.find(".select2-results__message").remove();
          };
          Results.prototype.append = function(data) {
            this.hideLoading();
            var $options = [];
            if (data.results == null || data.results.length === 0) {
              if (this.$results.children().length === 0) {
                this.trigger("results:message", {
                  message: "noResults"
                });
              }
              return;
            }
            data.results = this.sort(data.results);
            for (var d = 0; d < data.results.length; d++) {
              var item = data.results[d];
              var $option = this.option(item);
              $options.push($option);
            }
            this.$results.append($options);
          };
          Results.prototype.position = function($results, $dropdown) {
            var $resultsContainer = $dropdown.find(".select2-results");
            $resultsContainer.append($results);
          };
          Results.prototype.sort = function(data) {
            var sorter = this.options.get("sorter");
            return sorter(data);
          };
          Results.prototype.highlightFirstItem = function() {
            var $options = this.$results.find(".select2-results__option--selectable");
            var $selected = $options.filter(".select2-results__option--selected");
            if ($selected.length > 0) {
              $selected.first().trigger("mouseenter");
            } else {
              $options.first().trigger("mouseenter");
            }
            this.ensureHighlightVisible();
          };
          Results.prototype.setClasses = function() {
            var self2 = this;
            this.data.current(function(selected) {
              var selectedIds = selected.map(function(s) {
                return s.id.toString();
              });
              var $options = self2.$results.find(".select2-results__option--selectable");
              $options.each(function() {
                var $option = $2(this);
                var item = Utils.GetData(this, "data");
                var id = "" + item.id;
                if (item.element != null && item.element.selected || item.element == null && selectedIds.indexOf(id) > -1) {
                  this.classList.add("select2-results__option--selected");
                  $option.attr("aria-selected", "true");
                } else {
                  this.classList.remove("select2-results__option--selected");
                  $option.attr("aria-selected", "false");
                }
              });
            });
          };
          Results.prototype.showLoading = function(params) {
            this.hideLoading();
            var loadingMore = this.options.get("translations").get("searching");
            var loading = {
              disabled: true,
              loading: true,
              text: loadingMore(params)
            };
            var $loading = this.option(loading);
            $loading.className += " loading-results";
            this.$results.prepend($loading);
          };
          Results.prototype.hideLoading = function() {
            this.$results.find(".loading-results").remove();
          };
          Results.prototype.option = function(data) {
            var option = document.createElement("li");
            option.classList.add("select2-results__option");
            option.classList.add("select2-results__option--selectable");
            var attrs = {
              "role": "option"
            };
            var matches = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
            if (data.element != null && matches.call(data.element, ":disabled") || data.element == null && data.disabled) {
              attrs["aria-disabled"] = "true";
              option.classList.remove("select2-results__option--selectable");
              option.classList.add("select2-results__option--disabled");
            }
            if (data.id == null) {
              option.classList.remove("select2-results__option--selectable");
            }
            if (data._resultId != null) {
              option.id = data._resultId;
            }
            if (data.title) {
              option.title = data.title;
            }
            if (data.children) {
              attrs.role = "group";
              attrs["aria-label"] = data.text;
              option.classList.remove("select2-results__option--selectable");
              option.classList.add("select2-results__option--group");
            }
            for (var attr in attrs) {
              var val = attrs[attr];
              option.setAttribute(attr, val);
            }
            if (data.children) {
              var $option = $2(option);
              var label = document.createElement("strong");
              label.className = "select2-results__group";
              this.template(data, label);
              var $children = [];
              for (var c = 0; c < data.children.length; c++) {
                var child = data.children[c];
                var $child = this.option(child);
                $children.push($child);
              }
              var $childrenContainer = $2("<ul></ul>", {
                "class": "select2-results__options select2-results__options--nested",
                "role": "none"
              });
              $childrenContainer.append($children);
              $option.append(label);
              $option.append($childrenContainer);
            } else {
              this.template(data, option);
            }
            Utils.StoreData(option, "data", data);
            return option;
          };
          Results.prototype.bind = function(container, $container) {
            var self2 = this;
            var id = container.id + "-results";
            this.$results.attr("id", id);
            container.on("results:all", function(params) {
              self2.clear();
              self2.append(params.data);
              if (container.isOpen()) {
                self2.setClasses();
                self2.highlightFirstItem();
              }
            });
            container.on("results:append", function(params) {
              self2.append(params.data);
              if (container.isOpen()) {
                self2.setClasses();
              }
            });
            container.on("query", function(params) {
              self2.hideMessages();
              self2.showLoading(params);
            });
            container.on("select", function() {
              if (!container.isOpen()) {
                return;
              }
              self2.setClasses();
              if (self2.options.get("scrollAfterSelect")) {
                self2.highlightFirstItem();
              }
            });
            container.on("unselect", function() {
              if (!container.isOpen()) {
                return;
              }
              self2.setClasses();
              if (self2.options.get("scrollAfterSelect")) {
                self2.highlightFirstItem();
              }
            });
            container.on("open", function() {
              self2.$results.attr("aria-expanded", "true");
              self2.$results.attr("aria-hidden", "false");
              self2.setClasses();
              self2.ensureHighlightVisible();
            });
            container.on("close", function() {
              self2.$results.attr("aria-expanded", "false");
              self2.$results.attr("aria-hidden", "true");
              self2.$results.removeAttr("aria-activedescendant");
            });
            container.on("results:toggle", function() {
              var $highlighted = self2.getHighlightedResults();
              if ($highlighted.length === 0) {
                return;
              }
              $highlighted.trigger("mouseup");
            });
            container.on("results:select", function() {
              var $highlighted = self2.getHighlightedResults();
              if ($highlighted.length === 0) {
                return;
              }
              var data = Utils.GetData($highlighted[0], "data");
              if ($highlighted.hasClass("select2-results__option--selected")) {
                self2.trigger("close", {});
              } else {
                self2.trigger("select", {
                  data
                });
              }
            });
            container.on("results:previous", function() {
              var $highlighted = self2.getHighlightedResults();
              var $options = self2.$results.find(".select2-results__option--selectable");
              var currentIndex = $options.index($highlighted);
              if (currentIndex <= 0) {
                return;
              }
              var nextIndex = currentIndex - 1;
              if ($highlighted.length === 0) {
                nextIndex = 0;
              }
              var $next = $options.eq(nextIndex);
              $next.trigger("mouseenter");
              var currentOffset = self2.$results.offset().top;
              var nextTop = $next.offset().top;
              var nextOffset = self2.$results.scrollTop() + (nextTop - currentOffset);
              if (nextIndex === 0) {
                self2.$results.scrollTop(0);
              } else if (nextTop - currentOffset < 0) {
                self2.$results.scrollTop(nextOffset);
              }
            });
            container.on("results:next", function() {
              var $highlighted = self2.getHighlightedResults();
              var $options = self2.$results.find(".select2-results__option--selectable");
              var currentIndex = $options.index($highlighted);
              var nextIndex = currentIndex + 1;
              if (nextIndex >= $options.length) {
                return;
              }
              var $next = $options.eq(nextIndex);
              $next.trigger("mouseenter");
              var currentOffset = self2.$results.offset().top + self2.$results.outerHeight(false);
              var nextBottom = $next.offset().top + $next.outerHeight(false);
              var nextOffset = self2.$results.scrollTop() + nextBottom - currentOffset;
              if (nextIndex === 0) {
                self2.$results.scrollTop(0);
              } else if (nextBottom > currentOffset) {
                self2.$results.scrollTop(nextOffset);
              }
            });
            container.on("results:focus", function(params) {
              params.element[0].classList.add("select2-results__option--highlighted");
              params.element[0].setAttribute("aria-selected", "true");
            });
            container.on("results:message", function(params) {
              self2.displayMessage(params);
            });
            if ($2.fn.mousewheel) {
              this.$results.on("mousewheel", function(e) {
                var top = self2.$results.scrollTop();
                var bottom = self2.$results.get(0).scrollHeight - top + e.deltaY;
                var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
                var isAtBottom = e.deltaY < 0 && bottom <= self2.$results.height();
                if (isAtTop) {
                  self2.$results.scrollTop(0);
                  e.preventDefault();
                  e.stopPropagation();
                } else if (isAtBottom) {
                  self2.$results.scrollTop(
                    self2.$results.get(0).scrollHeight - self2.$results.height()
                  );
                  e.preventDefault();
                  e.stopPropagation();
                }
              });
            }
            this.$results.on(
              "mouseup",
              ".select2-results__option--selectable",
              function(evt) {
                var $this = $2(this);
                var data = Utils.GetData(this, "data");
                if ($this.hasClass("select2-results__option--selected")) {
                  if (self2.options.get("multiple")) {
                    self2.trigger("unselect", {
                      originalEvent: evt,
                      data
                    });
                  } else {
                    self2.trigger("close", {});
                  }
                  return;
                }
                self2.trigger("select", {
                  originalEvent: evt,
                  data
                });
              }
            );
            this.$results.on(
              "mouseenter",
              ".select2-results__option--selectable",
              function(evt) {
                var data = Utils.GetData(this, "data");
                self2.getHighlightedResults().removeClass("select2-results__option--highlighted").attr("aria-selected", "false");
                self2.trigger("results:focus", {
                  data,
                  element: $2(this)
                });
              }
            );
          };
          Results.prototype.getHighlightedResults = function() {
            var $highlighted = this.$results.find(".select2-results__option--highlighted");
            return $highlighted;
          };
          Results.prototype.destroy = function() {
            this.$results.remove();
          };
          Results.prototype.ensureHighlightVisible = function() {
            var $highlighted = this.getHighlightedResults();
            if ($highlighted.length === 0) {
              return;
            }
            var $options = this.$results.find(".select2-results__option--selectable");
            var currentIndex = $options.index($highlighted);
            var currentOffset = this.$results.offset().top;
            var nextTop = $highlighted.offset().top;
            var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);
            var offsetDelta = nextTop - currentOffset;
            nextOffset -= $highlighted.outerHeight(false) * 2;
            if (currentIndex <= 2) {
              this.$results.scrollTop(0);
            } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
              this.$results.scrollTop(nextOffset);
            }
          };
          Results.prototype.template = function(result, container) {
            var template = this.options.get("templateResult");
            var escapeMarkup = this.options.get("escapeMarkup");
            var content = template(result, container);
            if (content == null) {
              container.style.display = "none";
            } else if (typeof content === "string") {
              container.innerHTML = escapeMarkup(content);
            } else {
              $2(container).append(content);
            }
          };
          return Results;
        });
        S22.define("select2/keys", [], function() {
          var KEYS = {
            BACKSPACE: 8,
            TAB: 9,
            ENTER: 13,
            SHIFT: 16,
            CTRL: 17,
            ALT: 18,
            ESC: 27,
            SPACE: 32,
            PAGE_UP: 33,
            PAGE_DOWN: 34,
            END: 35,
            HOME: 36,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            DELETE: 46
          };
          return KEYS;
        });
        S22.define("select2/selection/base", [
          "jquery",
          "../utils",
          "../keys"
        ], function($2, Utils, KEYS) {
          function BaseSelection($element, options) {
            this.$element = $element;
            this.options = options;
            BaseSelection.__super__.constructor.call(this);
          }
          Utils.Extend(BaseSelection, Utils.Observable);
          BaseSelection.prototype.render = function() {
            var $selection = $2(
              '<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>'
            );
            this._tabindex = 0;
            if (Utils.GetData(this.$element[0], "old-tabindex") != null) {
              this._tabindex = Utils.GetData(this.$element[0], "old-tabindex");
            } else if (this.$element.attr("tabindex") != null) {
              this._tabindex = this.$element.attr("tabindex");
            }
            $selection.attr("title", this.$element.attr("title"));
            $selection.attr("tabindex", this._tabindex);
            $selection.attr("aria-disabled", "false");
            this.$selection = $selection;
            return $selection;
          };
          BaseSelection.prototype.bind = function(container, $container) {
            var self2 = this;
            var resultsId = container.id + "-results";
            this.container = container;
            this.$selection.on("focus", function(evt) {
              self2.trigger("focus", evt);
            });
            this.$selection.on("blur", function(evt) {
              self2._handleBlur(evt);
            });
            this.$selection.on("keydown", function(evt) {
              self2.trigger("keypress", evt);
              if (evt.which === KEYS.SPACE) {
                evt.preventDefault();
              }
            });
            container.on("results:focus", function(params) {
              self2.$selection.attr("aria-activedescendant", params.data._resultId);
            });
            container.on("selection:update", function(params) {
              self2.update(params.data);
            });
            container.on("open", function() {
              self2.$selection.attr("aria-expanded", "true");
              self2.$selection.attr("aria-owns", resultsId);
              self2._attachCloseHandler(container);
            });
            container.on("close", function() {
              self2.$selection.attr("aria-expanded", "false");
              self2.$selection.removeAttr("aria-activedescendant");
              self2.$selection.removeAttr("aria-owns");
              self2.$selection.trigger("focus");
              self2._detachCloseHandler(container);
            });
            container.on("enable", function() {
              self2.$selection.attr("tabindex", self2._tabindex);
              self2.$selection.attr("aria-disabled", "false");
            });
            container.on("disable", function() {
              self2.$selection.attr("tabindex", "-1");
              self2.$selection.attr("aria-disabled", "true");
            });
          };
          BaseSelection.prototype._handleBlur = function(evt) {
            var self2 = this;
            window.setTimeout(function() {
              if (document.activeElement == self2.$selection[0] || $2.contains(self2.$selection[0], document.activeElement)) {
                return;
              }
              self2.trigger("blur", evt);
            }, 1);
          };
          BaseSelection.prototype._attachCloseHandler = function(container) {
            $2(document.body).on("mousedown.select2." + container.id, function(e) {
              var $target = $2(e.target);
              var $select = $target.closest(".select2");
              var $all = $2(".select2.select2-container--open");
              $all.each(function() {
                if (this == $select[0]) {
                  return;
                }
                var $element = Utils.GetData(this, "element");
                $element.select2("close");
              });
            });
          };
          BaseSelection.prototype._detachCloseHandler = function(container) {
            $2(document.body).off("mousedown.select2." + container.id);
          };
          BaseSelection.prototype.position = function($selection, $container) {
            var $selectionContainer = $container.find(".selection");
            $selectionContainer.append($selection);
          };
          BaseSelection.prototype.destroy = function() {
            this._detachCloseHandler(this.container);
          };
          BaseSelection.prototype.update = function(data) {
            throw new Error("The `update` method must be defined in child classes.");
          };
          BaseSelection.prototype.isEnabled = function() {
            return !this.isDisabled();
          };
          BaseSelection.prototype.isDisabled = function() {
            return this.options.get("disabled");
          };
          return BaseSelection;
        });
        S22.define("select2/selection/single", [
          "jquery",
          "./base",
          "../utils",
          "../keys"
        ], function($2, BaseSelection, Utils, KEYS) {
          function SingleSelection() {
            SingleSelection.__super__.constructor.apply(this, arguments);
          }
          Utils.Extend(SingleSelection, BaseSelection);
          SingleSelection.prototype.render = function() {
            var $selection = SingleSelection.__super__.render.call(this);
            $selection[0].classList.add("select2-selection--single");
            $selection.html(
              '<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'
            );
            return $selection;
          };
          SingleSelection.prototype.bind = function(container, $container) {
            var self2 = this;
            SingleSelection.__super__.bind.apply(this, arguments);
            var id = container.id + "-container";
            this.$selection.find(".select2-selection__rendered").attr("id", id).attr("role", "textbox").attr("aria-readonly", "true");
            this.$selection.attr("aria-labelledby", id);
            this.$selection.attr("aria-controls", id);
            this.$selection.on("mousedown", function(evt) {
              if (evt.which !== 1) {
                return;
              }
              self2.trigger("toggle", {
                originalEvent: evt
              });
            });
            this.$selection.on("focus", function(evt) {
            });
            this.$selection.on("blur", function(evt) {
            });
            container.on("focus", function(evt) {
              if (!container.isOpen()) {
                self2.$selection.trigger("focus");
              }
            });
          };
          SingleSelection.prototype.clear = function() {
            var $rendered = this.$selection.find(".select2-selection__rendered");
            $rendered.empty();
            $rendered.removeAttr("title");
          };
          SingleSelection.prototype.display = function(data, container) {
            var template = this.options.get("templateSelection");
            var escapeMarkup = this.options.get("escapeMarkup");
            return escapeMarkup(template(data, container));
          };
          SingleSelection.prototype.selectionContainer = function() {
            return $2("<span></span>");
          };
          SingleSelection.prototype.update = function(data) {
            if (data.length === 0) {
              this.clear();
              return;
            }
            var selection = data[0];
            var $rendered = this.$selection.find(".select2-selection__rendered");
            var formatted = this.display(selection, $rendered);
            $rendered.empty().append(formatted);
            var title = selection.title || selection.text;
            if (title) {
              $rendered.attr("title", title);
            } else {
              $rendered.removeAttr("title");
            }
          };
          return SingleSelection;
        });
        S22.define("select2/selection/multiple", [
          "jquery",
          "./base",
          "../utils"
        ], function($2, BaseSelection, Utils) {
          function MultipleSelection($element, options) {
            MultipleSelection.__super__.constructor.apply(this, arguments);
          }
          Utils.Extend(MultipleSelection, BaseSelection);
          MultipleSelection.prototype.render = function() {
            var $selection = MultipleSelection.__super__.render.call(this);
            $selection[0].classList.add("select2-selection--multiple");
            $selection.html(
              '<ul class="select2-selection__rendered"></ul>'
            );
            return $selection;
          };
          MultipleSelection.prototype.bind = function(container, $container) {
            var self2 = this;
            MultipleSelection.__super__.bind.apply(this, arguments);
            var id = container.id + "-container";
            this.$selection.find(".select2-selection__rendered").attr("id", id);
            this.$selection.on("click", function(evt) {
              self2.trigger("toggle", {
                originalEvent: evt
              });
            });
            this.$selection.on(
              "click",
              ".select2-selection__choice__remove",
              function(evt) {
                if (self2.isDisabled()) {
                  return;
                }
                var $remove = $2(this);
                var $selection = $remove.parent();
                var data = Utils.GetData($selection[0], "data");
                self2.trigger("unselect", {
                  originalEvent: evt,
                  data
                });
              }
            );
            this.$selection.on(
              "keydown",
              ".select2-selection__choice__remove",
              function(evt) {
                if (self2.isDisabled()) {
                  return;
                }
                evt.stopPropagation();
              }
            );
          };
          MultipleSelection.prototype.clear = function() {
            var $rendered = this.$selection.find(".select2-selection__rendered");
            $rendered.empty();
            $rendered.removeAttr("title");
          };
          MultipleSelection.prototype.display = function(data, container) {
            var template = this.options.get("templateSelection");
            var escapeMarkup = this.options.get("escapeMarkup");
            return escapeMarkup(template(data, container));
          };
          MultipleSelection.prototype.selectionContainer = function() {
            var $container = $2(
              '<li class="select2-selection__choice"><button type="button" class="select2-selection__choice__remove" tabindex="-1"><span aria-hidden="true">&times;</span></button><span class="select2-selection__choice__display"></span></li>'
            );
            return $container;
          };
          MultipleSelection.prototype.update = function(data) {
            this.clear();
            if (data.length === 0) {
              return;
            }
            var $selections = [];
            var selectionIdPrefix = this.$selection.find(".select2-selection__rendered").attr("id") + "-choice-";
            for (var d = 0; d < data.length; d++) {
              var selection = data[d];
              var $selection = this.selectionContainer();
              var formatted = this.display(selection, $selection);
              var selectionId = selectionIdPrefix + Utils.generateChars(4) + "-";
              if (selection.id) {
                selectionId += selection.id;
              } else {
                selectionId += Utils.generateChars(4);
              }
              $selection.find(".select2-selection__choice__display").append(formatted).attr("id", selectionId);
              var title = selection.title || selection.text;
              if (title) {
                $selection.attr("title", title);
              }
              var removeItem = this.options.get("translations").get("removeItem");
              var $remove = $selection.find(".select2-selection__choice__remove");
              $remove.attr("title", removeItem());
              $remove.attr("aria-label", removeItem());
              $remove.attr("aria-describedby", selectionId);
              Utils.StoreData($selection[0], "data", selection);
              $selections.push($selection);
            }
            var $rendered = this.$selection.find(".select2-selection__rendered");
            $rendered.append($selections);
          };
          return MultipleSelection;
        });
        S22.define("select2/selection/placeholder", [], function() {
          function Placeholder(decorated, $element, options) {
            this.placeholder = this.normalizePlaceholder(options.get("placeholder"));
            decorated.call(this, $element, options);
          }
          Placeholder.prototype.normalizePlaceholder = function(_, placeholder) {
            if (typeof placeholder === "string") {
              placeholder = {
                id: "",
                text: placeholder
              };
            }
            return placeholder;
          };
          Placeholder.prototype.createPlaceholder = function(decorated, placeholder) {
            var $placeholder = this.selectionContainer();
            $placeholder.html(this.display(placeholder));
            $placeholder[0].classList.add("select2-selection__placeholder");
            $placeholder[0].classList.remove("select2-selection__choice");
            var placeholderTitle = placeholder.title || placeholder.text || $placeholder.text();
            this.$selection.find(".select2-selection__rendered").attr(
              "title",
              placeholderTitle
            );
            return $placeholder;
          };
          Placeholder.prototype.update = function(decorated, data) {
            var singlePlaceholder = data.length == 1 && data[0].id != this.placeholder.id;
            var multipleSelections = data.length > 1;
            if (multipleSelections || singlePlaceholder) {
              return decorated.call(this, data);
            }
            this.clear();
            var $placeholder = this.createPlaceholder(this.placeholder);
            this.$selection.find(".select2-selection__rendered").append($placeholder);
          };
          return Placeholder;
        });
        S22.define("select2/selection/allowClear", [
          "jquery",
          "../keys",
          "../utils"
        ], function($2, KEYS, Utils) {
          function AllowClear() {
          }
          AllowClear.prototype.bind = function(decorated, container, $container) {
            var self2 = this;
            decorated.call(this, container, $container);
            if (this.placeholder == null) {
              if (this.options.get("debug") && window.console && console.error) {
                console.error(
                  "Select2: The `allowClear` option should be used in combination with the `placeholder` option."
                );
              }
            }
            this.$selection.on(
              "mousedown",
              ".select2-selection__clear",
              function(evt) {
                self2._handleClear(evt);
              }
            );
            container.on("keypress", function(evt) {
              self2._handleKeyboardClear(evt, container);
            });
          };
          AllowClear.prototype._handleClear = function(_, evt) {
            if (this.isDisabled()) {
              return;
            }
            var $clear = this.$selection.find(".select2-selection__clear");
            if ($clear.length === 0) {
              return;
            }
            evt.stopPropagation();
            var data = Utils.GetData($clear[0], "data");
            var previousVal = this.$element.val();
            this.$element.val(this.placeholder.id);
            var unselectData = {
              data
            };
            this.trigger("clear", unselectData);
            if (unselectData.prevented) {
              this.$element.val(previousVal);
              return;
            }
            for (var d = 0; d < data.length; d++) {
              unselectData = {
                data: data[d]
              };
              this.trigger("unselect", unselectData);
              if (unselectData.prevented) {
                this.$element.val(previousVal);
                return;
              }
            }
            this.$element.trigger("input").trigger("change");
            this.trigger("toggle", {});
          };
          AllowClear.prototype._handleKeyboardClear = function(_, evt, container) {
            if (container.isOpen()) {
              return;
            }
            if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
              this._handleClear(evt);
            }
          };
          AllowClear.prototype.update = function(decorated, data) {
            decorated.call(this, data);
            this.$selection.find(".select2-selection__clear").remove();
            this.$selection[0].classList.remove("select2-selection--clearable");
            if (this.$selection.find(".select2-selection__placeholder").length > 0 || data.length === 0) {
              return;
            }
            var selectionId = this.$selection.find(".select2-selection__rendered").attr("id");
            var removeAll = this.options.get("translations").get("removeAllItems");
            var $remove = $2(
              '<button type="button" class="select2-selection__clear" tabindex="-1"><span aria-hidden="true">&times;</span></button>'
            );
            $remove.attr("title", removeAll());
            $remove.attr("aria-label", removeAll());
            $remove.attr("aria-describedby", selectionId);
            Utils.StoreData($remove[0], "data", data);
            this.$selection.prepend($remove);
            this.$selection[0].classList.add("select2-selection--clearable");
          };
          return AllowClear;
        });
        S22.define("select2/selection/search", [
          "jquery",
          "../utils",
          "../keys"
        ], function($2, Utils, KEYS) {
          function Search(decorated, $element, options) {
            decorated.call(this, $element, options);
          }
          Search.prototype.render = function(decorated) {
            var searchLabel = this.options.get("translations").get("search");
            var $search = $2(
              '<span class="select2-search select2-search--inline"><textarea class="select2-search__field" type="search" tabindex="-1" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" ></textarea></span>'
            );
            this.$searchContainer = $search;
            this.$search = $search.find("textarea");
            this.$search.prop("autocomplete", this.options.get("autocomplete"));
            this.$search.attr("aria-label", searchLabel());
            var $rendered = decorated.call(this);
            this._transferTabIndex();
            $rendered.append(this.$searchContainer);
            return $rendered;
          };
          Search.prototype.bind = function(decorated, container, $container) {
            var self2 = this;
            var resultsId = container.id + "-results";
            var selectionId = container.id + "-container";
            decorated.call(this, container, $container);
            self2.$search.attr("aria-describedby", selectionId);
            container.on("open", function() {
              self2.$search.attr("aria-controls", resultsId);
              self2.$search.trigger("focus");
            });
            container.on("close", function() {
              self2.$search.val("");
              self2.resizeSearch();
              self2.$search.removeAttr("aria-controls");
              self2.$search.removeAttr("aria-activedescendant");
              self2.$search.trigger("focus");
            });
            container.on("enable", function() {
              self2.$search.prop("disabled", false);
              self2._transferTabIndex();
            });
            container.on("disable", function() {
              self2.$search.prop("disabled", true);
            });
            container.on("focus", function(evt) {
              self2.$search.trigger("focus");
            });
            container.on("results:focus", function(params) {
              if (params.data._resultId) {
                self2.$search.attr("aria-activedescendant", params.data._resultId);
              } else {
                self2.$search.removeAttr("aria-activedescendant");
              }
            });
            this.$selection.on("focusin", ".select2-search--inline", function(evt) {
              self2.trigger("focus", evt);
            });
            this.$selection.on("focusout", ".select2-search--inline", function(evt) {
              self2._handleBlur(evt);
            });
            this.$selection.on("keydown", ".select2-search--inline", function(evt) {
              evt.stopPropagation();
              self2.trigger("keypress", evt);
              self2._keyUpPrevented = evt.isDefaultPrevented();
              var key = evt.which;
              if (key === KEYS.BACKSPACE && self2.$search.val() === "") {
                var $previousChoice = self2.$selection.find(".select2-selection__choice").last();
                if ($previousChoice.length > 0) {
                  var item = Utils.GetData($previousChoice[0], "data");
                  self2.searchRemoveChoice(item);
                  evt.preventDefault();
                }
              }
            });
            this.$selection.on("click", ".select2-search--inline", function(evt) {
              if (self2.$search.val()) {
                evt.stopPropagation();
              }
            });
            var msie = document.documentMode;
            var disableInputEvents = msie && msie <= 11;
            this.$selection.on(
              "input.searchcheck",
              ".select2-search--inline",
              function(evt) {
                if (disableInputEvents) {
                  self2.$selection.off("input.search input.searchcheck");
                  return;
                }
                self2.$selection.off("keyup.search");
              }
            );
            this.$selection.on(
              "keyup.search input.search",
              ".select2-search--inline",
              function(evt) {
                if (disableInputEvents && evt.type === "input") {
                  self2.$selection.off("input.search input.searchcheck");
                  return;
                }
                var key = evt.which;
                if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
                  return;
                }
                if (key == KEYS.TAB) {
                  return;
                }
                self2.handleSearch(evt);
              }
            );
          };
          Search.prototype._transferTabIndex = function(decorated) {
            this.$search.attr("tabindex", this.$selection.attr("tabindex"));
            this.$selection.attr("tabindex", "-1");
          };
          Search.prototype.createPlaceholder = function(decorated, placeholder) {
            this.$search.attr("placeholder", placeholder.text);
          };
          Search.prototype.update = function(decorated, data) {
            var searchHadFocus = this.$search[0] == document.activeElement;
            this.$search.attr("placeholder", "");
            decorated.call(this, data);
            this.resizeSearch();
            if (searchHadFocus) {
              this.$search.trigger("focus");
            }
          };
          Search.prototype.handleSearch = function() {
            this.resizeSearch();
            if (!this._keyUpPrevented) {
              var input = this.$search.val();
              this.trigger("query", {
                term: input
              });
            }
            this._keyUpPrevented = false;
          };
          Search.prototype.searchRemoveChoice = function(decorated, item) {
            this.trigger("unselect", {
              data: item
            });
            this.$search.val(item.text);
            this.handleSearch();
          };
          Search.prototype.resizeSearch = function() {
            this.$search.css("width", "25px");
            var width = "100%";
            if (this.$search.attr("placeholder") === "") {
              var minimumWidth = this.$search.val().length + 1;
              width = minimumWidth * 0.75 + "em";
            }
            this.$search.css("width", width);
          };
          return Search;
        });
        S22.define("select2/selection/selectionCss", [
          "../utils"
        ], function(Utils) {
          function SelectionCSS() {
          }
          SelectionCSS.prototype.render = function(decorated) {
            var $selection = decorated.call(this);
            var selectionCssClass = this.options.get("selectionCssClass") || "";
            if (selectionCssClass.indexOf(":all:") !== -1) {
              selectionCssClass = selectionCssClass.replace(":all:", "");
              Utils.copyNonInternalCssClasses($selection[0], this.$element[0]);
            }
            $selection.addClass(selectionCssClass);
            return $selection;
          };
          return SelectionCSS;
        });
        S22.define("select2/selection/eventRelay", [
          "jquery"
        ], function($2) {
          function EventRelay() {
          }
          EventRelay.prototype.bind = function(decorated, container, $container) {
            var self2 = this;
            var relayEvents = [
              "open",
              "opening",
              "close",
              "closing",
              "select",
              "selecting",
              "unselect",
              "unselecting",
              "clear",
              "clearing"
            ];
            var preventableEvents = [
              "opening",
              "closing",
              "selecting",
              "unselecting",
              "clearing"
            ];
            decorated.call(this, container, $container);
            container.on("*", function(name, params) {
              if (relayEvents.indexOf(name) === -1) {
                return;
              }
              params = params || {};
              var evt = $2.Event("select2:" + name, {
                params
              });
              self2.$element.trigger(evt);
              if (preventableEvents.indexOf(name) === -1) {
                return;
              }
              params.prevented = evt.isDefaultPrevented();
            });
          };
          return EventRelay;
        });
        S22.define("select2/translation", [
          "jquery",
          "require"
        ], function($2, require2) {
          function Translation(dict) {
            this.dict = dict || {};
          }
          Translation.prototype.all = function() {
            return this.dict;
          };
          Translation.prototype.get = function(key) {
            return this.dict[key];
          };
          Translation.prototype.extend = function(translation) {
            this.dict = $2.extend({}, translation.all(), this.dict);
          };
          Translation._cache = {};
          Translation.loadPath = function(path) {
            if (!(path in Translation._cache)) {
              var translations = require2(path);
              Translation._cache[path] = translations;
            }
            return new Translation(Translation._cache[path]);
          };
          return Translation;
        });
        S22.define("select2/diacritics", [], function() {
          var diacritics = {
            "Ⓐ": "A",
            "Ａ": "A",
            "À": "A",
            "Á": "A",
            "Â": "A",
            "Ầ": "A",
            "Ấ": "A",
            "Ẫ": "A",
            "Ẩ": "A",
            "Ã": "A",
            "Ā": "A",
            "Ă": "A",
            "Ằ": "A",
            "Ắ": "A",
            "Ẵ": "A",
            "Ẳ": "A",
            "Ȧ": "A",
            "Ǡ": "A",
            "Ä": "A",
            "Ǟ": "A",
            "Ả": "A",
            "Å": "A",
            "Ǻ": "A",
            "Ǎ": "A",
            "Ȁ": "A",
            "Ȃ": "A",
            "Ạ": "A",
            "Ậ": "A",
            "Ặ": "A",
            "Ḁ": "A",
            "Ą": "A",
            "Ⱥ": "A",
            "Ɐ": "A",
            "Ꜳ": "AA",
            "Æ": "AE",
            "Ǽ": "AE",
            "Ǣ": "AE",
            "Ꜵ": "AO",
            "Ꜷ": "AU",
            "Ꜹ": "AV",
            "Ꜻ": "AV",
            "Ꜽ": "AY",
            "Ⓑ": "B",
            "Ｂ": "B",
            "Ḃ": "B",
            "Ḅ": "B",
            "Ḇ": "B",
            "Ƀ": "B",
            "Ƃ": "B",
            "Ɓ": "B",
            "Ⓒ": "C",
            "Ｃ": "C",
            "Ć": "C",
            "Ĉ": "C",
            "Ċ": "C",
            "Č": "C",
            "Ç": "C",
            "Ḉ": "C",
            "Ƈ": "C",
            "Ȼ": "C",
            "Ꜿ": "C",
            "Ⓓ": "D",
            "Ｄ": "D",
            "Ḋ": "D",
            "Ď": "D",
            "Ḍ": "D",
            "Ḑ": "D",
            "Ḓ": "D",
            "Ḏ": "D",
            "Đ": "D",
            "Ƌ": "D",
            "Ɗ": "D",
            "Ɖ": "D",
            "Ꝺ": "D",
            "Ǳ": "DZ",
            "Ǆ": "DZ",
            "ǲ": "Dz",
            "ǅ": "Dz",
            "Ⓔ": "E",
            "Ｅ": "E",
            "È": "E",
            "É": "E",
            "Ê": "E",
            "Ề": "E",
            "Ế": "E",
            "Ễ": "E",
            "Ể": "E",
            "Ẽ": "E",
            "Ē": "E",
            "Ḕ": "E",
            "Ḗ": "E",
            "Ĕ": "E",
            "Ė": "E",
            "Ë": "E",
            "Ẻ": "E",
            "Ě": "E",
            "Ȅ": "E",
            "Ȇ": "E",
            "Ẹ": "E",
            "Ệ": "E",
            "Ȩ": "E",
            "Ḝ": "E",
            "Ę": "E",
            "Ḙ": "E",
            "Ḛ": "E",
            "Ɛ": "E",
            "Ǝ": "E",
            "Ⓕ": "F",
            "Ｆ": "F",
            "Ḟ": "F",
            "Ƒ": "F",
            "Ꝼ": "F",
            "Ⓖ": "G",
            "Ｇ": "G",
            "Ǵ": "G",
            "Ĝ": "G",
            "Ḡ": "G",
            "Ğ": "G",
            "Ġ": "G",
            "Ǧ": "G",
            "Ģ": "G",
            "Ǥ": "G",
            "Ɠ": "G",
            "Ꞡ": "G",
            "Ᵹ": "G",
            "Ꝿ": "G",
            "Ⓗ": "H",
            "Ｈ": "H",
            "Ĥ": "H",
            "Ḣ": "H",
            "Ḧ": "H",
            "Ȟ": "H",
            "Ḥ": "H",
            "Ḩ": "H",
            "Ḫ": "H",
            "Ħ": "H",
            "Ⱨ": "H",
            "Ⱶ": "H",
            "Ɥ": "H",
            "Ⓘ": "I",
            "Ｉ": "I",
            "Ì": "I",
            "Í": "I",
            "Î": "I",
            "Ĩ": "I",
            "Ī": "I",
            "Ĭ": "I",
            "İ": "I",
            "Ï": "I",
            "Ḯ": "I",
            "Ỉ": "I",
            "Ǐ": "I",
            "Ȉ": "I",
            "Ȋ": "I",
            "Ị": "I",
            "Į": "I",
            "Ḭ": "I",
            "Ɨ": "I",
            "Ⓙ": "J",
            "Ｊ": "J",
            "Ĵ": "J",
            "Ɉ": "J",
            "Ⓚ": "K",
            "Ｋ": "K",
            "Ḱ": "K",
            "Ǩ": "K",
            "Ḳ": "K",
            "Ķ": "K",
            "Ḵ": "K",
            "Ƙ": "K",
            "Ⱪ": "K",
            "Ꝁ": "K",
            "Ꝃ": "K",
            "Ꝅ": "K",
            "Ꞣ": "K",
            "Ⓛ": "L",
            "Ｌ": "L",
            "Ŀ": "L",
            "Ĺ": "L",
            "Ľ": "L",
            "Ḷ": "L",
            "Ḹ": "L",
            "Ļ": "L",
            "Ḽ": "L",
            "Ḻ": "L",
            "Ł": "L",
            "Ƚ": "L",
            "Ɫ": "L",
            "Ⱡ": "L",
            "Ꝉ": "L",
            "Ꝇ": "L",
            "Ꞁ": "L",
            "Ǉ": "LJ",
            "ǈ": "Lj",
            "Ⓜ": "M",
            "Ｍ": "M",
            "Ḿ": "M",
            "Ṁ": "M",
            "Ṃ": "M",
            "Ɱ": "M",
            "Ɯ": "M",
            "Ⓝ": "N",
            "Ｎ": "N",
            "Ǹ": "N",
            "Ń": "N",
            "Ñ": "N",
            "Ṅ": "N",
            "Ň": "N",
            "Ṇ": "N",
            "Ņ": "N",
            "Ṋ": "N",
            "Ṉ": "N",
            "Ƞ": "N",
            "Ɲ": "N",
            "Ꞑ": "N",
            "Ꞥ": "N",
            "Ǌ": "NJ",
            "ǋ": "Nj",
            "Ⓞ": "O",
            "Ｏ": "O",
            "Ò": "O",
            "Ó": "O",
            "Ô": "O",
            "Ồ": "O",
            "Ố": "O",
            "Ỗ": "O",
            "Ổ": "O",
            "Õ": "O",
            "Ṍ": "O",
            "Ȭ": "O",
            "Ṏ": "O",
            "Ō": "O",
            "Ṑ": "O",
            "Ṓ": "O",
            "Ŏ": "O",
            "Ȯ": "O",
            "Ȱ": "O",
            "Ö": "O",
            "Ȫ": "O",
            "Ỏ": "O",
            "Ő": "O",
            "Ǒ": "O",
            "Ȍ": "O",
            "Ȏ": "O",
            "Ơ": "O",
            "Ờ": "O",
            "Ớ": "O",
            "Ỡ": "O",
            "Ở": "O",
            "Ợ": "O",
            "Ọ": "O",
            "Ộ": "O",
            "Ǫ": "O",
            "Ǭ": "O",
            "Ø": "O",
            "Ǿ": "O",
            "Ɔ": "O",
            "Ɵ": "O",
            "Ꝋ": "O",
            "Ꝍ": "O",
            "Œ": "OE",
            "Ƣ": "OI",
            "Ꝏ": "OO",
            "Ȣ": "OU",
            "Ⓟ": "P",
            "Ｐ": "P",
            "Ṕ": "P",
            "Ṗ": "P",
            "Ƥ": "P",
            "Ᵽ": "P",
            "Ꝑ": "P",
            "Ꝓ": "P",
            "Ꝕ": "P",
            "Ⓠ": "Q",
            "Ｑ": "Q",
            "Ꝗ": "Q",
            "Ꝙ": "Q",
            "Ɋ": "Q",
            "Ⓡ": "R",
            "Ｒ": "R",
            "Ŕ": "R",
            "Ṙ": "R",
            "Ř": "R",
            "Ȑ": "R",
            "Ȓ": "R",
            "Ṛ": "R",
            "Ṝ": "R",
            "Ŗ": "R",
            "Ṟ": "R",
            "Ɍ": "R",
            "Ɽ": "R",
            "Ꝛ": "R",
            "Ꞧ": "R",
            "Ꞃ": "R",
            "Ⓢ": "S",
            "Ｓ": "S",
            "ẞ": "S",
            "Ś": "S",
            "Ṥ": "S",
            "Ŝ": "S",
            "Ṡ": "S",
            "Š": "S",
            "Ṧ": "S",
            "Ṣ": "S",
            "Ṩ": "S",
            "Ș": "S",
            "Ş": "S",
            "Ȿ": "S",
            "Ꞩ": "S",
            "Ꞅ": "S",
            "Ⓣ": "T",
            "Ｔ": "T",
            "Ṫ": "T",
            "Ť": "T",
            "Ṭ": "T",
            "Ț": "T",
            "Ţ": "T",
            "Ṱ": "T",
            "Ṯ": "T",
            "Ŧ": "T",
            "Ƭ": "T",
            "Ʈ": "T",
            "Ⱦ": "T",
            "Ꞇ": "T",
            "Ꜩ": "TZ",
            "Ⓤ": "U",
            "Ｕ": "U",
            "Ù": "U",
            "Ú": "U",
            "Û": "U",
            "Ũ": "U",
            "Ṹ": "U",
            "Ū": "U",
            "Ṻ": "U",
            "Ŭ": "U",
            "Ü": "U",
            "Ǜ": "U",
            "Ǘ": "U",
            "Ǖ": "U",
            "Ǚ": "U",
            "Ủ": "U",
            "Ů": "U",
            "Ű": "U",
            "Ǔ": "U",
            "Ȕ": "U",
            "Ȗ": "U",
            "Ư": "U",
            "Ừ": "U",
            "Ứ": "U",
            "Ữ": "U",
            "Ử": "U",
            "Ự": "U",
            "Ụ": "U",
            "Ṳ": "U",
            "Ų": "U",
            "Ṷ": "U",
            "Ṵ": "U",
            "Ʉ": "U",
            "Ⓥ": "V",
            "Ｖ": "V",
            "Ṽ": "V",
            "Ṿ": "V",
            "Ʋ": "V",
            "Ꝟ": "V",
            "Ʌ": "V",
            "Ꝡ": "VY",
            "Ⓦ": "W",
            "Ｗ": "W",
            "Ẁ": "W",
            "Ẃ": "W",
            "Ŵ": "W",
            "Ẇ": "W",
            "Ẅ": "W",
            "Ẉ": "W",
            "Ⱳ": "W",
            "Ⓧ": "X",
            "Ｘ": "X",
            "Ẋ": "X",
            "Ẍ": "X",
            "Ⓨ": "Y",
            "Ｙ": "Y",
            "Ỳ": "Y",
            "Ý": "Y",
            "Ŷ": "Y",
            "Ỹ": "Y",
            "Ȳ": "Y",
            "Ẏ": "Y",
            "Ÿ": "Y",
            "Ỷ": "Y",
            "Ỵ": "Y",
            "Ƴ": "Y",
            "Ɏ": "Y",
            "Ỿ": "Y",
            "Ⓩ": "Z",
            "Ｚ": "Z",
            "Ź": "Z",
            "Ẑ": "Z",
            "Ż": "Z",
            "Ž": "Z",
            "Ẓ": "Z",
            "Ẕ": "Z",
            "Ƶ": "Z",
            "Ȥ": "Z",
            "Ɀ": "Z",
            "Ⱬ": "Z",
            "Ꝣ": "Z",
            "ⓐ": "a",
            "ａ": "a",
            "ẚ": "a",
            "à": "a",
            "á": "a",
            "â": "a",
            "ầ": "a",
            "ấ": "a",
            "ẫ": "a",
            "ẩ": "a",
            "ã": "a",
            "ā": "a",
            "ă": "a",
            "ằ": "a",
            "ắ": "a",
            "ẵ": "a",
            "ẳ": "a",
            "ȧ": "a",
            "ǡ": "a",
            "ä": "a",
            "ǟ": "a",
            "ả": "a",
            "å": "a",
            "ǻ": "a",
            "ǎ": "a",
            "ȁ": "a",
            "ȃ": "a",
            "ạ": "a",
            "ậ": "a",
            "ặ": "a",
            "ḁ": "a",
            "ą": "a",
            "ⱥ": "a",
            "ɐ": "a",
            "ꜳ": "aa",
            "æ": "ae",
            "ǽ": "ae",
            "ǣ": "ae",
            "ꜵ": "ao",
            "ꜷ": "au",
            "ꜹ": "av",
            "ꜻ": "av",
            "ꜽ": "ay",
            "ⓑ": "b",
            "ｂ": "b",
            "ḃ": "b",
            "ḅ": "b",
            "ḇ": "b",
            "ƀ": "b",
            "ƃ": "b",
            "ɓ": "b",
            "ⓒ": "c",
            "ｃ": "c",
            "ć": "c",
            "ĉ": "c",
            "ċ": "c",
            "č": "c",
            "ç": "c",
            "ḉ": "c",
            "ƈ": "c",
            "ȼ": "c",
            "ꜿ": "c",
            "ↄ": "c",
            "ⓓ": "d",
            "ｄ": "d",
            "ḋ": "d",
            "ď": "d",
            "ḍ": "d",
            "ḑ": "d",
            "ḓ": "d",
            "ḏ": "d",
            "đ": "d",
            "ƌ": "d",
            "ɖ": "d",
            "ɗ": "d",
            "ꝺ": "d",
            "ǳ": "dz",
            "ǆ": "dz",
            "ⓔ": "e",
            "ｅ": "e",
            "è": "e",
            "é": "e",
            "ê": "e",
            "ề": "e",
            "ế": "e",
            "ễ": "e",
            "ể": "e",
            "ẽ": "e",
            "ē": "e",
            "ḕ": "e",
            "ḗ": "e",
            "ĕ": "e",
            "ė": "e",
            "ë": "e",
            "ẻ": "e",
            "ě": "e",
            "ȅ": "e",
            "ȇ": "e",
            "ẹ": "e",
            "ệ": "e",
            "ȩ": "e",
            "ḝ": "e",
            "ę": "e",
            "ḙ": "e",
            "ḛ": "e",
            "ɇ": "e",
            "ɛ": "e",
            "ǝ": "e",
            "ⓕ": "f",
            "ｆ": "f",
            "ḟ": "f",
            "ƒ": "f",
            "ꝼ": "f",
            "ⓖ": "g",
            "ｇ": "g",
            "ǵ": "g",
            "ĝ": "g",
            "ḡ": "g",
            "ğ": "g",
            "ġ": "g",
            "ǧ": "g",
            "ģ": "g",
            "ǥ": "g",
            "ɠ": "g",
            "ꞡ": "g",
            "ᵹ": "g",
            "ꝿ": "g",
            "ⓗ": "h",
            "ｈ": "h",
            "ĥ": "h",
            "ḣ": "h",
            "ḧ": "h",
            "ȟ": "h",
            "ḥ": "h",
            "ḩ": "h",
            "ḫ": "h",
            "ẖ": "h",
            "ħ": "h",
            "ⱨ": "h",
            "ⱶ": "h",
            "ɥ": "h",
            "ƕ": "hv",
            "ⓘ": "i",
            "ｉ": "i",
            "ì": "i",
            "í": "i",
            "î": "i",
            "ĩ": "i",
            "ī": "i",
            "ĭ": "i",
            "ï": "i",
            "ḯ": "i",
            "ỉ": "i",
            "ǐ": "i",
            "ȉ": "i",
            "ȋ": "i",
            "ị": "i",
            "į": "i",
            "ḭ": "i",
            "ɨ": "i",
            "ı": "i",
            "ⓙ": "j",
            "ｊ": "j",
            "ĵ": "j",
            "ǰ": "j",
            "ɉ": "j",
            "ⓚ": "k",
            "ｋ": "k",
            "ḱ": "k",
            "ǩ": "k",
            "ḳ": "k",
            "ķ": "k",
            "ḵ": "k",
            "ƙ": "k",
            "ⱪ": "k",
            "ꝁ": "k",
            "ꝃ": "k",
            "ꝅ": "k",
            "ꞣ": "k",
            "ⓛ": "l",
            "ｌ": "l",
            "ŀ": "l",
            "ĺ": "l",
            "ľ": "l",
            "ḷ": "l",
            "ḹ": "l",
            "ļ": "l",
            "ḽ": "l",
            "ḻ": "l",
            "ſ": "l",
            "ł": "l",
            "ƚ": "l",
            "ɫ": "l",
            "ⱡ": "l",
            "ꝉ": "l",
            "ꞁ": "l",
            "ꝇ": "l",
            "ǉ": "lj",
            "ⓜ": "m",
            "ｍ": "m",
            "ḿ": "m",
            "ṁ": "m",
            "ṃ": "m",
            "ɱ": "m",
            "ɯ": "m",
            "ⓝ": "n",
            "ｎ": "n",
            "ǹ": "n",
            "ń": "n",
            "ñ": "n",
            "ṅ": "n",
            "ň": "n",
            "ṇ": "n",
            "ņ": "n",
            "ṋ": "n",
            "ṉ": "n",
            "ƞ": "n",
            "ɲ": "n",
            "ŉ": "n",
            "ꞑ": "n",
            "ꞥ": "n",
            "ǌ": "nj",
            "ⓞ": "o",
            "ｏ": "o",
            "ò": "o",
            "ó": "o",
            "ô": "o",
            "ồ": "o",
            "ố": "o",
            "ỗ": "o",
            "ổ": "o",
            "õ": "o",
            "ṍ": "o",
            "ȭ": "o",
            "ṏ": "o",
            "ō": "o",
            "ṑ": "o",
            "ṓ": "o",
            "ŏ": "o",
            "ȯ": "o",
            "ȱ": "o",
            "ö": "o",
            "ȫ": "o",
            "ỏ": "o",
            "ő": "o",
            "ǒ": "o",
            "ȍ": "o",
            "ȏ": "o",
            "ơ": "o",
            "ờ": "o",
            "ớ": "o",
            "ỡ": "o",
            "ở": "o",
            "ợ": "o",
            "ọ": "o",
            "ộ": "o",
            "ǫ": "o",
            "ǭ": "o",
            "ø": "o",
            "ǿ": "o",
            "ɔ": "o",
            "ꝋ": "o",
            "ꝍ": "o",
            "ɵ": "o",
            "œ": "oe",
            "ƣ": "oi",
            "ȣ": "ou",
            "ꝏ": "oo",
            "ⓟ": "p",
            "ｐ": "p",
            "ṕ": "p",
            "ṗ": "p",
            "ƥ": "p",
            "ᵽ": "p",
            "ꝑ": "p",
            "ꝓ": "p",
            "ꝕ": "p",
            "ⓠ": "q",
            "ｑ": "q",
            "ɋ": "q",
            "ꝗ": "q",
            "ꝙ": "q",
            "ⓡ": "r",
            "ｒ": "r",
            "ŕ": "r",
            "ṙ": "r",
            "ř": "r",
            "ȑ": "r",
            "ȓ": "r",
            "ṛ": "r",
            "ṝ": "r",
            "ŗ": "r",
            "ṟ": "r",
            "ɍ": "r",
            "ɽ": "r",
            "ꝛ": "r",
            "ꞧ": "r",
            "ꞃ": "r",
            "ⓢ": "s",
            "ｓ": "s",
            "ß": "s",
            "ś": "s",
            "ṥ": "s",
            "ŝ": "s",
            "ṡ": "s",
            "š": "s",
            "ṧ": "s",
            "ṣ": "s",
            "ṩ": "s",
            "ș": "s",
            "ş": "s",
            "ȿ": "s",
            "ꞩ": "s",
            "ꞅ": "s",
            "ẛ": "s",
            "ⓣ": "t",
            "ｔ": "t",
            "ṫ": "t",
            "ẗ": "t",
            "ť": "t",
            "ṭ": "t",
            "ț": "t",
            "ţ": "t",
            "ṱ": "t",
            "ṯ": "t",
            "ŧ": "t",
            "ƭ": "t",
            "ʈ": "t",
            "ⱦ": "t",
            "ꞇ": "t",
            "ꜩ": "tz",
            "ⓤ": "u",
            "ｕ": "u",
            "ù": "u",
            "ú": "u",
            "û": "u",
            "ũ": "u",
            "ṹ": "u",
            "ū": "u",
            "ṻ": "u",
            "ŭ": "u",
            "ü": "u",
            "ǜ": "u",
            "ǘ": "u",
            "ǖ": "u",
            "ǚ": "u",
            "ủ": "u",
            "ů": "u",
            "ű": "u",
            "ǔ": "u",
            "ȕ": "u",
            "ȗ": "u",
            "ư": "u",
            "ừ": "u",
            "ứ": "u",
            "ữ": "u",
            "ử": "u",
            "ự": "u",
            "ụ": "u",
            "ṳ": "u",
            "ų": "u",
            "ṷ": "u",
            "ṵ": "u",
            "ʉ": "u",
            "ⓥ": "v",
            "ｖ": "v",
            "ṽ": "v",
            "ṿ": "v",
            "ʋ": "v",
            "ꝟ": "v",
            "ʌ": "v",
            "ꝡ": "vy",
            "ⓦ": "w",
            "ｗ": "w",
            "ẁ": "w",
            "ẃ": "w",
            "ŵ": "w",
            "ẇ": "w",
            "ẅ": "w",
            "ẘ": "w",
            "ẉ": "w",
            "ⱳ": "w",
            "ⓧ": "x",
            "ｘ": "x",
            "ẋ": "x",
            "ẍ": "x",
            "ⓨ": "y",
            "ｙ": "y",
            "ỳ": "y",
            "ý": "y",
            "ŷ": "y",
            "ỹ": "y",
            "ȳ": "y",
            "ẏ": "y",
            "ÿ": "y",
            "ỷ": "y",
            "ẙ": "y",
            "ỵ": "y",
            "ƴ": "y",
            "ɏ": "y",
            "ỿ": "y",
            "ⓩ": "z",
            "ｚ": "z",
            "ź": "z",
            "ẑ": "z",
            "ż": "z",
            "ž": "z",
            "ẓ": "z",
            "ẕ": "z",
            "ƶ": "z",
            "ȥ": "z",
            "ɀ": "z",
            "ⱬ": "z",
            "ꝣ": "z",
            "Ά": "Α",
            "Έ": "Ε",
            "Ή": "Η",
            "Ί": "Ι",
            "Ϊ": "Ι",
            "Ό": "Ο",
            "Ύ": "Υ",
            "Ϋ": "Υ",
            "Ώ": "Ω",
            "ά": "α",
            "έ": "ε",
            "ή": "η",
            "ί": "ι",
            "ϊ": "ι",
            "ΐ": "ι",
            "ό": "ο",
            "ύ": "υ",
            "ϋ": "υ",
            "ΰ": "υ",
            "ώ": "ω",
            "ς": "σ",
            "’": "'"
          };
          return diacritics;
        });
        S22.define("select2/data/base", [
          "../utils"
        ], function(Utils) {
          function BaseAdapter($element, options) {
            BaseAdapter.__super__.constructor.call(this);
          }
          Utils.Extend(BaseAdapter, Utils.Observable);
          BaseAdapter.prototype.current = function(callback) {
            throw new Error("The `current` method must be defined in child classes.");
          };
          BaseAdapter.prototype.query = function(params, callback) {
            throw new Error("The `query` method must be defined in child classes.");
          };
          BaseAdapter.prototype.bind = function(container, $container) {
          };
          BaseAdapter.prototype.destroy = function() {
          };
          BaseAdapter.prototype.generateResultId = function(container, data) {
            var id = container.id + "-result-";
            id += Utils.generateChars(4);
            if (data.id != null) {
              id += "-" + data.id.toString();
            } else {
              id += "-" + Utils.generateChars(4);
            }
            return id;
          };
          return BaseAdapter;
        });
        S22.define("select2/data/select", [
          "./base",
          "../utils",
          "jquery"
        ], function(BaseAdapter, Utils, $2) {
          function SelectAdapter($element, options) {
            this.$element = $element;
            this.options = options;
            SelectAdapter.__super__.constructor.call(this);
          }
          Utils.Extend(SelectAdapter, BaseAdapter);
          SelectAdapter.prototype.current = function(callback) {
            var self2 = this;
            var data = Array.prototype.map.call(
              this.$element[0].querySelectorAll(":checked"),
              function(selectedElement) {
                return self2.item($2(selectedElement));
              }
            );
            callback(data);
          };
          SelectAdapter.prototype.select = function(data) {
            var self2 = this;
            data.selected = true;
            if (data.element != null && data.element.tagName.toLowerCase() === "option") {
              data.element.selected = true;
              this.$element.trigger("input").trigger("change");
              return;
            }
            if (this.$element.prop("multiple")) {
              this.current(function(currentData) {
                var val2 = [];
                data = [data];
                data.push.apply(data, currentData);
                for (var d = 0; d < data.length; d++) {
                  var id = data[d].id;
                  if (val2.indexOf(id) === -1) {
                    val2.push(id);
                  }
                }
                self2.$element.val(val2);
                self2.$element.trigger("input").trigger("change");
              });
            } else {
              var val = data.id;
              this.$element.val(val);
              this.$element.trigger("input").trigger("change");
            }
          };
          SelectAdapter.prototype.unselect = function(data) {
            var self2 = this;
            if (!this.$element.prop("multiple")) {
              return;
            }
            data.selected = false;
            if (data.element != null && data.element.tagName.toLowerCase() === "option") {
              data.element.selected = false;
              this.$element.trigger("input").trigger("change");
              return;
            }
            this.current(function(currentData) {
              var val = [];
              for (var d = 0; d < currentData.length; d++) {
                var id = currentData[d].id;
                if (id !== data.id && val.indexOf(id) === -1) {
                  val.push(id);
                }
              }
              self2.$element.val(val);
              self2.$element.trigger("input").trigger("change");
            });
          };
          SelectAdapter.prototype.bind = function(container, $container) {
            var self2 = this;
            this.container = container;
            container.on("select", function(params) {
              self2.select(params.data);
            });
            container.on("unselect", function(params) {
              self2.unselect(params.data);
            });
          };
          SelectAdapter.prototype.destroy = function() {
            this.$element.find("*").each(function() {
              Utils.RemoveData(this);
            });
          };
          SelectAdapter.prototype.query = function(params, callback) {
            var data = [];
            var self2 = this;
            var $options = this.$element.children();
            $options.each(function() {
              if (this.tagName.toLowerCase() !== "option" && this.tagName.toLowerCase() !== "optgroup") {
                return;
              }
              var $option = $2(this);
              var option = self2.item($option);
              var matches = self2.matches(params, option);
              if (matches !== null) {
                data.push(matches);
              }
            });
            callback({
              results: data
            });
          };
          SelectAdapter.prototype.addOptions = function($options) {
            this.$element.append($options);
          };
          SelectAdapter.prototype.option = function(data) {
            var option;
            if (data.children) {
              option = document.createElement("optgroup");
              option.label = data.text;
            } else {
              option = document.createElement("option");
              if (option.textContent !== void 0) {
                option.textContent = data.text;
              } else {
                option.innerText = data.text;
              }
            }
            if (data.id !== void 0) {
              option.value = data.id;
            }
            if (data.disabled) {
              option.disabled = true;
            }
            if (data.selected) {
              option.selected = true;
            }
            if (data.title) {
              option.title = data.title;
            }
            var normalizedData = this._normalizeItem(data);
            normalizedData.element = option;
            Utils.StoreData(option, "data", normalizedData);
            return $2(option);
          };
          SelectAdapter.prototype.item = function($option) {
            var data = {};
            data = Utils.GetData($option[0], "data");
            if (data != null) {
              return data;
            }
            var option = $option[0];
            if (option.tagName.toLowerCase() === "option") {
              data = {
                id: $option.val(),
                text: $option.text(),
                disabled: $option.prop("disabled"),
                selected: $option.prop("selected"),
                title: $option.prop("title")
              };
            } else if (option.tagName.toLowerCase() === "optgroup") {
              data = {
                text: $option.prop("label"),
                children: [],
                title: $option.prop("title")
              };
              var $children = $option.children("option");
              var children = [];
              for (var c = 0; c < $children.length; c++) {
                var $child = $2($children[c]);
                var child = this.item($child);
                children.push(child);
              }
              data.children = children;
            }
            data = this._normalizeItem(data);
            data.element = $option[0];
            Utils.StoreData($option[0], "data", data);
            return data;
          };
          SelectAdapter.prototype._normalizeItem = function(item) {
            if (item !== Object(item)) {
              item = {
                id: item,
                text: item
              };
            }
            item = $2.extend({}, {
              text: ""
            }, item);
            var defaults = {
              selected: false,
              disabled: false
            };
            if (item.id != null) {
              item.id = item.id.toString();
            }
            if (item.text != null) {
              item.text = item.text.toString();
            }
            if (item._resultId == null && item.id && this.container != null) {
              item._resultId = this.generateResultId(this.container, item);
            }
            return $2.extend({}, defaults, item);
          };
          SelectAdapter.prototype.matches = function(params, data) {
            var matcher = this.options.get("matcher");
            return matcher(params, data);
          };
          return SelectAdapter;
        });
        S22.define("select2/data/array", [
          "./select",
          "../utils",
          "jquery"
        ], function(SelectAdapter, Utils, $2) {
          function ArrayAdapter($element, options) {
            this._dataToConvert = options.get("data") || [];
            ArrayAdapter.__super__.constructor.call(this, $element, options);
          }
          Utils.Extend(ArrayAdapter, SelectAdapter);
          ArrayAdapter.prototype.bind = function(container, $container) {
            ArrayAdapter.__super__.bind.call(this, container, $container);
            this.addOptions(this.convertToOptions(this._dataToConvert));
          };
          ArrayAdapter.prototype.select = function(data) {
            var $option = this.$element.find("option").filter(function(i, elm) {
              return elm.value == data.id.toString();
            });
            if ($option.length === 0) {
              $option = this.option(data);
              this.addOptions($option);
            }
            ArrayAdapter.__super__.select.call(this, data);
          };
          ArrayAdapter.prototype.convertToOptions = function(data) {
            var self2 = this;
            var $existing = this.$element.find("option");
            var existingIds = $existing.map(function() {
              return self2.item($2(this)).id;
            }).get();
            var $options = [];
            function onlyItem(item2) {
              return function() {
                return $2(this).val() == item2.id;
              };
            }
            for (var d = 0; d < data.length; d++) {
              var item = this._normalizeItem(data[d]);
              if (existingIds.indexOf(item.id) >= 0) {
                var $existingOption = $existing.filter(onlyItem(item));
                var existingData = this.item($existingOption);
                var newData = $2.extend(true, {}, item, existingData);
                var $newOption = this.option(newData);
                $existingOption.replaceWith($newOption);
                continue;
              }
              var $option = this.option(item);
              if (item.children) {
                var $children = this.convertToOptions(item.children);
                $option.append($children);
              }
              $options.push($option);
            }
            return $options;
          };
          return ArrayAdapter;
        });
        S22.define("select2/data/ajax", [
          "./array",
          "../utils",
          "jquery"
        ], function(ArrayAdapter, Utils, $2) {
          function AjaxAdapter($element, options) {
            this.ajaxOptions = this._applyDefaults(options.get("ajax"));
            if (this.ajaxOptions.processResults != null) {
              this.processResults = this.ajaxOptions.processResults;
            }
            AjaxAdapter.__super__.constructor.call(this, $element, options);
          }
          Utils.Extend(AjaxAdapter, ArrayAdapter);
          AjaxAdapter.prototype._applyDefaults = function(options) {
            var defaults = {
              data: function(params) {
                return $2.extend({}, params, {
                  q: params.term
                });
              },
              transport: function(params, success, failure) {
                var $request = $2.ajax(params);
                $request.then(success);
                $request.fail(failure);
                return $request;
              }
            };
            return $2.extend({}, defaults, options, true);
          };
          AjaxAdapter.prototype.processResults = function(results) {
            return results;
          };
          AjaxAdapter.prototype.query = function(params, callback) {
            var self2 = this;
            if (this._request != null) {
              if (typeof this._request.abort === "function") {
                this._request.abort();
              }
              this._request = null;
            }
            var options = $2.extend({
              type: "GET"
            }, this.ajaxOptions);
            if (typeof options.url === "function") {
              options.url = options.url.call(this.$element, params);
            }
            if (typeof options.data === "function") {
              options.data = options.data.call(this.$element, params);
            }
            function request() {
              var $request = options.transport(options, function(data) {
                var results = self2.processResults(data, params);
                if (self2.options.get("debug") && window.console && console.error) {
                  if (!results || !results.results || !Array.isArray(results.results)) {
                    console.error(
                      "Select2: The AJAX results did not return an array in the `results` key of the response."
                    );
                  }
                }
                callback(results);
              }, function() {
                if ("status" in $request && ($request.status === 0 || $request.status === "0")) {
                  return;
                }
                self2.trigger("results:message", {
                  message: "errorLoading"
                });
              });
              self2._request = $request;
            }
            if (this.ajaxOptions.delay && params.term != null) {
              if (this._queryTimeout) {
                window.clearTimeout(this._queryTimeout);
              }
              this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
            } else {
              request();
            }
          };
          return AjaxAdapter;
        });
        S22.define("select2/data/tags", [
          "jquery"
        ], function($2) {
          function Tags(decorated, $element, options) {
            var tags = options.get("tags");
            var createTag = options.get("createTag");
            if (createTag !== void 0) {
              this.createTag = createTag;
            }
            var insertTag = options.get("insertTag");
            if (insertTag !== void 0) {
              this.insertTag = insertTag;
            }
            decorated.call(this, $element, options);
            if (Array.isArray(tags)) {
              for (var t = 0; t < tags.length; t++) {
                var tag = tags[t];
                var item = this._normalizeItem(tag);
                var $option = this.option(item);
                this.$element.append($option);
              }
            }
          }
          Tags.prototype.query = function(decorated, params, callback) {
            var self2 = this;
            this._removeOldTags();
            if (params.term == null || params.page != null) {
              decorated.call(this, params, callback);
              return;
            }
            function wrapper(obj, child) {
              var data = obj.results;
              for (var i = 0; i < data.length; i++) {
                var option = data[i];
                var checkChildren = option.children != null && !wrapper({
                  results: option.children
                }, true);
                var optionText = (option.text || "").toUpperCase();
                var paramsTerm = (params.term || "").toUpperCase();
                var checkText = optionText === paramsTerm;
                if (checkText || checkChildren) {
                  if (child) {
                    return false;
                  }
                  obj.data = data;
                  callback(obj);
                  return;
                }
              }
              if (child) {
                return true;
              }
              var tag = self2.createTag(params);
              if (tag != null) {
                var $option = self2.option(tag);
                $option.attr("data-select2-tag", "true");
                self2.addOptions([$option]);
                self2.insertTag(data, tag);
              }
              obj.results = data;
              callback(obj);
            }
            decorated.call(this, params, wrapper);
          };
          Tags.prototype.createTag = function(decorated, params) {
            if (params.term == null) {
              return null;
            }
            var term = params.term.trim();
            if (term === "") {
              return null;
            }
            return {
              id: term,
              text: term
            };
          };
          Tags.prototype.insertTag = function(_, data, tag) {
            data.unshift(tag);
          };
          Tags.prototype._removeOldTags = function(_) {
            var $options = this.$element.find("option[data-select2-tag]");
            $options.each(function() {
              if (this.selected) {
                return;
              }
              $2(this).remove();
            });
          };
          return Tags;
        });
        S22.define("select2/data/tokenizer", [
          "jquery"
        ], function($2) {
          function Tokenizer(decorated, $element, options) {
            var tokenizer = options.get("tokenizer");
            if (tokenizer !== void 0) {
              this.tokenizer = tokenizer;
            }
            decorated.call(this, $element, options);
          }
          Tokenizer.prototype.bind = function(decorated, container, $container) {
            decorated.call(this, container, $container);
            this.$search = container.dropdown.$search || container.selection.$search || $container.find(".select2-search__field");
          };
          Tokenizer.prototype.query = function(decorated, params, callback) {
            var self2 = this;
            function createAndSelect(data) {
              var item = self2._normalizeItem(data);
              var $existingOptions = self2.$element.find("option").filter(function() {
                return $2(this).val() === item.id;
              });
              if (!$existingOptions.length) {
                var $option = self2.option(item);
                $option.attr("data-select2-tag", true);
                self2._removeOldTags();
                self2.addOptions([$option]);
              }
              select(item);
            }
            function select(data) {
              self2.trigger("select", {
                data
              });
            }
            params.term = params.term || "";
            var tokenData = this.tokenizer(params, this.options, createAndSelect);
            if (tokenData.term !== params.term) {
              if (this.$search.length) {
                this.$search.val(tokenData.term);
                this.$search.trigger("focus");
              }
              params.term = tokenData.term;
            }
            decorated.call(this, params, callback);
          };
          Tokenizer.prototype.tokenizer = function(_, params, options, callback) {
            var separators = options.get("tokenSeparators") || [];
            var term = params.term;
            var i = 0;
            var createTag = this.createTag || function(params2) {
              return {
                id: params2.term,
                text: params2.term
              };
            };
            while (i < term.length) {
              var termChar = term[i];
              if (separators.indexOf(termChar) === -1) {
                i++;
                continue;
              }
              var part = term.substr(0, i);
              var partParams = $2.extend({}, params, {
                term: part
              });
              var data = createTag(partParams);
              if (data == null) {
                i++;
                continue;
              }
              callback(data);
              term = term.substr(i + 1) || "";
              i = 0;
            }
            return {
              term
            };
          };
          return Tokenizer;
        });
        S22.define("select2/data/minimumInputLength", [], function() {
          function MinimumInputLength(decorated, $e, options) {
            this.minimumInputLength = options.get("minimumInputLength");
            decorated.call(this, $e, options);
          }
          MinimumInputLength.prototype.query = function(decorated, params, callback) {
            params.term = params.term || "";
            if (params.term.length < this.minimumInputLength) {
              this.trigger("results:message", {
                message: "inputTooShort",
                args: {
                  minimum: this.minimumInputLength,
                  input: params.term,
                  params
                }
              });
              return;
            }
            decorated.call(this, params, callback);
          };
          return MinimumInputLength;
        });
        S22.define("select2/data/maximumInputLength", [], function() {
          function MaximumInputLength(decorated, $e, options) {
            this.maximumInputLength = options.get("maximumInputLength");
            decorated.call(this, $e, options);
          }
          MaximumInputLength.prototype.query = function(decorated, params, callback) {
            params.term = params.term || "";
            if (this.maximumInputLength > 0 && params.term.length > this.maximumInputLength) {
              this.trigger("results:message", {
                message: "inputTooLong",
                args: {
                  maximum: this.maximumInputLength,
                  input: params.term,
                  params
                }
              });
              return;
            }
            decorated.call(this, params, callback);
          };
          return MaximumInputLength;
        });
        S22.define("select2/data/maximumSelectionLength", [], function() {
          function MaximumSelectionLength(decorated, $e, options) {
            this.maximumSelectionLength = options.get("maximumSelectionLength");
            decorated.call(this, $e, options);
          }
          MaximumSelectionLength.prototype.bind = function(decorated, container, $container) {
            var self2 = this;
            decorated.call(this, container, $container);
            container.on("select", function() {
              self2._checkIfMaximumSelected();
            });
          };
          MaximumSelectionLength.prototype.query = function(decorated, params, callback) {
            var self2 = this;
            this._checkIfMaximumSelected(function() {
              decorated.call(self2, params, callback);
            });
          };
          MaximumSelectionLength.prototype._checkIfMaximumSelected = function(_, successCallback) {
            var self2 = this;
            this.current(function(currentData) {
              var count = currentData != null ? currentData.length : 0;
              if (self2.maximumSelectionLength > 0 && count >= self2.maximumSelectionLength) {
                self2.trigger("results:message", {
                  message: "maximumSelected",
                  args: {
                    maximum: self2.maximumSelectionLength
                  }
                });
                return;
              }
              if (successCallback) {
                successCallback();
              }
            });
          };
          return MaximumSelectionLength;
        });
        S22.define("select2/dropdown", [
          "jquery",
          "./utils"
        ], function($2, Utils) {
          function Dropdown($element, options) {
            this.$element = $element;
            this.options = options;
            Dropdown.__super__.constructor.call(this);
          }
          Utils.Extend(Dropdown, Utils.Observable);
          Dropdown.prototype.render = function() {
            var $dropdown = $2(
              '<span class="select2-dropdown"><span class="select2-results"></span></span>'
            );
            $dropdown.attr("dir", this.options.get("dir"));
            this.$dropdown = $dropdown;
            return $dropdown;
          };
          Dropdown.prototype.bind = function() {
          };
          Dropdown.prototype.position = function($dropdown, $container) {
          };
          Dropdown.prototype.destroy = function() {
            this.$dropdown.remove();
          };
          return Dropdown;
        });
        S22.define("select2/dropdown/search", [
          "jquery"
        ], function($2) {
          function Search() {
          }
          Search.prototype.render = function(decorated) {
            var $rendered = decorated.call(this);
            var searchLabel = this.options.get("translations").get("search");
            var $search = $2(
              '<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>'
            );
            this.$searchContainer = $search;
            this.$search = $search.find("input");
            this.$search.prop("autocomplete", this.options.get("autocomplete"));
            this.$search.attr("aria-label", searchLabel());
            $rendered.prepend($search);
            return $rendered;
          };
          Search.prototype.bind = function(decorated, container, $container) {
            var self2 = this;
            var resultsId = container.id + "-results";
            decorated.call(this, container, $container);
            this.$search.on("keydown", function(evt) {
              self2.trigger("keypress", evt);
              self2._keyUpPrevented = evt.isDefaultPrevented();
            });
            this.$search.on("input", function(evt) {
              $2(this).off("keyup");
            });
            this.$search.on("keyup input", function(evt) {
              self2.handleSearch(evt);
            });
            container.on("open", function() {
              self2.$search.attr("tabindex", 0);
              self2.$search.attr("aria-controls", resultsId);
              self2.$search.trigger("focus");
              window.setTimeout(function() {
                self2.$search.trigger("focus");
              }, 0);
            });
            container.on("close", function() {
              self2.$search.attr("tabindex", -1);
              self2.$search.removeAttr("aria-controls");
              self2.$search.removeAttr("aria-activedescendant");
              self2.$search.val("");
              self2.$search.trigger("blur");
            });
            container.on("focus", function() {
              if (!container.isOpen()) {
                self2.$search.trigger("focus");
              }
            });
            container.on("results:all", function(params) {
              if (params.query.term == null || params.query.term === "") {
                var showSearch = self2.showSearch(params);
                if (showSearch) {
                  self2.$searchContainer[0].classList.remove("select2-search--hide");
                } else {
                  self2.$searchContainer[0].classList.add("select2-search--hide");
                }
              }
            });
            container.on("results:focus", function(params) {
              if (params.data._resultId) {
                self2.$search.attr("aria-activedescendant", params.data._resultId);
              } else {
                self2.$search.removeAttr("aria-activedescendant");
              }
            });
          };
          Search.prototype.handleSearch = function(evt) {
            if (!this._keyUpPrevented) {
              var input = this.$search.val();
              this.trigger("query", {
                term: input
              });
            }
            this._keyUpPrevented = false;
          };
          Search.prototype.showSearch = function(_, params) {
            return true;
          };
          return Search;
        });
        S22.define("select2/dropdown/hidePlaceholder", [], function() {
          function HidePlaceholder(decorated, $element, options, dataAdapter) {
            this.placeholder = this.normalizePlaceholder(options.get("placeholder"));
            decorated.call(this, $element, options, dataAdapter);
          }
          HidePlaceholder.prototype.append = function(decorated, data) {
            data.results = this.removePlaceholder(data.results);
            decorated.call(this, data);
          };
          HidePlaceholder.prototype.normalizePlaceholder = function(_, placeholder) {
            if (typeof placeholder === "string") {
              placeholder = {
                id: "",
                text: placeholder
              };
            }
            return placeholder;
          };
          HidePlaceholder.prototype.removePlaceholder = function(_, data) {
            var modifiedData = data.slice(0);
            for (var d = data.length - 1; d >= 0; d--) {
              var item = data[d];
              if (this.placeholder.id === item.id) {
                modifiedData.splice(d, 1);
              }
            }
            return modifiedData;
          };
          return HidePlaceholder;
        });
        S22.define("select2/dropdown/infiniteScroll", [
          "jquery"
        ], function($2) {
          function InfiniteScroll(decorated, $element, options, dataAdapter) {
            this.lastParams = {};
            decorated.call(this, $element, options, dataAdapter);
            this.$loadingMore = this.createLoadingMore();
            this.loading = false;
          }
          InfiniteScroll.prototype.append = function(decorated, data) {
            this.$loadingMore.remove();
            this.loading = false;
            decorated.call(this, data);
            if (this.showLoadingMore(data)) {
              this.$results.append(this.$loadingMore);
              this.loadMoreIfNeeded();
            }
          };
          InfiniteScroll.prototype.bind = function(decorated, container, $container) {
            var self2 = this;
            decorated.call(this, container, $container);
            container.on("query", function(params) {
              self2.lastParams = params;
              self2.loading = true;
            });
            container.on("query:append", function(params) {
              self2.lastParams = params;
              self2.loading = true;
            });
            this.$results.on("scroll", this.loadMoreIfNeeded.bind(this));
          };
          InfiniteScroll.prototype.loadMoreIfNeeded = function() {
            var isLoadMoreVisible = $2.contains(
              document.documentElement,
              this.$loadingMore[0]
            );
            if (this.loading || !isLoadMoreVisible) {
              return;
            }
            var currentOffset = this.$results.offset().top + this.$results.outerHeight(false);
            var loadingMoreOffset = this.$loadingMore.offset().top + this.$loadingMore.outerHeight(false);
            if (currentOffset + 50 >= loadingMoreOffset) {
              this.loadMore();
            }
          };
          InfiniteScroll.prototype.loadMore = function() {
            this.loading = true;
            var params = $2.extend({}, { page: 1 }, this.lastParams);
            params.page++;
            this.trigger("query:append", params);
          };
          InfiniteScroll.prototype.showLoadingMore = function(_, data) {
            return data.pagination && data.pagination.more;
          };
          InfiniteScroll.prototype.createLoadingMore = function() {
            var $option = $2(
              '<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'
            );
            var message = this.options.get("translations").get("loadingMore");
            $option.html(message(this.lastParams));
            return $option;
          };
          return InfiniteScroll;
        });
        S22.define("select2/dropdown/attachBody", [
          "jquery",
          "../utils"
        ], function($2, Utils) {
          function AttachBody(decorated, $element, options) {
            this.$dropdownParent = $2(options.get("dropdownParent") || document.body);
            decorated.call(this, $element, options);
          }
          AttachBody.prototype.bind = function(decorated, container, $container) {
            var self2 = this;
            decorated.call(this, container, $container);
            container.on("open", function() {
              self2._showDropdown();
              self2._attachPositioningHandler(container);
              self2._bindContainerResultHandlers(container);
            });
            container.on("close", function() {
              self2._hideDropdown();
              self2._detachPositioningHandler(container);
            });
            this.$dropdownContainer.on("mousedown", function(evt) {
              evt.stopPropagation();
            });
          };
          AttachBody.prototype.destroy = function(decorated) {
            decorated.call(this);
            this.$dropdownContainer.remove();
          };
          AttachBody.prototype.position = function(decorated, $dropdown, $container) {
            $dropdown.attr("class", $container.attr("class"));
            $dropdown[0].classList.remove("select2");
            $dropdown[0].classList.add("select2-container--open");
            $dropdown.css({
              position: "absolute",
              top: -999999
            });
            this.$container = $container;
          };
          AttachBody.prototype.render = function(decorated) {
            var $container = $2("<span></span>");
            var $dropdown = decorated.call(this);
            $container.append($dropdown);
            this.$dropdownContainer = $container;
            return $container;
          };
          AttachBody.prototype._hideDropdown = function(decorated) {
            this.$dropdownContainer.detach();
          };
          AttachBody.prototype._bindContainerResultHandlers = function(decorated, container) {
            if (this._containerResultsHandlersBound) {
              return;
            }
            var self2 = this;
            container.on("results:all", function() {
              self2._positionDropdown();
              self2._resizeDropdown();
            });
            container.on("results:append", function() {
              self2._positionDropdown();
              self2._resizeDropdown();
            });
            container.on("results:message", function() {
              self2._positionDropdown();
              self2._resizeDropdown();
            });
            container.on("select", function() {
              self2._positionDropdown();
              self2._resizeDropdown();
            });
            container.on("unselect", function() {
              self2._positionDropdown();
              self2._resizeDropdown();
            });
            this._containerResultsHandlersBound = true;
          };
          AttachBody.prototype._attachPositioningHandler = function(decorated, container) {
            var self2 = this;
            var scrollEvent = "scroll.select2." + container.id;
            var resizeEvent = "resize.select2." + container.id;
            var orientationEvent = "orientationchange.select2." + container.id;
            var $watchers = this.$container.parents().filter(Utils.hasScroll);
            $watchers.each(function() {
              Utils.StoreData(this, "select2-scroll-position", {
                x: $2(this).scrollLeft(),
                y: $2(this).scrollTop()
              });
            });
            $watchers.on(scrollEvent, function(ev) {
              var position = Utils.GetData(this, "select2-scroll-position");
              $2(this).scrollTop(position.y);
            });
            $2(window).on(
              scrollEvent + " " + resizeEvent + " " + orientationEvent,
              function(e) {
                self2._positionDropdown();
                self2._resizeDropdown();
              }
            );
          };
          AttachBody.prototype._detachPositioningHandler = function(decorated, container) {
            var scrollEvent = "scroll.select2." + container.id;
            var resizeEvent = "resize.select2." + container.id;
            var orientationEvent = "orientationchange.select2." + container.id;
            var $watchers = this.$container.parents().filter(Utils.hasScroll);
            $watchers.off(scrollEvent);
            $2(window).off(scrollEvent + " " + resizeEvent + " " + orientationEvent);
          };
          AttachBody.prototype._positionDropdown = function() {
            var $window = $2(window);
            var isCurrentlyAbove = this.$dropdown[0].classList.contains("select2-dropdown--above");
            var isCurrentlyBelow = this.$dropdown[0].classList.contains("select2-dropdown--below");
            var newDirection = null;
            var offset = this.$container.offset();
            offset.bottom = offset.top + this.$container.outerHeight(false);
            var container = {
              height: this.$container.outerHeight(false)
            };
            container.top = offset.top;
            container.bottom = offset.top + container.height;
            var dropdown = {
              height: this.$dropdown.outerHeight(false)
            };
            var viewport = {
              top: $window.scrollTop(),
              bottom: $window.scrollTop() + $window.height()
            };
            var enoughRoomAbove = viewport.top < offset.top - dropdown.height;
            var enoughRoomBelow = viewport.bottom > offset.bottom + dropdown.height;
            var css = {
              left: offset.left,
              top: container.bottom
            };
            var $offsetParent = this.$dropdownParent;
            if ($offsetParent.css("position") === "static") {
              $offsetParent = $offsetParent.offsetParent();
            }
            var parentOffset = {
              top: 0,
              left: 0
            };
            if ($2.contains(document.body, $offsetParent[0]) || $offsetParent[0].isConnected) {
              parentOffset = $offsetParent.offset();
            }
            css.top -= parentOffset.top;
            css.left -= parentOffset.left;
            if (!isCurrentlyAbove && !isCurrentlyBelow) {
              newDirection = "below";
            }
            if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
              newDirection = "above";
            } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
              newDirection = "below";
            }
            if (newDirection == "above" || isCurrentlyAbove && newDirection !== "below") {
              css.top = container.top - parentOffset.top - dropdown.height;
            }
            if (newDirection != null) {
              this.$dropdown[0].classList.remove("select2-dropdown--below");
              this.$dropdown[0].classList.remove("select2-dropdown--above");
              this.$dropdown[0].classList.add("select2-dropdown--" + newDirection);
              this.$container[0].classList.remove("select2-container--below");
              this.$container[0].classList.remove("select2-container--above");
              this.$container[0].classList.add("select2-container--" + newDirection);
            }
            this.$dropdownContainer.css(css);
          };
          AttachBody.prototype._resizeDropdown = function() {
            var css = {
              width: this.$container.outerWidth(false) + "px"
            };
            if (this.options.get("dropdownAutoWidth")) {
              css.minWidth = css.width;
              css.position = "relative";
              css.width = "auto";
            }
            this.$dropdown.css(css);
          };
          AttachBody.prototype._showDropdown = function(decorated) {
            this.$dropdownContainer.appendTo(this.$dropdownParent);
            this._positionDropdown();
            this._resizeDropdown();
          };
          return AttachBody;
        });
        S22.define("select2/dropdown/minimumResultsForSearch", [], function() {
          function countResults(data) {
            var count = 0;
            for (var d = 0; d < data.length; d++) {
              var item = data[d];
              if (item.children) {
                count += countResults(item.children);
              } else {
                count++;
              }
            }
            return count;
          }
          function MinimumResultsForSearch(decorated, $element, options, dataAdapter) {
            this.minimumResultsForSearch = options.get("minimumResultsForSearch");
            if (this.minimumResultsForSearch < 0) {
              this.minimumResultsForSearch = Infinity;
            }
            decorated.call(this, $element, options, dataAdapter);
          }
          MinimumResultsForSearch.prototype.showSearch = function(decorated, params) {
            if (countResults(params.data.results) < this.minimumResultsForSearch) {
              return false;
            }
            return decorated.call(this, params);
          };
          return MinimumResultsForSearch;
        });
        S22.define("select2/dropdown/selectOnClose", [
          "../utils"
        ], function(Utils) {
          function SelectOnClose() {
          }
          SelectOnClose.prototype.bind = function(decorated, container, $container) {
            var self2 = this;
            decorated.call(this, container, $container);
            container.on("close", function(params) {
              self2._handleSelectOnClose(params);
            });
          };
          SelectOnClose.prototype._handleSelectOnClose = function(_, params) {
            if (params && params.originalSelect2Event != null) {
              var event = params.originalSelect2Event;
              if (event._type === "select" || event._type === "unselect") {
                return;
              }
            }
            var $highlightedResults = this.getHighlightedResults();
            if ($highlightedResults.length < 1) {
              return;
            }
            var data = Utils.GetData($highlightedResults[0], "data");
            if (data.element != null && data.element.selected || data.element == null && data.selected) {
              return;
            }
            this.trigger("select", {
              data
            });
          };
          return SelectOnClose;
        });
        S22.define("select2/dropdown/closeOnSelect", [], function() {
          function CloseOnSelect() {
          }
          CloseOnSelect.prototype.bind = function(decorated, container, $container) {
            var self2 = this;
            decorated.call(this, container, $container);
            container.on("select", function(evt) {
              self2._selectTriggered(evt);
            });
            container.on("unselect", function(evt) {
              self2._selectTriggered(evt);
            });
          };
          CloseOnSelect.prototype._selectTriggered = function(_, evt) {
            var originalEvent = evt.originalEvent;
            if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
              return;
            }
            this.trigger("close", {
              originalEvent,
              originalSelect2Event: evt
            });
          };
          return CloseOnSelect;
        });
        S22.define("select2/dropdown/dropdownCss", [
          "../utils"
        ], function(Utils) {
          function DropdownCSS() {
          }
          DropdownCSS.prototype.render = function(decorated) {
            var $dropdown = decorated.call(this);
            var dropdownCssClass = this.options.get("dropdownCssClass") || "";
            if (dropdownCssClass.indexOf(":all:") !== -1) {
              dropdownCssClass = dropdownCssClass.replace(":all:", "");
              Utils.copyNonInternalCssClasses($dropdown[0], this.$element[0]);
            }
            $dropdown.addClass(dropdownCssClass);
            return $dropdown;
          };
          return DropdownCSS;
        });
        S22.define("select2/dropdown/tagsSearchHighlight", [
          "../utils"
        ], function(Utils) {
          function TagsSearchHighlight() {
          }
          TagsSearchHighlight.prototype.highlightFirstItem = function(decorated) {
            var $options = this.$results.find(
              ".select2-results__option--selectable:not(.select2-results__option--selected)"
            );
            if ($options.length > 0) {
              var $firstOption = $options.first();
              var data = Utils.GetData($firstOption[0], "data");
              var firstElement = data.element;
              if (firstElement && firstElement.getAttribute) {
                if (firstElement.getAttribute("data-select2-tag") === "true") {
                  $firstOption.trigger("mouseenter");
                  return;
                }
              }
            }
            decorated.call(this);
          };
          return TagsSearchHighlight;
        });
        S22.define("select2/i18n/en", [], function() {
          return {
            errorLoading: function() {
              return "The results could not be loaded.";
            },
            inputTooLong: function(args) {
              var overChars = args.input.length - args.maximum;
              var message = "Please delete " + overChars + " character";
              if (overChars != 1) {
                message += "s";
              }
              return message;
            },
            inputTooShort: function(args) {
              var remainingChars = args.minimum - args.input.length;
              var message = "Please enter " + remainingChars + " or more characters";
              return message;
            },
            loadingMore: function() {
              return "Loading more results…";
            },
            maximumSelected: function(args) {
              var message = "You can only select " + args.maximum + " item";
              if (args.maximum != 1) {
                message += "s";
              }
              return message;
            },
            noResults: function() {
              return "No results found";
            },
            searching: function() {
              return "Searching…";
            },
            removeAllItems: function() {
              return "Remove all items";
            },
            removeItem: function() {
              return "Remove item";
            },
            search: function() {
              return "Search";
            }
          };
        });
        S22.define("select2/defaults", [
          "jquery",
          "./results",
          "./selection/single",
          "./selection/multiple",
          "./selection/placeholder",
          "./selection/allowClear",
          "./selection/search",
          "./selection/selectionCss",
          "./selection/eventRelay",
          "./utils",
          "./translation",
          "./diacritics",
          "./data/select",
          "./data/array",
          "./data/ajax",
          "./data/tags",
          "./data/tokenizer",
          "./data/minimumInputLength",
          "./data/maximumInputLength",
          "./data/maximumSelectionLength",
          "./dropdown",
          "./dropdown/search",
          "./dropdown/hidePlaceholder",
          "./dropdown/infiniteScroll",
          "./dropdown/attachBody",
          "./dropdown/minimumResultsForSearch",
          "./dropdown/selectOnClose",
          "./dropdown/closeOnSelect",
          "./dropdown/dropdownCss",
          "./dropdown/tagsSearchHighlight",
          "./i18n/en"
        ], function($2, ResultsList, SingleSelection, MultipleSelection, Placeholder, AllowClear, SelectionSearch, SelectionCSS, EventRelay, Utils, Translation, DIACRITICS, SelectData, ArrayData, AjaxData, Tags, Tokenizer, MinimumInputLength, MaximumInputLength, MaximumSelectionLength, Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll, AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect, DropdownCSS, TagsSearchHighlight, EnglishTranslation) {
          function Defaults() {
            this.reset();
          }
          Defaults.prototype.apply = function(options) {
            options = $2.extend(true, {}, this.defaults, options);
            if (options.dataAdapter == null) {
              if (options.ajax != null) {
                options.dataAdapter = AjaxData;
              } else if (options.data != null) {
                options.dataAdapter = ArrayData;
              } else {
                options.dataAdapter = SelectData;
              }
              if (options.minimumInputLength > 0) {
                options.dataAdapter = Utils.Decorate(
                  options.dataAdapter,
                  MinimumInputLength
                );
              }
              if (options.maximumInputLength > 0) {
                options.dataAdapter = Utils.Decorate(
                  options.dataAdapter,
                  MaximumInputLength
                );
              }
              if (options.maximumSelectionLength > 0) {
                options.dataAdapter = Utils.Decorate(
                  options.dataAdapter,
                  MaximumSelectionLength
                );
              }
              if (options.tags) {
                options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
              }
              if (options.tokenSeparators != null || options.tokenizer != null) {
                options.dataAdapter = Utils.Decorate(
                  options.dataAdapter,
                  Tokenizer
                );
              }
            }
            if (options.resultsAdapter == null) {
              options.resultsAdapter = ResultsList;
              if (options.ajax != null) {
                options.resultsAdapter = Utils.Decorate(
                  options.resultsAdapter,
                  InfiniteScroll
                );
              }
              if (options.placeholder != null) {
                options.resultsAdapter = Utils.Decorate(
                  options.resultsAdapter,
                  HidePlaceholder
                );
              }
              if (options.selectOnClose) {
                options.resultsAdapter = Utils.Decorate(
                  options.resultsAdapter,
                  SelectOnClose
                );
              }
              if (options.tags) {
                options.resultsAdapter = Utils.Decorate(
                  options.resultsAdapter,
                  TagsSearchHighlight
                );
              }
            }
            if (options.dropdownAdapter == null) {
              if (options.multiple) {
                options.dropdownAdapter = Dropdown;
              } else {
                var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);
                options.dropdownAdapter = SearchableDropdown;
              }
              if (options.minimumResultsForSearch !== 0) {
                options.dropdownAdapter = Utils.Decorate(
                  options.dropdownAdapter,
                  MinimumResultsForSearch
                );
              }
              if (options.closeOnSelect) {
                options.dropdownAdapter = Utils.Decorate(
                  options.dropdownAdapter,
                  CloseOnSelect
                );
              }
              if (options.dropdownCssClass != null) {
                options.dropdownAdapter = Utils.Decorate(
                  options.dropdownAdapter,
                  DropdownCSS
                );
              }
              options.dropdownAdapter = Utils.Decorate(
                options.dropdownAdapter,
                AttachBody
              );
            }
            if (options.selectionAdapter == null) {
              if (options.multiple) {
                options.selectionAdapter = MultipleSelection;
              } else {
                options.selectionAdapter = SingleSelection;
              }
              if (options.placeholder != null) {
                options.selectionAdapter = Utils.Decorate(
                  options.selectionAdapter,
                  Placeholder
                );
              }
              if (options.allowClear) {
                options.selectionAdapter = Utils.Decorate(
                  options.selectionAdapter,
                  AllowClear
                );
              }
              if (options.multiple) {
                options.selectionAdapter = Utils.Decorate(
                  options.selectionAdapter,
                  SelectionSearch
                );
              }
              if (options.selectionCssClass != null) {
                options.selectionAdapter = Utils.Decorate(
                  options.selectionAdapter,
                  SelectionCSS
                );
              }
              options.selectionAdapter = Utils.Decorate(
                options.selectionAdapter,
                EventRelay
              );
            }
            options.language = this._resolveLanguage(options.language);
            options.language.push("en");
            var uniqueLanguages = [];
            for (var l = 0; l < options.language.length; l++) {
              var language = options.language[l];
              if (uniqueLanguages.indexOf(language) === -1) {
                uniqueLanguages.push(language);
              }
            }
            options.language = uniqueLanguages;
            options.translations = this._processTranslations(
              options.language,
              options.debug
            );
            return options;
          };
          Defaults.prototype.reset = function() {
            function stripDiacritics(text) {
              function match(a) {
                return DIACRITICS[a] || a;
              }
              return text.replace(/[^\u0000-\u007E]/g, match);
            }
            function matcher(params, data) {
              if (params.term == null || params.term.trim() === "") {
                return data;
              }
              if (data.children && data.children.length > 0) {
                var match = $2.extend(true, {}, data);
                for (var c = data.children.length - 1; c >= 0; c--) {
                  var child = data.children[c];
                  var matches = matcher(params, child);
                  if (matches == null) {
                    match.children.splice(c, 1);
                  }
                }
                if (match.children.length > 0) {
                  return match;
                }
                return matcher(params, match);
              }
              var original = stripDiacritics(data.text).toUpperCase();
              var term = stripDiacritics(params.term).toUpperCase();
              if (original.indexOf(term) > -1) {
                return data;
              }
              return null;
            }
            this.defaults = {
              amdLanguageBase: "./i18n/",
              autocomplete: "off",
              closeOnSelect: true,
              debug: false,
              dropdownAutoWidth: false,
              escapeMarkup: Utils.escapeMarkup,
              language: {},
              matcher,
              minimumInputLength: 0,
              maximumInputLength: 0,
              maximumSelectionLength: 0,
              minimumResultsForSearch: 0,
              selectOnClose: false,
              scrollAfterSelect: false,
              sorter: function(data) {
                return data;
              },
              templateResult: function(result) {
                return result.text;
              },
              templateSelection: function(selection) {
                return selection.text;
              },
              theme: "default",
              width: "resolve"
            };
          };
          Defaults.prototype.applyFromElement = function(options, $element) {
            var optionLanguage = options.language;
            var defaultLanguage = this.defaults.language;
            var elementLanguage = $element.prop("lang");
            var parentLanguage = $element.closest("[lang]").prop("lang");
            var languages = Array.prototype.concat.call(
              this._resolveLanguage(elementLanguage),
              this._resolveLanguage(optionLanguage),
              this._resolveLanguage(defaultLanguage),
              this._resolveLanguage(parentLanguage)
            );
            options.language = languages;
            return options;
          };
          Defaults.prototype._resolveLanguage = function(language) {
            if (!language) {
              return [];
            }
            if ($2.isEmptyObject(language)) {
              return [];
            }
            if ($2.isPlainObject(language)) {
              return [language];
            }
            var languages;
            if (!Array.isArray(language)) {
              languages = [language];
            } else {
              languages = language;
            }
            var resolvedLanguages = [];
            for (var l = 0; l < languages.length; l++) {
              resolvedLanguages.push(languages[l]);
              if (typeof languages[l] === "string" && languages[l].indexOf("-") > 0) {
                var languageParts = languages[l].split("-");
                var baseLanguage = languageParts[0];
                resolvedLanguages.push(baseLanguage);
              }
            }
            return resolvedLanguages;
          };
          Defaults.prototype._processTranslations = function(languages, debug) {
            var translations = new Translation();
            for (var l = 0; l < languages.length; l++) {
              var languageData = new Translation();
              var language = languages[l];
              if (typeof language === "string") {
                try {
                  languageData = Translation.loadPath(language);
                } catch (e) {
                  try {
                    language = this.defaults.amdLanguageBase + language;
                    languageData = Translation.loadPath(language);
                  } catch (ex) {
                    if (debug && window.console && console.warn) {
                      console.warn(
                        'Select2: The language file for "' + language + '" could not be automatically loaded. A fallback will be used instead.'
                      );
                    }
                  }
                }
              } else if ($2.isPlainObject(language)) {
                languageData = new Translation(language);
              } else {
                languageData = language;
              }
              translations.extend(languageData);
            }
            return translations;
          };
          Defaults.prototype.set = function(key, value) {
            var camelKey = $2.camelCase(key);
            var data = {};
            data[camelKey] = value;
            var convertedData = Utils._convertData(data);
            $2.extend(true, this.defaults, convertedData);
          };
          var defaults = new Defaults();
          return defaults;
        });
        S22.define("select2/options", [
          "jquery",
          "./defaults",
          "./utils"
        ], function($2, Defaults, Utils) {
          function Options(options, $element) {
            this.options = options;
            if ($element != null) {
              this.fromElement($element);
            }
            if ($element != null) {
              this.options = Defaults.applyFromElement(this.options, $element);
            }
            this.options = Defaults.apply(this.options);
          }
          Options.prototype.fromElement = function($e) {
            var excludedData = ["select2"];
            if (this.options.multiple == null) {
              this.options.multiple = $e.prop("multiple");
            }
            if (this.options.disabled == null) {
              this.options.disabled = $e.prop("disabled");
            }
            if (this.options.autocomplete == null && $e.prop("autocomplete")) {
              this.options.autocomplete = $e.prop("autocomplete");
            }
            if (this.options.dir == null) {
              if ($e.prop("dir")) {
                this.options.dir = $e.prop("dir");
              } else if ($e.closest("[dir]").prop("dir")) {
                this.options.dir = $e.closest("[dir]").prop("dir");
              } else {
                this.options.dir = "ltr";
              }
            }
            $e.prop("disabled", this.options.disabled);
            $e.prop("multiple", this.options.multiple);
            if (Utils.GetData($e[0], "select2Tags")) {
              if (this.options.debug && window.console && console.warn) {
                console.warn(
                  'Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'
                );
              }
              Utils.StoreData($e[0], "data", Utils.GetData($e[0], "select2Tags"));
              Utils.StoreData($e[0], "tags", true);
            }
            if (Utils.GetData($e[0], "ajaxUrl")) {
              if (this.options.debug && window.console && console.warn) {
                console.warn(
                  "Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."
                );
              }
              $e.attr("ajax--url", Utils.GetData($e[0], "ajaxUrl"));
              Utils.StoreData($e[0], "ajax-Url", Utils.GetData($e[0], "ajaxUrl"));
            }
            var dataset = {};
            function upperCaseLetter(_, letter) {
              return letter.toUpperCase();
            }
            for (var attr = 0; attr < $e[0].attributes.length; attr++) {
              var attributeName = $e[0].attributes[attr].name;
              var prefix = "data-";
              if (attributeName.substr(0, prefix.length) == prefix) {
                var dataName = attributeName.substring(prefix.length);
                var dataValue = Utils.GetData($e[0], dataName);
                var camelDataName = dataName.replace(/-([a-z])/g, upperCaseLetter);
                dataset[camelDataName] = dataValue;
              }
            }
            if ($2.fn.jquery && $2.fn.jquery.substr(0, 2) == "1." && $e[0].dataset) {
              dataset = $2.extend(true, {}, $e[0].dataset, dataset);
            }
            var data = $2.extend(true, {}, Utils.GetData($e[0]), dataset);
            data = Utils._convertData(data);
            for (var key in data) {
              if (excludedData.indexOf(key) > -1) {
                continue;
              }
              if ($2.isPlainObject(this.options[key])) {
                $2.extend(this.options[key], data[key]);
              } else {
                this.options[key] = data[key];
              }
            }
            return this;
          };
          Options.prototype.get = function(key) {
            return this.options[key];
          };
          Options.prototype.set = function(key, val) {
            this.options[key] = val;
          };
          return Options;
        });
        S22.define("select2/core", [
          "jquery",
          "./options",
          "./utils",
          "./keys"
        ], function($2, Options, Utils, KEYS) {
          var Select2 = function($element, options) {
            if (Utils.GetData($element[0], "select2") != null) {
              Utils.GetData($element[0], "select2").destroy();
            }
            this.$element = $element;
            this.id = this._generateId($element);
            options = options || {};
            this.options = new Options(options, $element);
            Select2.__super__.constructor.call(this);
            var tabindex = $element.attr("tabindex") || 0;
            Utils.StoreData($element[0], "old-tabindex", tabindex);
            $element.attr("tabindex", "-1");
            var DataAdapter = this.options.get("dataAdapter");
            this.dataAdapter = new DataAdapter($element, this.options);
            var $container = this.render();
            this._placeContainer($container);
            var SelectionAdapter = this.options.get("selectionAdapter");
            this.selection = new SelectionAdapter($element, this.options);
            this.$selection = this.selection.render();
            this.selection.position(this.$selection, $container);
            var DropdownAdapter = this.options.get("dropdownAdapter");
            this.dropdown = new DropdownAdapter($element, this.options);
            this.$dropdown = this.dropdown.render();
            this.dropdown.position(this.$dropdown, $container);
            var ResultsAdapter = this.options.get("resultsAdapter");
            this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
            this.$results = this.results.render();
            this.results.position(this.$results, this.$dropdown);
            var self2 = this;
            this._bindAdapters();
            this._registerDomEvents();
            this._registerDataEvents();
            this._registerSelectionEvents();
            this._registerDropdownEvents();
            this._registerResultsEvents();
            this._registerEvents();
            this.dataAdapter.current(function(initialData) {
              self2.trigger("selection:update", {
                data: initialData
              });
            });
            $element[0].classList.add("select2-hidden-accessible");
            $element.attr("aria-hidden", "true");
            this._syncAttributes();
            Utils.StoreData($element[0], "select2", this);
            $element.data("select2", this);
          };
          Utils.Extend(Select2, Utils.Observable);
          Select2.prototype._generateId = function($element) {
            var id = "";
            if ($element.attr("id") != null) {
              id = $element.attr("id");
            } else if ($element.attr("name") != null) {
              id = $element.attr("name") + "-" + Utils.generateChars(2);
            } else {
              id = Utils.generateChars(4);
            }
            id = id.replace(/(:|\.|\[|\]|,)/g, "");
            id = "select2-" + id;
            return id;
          };
          Select2.prototype._placeContainer = function($container) {
            $container.insertAfter(this.$element);
            var width = this._resolveWidth(this.$element, this.options.get("width"));
            if (width != null) {
              $container.css("width", width);
            }
          };
          Select2.prototype._resolveWidth = function($element, method) {
            var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
            if (method == "resolve") {
              var styleWidth = this._resolveWidth($element, "style");
              if (styleWidth != null) {
                return styleWidth;
              }
              return this._resolveWidth($element, "element");
            }
            if (method == "element") {
              var elementWidth = $element.outerWidth(false);
              if (elementWidth <= 0) {
                return "auto";
              }
              return elementWidth + "px";
            }
            if (method == "style") {
              var style = $element.attr("style");
              if (typeof style !== "string") {
                return null;
              }
              var attrs = style.split(";");
              for (var i = 0, l = attrs.length; i < l; i = i + 1) {
                var attr = attrs[i].replace(/\s/g, "");
                var matches = attr.match(WIDTH);
                if (matches !== null && matches.length >= 1) {
                  return matches[1];
                }
              }
              return null;
            }
            if (method == "computedstyle") {
              var computedStyle = window.getComputedStyle($element[0]);
              return computedStyle.width;
            }
            return method;
          };
          Select2.prototype._bindAdapters = function() {
            this.dataAdapter.bind(this, this.$container);
            this.selection.bind(this, this.$container);
            this.dropdown.bind(this, this.$container);
            this.results.bind(this, this.$container);
          };
          Select2.prototype._registerDomEvents = function() {
            var self2 = this;
            this.$element.on("change.select2", function() {
              self2.dataAdapter.current(function(data) {
                self2.trigger("selection:update", {
                  data
                });
              });
            });
            this.$element.on("focus.select2", function(evt) {
              self2.trigger("focus", evt);
            });
            this._syncA = Utils.bind(this._syncAttributes, this);
            this._syncS = Utils.bind(this._syncSubtree, this);
            this._observer = new window.MutationObserver(function(mutations) {
              self2._syncA();
              self2._syncS(mutations);
            });
            this._observer.observe(this.$element[0], {
              attributes: true,
              childList: true,
              subtree: false
            });
          };
          Select2.prototype._registerDataEvents = function() {
            var self2 = this;
            this.dataAdapter.on("*", function(name, params) {
              self2.trigger(name, params);
            });
          };
          Select2.prototype._registerSelectionEvents = function() {
            var self2 = this;
            var nonRelayEvents = ["toggle", "focus"];
            this.selection.on("toggle", function() {
              self2.toggleDropdown();
            });
            this.selection.on("focus", function(params) {
              self2.focus(params);
            });
            this.selection.on("*", function(name, params) {
              if (nonRelayEvents.indexOf(name) !== -1) {
                return;
              }
              self2.trigger(name, params);
            });
          };
          Select2.prototype._registerDropdownEvents = function() {
            var self2 = this;
            this.dropdown.on("*", function(name, params) {
              self2.trigger(name, params);
            });
          };
          Select2.prototype._registerResultsEvents = function() {
            var self2 = this;
            this.results.on("*", function(name, params) {
              self2.trigger(name, params);
            });
          };
          Select2.prototype._registerEvents = function() {
            var self2 = this;
            this.on("open", function() {
              self2.$container[0].classList.add("select2-container--open");
            });
            this.on("close", function() {
              self2.$container[0].classList.remove("select2-container--open");
            });
            this.on("enable", function() {
              self2.$container[0].classList.remove("select2-container--disabled");
            });
            this.on("disable", function() {
              self2.$container[0].classList.add("select2-container--disabled");
            });
            this.on("blur", function() {
              self2.$container[0].classList.remove("select2-container--focus");
            });
            this.on("query", function(params) {
              if (!self2.isOpen()) {
                self2.trigger("open", {});
              }
              this.dataAdapter.query(params, function(data) {
                self2.trigger("results:all", {
                  data,
                  query: params
                });
              });
            });
            this.on("query:append", function(params) {
              this.dataAdapter.query(params, function(data) {
                self2.trigger("results:append", {
                  data,
                  query: params
                });
              });
            });
            this.on("keypress", function(evt) {
              var key = evt.which;
              if (self2.isOpen()) {
                if (key === KEYS.ESC || key === KEYS.UP && evt.altKey) {
                  self2.close(evt);
                  evt.preventDefault();
                } else if (key === KEYS.ENTER || key === KEYS.TAB) {
                  self2.trigger("results:select", {});
                  evt.preventDefault();
                } else if (key === KEYS.SPACE && evt.ctrlKey) {
                  self2.trigger("results:toggle", {});
                  evt.preventDefault();
                } else if (key === KEYS.UP) {
                  self2.trigger("results:previous", {});
                  evt.preventDefault();
                } else if (key === KEYS.DOWN) {
                  self2.trigger("results:next", {});
                  evt.preventDefault();
                }
              } else {
                if (key === KEYS.ENTER || key === KEYS.SPACE || key === KEYS.DOWN && evt.altKey) {
                  self2.open();
                  evt.preventDefault();
                }
              }
            });
          };
          Select2.prototype._syncAttributes = function() {
            this.options.set("disabled", this.$element.prop("disabled"));
            if (this.isDisabled()) {
              if (this.isOpen()) {
                this.close();
              }
              this.trigger("disable", {});
            } else {
              this.trigger("enable", {});
            }
          };
          Select2.prototype._isChangeMutation = function(mutations) {
            var self2 = this;
            if (mutations.addedNodes && mutations.addedNodes.length > 0) {
              for (var n = 0; n < mutations.addedNodes.length; n++) {
                var node = mutations.addedNodes[n];
                if (node.selected) {
                  return true;
                }
              }
            } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
              return true;
            } else if (Array.isArray(mutations)) {
              return mutations.some(function(mutation) {
                return self2._isChangeMutation(mutation);
              });
            }
            return false;
          };
          Select2.prototype._syncSubtree = function(mutations) {
            var changed = this._isChangeMutation(mutations);
            var self2 = this;
            if (changed) {
              this.dataAdapter.current(function(currentData) {
                self2.trigger("selection:update", {
                  data: currentData
                });
              });
            }
          };
          Select2.prototype.trigger = function(name, args) {
            var actualTrigger = Select2.__super__.trigger;
            var preTriggerMap = {
              "open": "opening",
              "close": "closing",
              "select": "selecting",
              "unselect": "unselecting",
              "clear": "clearing"
            };
            if (args === void 0) {
              args = {};
            }
            if (name in preTriggerMap) {
              var preTriggerName = preTriggerMap[name];
              var preTriggerArgs = {
                prevented: false,
                name,
                args
              };
              actualTrigger.call(this, preTriggerName, preTriggerArgs);
              if (preTriggerArgs.prevented) {
                args.prevented = true;
                return;
              }
            }
            actualTrigger.call(this, name, args);
          };
          Select2.prototype.toggleDropdown = function() {
            if (this.isDisabled()) {
              return;
            }
            if (this.isOpen()) {
              this.close();
            } else {
              this.open();
            }
          };
          Select2.prototype.open = function() {
            if (this.isOpen()) {
              return;
            }
            if (this.isDisabled()) {
              return;
            }
            this.trigger("query", {});
          };
          Select2.prototype.close = function(evt) {
            if (!this.isOpen()) {
              return;
            }
            this.trigger("close", { originalEvent: evt });
          };
          Select2.prototype.isEnabled = function() {
            return !this.isDisabled();
          };
          Select2.prototype.isDisabled = function() {
            return this.options.get("disabled");
          };
          Select2.prototype.isOpen = function() {
            return this.$container[0].classList.contains("select2-container--open");
          };
          Select2.prototype.hasFocus = function() {
            return this.$container[0].classList.contains("select2-container--focus");
          };
          Select2.prototype.focus = function(data) {
            if (this.hasFocus()) {
              return;
            }
            this.$container[0].classList.add("select2-container--focus");
            this.trigger("focus", {});
          };
          Select2.prototype.enable = function(args) {
            if (this.options.get("debug") && window.console && console.warn) {
              console.warn(
                'Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'
              );
            }
            if (args == null || args.length === 0) {
              args = [true];
            }
            var disabled = !args[0];
            this.$element.prop("disabled", disabled);
          };
          Select2.prototype.data = function() {
            if (this.options.get("debug") && arguments.length > 0 && window.console && console.warn) {
              console.warn(
                'Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.'
              );
            }
            var data = [];
            this.dataAdapter.current(function(currentData) {
              data = currentData;
            });
            return data;
          };
          Select2.prototype.val = function(args) {
            if (this.options.get("debug") && window.console && console.warn) {
              console.warn(
                'Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'
              );
            }
            if (args == null || args.length === 0) {
              return this.$element.val();
            }
            var newVal = args[0];
            if (Array.isArray(newVal)) {
              newVal = newVal.map(function(obj) {
                return obj.toString();
              });
            }
            this.$element.val(newVal).trigger("input").trigger("change");
          };
          Select2.prototype.destroy = function() {
            Utils.RemoveData(this.$container[0]);
            this.$container.remove();
            this._observer.disconnect();
            this._observer = null;
            this._syncA = null;
            this._syncS = null;
            this.$element.off(".select2");
            this.$element.attr(
              "tabindex",
              Utils.GetData(this.$element[0], "old-tabindex")
            );
            this.$element[0].classList.remove("select2-hidden-accessible");
            this.$element.attr("aria-hidden", "false");
            Utils.RemoveData(this.$element[0]);
            this.$element.removeData("select2");
            this.dataAdapter.destroy();
            this.selection.destroy();
            this.dropdown.destroy();
            this.results.destroy();
            this.dataAdapter = null;
            this.selection = null;
            this.dropdown = null;
            this.results = null;
          };
          Select2.prototype.render = function() {
            var $container = $2(
              '<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>'
            );
            $container.attr("dir", this.options.get("dir"));
            this.$container = $container;
            this.$container[0].classList.add("select2-container--" + this.options.get("theme"));
            Utils.StoreData($container[0], "element", this.$element);
            return $container;
          };
          return Select2;
        });
        S22.define("select2/dropdown/attachContainer", [], function() {
          function AttachContainer(decorated, $element, options) {
            decorated.call(this, $element, options);
          }
          AttachContainer.prototype.position = function(decorated, $dropdown, $container) {
            var $dropdownContainer = $container.find(".dropdown-wrapper");
            $dropdownContainer.append($dropdown);
            $dropdown[0].classList.add("select2-dropdown--below");
            $container[0].classList.add("select2-container--below");
          };
          return AttachContainer;
        });
        S22.define("select2/dropdown/stopPropagation", [], function() {
          function StopPropagation() {
          }
          StopPropagation.prototype.bind = function(decorated, container, $container) {
            decorated.call(this, container, $container);
            var stoppedEvents = [
              "blur",
              "change",
              "click",
              "dblclick",
              "focus",
              "focusin",
              "focusout",
              "input",
              "keydown",
              "keyup",
              "keypress",
              "mousedown",
              "mouseenter",
              "mouseleave",
              "mousemove",
              "mouseover",
              "mouseup",
              "search",
              "touchend",
              "touchstart"
            ];
            this.$dropdown.on(stoppedEvents.join(" "), function(evt) {
              evt.stopPropagation();
            });
          };
          return StopPropagation;
        });
        S22.define("select2/selection/stopPropagation", [], function() {
          function StopPropagation() {
          }
          StopPropagation.prototype.bind = function(decorated, container, $container) {
            decorated.call(this, container, $container);
            var stoppedEvents = [
              "blur",
              "change",
              "click",
              "dblclick",
              "focus",
              "focusin",
              "focusout",
              "input",
              "keydown",
              "keyup",
              "keypress",
              "mousedown",
              "mouseenter",
              "mouseleave",
              "mousemove",
              "mouseover",
              "mouseup",
              "search",
              "touchend",
              "touchstart"
            ];
            this.$selection.on(stoppedEvents.join(" "), function(evt) {
              evt.stopPropagation();
            });
          };
          return StopPropagation;
        });
        /*!
         * jQuery Mousewheel 3.1.13
         *
         * Copyright jQuery Foundation and other contributors
         * Released under the MIT license
         * http://jquery.org/license
         */
        (function(factory) {
          if (typeof S22.define === "function" && S22.define.amd) {
            S22.define("jquery-mousewheel", ["jquery"], factory);
          } else {
            module.exports = factory;
          }
        })(function($2) {
          var toFix = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"], toBind = "onwheel" in document || document.documentMode >= 9 ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"], slice = Array.prototype.slice, nullLowestDeltaTimeout, lowestDelta;
          if ($2.event.fixHooks) {
            for (var i = toFix.length; i; ) {
              $2.event.fixHooks[toFix[--i]] = $2.event.mouseHooks;
            }
          }
          var special = $2.event.special.mousewheel = {
            version: "3.1.12",
            setup: function() {
              if (this.addEventListener) {
                for (var i2 = toBind.length; i2; ) {
                  this.addEventListener(toBind[--i2], handler, false);
                }
              } else {
                this.onmousewheel = handler;
              }
              $2.data(this, "mousewheel-line-height", special.getLineHeight(this));
              $2.data(this, "mousewheel-page-height", special.getPageHeight(this));
            },
            teardown: function() {
              if (this.removeEventListener) {
                for (var i2 = toBind.length; i2; ) {
                  this.removeEventListener(toBind[--i2], handler, false);
                }
              } else {
                this.onmousewheel = null;
              }
              $2.removeData(this, "mousewheel-line-height");
              $2.removeData(this, "mousewheel-page-height");
            },
            getLineHeight: function(elem) {
              var $elem = $2(elem), $parent = $elem["offsetParent" in $2.fn ? "offsetParent" : "parent"]();
              if (!$parent.length) {
                $parent = $2("body");
              }
              return parseInt($parent.css("fontSize"), 10) || parseInt($elem.css("fontSize"), 10) || 16;
            },
            getPageHeight: function(elem) {
              return $2(elem).height();
            },
            settings: {
              adjustOldDeltas: true,
              // see shouldAdjustOldDeltas() below
              normalizeOffset: true
              // calls getBoundingClientRect for each event
            }
          };
          $2.fn.extend({
            mousewheel: function(fn) {
              return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
            },
            unmousewheel: function(fn) {
              return this.unbind("mousewheel", fn);
            }
          });
          function handler(event) {
            var orgEvent = event || window.event, args = slice.call(arguments, 1), delta = 0, deltaX = 0, deltaY = 0, absDelta = 0, offsetX = 0, offsetY = 0;
            event = $2.event.fix(orgEvent);
            event.type = "mousewheel";
            if ("detail" in orgEvent) {
              deltaY = orgEvent.detail * -1;
            }
            if ("wheelDelta" in orgEvent) {
              deltaY = orgEvent.wheelDelta;
            }
            if ("wheelDeltaY" in orgEvent) {
              deltaY = orgEvent.wheelDeltaY;
            }
            if ("wheelDeltaX" in orgEvent) {
              deltaX = orgEvent.wheelDeltaX * -1;
            }
            if ("axis" in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS) {
              deltaX = deltaY * -1;
              deltaY = 0;
            }
            delta = deltaY === 0 ? deltaX : deltaY;
            if ("deltaY" in orgEvent) {
              deltaY = orgEvent.deltaY * -1;
              delta = deltaY;
            }
            if ("deltaX" in orgEvent) {
              deltaX = orgEvent.deltaX;
              if (deltaY === 0) {
                delta = deltaX * -1;
              }
            }
            if (deltaY === 0 && deltaX === 0) {
              return;
            }
            if (orgEvent.deltaMode === 1) {
              var lineHeight = $2.data(this, "mousewheel-line-height");
              delta *= lineHeight;
              deltaY *= lineHeight;
              deltaX *= lineHeight;
            } else if (orgEvent.deltaMode === 2) {
              var pageHeight = $2.data(this, "mousewheel-page-height");
              delta *= pageHeight;
              deltaY *= pageHeight;
              deltaX *= pageHeight;
            }
            absDelta = Math.max(Math.abs(deltaY), Math.abs(deltaX));
            if (!lowestDelta || absDelta < lowestDelta) {
              lowestDelta = absDelta;
              if (shouldAdjustOldDeltas(orgEvent, absDelta)) {
                lowestDelta /= 40;
              }
            }
            if (shouldAdjustOldDeltas(orgEvent, absDelta)) {
              delta /= 40;
              deltaX /= 40;
              deltaY /= 40;
            }
            delta = Math[delta >= 1 ? "floor" : "ceil"](delta / lowestDelta);
            deltaX = Math[deltaX >= 1 ? "floor" : "ceil"](deltaX / lowestDelta);
            deltaY = Math[deltaY >= 1 ? "floor" : "ceil"](deltaY / lowestDelta);
            if (special.settings.normalizeOffset && this.getBoundingClientRect) {
              var boundingRect = this.getBoundingClientRect();
              offsetX = event.clientX - boundingRect.left;
              offsetY = event.clientY - boundingRect.top;
            }
            event.deltaX = deltaX;
            event.deltaY = deltaY;
            event.deltaFactor = lowestDelta;
            event.offsetX = offsetX;
            event.offsetY = offsetY;
            event.deltaMode = 0;
            args.unshift(event, delta, deltaX, deltaY);
            if (nullLowestDeltaTimeout) {
              clearTimeout(nullLowestDeltaTimeout);
            }
            nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);
            return ($2.event.dispatch || $2.event.handle).apply(this, args);
          }
          function nullLowestDelta() {
            lowestDelta = null;
          }
          function shouldAdjustOldDeltas(orgEvent, absDelta) {
            return special.settings.adjustOldDeltas && orgEvent.type === "mousewheel" && absDelta % 120 === 0;
          }
        });
        S22.define("jquery.select2", [
          "jquery",
          "jquery-mousewheel",
          "./select2/core",
          "./select2/defaults",
          "./select2/utils"
        ], function($2, _, Select2, Defaults, Utils) {
          if ($2.fn.select2 == null) {
            var thisMethods = ["open", "close", "destroy"];
            $2.fn.select2 = function(options) {
              options = options || {};
              if (typeof options === "object") {
                this.each(function() {
                  var instanceOptions = $2.extend(true, {}, options);
                  new Select2($2(this), instanceOptions);
                });
                return this;
              } else if (typeof options === "string") {
                var ret;
                var args = Array.prototype.slice.call(arguments, 1);
                this.each(function() {
                  var instance = Utils.GetData(this, "select2");
                  if (instance == null && window.console && console.error) {
                    console.error(
                      "The select2('" + options + "') method was called on an element that is not using Select2."
                    );
                  }
                  ret = instance[options].apply(instance, args);
                });
                if (thisMethods.indexOf(options) > -1) {
                  return this;
                }
                return ret;
              } else {
                throw new Error("Invalid arguments for Select2: " + options);
              }
            };
          }
          if ($2.fn.select2.defaults == null) {
            $2.fn.select2.defaults = Defaults;
          }
          return Select2;
        });
        return {
          define: S22.define,
          require: S22.require
        };
      }();
      var select22 = S2.require("jquery.select2");
      jQuery2.fn.select2.amd = S2;
      return select22;
    });
  })(select2_full);
  return select2_full.exports;
}
var select2_fullExports = requireSelect2_full();
var select2 = /* @__PURE__ */ getDefaultExportFromCjs(select2_fullExports);
(function() {
  function initializeSelect2() {
    const selects = document.querySelectorAll("select");
    if (typeof $ === "undefined" || typeof $.fn.select2 === "undefined") {
      return;
    }
    selects.forEach((select) => {
      if ($(select).hasClass("select2-hidden-accessible")) {
        try {
          $(select).select2("destroy");
        } catch (e) {
        }
      }
    });
    selects.forEach((select) => {
      $(select).select2({
        minimumResultsForSearch: Infinity,
        width: "resolve",
        // This helps Select2 to calculate the width correctly
        dropdownParent: $(select).parent()
        // Ensure dropdown is attached to the correct parent
      }).on("select2:select", (e) => {
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }).on("select2:open", function(e) {
      }).on("select2:close", function(e) {
      });
    });
  }
  document.addEventListener("DOMContentLoaded", () => {
    var _a;
    initializeSelect2();
    $(window).resize(() => {
      initializeSelect2();
    });
    if ((_a = window.Shopify) == null ? void 0 : _a.designMode) {
      document.addEventListener("shopify:section:load", initializeSelect2);
      document.addEventListener("shopify:section:select", initializeSelect2);
      document.addEventListener("shopify:block:select", initializeSelect2);
      document.addEventListener("shopify:block:deselect", initializeSelect2);
    }
  });
})();
(function() {
  let activeVariantOptions = null;
  let activeDropdowns = /* @__PURE__ */ new Set();
  document.addEventListener("click", (e) => {
    if (e.target.closest(".select2-container") || e.target.closest(".select2-dropdown") || e.target.closest(".select2-results")) {
      return;
    }
    if (activeVariantOptions && !e.target.closest(".product-card-container")) {
      if (typeof window.closeVariantOptions === "function") {
        window.closeVariantOptions(activeVariantOptions);
        activeVariantOptions = null;
      }
    }
    activeDropdowns.forEach((dropdown) => {
      if (dropdown.shouldClose && dropdown.shouldClose(e)) {
        dropdown.close();
        activeDropdowns.delete(dropdown);
      }
    });
  });
  window.GlobalClickHandlers = {
    setActiveVariantOptions: (options) => {
      activeVariantOptions = options;
    },
    getActiveVariantOptions: () => {
      return activeVariantOptions;
    },
    clearActiveVariantOptions: () => {
      activeVariantOptions = null;
    },
    registerDropdown: (dropdown) => {
      activeDropdowns.add(dropdown);
    },
    unregisterDropdown: (dropdown) => {
      activeDropdowns.delete(dropdown);
    }
  };
})();
var aos$1 = { exports: {} };
var aos = aos$1.exports;
var hasRequiredAos;
function requireAos() {
  if (hasRequiredAos) return aos$1.exports;
  hasRequiredAos = 1;
  (function(module, exports) {
    !function(e, t) {
      module.exports = t();
    }(aos, function() {
      return function(e) {
        function t(o) {
          if (n[o]) return n[o].exports;
          var i = n[o] = { exports: {}, id: o, loaded: false };
          return e[o].call(i.exports, i, i.exports, t), i.loaded = true, i.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.p = "dist/", t(0);
      }([function(e, t, n) {
        function o(e2) {
          return e2 && e2.__esModule ? e2 : { default: e2 };
        }
        var i = Object.assign || function(e2) {
          for (var t2 = 1; t2 < arguments.length; t2++) {
            var n2 = arguments[t2];
            for (var o2 in n2) Object.prototype.hasOwnProperty.call(n2, o2) && (e2[o2] = n2[o2]);
          }
          return e2;
        }, r = n(1), a = (o(r), n(6)), u = o(a), c = n(7), s = o(c), f = n(8), d = o(f), l = n(9), p = o(l), m = n(10), b = o(m), v = n(11), y = o(v), g = n(14), h = o(g), w = [], k = false, x = { offset: 120, delay: 0, easing: "ease", duration: 400, disable: false, once: false, startEvent: "DOMContentLoaded", throttleDelay: 99, debounceDelay: 50, disableMutationObserver: false }, j = function() {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (e2 && (k = true), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w;
        }, O = function() {
          w = (0, h.default)(), j();
        }, M = function() {
          w.forEach(function(e2, t2) {
            e2.node.removeAttribute("data-aos"), e2.node.removeAttribute("data-aos-easing"), e2.node.removeAttribute("data-aos-duration"), e2.node.removeAttribute("data-aos-delay");
          });
        }, S = function(e2) {
          return e2 === true || "mobile" === e2 && p.default.mobile() || "phone" === e2 && p.default.phone() || "tablet" === e2 && p.default.tablet() || "function" == typeof e2 && e2() === true;
        }, _ = function(e2) {
          x = i(x, e2), w = (0, h.default)();
          var t2 = document.all && !window.atob;
          return S(x.disable) || t2 ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = true), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && ["complete", "interactive"].indexOf(document.readyState) > -1 ? j(true) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function() {
            j(true);
          }) : document.addEventListener(x.startEvent, function() {
            j(true);
          }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, true)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, true)), window.addEventListener("scroll", (0, u.default)(function() {
            (0, b.default)(w, x.once);
          }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w);
        };
        e.exports = { init: _, refresh: j, refreshHard: O };
      }, function(e, t) {
      }, , , , , function(e, t) {
        (function(t2) {
          function n(e2, t3, n2) {
            function o2(t4) {
              var n3 = b2, o3 = v2;
              return b2 = v2 = void 0, k2 = t4, g2 = e2.apply(o3, n3);
            }
            function r2(e3) {
              return k2 = e3, h2 = setTimeout(f2, t3), M ? o2(e3) : g2;
            }
            function a2(e3) {
              var n3 = e3 - w2, o3 = e3 - k2, i2 = t3 - n3;
              return S ? j(i2, y2 - o3) : i2;
            }
            function c2(e3) {
              var n3 = e3 - w2, o3 = e3 - k2;
              return void 0 === w2 || n3 >= t3 || n3 < 0 || S && o3 >= y2;
            }
            function f2() {
              var e3 = O();
              return c2(e3) ? d2(e3) : void (h2 = setTimeout(f2, a2(e3)));
            }
            function d2(e3) {
              return h2 = void 0, _ && b2 ? o2(e3) : (b2 = v2 = void 0, g2);
            }
            function l2() {
              void 0 !== h2 && clearTimeout(h2), k2 = 0, b2 = w2 = v2 = h2 = void 0;
            }
            function p2() {
              return void 0 === h2 ? g2 : d2(O());
            }
            function m2() {
              var e3 = O(), n3 = c2(e3);
              if (b2 = arguments, v2 = this, w2 = e3, n3) {
                if (void 0 === h2) return r2(w2);
                if (S) return h2 = setTimeout(f2, t3), o2(w2);
              }
              return void 0 === h2 && (h2 = setTimeout(f2, t3)), g2;
            }
            var b2, v2, y2, g2, h2, w2, k2 = 0, M = false, S = false, _ = true;
            if ("function" != typeof e2) throw new TypeError(s);
            return t3 = u(t3) || 0, i(n2) && (M = !!n2.leading, S = "maxWait" in n2, y2 = S ? x(u(n2.maxWait) || 0, t3) : y2, _ = "trailing" in n2 ? !!n2.trailing : _), m2.cancel = l2, m2.flush = p2, m2;
          }
          function o(e2, t3, o2) {
            var r2 = true, a2 = true;
            if ("function" != typeof e2) throw new TypeError(s);
            return i(o2) && (r2 = "leading" in o2 ? !!o2.leading : r2, a2 = "trailing" in o2 ? !!o2.trailing : a2), n(e2, t3, { leading: r2, maxWait: t3, trailing: a2 });
          }
          function i(e2) {
            var t3 = "undefined" == typeof e2 ? "undefined" : c(e2);
            return !!e2 && ("object" == t3 || "function" == t3);
          }
          function r(e2) {
            return !!e2 && "object" == ("undefined" == typeof e2 ? "undefined" : c(e2));
          }
          function a(e2) {
            return "symbol" == ("undefined" == typeof e2 ? "undefined" : c(e2)) || r(e2) && k.call(e2) == d;
          }
          function u(e2) {
            if ("number" == typeof e2) return e2;
            if (a(e2)) return f;
            if (i(e2)) {
              var t3 = "function" == typeof e2.valueOf ? e2.valueOf() : e2;
              e2 = i(t3) ? t3 + "" : t3;
            }
            if ("string" != typeof e2) return 0 === e2 ? e2 : +e2;
            e2 = e2.replace(l, "");
            var n2 = m.test(e2);
            return n2 || b.test(e2) ? v(e2.slice(2), n2 ? 2 : 8) : p.test(e2) ? f : +e2;
          }
          var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e2) {
            return typeof e2;
          } : function(e2) {
            return e2 && "function" == typeof Symbol && e2.constructor === Symbol && e2 !== Symbol.prototype ? "symbol" : typeof e2;
          }, s = "Expected a function", f = NaN, d = "[object Symbol]", l = /^\s+|\s+$/g, p = /^[-+]0x[0-9a-f]+$/i, m = /^0b[01]+$/i, b = /^0o[0-7]+$/i, v = parseInt, y = "object" == ("undefined" == typeof t2 ? "undefined" : c(t2)) && t2 && t2.Object === Object && t2, g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self, h = y || g || Function("return this")(), w = Object.prototype, k = w.toString, x = Math.max, j = Math.min, O = function() {
            return h.Date.now();
          };
          e.exports = o;
        }).call(t, /* @__PURE__ */ function() {
          return this;
        }());
      }, function(e, t) {
        (function(t2) {
          function n(e2, t3, n2) {
            function i2(t4) {
              var n3 = b2, o2 = v2;
              return b2 = v2 = void 0, O = t4, g2 = e2.apply(o2, n3);
            }
            function r2(e3) {
              return O = e3, h2 = setTimeout(f2, t3), M ? i2(e3) : g2;
            }
            function u2(e3) {
              var n3 = e3 - w2, o2 = e3 - O, i3 = t3 - n3;
              return S ? x(i3, y2 - o2) : i3;
            }
            function s2(e3) {
              var n3 = e3 - w2, o2 = e3 - O;
              return void 0 === w2 || n3 >= t3 || n3 < 0 || S && o2 >= y2;
            }
            function f2() {
              var e3 = j();
              return s2(e3) ? d2(e3) : void (h2 = setTimeout(f2, u2(e3)));
            }
            function d2(e3) {
              return h2 = void 0, _ && b2 ? i2(e3) : (b2 = v2 = void 0, g2);
            }
            function l2() {
              void 0 !== h2 && clearTimeout(h2), O = 0, b2 = w2 = v2 = h2 = void 0;
            }
            function p2() {
              return void 0 === h2 ? g2 : d2(j());
            }
            function m2() {
              var e3 = j(), n3 = s2(e3);
              if (b2 = arguments, v2 = this, w2 = e3, n3) {
                if (void 0 === h2) return r2(w2);
                if (S) return h2 = setTimeout(f2, t3), i2(w2);
              }
              return void 0 === h2 && (h2 = setTimeout(f2, t3)), g2;
            }
            var b2, v2, y2, g2, h2, w2, O = 0, M = false, S = false, _ = true;
            if ("function" != typeof e2) throw new TypeError(c);
            return t3 = a(t3) || 0, o(n2) && (M = !!n2.leading, S = "maxWait" in n2, y2 = S ? k(a(n2.maxWait) || 0, t3) : y2, _ = "trailing" in n2 ? !!n2.trailing : _), m2.cancel = l2, m2.flush = p2, m2;
          }
          function o(e2) {
            var t3 = "undefined" == typeof e2 ? "undefined" : u(e2);
            return !!e2 && ("object" == t3 || "function" == t3);
          }
          function i(e2) {
            return !!e2 && "object" == ("undefined" == typeof e2 ? "undefined" : u(e2));
          }
          function r(e2) {
            return "symbol" == ("undefined" == typeof e2 ? "undefined" : u(e2)) || i(e2) && w.call(e2) == f;
          }
          function a(e2) {
            if ("number" == typeof e2) return e2;
            if (r(e2)) return s;
            if (o(e2)) {
              var t3 = "function" == typeof e2.valueOf ? e2.valueOf() : e2;
              e2 = o(t3) ? t3 + "" : t3;
            }
            if ("string" != typeof e2) return 0 === e2 ? e2 : +e2;
            e2 = e2.replace(d, "");
            var n2 = p.test(e2);
            return n2 || m.test(e2) ? b(e2.slice(2), n2 ? 2 : 8) : l.test(e2) ? s : +e2;
          }
          var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e2) {
            return typeof e2;
          } : function(e2) {
            return e2 && "function" == typeof Symbol && e2.constructor === Symbol && e2 !== Symbol.prototype ? "symbol" : typeof e2;
          }, c = "Expected a function", s = NaN, f = "[object Symbol]", d = /^\s+|\s+$/g, l = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, m = /^0o[0-7]+$/i, b = parseInt, v = "object" == ("undefined" == typeof t2 ? "undefined" : u(t2)) && t2 && t2.Object === Object && t2, y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self, g = v || y || Function("return this")(), h = Object.prototype, w = h.toString, k = Math.max, x = Math.min, j = function() {
            return g.Date.now();
          };
          e.exports = n;
        }).call(t, /* @__PURE__ */ function() {
          return this;
        }());
      }, function(e, t) {
        function n(e2) {
          var t2 = void 0, o2 = void 0;
          for (t2 = 0; t2 < e2.length; t2 += 1) {
            if (o2 = e2[t2], o2.dataset && o2.dataset.aos) return true;
            if (o2.children && n(o2.children)) return true;
          }
          return false;
        }
        function o() {
          return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        }
        function i() {
          return !!o();
        }
        function r(e2, t2) {
          var n2 = window.document, i2 = o(), r2 = new i2(a);
          u = t2, r2.observe(n2.documentElement, { childList: true, subtree: true, removedNodes: true });
        }
        function a(e2) {
          e2 && e2.forEach(function(e3) {
            var t2 = Array.prototype.slice.call(e3.addedNodes), o2 = Array.prototype.slice.call(e3.removedNodes), i2 = t2.concat(o2);
            if (n(i2)) return u();
          });
        }
        Object.defineProperty(t, "__esModule", { value: true });
        var u = function() {
        };
        t.default = { isSupported: i, ready: r };
      }, function(e, t) {
        function n(e2, t2) {
          if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
        }
        function o() {
          return navigator.userAgent || navigator.vendor || window.opera || "";
        }
        Object.defineProperty(t, "__esModule", { value: true });
        var i = /* @__PURE__ */ function() {
          function e2(e3, t2) {
            for (var n2 = 0; n2 < t2.length; n2++) {
              var o2 = t2[n2];
              o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e3, o2.key, o2);
            }
          }
          return function(t2, n2, o2) {
            return n2 && e2(t2.prototype, n2), o2 && e2(t2, o2), t2;
          };
        }(), r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, s = function() {
          function e2() {
            n(this, e2);
          }
          return i(e2, [{ key: "phone", value: function() {
            var e3 = o();
            return !(!r.test(e3) && !a.test(e3.substr(0, 4)));
          } }, { key: "mobile", value: function() {
            var e3 = o();
            return !(!u.test(e3) && !c.test(e3.substr(0, 4)));
          } }, { key: "tablet", value: function() {
            return this.mobile() && !this.phone();
          } }]), e2;
        }();
        t.default = new s();
      }, function(e, t) {
        Object.defineProperty(t, "__esModule", { value: true });
        var n = function(e2, t2, n2) {
          var o2 = e2.node.getAttribute("data-aos-once");
          t2 > e2.position ? e2.node.classList.add("aos-animate") : "undefined" != typeof o2 && ("false" === o2 || !n2 && "true" !== o2) && e2.node.classList.remove("aos-animate");
        }, o = function(e2, t2) {
          var o2 = window.pageYOffset, i = window.innerHeight;
          e2.forEach(function(e3, r) {
            n(e3, i + o2, t2);
          });
        };
        t.default = o;
      }, function(e, t, n) {
        function o(e2) {
          return e2 && e2.__esModule ? e2 : { default: e2 };
        }
        Object.defineProperty(t, "__esModule", { value: true });
        var i = n(12), r = o(i), a = function(e2, t2) {
          return e2.forEach(function(e3, n2) {
            e3.node.classList.add("aos-init"), e3.position = (0, r.default)(e3.node, t2.offset);
          }), e2;
        };
        t.default = a;
      }, function(e, t, n) {
        function o(e2) {
          return e2 && e2.__esModule ? e2 : { default: e2 };
        }
        Object.defineProperty(t, "__esModule", { value: true });
        var i = n(13), r = o(i), a = function(e2, t2) {
          var n2 = 0, o2 = 0, i2 = window.innerHeight, a2 = { offset: e2.getAttribute("data-aos-offset"), anchor: e2.getAttribute("data-aos-anchor"), anchorPlacement: e2.getAttribute("data-aos-anchor-placement") };
          switch (a2.offset && !isNaN(a2.offset) && (o2 = parseInt(a2.offset)), a2.anchor && document.querySelectorAll(a2.anchor) && (e2 = document.querySelectorAll(a2.anchor)[0]), n2 = (0, r.default)(e2).top, a2.anchorPlacement) {
            case "top-bottom":
              break;
            case "center-bottom":
              n2 += e2.offsetHeight / 2;
              break;
            case "bottom-bottom":
              n2 += e2.offsetHeight;
              break;
            case "top-center":
              n2 += i2 / 2;
              break;
            case "bottom-center":
              n2 += i2 / 2 + e2.offsetHeight;
              break;
            case "center-center":
              n2 += i2 / 2 + e2.offsetHeight / 2;
              break;
            case "top-top":
              n2 += i2;
              break;
            case "bottom-top":
              n2 += e2.offsetHeight + i2;
              break;
            case "center-top":
              n2 += e2.offsetHeight / 2 + i2;
          }
          return a2.anchorPlacement || a2.offset || isNaN(t2) || (o2 = t2), n2 + o2;
        };
        t.default = a;
      }, function(e, t) {
        Object.defineProperty(t, "__esModule", { value: true });
        var n = function(e2) {
          for (var t2 = 0, n2 = 0; e2 && !isNaN(e2.offsetLeft) && !isNaN(e2.offsetTop); ) t2 += e2.offsetLeft - ("BODY" != e2.tagName ? e2.scrollLeft : 0), n2 += e2.offsetTop - ("BODY" != e2.tagName ? e2.scrollTop : 0), e2 = e2.offsetParent;
          return { top: n2, left: t2 };
        };
        t.default = n;
      }, function(e, t) {
        Object.defineProperty(t, "__esModule", { value: true });
        var n = function(e2) {
          return e2 = e2 || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e2, function(e3) {
            return { node: e3 };
          });
        };
        t.default = n;
      }]);
    });
  })(aos$1);
  return aos$1.exports;
}
var aosExports = requireAos();
var AOS$1 = /* @__PURE__ */ getDefaultExportFromCjs(aosExports);
function addScaleOutAnimation() {
  if (!document.getElementById("scale-out-animation-style")) {
    const styleSheet = document.createElement("style");
    styleSheet.id = "scale-out-animation-style";
    styleSheet.textContent = `
            [data-aos="scale-out"] {
                transform: scale(1);
                transition-property: none;
            }
            
            [data-aos="slide-up"] {
                transform: translateY(100px);
                transition-property: transform;
                transition-duration: 600ms;
            }
            
            [data-aos="slide-up"].aos-animate {
                transform: translateY(0);
            }
        `;
    document.head.appendChild(styleSheet);
  }
}
function handleScaleOutEffect() {
  const sections = document.querySelectorAll("[data-scale-out-animation]");
  const infiniteScrollContainers = [
    document.querySelector("#product-grid"),
    document.querySelector('[id^="collection-grid-"]'),
    document.querySelector('[id^="search-results-"]'),
    document.querySelector("#BlogGridContainer")
  ].filter(Boolean);
  const excludedElements = /* @__PURE__ */ new Set();
  infiniteScrollContainers.forEach((container) => {
    if (container) {
      const infiniteScrollSections = container.closest("[data-scale-out-animation]");
      if (infiniteScrollSections) {
        excludedElements.add(infiniteScrollSections);
      }
      let parent = container.parentElement;
      while (parent) {
        if (parent.hasAttribute("data-scale-out-animation")) {
          excludedElements.add(parent);
        }
        parent = parent.parentElement;
      }
    }
  });
  sections.forEach((section) => {
    if (excludedElements.has(section)) {
      section.style.transform = "scale(1)";
      return;
    }
    const rect = section.getBoundingClientRect();
    const triggerPoint = -(rect.height * 0.6);
    if (rect.top <= triggerPoint) {
      const remainingHeight = rect.height * 0.4;
      const exitProgress = Math.min(Math.max((rect.top - triggerPoint) / -remainingHeight, 0), 1);
      const scale = 1 - 0.3 * exitProgress;
      section.style.transform = `scale(${scale})`;
    } else {
      section.style.transform = "scale(1)";
    }
  });
}
function initializeSectionAnimations() {
  if (Shopify.designMode) {
    document.querySelectorAll("[data-aos]").forEach((el) => {
      el.removeAttribute("data-aos");
    });
    document.querySelectorAll("[data-scale-out-animation]").forEach((el) => {
      el.style.transform = "";
    });
    return;
  }
  const pageAnimation = document.body.getAttribute("data-page-animation");
  const enableSectionAnimations = pageAnimation === "section_fade" || pageAnimation === "section_slide_up" || pageAnimation === "section_scale_out";
  if (enableSectionAnimations && typeof AOS$1 !== "undefined") {
    let scrollTimeout;
    let lastScrollTime2 = 0;
    const SCROLL_THROTTLE2 = 100;
    const throttledScaleOutEffect = () => {
      const now = Date.now();
      if (now - lastScrollTime2 < SCROLL_THROTTLE2) {
        return;
      }
      if (!scrollTimeout) {
        scrollTimeout = setTimeout(() => {
          handleScaleOutEffect();
          scrollTimeout = null;
          lastScrollTime2 = Date.now();
        }, SCROLL_THROTTLE2);
      }
    };
    if (pageAnimation === "section_scale_out") {
      addScaleOutAnimation();
      window.addEventListener("scroll", throttledScaleOutEffect, { passive: true });
      handleScaleOutEffect();
    } else {
      window.removeEventListener("scroll", throttledScaleOutEffect);
      window.removeEventListener("scroll", handleScaleOutEffect);
      const customStyles = document.getElementById("scale-out-animation-style");
      if (customStyles) {
        customStyles.remove();
      }
      document.querySelectorAll("[data-scale-out-animation]").forEach((el) => {
        el.style.transform = "";
      });
    }
    AOS$1.init({
      useClassNames: true,
      offset: pageAnimation === "section_scale_out" ? 100 : 50,
      duration: pageAnimation === "section_slide_up" ? 600 : 1e3,
      easing: "ease-out",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
      startEvent: "DOMContentLoaded"
    });
  }
}
document.addEventListener("DOMContentLoaded", initializeSectionAnimations);
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", initializeSectionAnimations);
  document.addEventListener("shopify:section:select", initializeSectionAnimations);
  document.addEventListener("shopify:section:deselect", initializeSectionAnimations);
}
window.addEventListener("resize", () => {
  if (document.body.getAttribute("data-page-animation") === "section_scale_out") {
    handleScaleOutEffect();
  }
}, { passive: true });
const _EventManager = class _EventManager {
  /**
   * Create a new EventManager instance for a specific context
   * @param {string} id - Unique identifier for this instance
   * @param {Element} context - DOM context for this instance (default: document)
   */
  constructor(id, context = document) {
    this.id = id;
    this.context = context;
    this.listeners = /* @__PURE__ */ new Map();
    this.sectionEvents = /* @__PURE__ */ new Map();
    this.timers = /* @__PURE__ */ new Map();
    _EventManager.instances.set(id, this);
  }
  /**
   * Add event listener with automatic cleanup tracking
   * @param {Element|string} target - Target element or selector
   * @param {string} event - Event type
   * @param {Function} handler - Event handler
   * @param {Object|boolean} options - Event options or useCapture
   * @returns {Function} Cleanup function
   */
  on(target, event, handler, options = {}) {
    const element = typeof target === "string" ? this.context.querySelector(target) : target;
    if (!element) {
      return () => {
      };
    }
    const wrappedHandler = this._wrapHandler(handler, options);
    element.addEventListener(event, wrappedHandler, options);
    const listenerKey = `${event}-${this._getElementId(element)}`;
    if (!this.listeners.has(listenerKey)) {
      this.listeners.set(listenerKey, []);
    }
    this.listeners.get(listenerKey).push({
      element,
      event,
      handler: wrappedHandler,
      options
    });
    return () => this.off(element, event, wrappedHandler, options);
  }
  /**
   * Remove event listener
   * @param {Element} element - Target element
   * @param {string} event - Event type
   * @param {Function} handler - Event handler
   * @param {Object|boolean} options - Event options
   */
  off(element, event, handler, options = {}) {
    element.removeEventListener(event, handler, options);
    const listenerKey = `${event}-${this._getElementId(element)}`;
    const listeners = this.listeners.get(listenerKey);
    if (listeners) {
      const index = listeners.findIndex(
        (l) => l.element === element && l.event === event && l.handler === handler
      );
      if (index !== -1) {
        listeners.splice(index, 1);
        if (listeners.length === 0) {
          this.listeners.delete(listenerKey);
        }
      }
    }
  }
  /**
   * Add delegated event listener
   * @param {string} selector - Selector for event delegation
   * @param {string} event - Event type
   * @param {Function} handler - Event handler
   * @param {Object} options - Event options
   * @returns {Function} Cleanup function
   */
  delegate(selector, event, handler, options = {}) {
    const delegatedHandler = (e) => {
      const target = e.target.closest(selector);
      if (target && this.context.contains(target)) {
        handler.call(target, e);
      }
    };
    return this.on(this.context, event, delegatedHandler, options);
  }
  /**
   * Add debounced event listener
   * @param {Element|string} target - Target element or selector
   * @param {string} event - Event type
   * @param {Function} handler - Event handler
   * @param {number} delay - Debounce delay in milliseconds
   * @param {Object} options - Event options
   * @returns {Function} Cleanup function
   */
  debounce(target, event, handler, delay = 250, options = {}) {
    const debouncedHandler = this._createDebouncedHandler(handler, delay);
    return this.on(target, event, debouncedHandler, options);
  }
  /**
   * Add throttled event listener
   * @param {Element|string} target - Target element or selector
   * @param {string} event - Event type
   * @param {Function} handler - Event handler
   * @param {number} limit - Throttle limit in milliseconds
   * @param {Object} options - Event options
   * @returns {Function} Cleanup function
   */
  throttle(target, event, handler, limit = 16, options = {}) {
    const throttledHandler = this._createThrottledHandler(handler, limit);
    return this.on(target, event, throttledHandler, options);
  }
  /**
   * Shopify Section Events
   */
  /**
   * Add Shopify section event listeners
   * @param {Object} events - Object mapping event types to handlers
   * @param {string} sectionId - Optional section ID filter
   */
  onSection(events, sectionId = null) {
    const sectionEvents = [
      "shopify:section:load",
      "shopify:section:unload",
      "shopify:section:select",
      "shopify:section:deselect",
      "shopify:section:reorder"
    ];
    const blockEvents = [
      "shopify:block:select",
      "shopify:block:deselect"
    ];
    const allEvents = [...sectionEvents, ...blockEvents];
    allEvents.forEach((eventType) => {
      if (events[eventType]) {
        const handler = (event) => {
          var _a;
          if (sectionId && ((_a = event.detail) == null ? void 0 : _a.sectionId) !== sectionId) {
            return;
          }
          events[eventType](event);
        };
        this.on(document, eventType, handler);
        if (!this.sectionEvents.has(eventType)) {
          this.sectionEvents.set(eventType, []);
        }
        this.sectionEvents.get(eventType).push(handler);
      }
    });
  }
  /**
   * Utility Methods
   */
  /**
   * Wait for element and then add event
   * @param {string} selector - Element selector
   * @param {string} event - Event type
   * @param {Function} handler - Event handler
   * @param {number} timeout - Timeout in milliseconds
   * @param {Object} options - Event options
   * @returns {Promise<Function>} Promise resolving to cleanup function
   */
  waitAndOn(_0, _1, _2) {
    return __async(this, arguments, function* (selector, event, handler, timeout = 5e3, options = {}) {
      try {
        const element = yield this._waitForElement(selector, timeout);
        return this.on(element, event, handler, options);
      } catch (error) {
        return () => {
        };
      }
    });
  }
  /**
   * Add event listener that auto-removes after first trigger
   * @param {Element|string} target - Target element or selector
   * @param {string} event - Event type
   * @param {Function} handler - Event handler
   * @param {Object} options - Event options
   * @returns {Function} Cleanup function
   */
  once(target, event, handler, options = {}) {
    const onceHandler = (e) => {
      handler(e);
      this.off(e.currentTarget, event, onceHandler, options);
    };
    return this.on(target, event, onceHandler, options);
  }
  /**
   * Clean up all listeners for this instance
   */
  destroy() {
    this.listeners.forEach((listenerGroup) => {
      listenerGroup.forEach(({ element, event, handler, options }) => {
        element.removeEventListener(event, handler, options);
      });
    });
    this.listeners.clear();
    this.sectionEvents.clear();
    this.timers.forEach((timer) => clearTimeout(timer));
    this.timers.clear();
    _EventManager.instances.delete(this.id);
  }
  /**
   * Static Methods
   */
  /**
   * Get or create EventManager instance
   * @param {string} id - Instance ID
   * @param {Element} context - DOM context
   * @returns {EventManager} EventManager instance
   */
  static getInstance(id, context = document) {
    if (!this.instances.has(id)) {
      new _EventManager(id, context);
    }
    return this.instances.get(id);
  }
  /**
   * Create global event listener (not tied to any instance)
   * @param {Element|string} target - Target element or selector
   * @param {string} event - Event type
   * @param {Function} handler - Event handler
   * @param {Object} options - Event options
   * @returns {Function} Cleanup function
   */
  static globalOn(target, event, handler, options = {}) {
    const element = typeof target === "string" ? document.querySelector(target) : target;
    if (!element) return () => {
    };
    element.addEventListener(event, handler, options);
    const key = `${event}-${this._getGlobalElementId(element)}`;
    if (!this.globalListeners.has(key)) {
      this.globalListeners.set(key, []);
    }
    this.globalListeners.get(key).push({ element, event, handler, options });
    return () => {
      element.removeEventListener(event, handler, options);
    };
  }
  /**
   * Convenience static methods
   */
  static on(target, event, handler, options = {}) {
    return this.globalOn(target, event, handler, options);
  }
  static onReady(handler) {
    if (document.readyState === "loading") {
      return this.on(document, "DOMContentLoaded", handler);
    } else {
      handler();
      return () => {
      };
    }
  }
  static onScroll(handler, options = {}) {
    const throttledHandler = this._throttle(handler, options.throttle || 16);
    return this.on(window, "scroll", throttledHandler, options);
  }
  static onResize(handler, options = {}) {
    const throttledHandler = this._throttle(handler, options.throttle || 16);
    return this.on(window, "resize", throttledHandler, options);
  }
  static onShopifyEvent(eventName, handler) {
    if (Array.isArray(eventName)) {
      const cleanupFunctions = eventName.map(
        (name) => this.on(document, `shopify:${name}`, handler)
      );
      return () => cleanupFunctions.forEach((fn) => fn());
    }
    return this.on(document, `shopify:${eventName}`, handler);
  }
  static _throttle(func, delay) {
    let timeoutId;
    let lastExecTime = 0;
    return function(...args) {
      const currentTime = Date.now();
      if (currentTime - lastExecTime > delay) {
        func.apply(this, args);
        lastExecTime = currentTime;
      } else {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
          lastExecTime = Date.now();
        }, delay - (currentTime - lastExecTime));
      }
    };
  }
  /**
   * Clean up all global listeners
   */
  static destroyAll() {
    this.instances.forEach((instance) => instance.destroy());
    this.globalListeners.clear();
  }
  /**
   * Private Methods
   */
  _wrapHandler(handler, options) {
    if (options.passive !== void 0) {
      return handler;
    }
    return (event) => {
      try {
        return handler(event);
      } catch (error) {
      }
    };
  }
  _createDebouncedHandler(handler, delay) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => handler(...args), delay);
      this.timers.set(handler, timeoutId);
    };
  }
  _createThrottledHandler(handler, limit) {
    let lastExecution = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastExecution >= limit) {
        lastExecution = now;
        return handler(...args);
      }
    };
  }
  _getElementId(element) {
    return element.id || element.className || element.tagName + "-" + Array.from(element.parentNode.children).indexOf(element);
  }
  static _getGlobalElementId(element) {
    return element.id || element.className || element.tagName + "-" + Date.now();
  }
  _waitForElement(selector, timeout) {
    return new Promise((resolve, reject) => {
      const element = this.context.querySelector(selector);
      if (element) {
        resolve(element);
        return;
      }
      const observer = new MutationObserver(() => {
        const element2 = this.context.querySelector(selector);
        if (element2) {
          observer.disconnect();
          resolve(element2);
        }
      });
      observer.observe(this.context, {
        childList: true,
        subtree: true
      });
      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element ${selector} not found`));
      }, timeout);
    });
  }
};
__publicField(_EventManager, "instances", /* @__PURE__ */ new Map());
__publicField(_EventManager, "globalListeners", /* @__PURE__ */ new Map());
__publicField(_EventManager, "sectionListeners", /* @__PURE__ */ new Map());
let EventManager = _EventManager;
if (typeof window !== "undefined") {
  window.EventManager = EventManager;
}
document.addEventListener("DOMContentLoaded", () => {
  const headerContainer = document.getElementById("header-container");
  if (!headerContainer) {
    return;
  }
  const sections = headerContainer.children;
  const totalSections = sections.length;
  Array.from(sections).forEach((section, index) => {
    var _a;
    const sectionType = section.dataset.sectionType || ((_a = section.querySelector("[data-section-type]")) == null ? void 0 : _a.dataset.sectionType) || "Unknown";
    const isFirstSection = index === 0;
    const isLastSection = index === totalSections - 1;
    section.setAttribute("data-section-index", index);
    section.setAttribute("data-section-type", sectionType);
    section.setAttribute("data-is-first", isFirstSection);
    section.setAttribute("data-is-last", isLastSection);
    if (isFirstSection) {
      section.classList.add("first-section");
    }
    if (isLastSection) {
      section.classList.add("last-section");
    }
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const bodyElement = document.body;
  bodyElement.dataset.template;
  const searchButton = document.querySelector(".search-button--floating");
  const fixedMobileForm = document.querySelector(".product-form--fixed-mobile");
  if (fixedMobileForm) {
    bodyElement.classList.add("has-fixed-form");
  }
  let shouldAddFooterSpacer = false;
  let spacerHeight = 0;
  if (searchButton && window.getComputedStyle(searchButton).display !== "none") {
    shouldAddFooterSpacer = true;
    spacerHeight = 50;
  } else if (fixedMobileForm && window.getComputedStyle(fixedMobileForm).display !== "none") {
    shouldAddFooterSpacer = true;
    spacerHeight = fixedMobileForm.offsetHeight;
  }
  const footerContainer = document.getElementById("footer-container");
  if (!footerContainer) {
    return;
  }
  const sections = footerContainer.querySelectorAll(".shopify-section-group-footer-group");
  const totalSections = sections.length;
  sections.forEach((section, index) => {
    const isFirstSection = index === 0;
    const isLastSection = index === totalSections - 1;
    section.setAttribute("data-section-index", index);
    section.setAttribute("data-is-first", isFirstSection);
    section.setAttribute("data-is-last", isLastSection);
    if (isFirstSection) {
      section.classList.add("first-section");
    }
    if (isLastSection) {
      section.classList.add("last-section");
      if (shouldAddFooterSpacer) {
        addFooterSpacer(section, spacerHeight);
      }
    }
  });
});
function addFooterSpacer(section, height) {
  const spacer = document.createElement("div");
  spacer.id = "footer-spacer";
  spacer.style.height = `${height}px`;
  spacer.style.display = "block";
  const mediaQuery = window.matchMedia("(min-width: 1024px)");
  function handleMediaQueryChange(e) {
    spacer.style.display = e.matches ? "none" : "block";
  }
  handleMediaQueryChange(mediaQuery);
  mediaQuery.addListener(handleMediaQueryChange);
  const contentWrapper = section.querySelector(".footer") || section.querySelector("[data-section-type]") || section;
  contentWrapper.appendChild(spacer);
}
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.closest("#footer-container")) {
      document.dispatchEvent(new Event("DOMContentLoaded"));
    }
  });
}
class ShopifyAPIHelper {
  // 30 seconds cache
  /**
   * Get Shopify routes base URL
   * @returns {string} Base routes URL
   */
  static getRoutesRoot() {
    var _a, _b;
    const root = ((_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) || "/";
    if (!root) return "/";
    return root.endsWith("/") ? root : `${root}/`;
  }
  /**
   * Generic fetch wrapper with error handling and retries
   * @param {string} url - Request URL
   * @param {Object} options - Fetch options
   * @param {number} retryCount - Current retry attempt
   * @returns {Promise<Response>} Fetch response
   */
  static safeFetch(_0) {
    return __async(this, arguments, function* (url, options = {}, retryCount = 0) {
      try {
        const response = yield fetch(url, __spreadValues({
          headers: __spreadValues({
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }, options.headers)
        }, options));
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response;
      } catch (error) {
        if (retryCount < this.maxRetries) {
          yield this.delay(this.retryDelay * (retryCount + 1));
          return this.safeFetch(url, options, retryCount + 1);
        }
        throw error;
      }
    });
  }
  /**
   * Cart Operations
   */
  /**
   * Get current cart data
   * @param {boolean} forceFetch - Skip cache and force new request
   * @returns {Promise<Object>} Cart data
   */
  static getCart(forceFetch = false) {
    return __async(this, null, function* () {
      const cacheKey = "cart-data";
      if (!forceFetch && this.isCacheValid(cacheKey)) {
        return this.cache.get(cacheKey).data;
      }
      try {
        const response = yield this.safeFetch(`${this.getRoutesRoot()}cart.js`);
        const cartData = yield response.json();
        this.setCache(cacheKey, cartData);
        return cartData;
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Add items to cart
   * @param {Object|Array} items - Item(s) to add
   * @returns {Promise<Object>} Updated cart data
   */
  static addToCart(items) {
    return __async(this, null, function* () {
      try {
        const payload = Array.isArray(items) ? { items } : items;
        const response = yield this.safeFetch(`${this.getRoutesRoot()}cart/add.js`, {
          method: "POST",
          body: JSON.stringify(payload)
        });
        const result = yield response.json();
        this.clearCache("cart-data");
        return result;
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Update cart items
   * @param {Object} updates - Updates object with line item keys and quantities
   * @returns {Promise<Object>} Updated cart data
   */
  static updateCart(updates) {
    return __async(this, null, function* () {
      try {
        const response = yield this.safeFetch(`${this.getRoutesRoot()}cart/update.js`, {
          method: "POST",
          body: JSON.stringify({ updates })
        });
        const cartData = yield response.json();
        this.setCache("cart-data", cartData);
        return cartData;
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Change cart line item
   * @param {string|number} line - Line item index (1-based)
   * @param {number} quantity - New quantity
   * @returns {Promise<Object>} Updated cart data
   */
  static changeCartItem(idOrLine, quantity) {
    return __async(this, null, function* () {
      try {
        const payload = typeof idOrLine === "string" ? { id: idOrLine, quantity } : { line: idOrLine, quantity };
        const response = yield this.safeFetch(`${this.getRoutesRoot()}cart/change.js`, {
          method: "POST",
          body: JSON.stringify(payload)
        });
        const cartData = yield response.json();
        this.setCache("cart-data", cartData);
        return cartData;
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Clear cart
   * @returns {Promise<Object>} Empty cart data
   */
  static clearCart() {
    return __async(this, null, function* () {
      try {
        const response = yield this.safeFetch(`${this.getRoutesRoot()}cart/clear.js`, {
          method: "POST"
        });
        const cartData = yield response.json();
        this.setCache("cart-data", cartData);
        return cartData;
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Get cart HTML (for drawer/page updates)
   * @param {string} view - View parameter (e.g., 'drawer', 'page')
   * @returns {Promise<string>} Cart HTML
   */
  static getCartHTML(view = "drawer") {
    return __async(this, null, function* () {
      try {
        const response = yield this.safeFetch(`${this.getRoutesRoot()}cart?view=${view}`);
        return yield response.text();
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Product Operations
   */
  /**
   * Get product data
   * @param {string} handle - Product handle
   * @param {string} view - View parameter for custom data
   * @returns {Promise<Object>} Product data
   */
  static getProduct(handle, view = null) {
    return __async(this, null, function* () {
      const cacheKey = `product-${handle}-${view || "default"}`;
      if (this.isCacheValid(cacheKey)) {
        return this.cache.get(cacheKey).data;
      }
      try {
        const url = view ? `${this.getRoutesRoot()}products/${handle}?view=${view}` : `${this.getRoutesRoot()}products/${handle}.js`;
        const response = yield this.safeFetch(url);
        const productData = view ? yield response.text() : yield response.json();
        this.setCache(cacheKey, productData);
        return productData;
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Get page data
   * @param {string} handle - Page handle
   * @param {string} view - View parameter for custom data
   * @returns {Promise<string>} Page HTML
   */
  static getPage(handle, view = null) {
    return __async(this, null, function* () {
      const cacheKey = `page-${handle}-${view || "default"}`;
      if (this.isCacheValid(cacheKey)) {
        return this.cache.get(cacheKey).data;
      }
      try {
        const url = view ? `${this.getRoutesRoot()}pages/${handle}?view=${view}` : `${this.getRoutesRoot()}pages/${handle}`;
        const response = yield this.safeFetch(url);
        const pageData = yield response.text();
        this.setCache(cacheKey, pageData);
        return pageData;
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Get variant inventory data
   * @param {string} handle - Product handle
   * @param {string|number} variantId - Variant ID
   * @returns {Promise<string>} Inventory HTML
   */
  static getVariantInventory(handle, variantId) {
    return __async(this, null, function* () {
      try {
        const response = yield this.safeFetch(`/products/${handle}?view=inventory&variant=${variantId}`);
        return yield response.text();
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Section Operations
   */
  /**
   * Render section with parameters
   * @param {string} sectionId - Section ID
   * @param {Object} params - URL parameters
   * @returns {Promise<string>} Section HTML
   */
  static renderSection(_0) {
    return __async(this, arguments, function* (sectionId, params = {}) {
      const cacheKey = `section-${sectionId}-${JSON.stringify(params)}`;
      if (this.isCacheValid(cacheKey)) {
        return this.cache.get(cacheKey).data;
      }
      try {
        const searchParams = new URLSearchParams(params);
        searchParams.append("section_id", sectionId);
        const response = yield this.safeFetch(`${this.getRoutesRoot()}?${searchParams.toString()}`);
        const html = yield response.text();
        this.setCache(cacheKey, html, 1e4);
        return html;
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Search Operations
   */
  /**
   * Perform predictive search
   * @param {string} query - Search query
   * @param {Object} options - Search options
   * @returns {Promise<string>} Search results HTML
   */
  static predictiveSearch(_0) {
    return __async(this, arguments, function* (query, options = {}) {
      if (!query || query.length < 2) {
        return "";
      }
      const cacheKey = `search-${query}-${JSON.stringify(options)}`;
      if (this.isCacheValid(cacheKey, 6e4)) {
        return this.cache.get(cacheKey).data;
      }
      try {
        const searchParams = new URLSearchParams(__spreadValues({
          q: query,
          section_id: "predictive-search"
        }, options));
        const response = yield this.safeFetch(`${this.getRoutesRoot()}search/suggest?${searchParams.toString()}`);
        const html = yield response.text();
        this.setCache(cacheKey, html, 6e4);
        return html;
      } catch (error) {
        throw error;
      }
    });
  }
  /**
   * Utility Methods
   */
  /**
   * Set cache with timestamp
   * @param {string} key - Cache key
   * @param {*} data - Data to cache
   * @param {number} timeout - Cache timeout (default: class timeout)
   */
  static setCache(key, data, timeout = this.cacheTimeout) {
    this.cache.set(key, {
      data,
      timestamp: Date.now(),
      timeout
    });
  }
  /**
   * Check if cache entry is valid
   * @param {string} key - Cache key
   * @param {number} customTimeout - Custom timeout override
   * @returns {boolean} Whether cache is valid
   */
  static isCacheValid(key, customTimeout = null) {
    if (!this.cache.has(key)) return false;
    const cached = this.cache.get(key);
    const timeout = customTimeout || cached.timeout || this.cacheTimeout;
    return Date.now() - cached.timestamp < timeout;
  }
  /**
   * Clear specific cache entry or all cache
   * @param {string} key - Specific cache key (optional)
   */
  static clearCache(key = null) {
    if (key) {
      this.cache.delete(key);
    } else {
      this.cache.clear();
    }
  }
  /**
   * Delay utility for retries
   * @param {number} ms - Milliseconds to delay
   * @returns {Promise} Promise that resolves after delay
   */
  static delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  /**
   * Queue API requests to prevent overwhelming the server
   * @param {Function} requestFunction - Function that returns a Promise
   * @returns {Promise} Queued request result
   */
  static queueRequest(requestFunction) {
    return __async(this, null, function* () {
      return new Promise((resolve, reject) => {
        this.requestQueue.push({ requestFunction, resolve, reject });
        this.processQueue();
      });
    });
  }
  /**
   * Process the request queue
   * @private
   */
  static processQueue() {
    return __async(this, null, function* () {
      if (this.isProcessingQueue || this.requestQueue.length === 0) return;
      this.isProcessingQueue = true;
      while (this.requestQueue.length > 0) {
        const { requestFunction, resolve, reject } = this.requestQueue.shift();
        try {
          const result = yield requestFunction();
          resolve(result);
        } catch (error) {
          reject(error);
        }
        yield this.delay(25);
      }
      this.isProcessingQueue = false;
    });
  }
}
__publicField(ShopifyAPIHelper, "cache", /* @__PURE__ */ new Map());
__publicField(ShopifyAPIHelper, "requestQueue", []);
__publicField(ShopifyAPIHelper, "isProcessingQueue", false);
__publicField(ShopifyAPIHelper, "maxRetries", 3);
__publicField(ShopifyAPIHelper, "retryDelay", 1e3);
__publicField(ShopifyAPIHelper, "cacheTimeout", 3e4);
if (typeof window !== "undefined") {
  window.ShopifyAPIHelper = ShopifyAPIHelper;
}
function isSlideAnimationEnabled() {
  try {
    return document.body.getAttribute("data-slide-in-drawers") === "true";
  } catch (error) {
    return false;
  }
}
class Drawer {
  constructor(options = {}) {
    this.drawerElement = options.element;
    if (!this.drawerElement) {
      return;
    }
    this.drawerElement.drawer = this;
    this.isAnimating = false;
    this.onOpen = options.onOpen || (() => {
    });
    this.onClose = options.onClose || (() => {
    });
    this.slideEnabled = isSlideAnimationEnabled();
    this.config = {
      desktopWidth: this.drawerElement.getAttribute("data-desktop-width"),
      mobileWidth: this.drawerElement.getAttribute("data-mobile-width"),
      hasBackground: this.drawerElement.classList.contains("drawer--with-background")
    };
    this.setupListeners();
    this.setupResponsiveWidth();
    this.events = {};
  }
  setupListeners() {
    const overlay = this.drawerElement.querySelector(".drawer-overlay");
    const closeBtn = this.drawerElement.querySelector(".drawer-close");
    if (overlay) overlay.addEventListener("click", () => this.close());
    if (closeBtn) closeBtn.addEventListener("click", () => this.close());
    this.drawerElement.addEventListener("click", (e) => {
      if (e.target === this.drawerElement) {
        this.close();
      }
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.drawerElement.classList.contains("active")) {
        this.close();
      }
    });
    window.addEventListener("resize", () => this.setupResponsiveWidth());
  }
  setupResponsiveWidth() {
    const drawerContent = this.drawerElement.querySelector(".drawer-content");
    if (!drawerContent) return;
    const desktopWidth = this.drawerElement.getAttribute("data-desktop-width") || this.config.desktopWidth;
    const mobileWidth = this.drawerElement.getAttribute("data-mobile-width") || this.config.mobileWidth;
    if (window.innerWidth < 768 && mobileWidth) {
      drawerContent.style.width = mobileWidth;
      drawerContent.style.maxWidth = "100vw";
    } else if (desktopWidth) {
      drawerContent.style.width = desktopWidth;
      drawerContent.style.maxWidth = "";
    }
  }
  open() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    if (window.innerWidth <= 1023) {
      document.body.style.overflow = "hidden";
    }
    this.drawerElement.style.display = "block";
    this.drawerElement.setAttribute("aria-hidden", "false");
    void this.drawerElement.offsetWidth;
    this.setupResponsiveWidth();
    this.drawerElement.classList.add("active");
    setTimeout(() => {
      this.isAnimating = false;
      this.onOpen();
      this.trigger("open");
      const closeBtn = this.drawerElement.querySelector(".drawer-close");
      if (closeBtn) closeBtn.focus();
    }, this.slideEnabled ? 300 : 0);
  }
  close() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    if (window.innerWidth <= 1023) {
      document.body.style.overflow = "";
    }
    if (this.slideEnabled) {
      this.drawerElement.classList.add("closing");
      setTimeout(() => {
        this.drawerElement.classList.remove("active");
        setTimeout(() => {
          this.drawerElement.classList.remove("closing");
          this.drawerElement.style.display = "none";
          this.drawerElement.setAttribute("aria-hidden", "true");
          this.isAnimating = false;
          this.onClose();
          this.trigger("close");
        }, 50);
      }, 400);
    } else {
      this.drawerElement.classList.remove("active");
      this.drawerElement.style.display = "none";
      this.drawerElement.setAttribute("aria-hidden", "true");
      this.isAnimating = false;
      this.onClose();
      this.trigger("close");
    }
  }
  setContent(content) {
    const drawerBody = this.drawerElement.querySelector(".drawer-body");
    if (!drawerBody) return;
    if (typeof content === "string") {
      drawerBody.innerHTML = content;
    } else if (content instanceof Node) {
      drawerBody.innerHTML = "";
      drawerBody.appendChild(content);
    }
    this.setupResponsiveWidth();
  }
  // Event handling
  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
    return this;
  }
  off(event, callback) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter((cb) => cb !== callback);
    }
    return this;
  }
  trigger(event, ...args) {
    if (this.events[event]) {
      this.events[event].forEach((callback) => callback(...args));
    }
    return this;
  }
  get isOpen() {
    return this.drawerElement.classList.contains("active");
  }
}
function initializeDrawers() {
  const mobileDrawer = document.querySelector("[data-mobile-drawer]");
  if (mobileDrawer && !mobileDrawer.drawer) {
    new Drawer({ element: mobileDrawer });
  }
  const cartDrawer = document.querySelector("[data-cart-drawer]");
  if (cartDrawer && !cartDrawer.drawer) {
    new Drawer({ element: cartDrawer });
  }
  const sizeGuideDrawer2 = document.querySelector("[data-sizeguide-drawer]");
  if (sizeGuideDrawer2 && !sizeGuideDrawer2.drawer) {
    new Drawer({ element: sizeGuideDrawer2 });
  }
  const pickupDrawer = document.querySelector("[data-pickup-availability-drawer]");
  if (pickupDrawer && !pickupDrawer.drawer) {
    new Drawer({ element: pickupDrawer });
  }
  const filterDrawer = document.querySelector("[data-collection-filter-drawer]");
  if (filterDrawer && !filterDrawer.drawer) {
    new Drawer({ element: filterDrawer });
  }
  const orderNotesDrawer = document.querySelector("[data-order-notes-drawer]");
  if (orderNotesDrawer && !orderNotesDrawer.drawer) {
    new Drawer({ element: orderNotesDrawer });
  }
  const giftNotesDrawer = document.querySelector("[data-gift-notes-drawer]");
  if (giftNotesDrawer && !giftNotesDrawer.drawer) {
    new Drawer({ element: giftNotesDrawer });
  }
}
function setupDrawerInitializers() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeDrawers);
  } else {
    initializeDrawers();
  }
  document.addEventListener("criticalReady", initializeDrawers);
  document.addEventListener("shopify:section:load", (event) => {
    const drawer = event.target.querySelector("[data-drawer]");
    if (drawer && !drawer.drawer) {
      new Drawer({ element: drawer });
    }
  });
}
setupDrawerInitializers();
if (typeof window !== "undefined") {
  window.Drawer = Drawer;
}
const safeAreaHeight = window.innerHeight;
window.addEventListener("resize", () => {
  if (window.innerHeight < safeAreaHeight) {
    document.body.style.marginBottom = `${safeAreaHeight - window.innerHeight}px`;
  } else {
    document.body.style.marginBottom = "0px";
  }
});
document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".no-scroll-enabled")) {
    document.body.classList.add("no-scroll-active");
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const sortFilterBtn = document.getElementById("collectionSortFilterBtn");
  if (sortFilterBtn) {
    const caretWrapper = sortFilterBtn.querySelector(".collection-sort-caret-wrapper");
    const dropdownContent = sortFilterBtn.nextElementSibling;
    if (caretWrapper && dropdownContent) {
      sortFilterBtn.addEventListener("click", () => {
        dropdownContent.classList.toggle("hidden");
        caretWrapper.classList.toggle("flipped");
      });
    }
  }
});
let lastScrollTime = 0;
const SCROLL_THROTTLE = 150;
let cachedWindowWidth = window.innerWidth;
window.addEventListener("resize", () => {
  cachedWindowWidth = window.innerWidth;
});
$(window).scroll(function() {
  const now = Date.now();
  if (now - lastScrollTime < SCROLL_THROTTLE) {
    return;
  }
  lastScrollTime = now;
  const backToTop = document.getElementById("back-to-top");
  if (!backToTop) return;
  if ($(this).scrollTop() > 0 && cachedWindowWidth > 1024) {
    backToTop.style.opacity = "1";
    backToTop.style.visibility = "visible";
    backToTop.style.transform = "translate3d(0, 0, 0)";
    backToTop.classList.remove("opacity-0", "invisible");
    backToTop.classList.add("opacity-100", "visible");
  } else {
    backToTop.style.opacity = "0";
    backToTop.style.visibility = "hidden";
    backToTop.classList.remove("opacity-100", "visible");
    backToTop.classList.add("opacity-0", "invisible");
  }
});
$("#back-to-top").click(() => {
  $("body,html").animate({ scrollTop: 0 }, 500);
  return false;
});
class HeaderTransparencyManager {
  constructor() {
    this.isScrollFadeEnabled = false;
    this.scrollThreshold = 50;
    this.currentState = "solid";
    this.isMenuHovered = false;
    this.cachedNavElements = null;
    this.lastScrollTime = 0;
    this.scrollHandler = this.handleScroll.bind(this);
  }
  init() {
    if (!window.DOMHelper) {
      window.addEventListener("DOMHelperReady", () => {
        setTimeout(() => this.init(), 50);
      });
      return;
    }
    this.checkInitialState();
    this.setupEvents();
    this.applyState();
    window.headerTransparencyManager = this;
  }
  checkInitialState() {
    if (!window.DOMHelper) return;
    try {
      const body = document.body;
      const main = window.DOMHelper.safeQuery("#main");
      const isGloballyTransparent = window.DOMHelper.getAttribute(body, "data-transparent-background") === "true";
      const firstSection = window.DOMHelper.safeQuery('[id^="shopify-section-"]:first-child', main);
      const hasDisableHeaderSpace = window.DOMHelper.safeQuery(".disable-main-header-space", firstSection) !== null;
      this.isScrollFadeEnabled = hasDisableHeaderSpace && !isGloballyTransparent;
      if (this.isScrollFadeEnabled) {
        this.currentState = window.scrollY <= this.scrollThreshold ? "transparent" : "solid";
      } else if (isGloballyTransparent) {
        this.currentState = "transparent";
      } else {
        this.currentState = "solid";
      }
    } catch (error) {
    }
  }
  setupEvents() {
    try {
      if (this.isScrollFadeEnabled) {
        if (window.ultraScrollCoordinator) {
          window.ultraScrollCoordinator.subscribe("header-transparency", this.scrollHandler, {
            priority: "high",
            // Header has high priority for immediate visual feedback
            throttle: 16
            // Reduced for better fast scroll responsiveness
          });
        } else {
          window.addEventListener("scroll", this.scrollHandler, { passive: true });
          window.addEventListener("wheel", this.scrollHandler, { passive: true });
          window.addEventListener("touchmove", this.scrollHandler, { passive: true });
        }
      }
      window.addEventListener("menuHover", (e) => {
        var _a;
        this.isMenuHovered = ((_a = e.detail) == null ? void 0 : _a.isHovered) || false;
        this.applyState();
      });
      document.addEventListener("searchOpened", () => {
        this.applyState();
      });
      document.addEventListener("searchClosed", () => {
        this.applyState();
      });
      const searchObserver = new MutationObserver(() => {
        this.applyState();
      });
      if (document.body) {
        searchObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ["data-search-open"]
        });
        this.searchObserver = searchObserver;
      }
    } catch (error) {
    }
  }
  handleScroll() {
    const now = Date.now();
    if (now - this.lastScrollTime < 16) return;
    this.lastScrollTime = now;
    if (!this.isScrollFadeEnabled) return;
    const newState = window.scrollY <= this.scrollThreshold ? "transparent" : "solid";
    if (newState !== this.currentState) {
      this.currentState = newState;
      this.applyState();
    }
  }
  applyState() {
    if (!window.DOMHelper) return;
    try {
      const isTransparent = this.currentState === "transparent";
      const isSearchOpen = window.DOMHelper.getAttribute(document.body, "data-search-open") === "true";
      const shouldBeTransparent = isTransparent && !this.isMenuHovered && !isSearchOpen;
      const headers = window.DOMHelper.getAllHeaders();
      Object.values(headers).forEach((header) => {
        if (!header) return;
        if (shouldBeTransparent) {
          window.DOMHelper.addClass(header, "header--transparent");
          window.DOMHelper.removeClass(header, "header--solid");
        } else {
          window.DOMHelper.addClass(header, "header--solid");
          window.DOMHelper.removeClass(header, "header--transparent");
        }
      });
      this.updateNavLinks(shouldBeTransparent);
      this.updateGlobalFlags(shouldBeTransparent);
      document.dispatchEvent(new CustomEvent("headerTransparencyChanged", {
        detail: { isTransparent: shouldBeTransparent }
      }));
    } catch (error) {
    }
  }
  updateNavLinks(usePriority) {
    try {
      if (!this.cachedNavElements) {
        this.cachedNavElements = window.DOMHelper.safeQueryAll(".header-navigation a, .header-navigation button");
      }
      this.cachedNavElements.forEach((link) => {
        if (usePriority) {
          window.DOMHelper.addClass(link, "nav-link--priority");
        } else {
          window.DOMHelper.removeClass(link, "nav-link--priority");
        }
      });
    } catch (error) {
    }
  }
  updateGlobalFlags(isTransparent) {
    try {
      const body = document.body;
      const isGloballyTransparent = window.DOMHelper.getAttribute(body, "data-transparent-background") === "true";
      window.tempTransparentOverride = this.isScrollFadeEnabled && isTransparent || isGloballyTransparent && isTransparent;
      window.altColorShouldContinue = this.isScrollFadeEnabled && isTransparent || isGloballyTransparent && isTransparent;
      if (isTransparent) {
        window.DOMHelper.addClass(body, "header-transparent");
        window.DOMHelper.removeClass(body, "header-solid");
      } else {
        window.DOMHelper.addClass(body, "header-solid");
        window.DOMHelper.removeClass(body, "header-transparent");
      }
    } catch (error) {
    }
  }
  cleanup() {
    try {
      if (window.ultraScrollCoordinator) {
        window.ultraScrollCoordinator.unsubscribe("header-transparency", this.scrollHandler);
      } else {
        window.removeEventListener("scroll", this.scrollHandler);
        window.removeEventListener("wheel", this.scrollHandler);
        window.removeEventListener("touchmove", this.scrollHandler);
      }
      this.cachedNavElements = null;
      if (this.searchObserver) {
        this.searchObserver.disconnect();
        this.searchObserver = null;
      }
    } catch (error) {
    }
  }
}
function initHeaderTransparency() {
  if (!window.DOMHelper) {
    window.addEventListener("DOMHelperReady", () => {
      setTimeout(() => initHeaderTransparency(), 50);
    });
    return;
  }
  try {
    new HeaderTransparencyManager().init();
  } catch (error) {
  }
}
if (typeof window.ModuleManager !== "undefined") {
  window.ModuleManager.register("HeaderTransparencyManager", initHeaderTransparency, ["DOMHelper"]);
} else {
  const initWhenReady = () => {
    if (window.DOMHelper) {
      initHeaderTransparency();
    } else {
      setTimeout(initWhenReady, 100);
    }
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWhenReady);
  } else {
    initWhenReady();
  }
}
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  const themeEditorEvents = [
    "shopify:section:load",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect"
  ];
  themeEditorEvents.forEach((eventName) => {
    document.addEventListener(eventName, () => {
      setTimeout(() => {
        initHeaderTransparency();
      }, 100);
    });
  });
}
document.addEventListener("DOMContentLoaded", () => {
  const navLinks = document.querySelectorAll("[data-nav-link]");
  navLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      const url = link.getAttribute("href");
      if (url.startsWith("#")) {
        event.preventDefault();
      }
    });
  });
});
function initializeAltColorAndLogoLogic() {
  if (window.altColorLogicInitialized) {
    cleanupAltColorLogic();
  }
  const transparentBackground = document.body.dataset.transparentBackground === "true";
  const headerLayout = document.body.dataset.headerLayout;
  const disableScrolling = document.body.dataset.disableScrolling === "true";
  let disableAltColorSideNav = false;
  let cachedElements = {
    menuItems: null,
    colorTriggers: null,
    logoTriggers: null,
    headerCenter: null,
    lastUpdate: 0
  };
  function cacheElements() {
    cachedElements.menuItems = document.querySelectorAll(".menu-item, .menu-item-left, .nav-alt-trigger, .nav-logo-alt-trigger");
    cachedElements.colorTriggers = document.querySelectorAll(".alt-color-trigger");
    cachedElements.logoTriggers = document.querySelectorAll(".alt-logo-trigger");
    cachedElements.headerCenter = document.getElementById("header-center");
    cachedElements.lastUpdate = Date.now();
    window.altColorCachedElements = cachedElements;
  }
  let intersectionObserver = null;
  let observedElements = /* @__PURE__ */ new Map();
  function setupIntersectionObserver() {
    if ("IntersectionObserver" in window) {
      intersectionObserver = new IntersectionObserver((entries) => {
        let hasChanges = false;
        entries.forEach((entry) => {
          const element = entry.target;
          const isIntersecting = entry.isIntersecting;
          const wasIntersecting = observedElements.get(element);
          if (wasIntersecting !== isIntersecting) {
            observedElements.set(element, isIntersecting);
            hasChanges = true;
          }
        });
        if (hasChanges) {
          updateStyles();
        }
      }, {
        rootMargin: "50px 0px",
        threshold: 0.1
      });
      window.altColorIntersectionObserver = intersectionObserver;
      [...cachedElements.colorTriggers, ...cachedElements.logoTriggers].forEach((trigger) => {
        intersectionObserver.observe(trigger);
        observedElements.set(trigger, false);
      });
    }
  }
  let lastTransparencyState = null;
  let lastMenuHoverState = null;
  let lastSearchState = null;
  let animationFrameId = null;
  let updateThrottleId = null;
  function throttledUpdate() {
    if (updateThrottleId) return;
    updateThrottleId = setTimeout(() => {
      updateStyles();
      updateThrottleId = null;
    }, 16);
  }
  function updateStyles() {
    var _a;
    const currentTransparencyState = transparentBackground || window.tempTransparentOverride;
    const currentMenuHoverState = ((_a = cachedElements.headerCenter) == null ? void 0 : _a.getAttribute("data-menu-hovered")) === "true";
    const currentSearchState = document.body.hasAttribute("data-search-open");
    if (lastTransparencyState === currentTransparencyState && lastMenuHoverState === currentMenuHoverState && lastSearchState === currentSearchState && !window.altColorShouldContinue) {
      return;
    }
    lastTransparencyState = currentTransparencyState;
    lastMenuHoverState = currentMenuHoverState;
    lastSearchState = currentSearchState;
    const isEffectivelyTransparent = currentTransparencyState && !currentSearchState && !currentMenuHoverState;
    document.createDocumentFragment();
    cachedElements.menuItems.forEach((menuItem) => {
      let useAltLogo = null;
      let useAltColor = false;
      if (intersectionObserver) {
        cachedElements.logoTriggers.forEach((trigger) => {
          if (observedElements.get(trigger)) {
            useAltLogo = trigger.dataset.useAltLogo === "true";
          }
        });
        cachedElements.colorTriggers.forEach((trigger) => {
          if (observedElements.get(trigger)) {
            useAltColor = trigger.dataset.useAltColor === "true";
          }
        });
      } else {
        const menuItemRect = menuItem.getBoundingClientRect();
        cachedElements.logoTriggers.forEach((trigger) => {
          const triggerRect = trigger.getBoundingClientRect();
          if (menuItemRect.top < triggerRect.bottom && menuItemRect.bottom > triggerRect.top) {
            useAltLogo = trigger.dataset.useAltLogo === "true";
          }
        });
        cachedElements.colorTriggers.forEach((trigger) => {
          const triggerRect = trigger.getBoundingClientRect();
          if (menuItemRect.top < triggerRect.bottom && menuItemRect.bottom > triggerRect.top) {
            useAltColor = trigger.dataset.useAltColor === "true";
          }
        });
      }
      if (headerLayout === "left" && !isEffectivelyTransparent && menuItem.classList.contains("menu-item")) {
        useAltColor = false;
      }
      if (headerLayout === "left" && !isEffectivelyTransparent) {
        useAltLogo = false;
      }
      if (headerLayout === "center" && !isEffectivelyTransparent) {
        useAltColor = false;
        useAltLogo = false;
      }
      if (headerLayout === "inline" && !isEffectivelyTransparent) {
        useAltColor = false;
        useAltLogo = false;
      }
      const normalLogos = menuItem.querySelectorAll(".normal-logo, .normal-logo-left");
      const altLogos = menuItem.querySelectorAll(".alt-logo, .alt-logo-left");
      if (normalLogos.length > 0 && altLogos.length > 0) {
        normalLogos.forEach((normalLogo) => {
          if (!isEffectivelyTransparent) {
            normalLogo.style.cssText = "visibility: visible; opacity: 1; display: block;";
          } else if (useAltLogo !== null) {
            normalLogo.style.cssText = `visibility: ${useAltLogo ? "hidden" : "visible"}; opacity: ${useAltLogo ? "0" : "1"}; display: block;`;
          } else {
            normalLogo.style.cssText = `visibility: ${useAltColor ? "hidden" : "visible"}; opacity: ${useAltColor ? "0" : "1"}; display: block;`;
          }
        });
        altLogos.forEach((altLogo) => {
          if (!isEffectivelyTransparent) {
            altLogo.style.cssText = "visibility: hidden; opacity: 0; display: block;";
          } else if (useAltLogo !== null) {
            altLogo.style.cssText = `visibility: ${useAltLogo ? "visible" : "hidden"}; opacity: ${useAltLogo ? "1" : "0"}; display: block;`;
          } else {
            altLogo.style.cssText = `visibility: ${useAltColor ? "visible" : "hidden"}; opacity: ${useAltColor ? "1" : "0"}; display: block;`;
          }
        });
      }
      const navElements = menuItem.querySelectorAll(".nav-link, .disclosure__button, .disclosure__button span, .clear-search");
      const shouldUseAltLink = isEffectivelyTransparent && useAltColor;
      navElements.forEach((element) => {
        element.classList.toggle("alt-nav-link", shouldUseAltLink);
      });
      const sideNavElements = menuItem.querySelectorAll(".nav-link-side, .sub-nav-link-side");
      if (!disableAltColorSideNav) {
        sideNavElements.forEach((element) => {
          element.classList.toggle("alt-nav-link", shouldUseAltLink);
        });
      } else {
        sideNavElements.forEach((element) => {
          element.classList.remove("alt-nav-link");
        });
      }
      const normalLogoLefts = menuItem.querySelectorAll(".normal-logo-left");
      const altLogoLefts = menuItem.querySelectorAll(".alt-logo-left");
      normalLogoLefts.forEach((normalLogoLeft) => {
        let shouldDisplay = "block";
        if (useAltLogo !== null) {
          shouldDisplay = useAltLogo ? "none" : "block";
        } else if (useAltColor) {
          shouldDisplay = "none";
        }
        normalLogoLeft.style.display = shouldDisplay;
      });
      altLogoLefts.forEach((altLogoLeft) => {
        let shouldDisplay = "none";
        if (useAltLogo !== null) {
          shouldDisplay = useAltLogo ? "block" : "none";
        } else if (useAltColor) {
          shouldDisplay = "block";
        }
        altLogoLeft.style.display = shouldDisplay;
      });
    });
  }
  function checkForUpdates() {
    const hasActiveTriggers = cachedElements.colorTriggers.length > 0 || cachedElements.logoTriggers.length > 0;
    const currentTransparencyState = transparentBackground || window.tempTransparentOverride;
    const shouldContinue = hasActiveTriggers || lastTransparencyState === null || lastTransparencyState !== currentTransparencyState || window.altColorShouldContinue;
    if (shouldContinue) {
      animationFrameId = requestAnimationFrame(checkForUpdates);
    } else {
      animationFrameId = null;
    }
  }
  function initialize() {
    cacheElements();
    setupIntersectionObserver();
    updateStyles();
    checkForUpdates();
    window.altColorLogicInitialized = true;
    window.altColorCleanupId = animationFrameId;
  }
  document.addEventListener("headerTransparencyChanged", throttledUpdate);
  window.addEventListener("menuHover", (e) => {
    throttledUpdate();
    if (!animationFrameId) {
      checkForUpdates();
    }
  });
  document.addEventListener("menuOpenManualOverride", () => {
    disableAltColorSideNav = true;
    throttledUpdate();
  });
  document.addEventListener("menuCloseManualOverride", () => {
    disableAltColorSideNav = false;
    throttledUpdate();
  });
  initialize();
  if (disableScrolling) {
    document.body.classList.add("no-scroll-enabled", "noscroll-local-footer", "lp-disable-main-header-space", "noscroll-local-footer");
  }
}
document.addEventListener("DOMContentLoaded", initializeAltColorAndLogoLogic);
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  const themeEditorEvents = [
    "shopify:section:load",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect",
    "shopify:section:reorder"
  ];
  themeEditorEvents.forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.target.closest("header") || event.target.querySelector("header") || event.target.closest('[class*="header"]') || event.target.querySelector('[class*="header"]')) {
        cleanupAltColorLogic();
        setTimeout(() => {
          initializeAltColorAndLogoLogic();
        }, 100);
      }
    });
  });
  document.addEventListener("shopify:editor:settings:update", () => {
    cleanupAltColorLogic();
    setTimeout(() => {
      initializeAltColorAndLogoLogic();
    }, 150);
  });
}
function cleanupAltColorLogic() {
  if (window.altColorLogicInitialized) {
    if (window.altColorCleanupId) {
      cancelAnimationFrame(window.altColorCleanupId);
      window.altColorCleanupId = null;
    }
    if (window.altColorIntersectionObserver) {
      window.altColorIntersectionObserver.disconnect();
      window.altColorIntersectionObserver = null;
    }
    if (window.altColorCachedElements) {
      window.altColorCachedElements.menuItems = null;
      window.altColorCachedElements.colorTriggers = null;
      window.altColorCachedElements.logoTriggers = null;
      window.altColorCachedElements.headerCenter = null;
    }
    window.altColorLogicInitialized = false;
  }
}
document.addEventListener("DOMContentLoaded", initializeMenu);
document.addEventListener("shopify:section:load", initializeMenu);
document.addEventListener("shopify:section:reorder", initializeMenu);
document.addEventListener("shopify:block:select", initializeMenu);
let headerClickHandler;
window.headerClickHandler = headerClickHandler;
function initializeMenu() {
  const header = document.getElementById("header-side");
  if (!header) {
    return;
  }
  header.style.visibility = "hidden";
  if (headerClickHandler) {
    header.removeEventListener("click", headerClickHandler);
  }
  headerClickHandler = (event) => {
    const clickedElement = event.target.closest(".nav-alt-trigger");
    if (clickedElement) {
      const parentItem = clickedElement.closest(".menu-item-left, .submenu-item-left, .sub-submenu-item-left");
      if (parentItem) {
        handleAccordionToggle(parentItem, event);
      }
    }
  };
  header.addEventListener("click", headerClickHandler);
  markPlaceholderLinks();
  clearSessionStorageOnLoad();
  restoreAccordionState();
  header.style.visibility = "visible";
}
function markPlaceholderLinks() {
  const submenuItems = document.querySelectorAll(".submenu-item-left, .sub-submenu-item-left");
  submenuItems.forEach((item) => {
    const link = item.querySelector("a");
    if (link) {
      const href = link.getAttribute("href");
      const isPlaceholder = !href || href === "#" || href === "";
      if (isPlaceholder) {
        item.setAttribute("data-placeholder-link", "true");
      } else {
        item.removeAttribute("data-placeholder-link");
        item.classList.add("active");
        const submenu = item.querySelector(".submenu-left, .sub-submenu-left");
        if (submenu) {
          submenu.style.height = "auto";
          submenu.style.display = "block";
          submenu.style.opacity = "1";
          submenu.style.visibility = "visible";
        }
        const childLinks = item.querySelectorAll(".sub-nav-link-side");
        childLinks.forEach((link2) => link2.setAttribute("tabindex", "0"));
      }
    }
  });
}
function clearSessionStorageOnLoad() {
  const sessionMarker = sessionStorage.getItem("vertical-menuSessionActive");
  if (!sessionMarker) {
    sessionStorage.removeItem("vertical-activeMenuItem");
    sessionStorage.removeItem("vertical-activeSubmenuItem");
    sessionStorage.removeItem("vertical-activeSubSubmenuItem");
    sessionStorage.removeItem("vertical-closedMenuItem");
    sessionStorage.removeItem("vertical-closedSubmenuItem");
    sessionStorage.removeItem("vertical-closedSubSubmenuItem");
    sessionStorage.setItem("vertical-menuSessionActive", "true");
  }
}
function handleAccordionToggle(clickedItem, event) {
  const isMenuItem = clickedItem.classList.contains("menu-item-left");
  const isSubmenuItem = clickedItem.classList.contains("submenu-item-left");
  const isActive = clickedItem.classList.contains("active");
  const isAnimated = document.body.getAttribute("data-enable-submenu-fadein") === "true";
  const isPlaceholderLink = clickedItem.hasAttribute("data-placeholder-link");
  if (!isPlaceholderLink && (isSubmenuItem || clickedItem.classList.contains("sub-submenu-item-left"))) {
    const clickedLink2 = event.target.closest("a");
    if (clickedLink2 && clickedLink2.getAttribute("href") !== "#") {
      return;
    }
  }
  closeItemsAtSameOrLowerLevel(isMenuItem, isSubmenuItem);
  if (!isActive) {
    requestAnimationFrame(() => {
      clickedItem.classList.add("active");
      if (isAnimated) {
        const submenu = clickedItem.querySelector(".submenu-left, .sub-submenu-left");
        if (submenu) {
          animateSubmenu(submenu, true);
        }
      }
    });
    const childLinks = clickedItem.querySelectorAll(".sub-nav-link-side");
    childLinks.forEach((link) => link.setAttribute("tabindex", "0"));
    saveState(clickedItem);
  } else {
    if (isAnimated) {
      const submenu = clickedItem.querySelector(".submenu-left, .sub-submenu-left");
      if (submenu) {
        animateSubmenu(submenu, false);
      }
    }
    clickedItem.classList.remove("active");
    sessionStorage.removeItem(clickedItem.id);
    const childLinks = clickedItem.querySelectorAll(".sub-nav-link-side");
    childLinks.forEach((link) => link.setAttribute("tabindex", "-1"));
  }
  event.preventDefault();
  const clickedLink = event.target.closest("a");
  if (clickedLink && clickedLink.getAttribute("href") !== "#") {
    window.location.href = clickedLink.getAttribute("href");
  }
}
function animateSubmenu(submenu, isOpening) {
  const animationDuration = 300;
  if (isOpening) {
    submenu.style.height = "0px";
    const scrollHeight = submenu.scrollHeight;
    submenu.style.height = `${scrollHeight}px`;
    setTimeout(() => {
      submenu.style.height = "";
    }, animationDuration);
  } else {
    const scrollHeight = submenu.scrollHeight;
    submenu.style.height = `${scrollHeight}px`;
    submenu.offsetHeight;
    submenu.style.height = "0px";
    setTimeout(() => {
      submenu.style.height = "";
    }, animationDuration);
  }
}
function closeItemsAtSameOrLowerLevel(isMenuItem, isSubmenuItem) {
  const isAnimated = document.body.getAttribute("data-enable-submenu-fadein") === "true";
  const allItems = document.querySelectorAll(".menu-item-left, .submenu-item-left, .sub-submenu-item-left");
  allItems.forEach((item) => {
    const isPlaceholderLink = item.hasAttribute("data-placeholder-link");
    if (!isPlaceholderLink && (item.classList.contains("submenu-item-left") || item.classList.contains("sub-submenu-item-left"))) {
      return;
    }
    const isSubSubmenuItem = item.classList.contains("sub-submenu-item-left");
    const isCurrentSubmenuItem = item.classList.contains("submenu-item-left");
    if (isMenuItem || isSubmenuItem && isSubSubmenuItem || isSubmenuItem && isCurrentSubmenuItem) {
      if (isSubSubmenuItem) {
        return;
      }
      if (isAnimated && item.classList.contains("active")) {
        const submenu = item.querySelector(".submenu-left, .sub-submenu-left");
        if (submenu) {
          animateSubmenu(submenu, false);
        }
      }
      item.classList.remove("active");
      const childLinks = item.querySelectorAll(".sub-nav-link-side");
      childLinks.forEach((link) => link.setAttribute("tabindex", "-1"));
      if (item.classList.contains("menu-item-left")) {
        sessionStorage.removeItem("vertical-activeMenuItem");
        sessionStorage.setItem("vertical-closedMenuItem", item.id);
      } else if (item.classList.contains("submenu-item-left")) {
        sessionStorage.removeItem("vertical-activeSubmenuItem");
        sessionStorage.setItem("vertical-closedSubmenuItem", item.id);
      }
    }
  });
}
function saveState(item) {
  if (item.classList.contains("menu-item-left")) {
    sessionStorage.setItem("vertical-activeMenuItem", item.id);
    sessionStorage.removeItem("vertical-closedMenuItem");
  } else if (item.classList.contains("submenu-item-left")) {
    sessionStorage.setItem("vertical-activeSubmenuItem", item.id);
    sessionStorage.removeItem("vertical-closedSubmenuItem");
  } else if (item.classList.contains("sub-submenu-item-left")) {
    sessionStorage.setItem("vertical-activeSubSubmenuItem", item.id);
    sessionStorage.removeItem("vertical-closedSubSubmenuItem");
  }
}
function restoreAccordionState() {
  document.documentElement.classList.add("disable-accordion-transitions");
  const activeMenuItemId = sessionStorage.getItem("vertical-activeMenuItem");
  const activeSubmenuItemId = sessionStorage.getItem("vertical-activeSubmenuItem");
  const activeSubSubmenuItemId = sessionStorage.getItem("vertical-activeSubSubmenuItem");
  const closedMenuItemId = sessionStorage.getItem("vertical-closedMenuItem");
  const closedSubmenuItemId = sessionStorage.getItem("vertical-closedSubmenuItem");
  const closedSubSubmenuItemId = sessionStorage.getItem("vertical-closedSubSubmenuItem");
  if (activeMenuItemId && document.getElementById(activeMenuItemId) && activeMenuItemId !== closedMenuItemId) {
    const menuItem = document.getElementById(activeMenuItemId);
    menuItem.classList.add("active");
    const childLinks = menuItem.querySelectorAll(".sub-nav-link-side");
    childLinks.forEach((link) => link.setAttribute("tabindex", "0"));
  }
  if (activeSubmenuItemId && document.getElementById(activeSubmenuItemId) && activeSubmenuItemId !== closedSubmenuItemId) {
    const submenuItem = document.getElementById(activeSubmenuItemId);
    submenuItem.classList.add("active");
    const childLinks = submenuItem.querySelectorAll(".sub-nav-link-side");
    childLinks.forEach((link) => link.setAttribute("tabindex", "0"));
  }
  if (activeSubSubmenuItemId && document.getElementById(activeSubSubmenuItemId) && activeSubSubmenuItemId !== closedSubSubmenuItemId) {
    const subSubmenuItem = document.getElementById(activeSubSubmenuItemId);
    subSubmenuItem.classList.add("active");
    const childLinks = subSubmenuItem.querySelectorAll(".sub-nav-link-side");
    childLinks.forEach((link) => link.setAttribute("tabindex", "0"));
  }
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.documentElement.classList.remove("disable-accordion-transitions");
    });
  });
}
function initializeLeftNavHideLogic() {
  var _a;
  if (window.leftNavHideLogicInitialized) {
    cleanupLeftNavHideLogic();
  }
  const headerLayout = document.body.dataset.headerLayout;
  let isManualOverride = false;
  if (window.innerWidth < 1024 || headerLayout !== "left") {
    return;
  }
  const headerNav = document.getElementById("header-left-navi");
  const hamburgerIcon = document.getElementById("hamburger-menu");
  const closeIcon = document.getElementById("close-menu");
  const triggers = document.querySelectorAll(".left-nav-hide-trigger");
  if (!headerNav || !hamburgerIcon || !closeIcon) {
    return;
  }
  const alwaysHideNav = ((_a = document.querySelector('[data-section-type="header"]')) == null ? void 0 : _a.dataset.alwaysHideVerticalNav) === "true";
  if (alwaysHideNav) {
    headerNav.style.visibility = "hidden";
    headerNav.style.opacity = "0";
    hamburgerIcon.style.display = "block";
    hamburgerIcon.style.visibility = "visible";
    hamburgerIcon.style.opacity = "1";
    closeIcon.style.display = "none";
    window.leftNavHideLogicInitialized = true;
    return;
  }
  if (triggers.length === 0) {
    return;
  }
  function checkIntersection() {
    var _a2;
    if (isManualOverride) return;
    const alwaysHideNav2 = ((_a2 = document.querySelector('[data-section-type="header"]')) == null ? void 0 : _a2.dataset.alwaysHideVerticalNav) === "true";
    if (alwaysHideNav2) {
      const isCurrentlyHidden2 = headerNav.style.visibility === "hidden" || headerNav.style.opacity === "0";
      if (!isCurrentlyHidden2) {
        hideNav();
      }
      return;
    }
    const navRect = headerNav.getBoundingClientRect();
    let shouldHide = false;
    triggers.forEach((trigger) => {
      const triggerRect = trigger.getBoundingClientRect();
      if (triggerRect.top < navRect.bottom && triggerRect.bottom > navRect.top && triggerRect.left < navRect.right && triggerRect.right > navRect.left) {
        shouldHide = true;
      }
    });
    const isCurrentlyHidden = headerNav.style.visibility === "hidden" || headerNav.style.opacity === "0";
    if (shouldHide && !isCurrentlyHidden) {
      hideNav();
    } else if (!shouldHide && isCurrentlyHidden) {
      showNav();
    }
  }
  function hideNav() {
    headerNav.style.opacity = "0";
    headerNav.style.visibility = "hidden";
    hamburgerIcon.style.display = "block";
    closeIcon.style.display = "none";
  }
  function showNav() {
    headerNav.style.visibility = "visible";
    headerNav.style.opacity = "1";
    hamburgerIcon.style.display = "none";
    closeIcon.style.display = "none";
    headerNav.style.background = "";
    headerNav.style.border = "";
    headerNav.style.transform = "none";
  }
  hamburgerIcon.addEventListener("click", () => {
    const navRect = headerNav.getBoundingClientRect();
    const isInTriggerArea = Array.from(triggers).some((trigger) => {
      const triggerRect = trigger.getBoundingClientRect();
      return triggerRect.top < navRect.bottom && triggerRect.bottom > navRect.top && triggerRect.left < navRect.right && triggerRect.right > navRect.left;
    });
    if (isInTriggerArea) {
      isManualOverride = true;
      const floatingMenu = document.getElementById("left-nav-floating-menu");
      if (floatingMenu && typeof window.openFloatingMenu === "function") {
        window.openFloatingMenu();
      }
    } else {
      showNav();
    }
  });
  closeIcon.addEventListener("click", () => {
    headerNav.style.visibility = "hidden";
    headerNav.style.opacity = "0";
    closeIcon.style.display = "none";
    hamburgerIcon.style.display = "block";
    if (isManualOverride) {
      isManualOverride = false;
    }
  });
  window.addEventListener("scroll", () => {
    checkIntersection();
  }, { passive: true });
  window.addEventListener("resize", () => {
    cleanupLeftNavHideLogic();
    setTimeout(() => {
      initializeLeftNavHideLogic();
    }, 100);
  });
  checkIntersection();
  window.leftNavHideLogicInitialized = true;
}
document.addEventListener("DOMContentLoaded", initializeLeftNavHideLogic);
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  const themeEditorEvents = [
    "shopify:section:load",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect",
    "shopify:section:reorder"
  ];
  themeEditorEvents.forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.target.closest("header") || event.target.querySelector("header") || event.target.closest('[class*="header"]') || event.target.querySelector('[class*="header"]') || event.target.querySelector(".left-nav-hide-trigger")) {
        cleanupLeftNavHideLogic();
        setTimeout(() => {
          initializeLeftNavHideLogic();
        }, 100);
      }
    });
  });
  document.addEventListener("shopify:editor:settings:update", () => {
    cleanupLeftNavHideLogic();
    setTimeout(() => {
      initializeLeftNavHideLogic();
    }, 150);
  });
}
function cleanupLeftNavHideLogic() {
  if (window.leftNavHideLogicInitialized) {
    window.leftNavHideLogicInitialized = false;
  }
}
function initializeLeftNavFloatingMenu() {
  if (window.leftNavFloatingMenuInitialized) {
    cleanupLeftNavFloatingMenu();
  }
  const headerLayout = document.body.dataset.headerLayout;
  if (window.innerWidth < 1024 || headerLayout !== "left") {
    return;
  }
  const headerNav = document.getElementById("header-left-navi");
  const hamburgerIcon = document.getElementById("hamburger-menu");
  const closeIcon = document.getElementById("close-menu");
  if (!headerNav || !hamburgerIcon || !closeIcon) {
    return;
  }
  const alwaysHideNav = document.body.getAttribute("data-always-hide-vertical-nav") === "true";
  if (alwaysHideNav) {
    initializeAlwaysHideMode();
  } else {
    initializeNormalMode();
  }
  window.leftNavFloatingMenuInitialized = true;
}
function initializeAlwaysHideMode() {
  const headerNav = document.getElementById("header-left-navi");
  const hamburgerIcon = document.getElementById("hamburger-menu");
  const closeIcon = document.getElementById("close-menu");
  const headerSide = document.getElementById("header-side");
  headerNav.style.visibility = "hidden";
  headerNav.style.opacity = "0";
  headerSide.style.visibility = "hidden";
  headerSide.style.opacity = "0";
  hamburgerIcon.style.display = "block";
  hamburgerIcon.style.visibility = "visible";
  hamburgerIcon.style.opacity = "1";
  closeIcon.style.display = "none";
  setupFloatingMenu();
  initializeFloatingAccordion();
  hamburgerIcon.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    openFloatingMenu();
  });
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "style") {
        const target = mutation.target;
        if (target === hamburgerIcon && target.style.display === "none") {
          target.style.display = "block";
          target.style.visibility = "visible";
          target.style.opacity = "1";
        }
      }
    });
  });
  observer.observe(hamburgerIcon, {
    attributes: true,
    attributeFilter: ["style"]
  });
  window.hamburgerObserver = observer;
}
function initializeNormalMode() {
  const headerNav = document.getElementById("header-left-navi");
  const hamburgerIcon = document.getElementById("hamburger-menu");
  const closeIcon = document.getElementById("close-menu");
  const triggers = document.querySelectorAll(".left-nav-hide-trigger");
  if (triggers.length === 0) {
    return;
  }
  setupFloatingMenu();
  function checkIntersection() {
    const navRect = headerNav.getBoundingClientRect();
    let shouldHide = false;
    triggers.forEach((trigger) => {
      const triggerRect = trigger.getBoundingClientRect();
      if (triggerRect.top < navRect.bottom && triggerRect.bottom > navRect.top && triggerRect.left < navRect.right && triggerRect.right > navRect.left) {
        shouldHide = true;
      }
    });
    const isCurrentlyHidden = headerNav.style.visibility === "hidden" || headerNav.style.opacity === "0";
    if (shouldHide && !isCurrentlyHidden) {
      hideNav();
    } else if (!shouldHide && isCurrentlyHidden) {
      showNav();
    }
  }
  function hideNav() {
    const enableAnimateDrawers = document.body.getAttribute("data-slide-in-drawers") === "true";
    if (enableAnimateDrawers) {
      headerNav.style.transition = "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out";
      headerNav.style.opacity = "0";
      headerNav.style.visibility = "hidden";
      hamburgerIcon.style.transition = "opacity 0.3s ease-in-out";
      hamburgerIcon.style.opacity = "0";
      hamburgerIcon.style.display = "block";
      hamburgerIcon.offsetHeight;
      hamburgerIcon.style.opacity = "1";
      closeIcon.style.display = "none";
    } else {
      headerNav.style.opacity = "0";
      headerNav.style.visibility = "hidden";
      hamburgerIcon.style.display = "block";
      closeIcon.style.display = "none";
    }
  }
  function showNav() {
    const enableAnimateDrawers = document.body.getAttribute("data-slide-in-drawers") === "true";
    if (enableAnimateDrawers) {
      headerNav.style.transition = "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out";
      headerNav.style.visibility = "visible";
      headerNav.style.opacity = "1";
      hamburgerIcon.style.transition = "opacity 0.3s ease-in-out";
      hamburgerIcon.style.opacity = "0";
      setTimeout(() => {
        hamburgerIcon.style.display = "none";
        hamburgerIcon.style.opacity = "";
        hamburgerIcon.style.transition = "";
      }, 300);
      closeIcon.style.display = "none";
    } else {
      headerNav.style.visibility = "visible";
      headerNav.style.opacity = "1";
      hamburgerIcon.style.display = "none";
      closeIcon.style.display = "none";
    }
  }
  window.addEventListener("scroll", () => {
    checkIntersection();
  }, { passive: true });
  initializeFloatingAccordion();
  checkIntersection();
}
function setupFloatingMenu() {
  const hamburgerIcon = document.getElementById("hamburger-menu");
  const closeIcon = document.getElementById("close-menu");
  let floatingMenu = document.getElementById("left-nav-floating-menu");
  if (!floatingMenu) {
    floatingMenu = document.createElement("div");
    floatingMenu.id = "left-nav-floating-menu";
    floatingMenu.className = "left-nav-floating-menu hidden";
    document.body.appendChild(floatingMenu);
  }
  let menuPanel = document.getElementById("left-nav-menu-panel");
  if (!menuPanel) {
    menuPanel = document.createElement("div");
    menuPanel.id = "left-nav-menu-panel";
    menuPanel.className = "left-nav-menu-panel";
    floatingMenu.appendChild(menuPanel);
    const navContainer = document.createElement("nav");
    navContainer.id = "left-nav-menu-content";
    navContainer.className = "left-nav-menu-content navigation-container w-full vertical-nav-spacing";
    navContainer.setAttribute("role", "navigation");
    navContainer.setAttribute("aria-label", "Main navigation");
    menuPanel.appendChild(navContainer);
    const headerNav = document.getElementById("header-left-navi");
    if (headerNav) {
      const originalNav = headerNav.cloneNode(true);
      navContainer.innerHTML = originalNav.innerHTML;
    }
  }
  const alwaysHideNav = document.body.getAttribute("data-always-hide-vertical-nav") === "true";
  if (alwaysHideNav) {
    const newHamburgerIcon = hamburgerIcon.cloneNode(true);
    const newCloseIcon = closeIcon.cloneNode(true);
    hamburgerIcon.parentNode.replaceChild(newHamburgerIcon, hamburgerIcon);
    closeIcon.parentNode.replaceChild(newCloseIcon, closeIcon);
    newHamburgerIcon.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      openFloatingMenu();
    });
    newCloseIcon.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeFloatingMenu();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !floatingMenu.classList.contains("hidden")) {
        closeFloatingMenu();
      }
    });
    document.addEventListener("click", (e) => {
      if (!floatingMenu.classList.contains("hidden") && !floatingMenu.contains(e.target) && !newHamburgerIcon.contains(e.target) && !newCloseIcon.contains(e.target)) {
        closeFloatingMenu();
      }
    });
  } else {
    closeIcon.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeFloatingMenu();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !floatingMenu.classList.contains("hidden")) {
        closeFloatingMenu();
      }
    });
    document.addEventListener("click", (e) => {
      if (!floatingMenu.classList.contains("hidden") && !floatingMenu.contains(e.target) && !hamburgerIcon.contains(e.target) && !closeIcon.contains(e.target)) {
        closeFloatingMenu();
      }
    });
  }
}
function openFloatingMenu() {
  const headerSide = document.getElementById("header-side");
  const floatingMenu = document.getElementById("left-nav-floating-menu");
  const menuPanel = document.getElementById("left-nav-menu-panel");
  const hamburgerIcon = document.getElementById("hamburger-menu");
  const closeIcon = document.getElementById("close-menu");
  if (headerSide) {
    headerSide.style.visibility = "hidden";
    headerSide.style.opacity = "0";
  }
  if (hamburgerIcon) {
    hamburgerIcon.style.display = "none";
    hamburgerIcon.style.visibility = "hidden";
    hamburgerIcon.style.opacity = "0";
  }
  if (closeIcon) {
    closeIcon.style.display = "block";
    closeIcon.style.visibility = "visible";
    closeIcon.style.opacity = "1";
  }
  floatingMenu.classList.remove("hidden");
  menuPanel.style.opacity = "0";
  menuPanel.offsetHeight;
  menuPanel.style.transition = "opacity 0.3s ease-in-out";
  menuPanel.style.opacity = "1";
  setTimeout(() => {
    markFloatingPlaceholderLinks();
  }, 50);
}
function markFloatingPlaceholderLinks() {
  const floatingNav = document.getElementById("left-nav-menu-content");
  if (!floatingNav) return;
  const submenuItems = floatingNav.querySelectorAll(".submenu-item-left, .sub-submenu-item-left");
  submenuItems.forEach((item) => {
    const link = item.querySelector("a");
    if (link) {
      const href = link.getAttribute("href");
      const isPlaceholder = !href || href === "#" || href === "";
      if (isPlaceholder) {
        item.setAttribute("data-placeholder-link", "true");
      } else {
        item.removeAttribute("data-placeholder-link");
        item.classList.add("active");
        const submenu = item.querySelector(".submenu-left, .sub-submenu-left");
        if (submenu) {
          submenu.style.height = "auto";
          submenu.style.display = "block";
          submenu.style.opacity = "1";
          submenu.style.visibility = "visible";
        }
        const childLinks = item.querySelectorAll(".sub-nav-link-side");
        childLinks.forEach((link2) => link2.setAttribute("tabindex", "0"));
      }
    }
  });
}
function syncToOriginalHeader() {
  const floatingNav = document.getElementById("left-nav-menu-content");
  const originalNav = document.getElementById("header-left-navi");
  if (!floatingNav || !originalNav) return;
  const floatingItems = floatingNav.querySelectorAll(".menu-item-left, .submenu-item-left, .sub-submenu-item-left");
  const originalItems = originalNav.querySelectorAll(".menu-item-left, .submenu-item-left, .sub-submenu-item-left");
  const originalItemsMap = /* @__PURE__ */ new Map();
  originalItems.forEach((item) => {
    originalItemsMap.set(item.id, item);
  });
  floatingItems.forEach((floatingItem) => {
    const originalItem = originalItemsMap.get(floatingItem.id);
    if (originalItem) {
      const isActive = floatingItem.classList.contains("active");
      if (isActive) {
        originalItem.classList.add("active");
        const childLinks = originalItem.querySelectorAll(".sub-nav-link-side");
        childLinks.forEach((link) => link.setAttribute("tabindex", "0"));
      } else {
        originalItem.classList.remove("active");
        const childLinks = originalItem.querySelectorAll(".sub-nav-link-side");
        childLinks.forEach((link) => link.setAttribute("tabindex", "-1"));
      }
    }
  });
}
window.openFloatingMenu = openFloatingMenu;
function closeFloatingMenu() {
  const alwaysHideNav = document.body.getAttribute("data-always-hide-vertical-nav") === "true";
  const headerSide = document.getElementById("header-side");
  const floatingMenu = document.getElementById("left-nav-floating-menu");
  const menuPanel = document.getElementById("left-nav-menu-panel");
  const hamburgerIcon = document.getElementById("hamburger-menu");
  const closeIcon = document.getElementById("close-menu");
  const floatingNav = document.getElementById("left-nav-menu-content");
  if (floatingNav) {
    const allItems = floatingNav.querySelectorAll(".menu-item-left, .submenu-item-left, .sub-submenu-item-left");
    allItems.forEach((item) => {
      item.dataset.animating = "false";
      const submenu = item.querySelector(".submenu-left, .sub-submenu-left");
      if (submenu && submenu.dataset.animationTimeout) {
        clearTimeout(parseInt(submenu.dataset.animationTimeout));
        submenu.dataset.animationTimeout = "";
      }
    });
  }
  syncToOriginalHeader();
  menuPanel.style.transition = "opacity 0.3s ease-in-out";
  menuPanel.style.opacity = "0";
  setTimeout(() => {
    floatingMenu.classList.add("hidden");
    menuPanel.style.opacity = "";
    menuPanel.style.transition = "";
  }, 300);
  if (closeIcon) {
    if (alwaysHideNav) {
      closeIcon.style.display = "none";
      closeIcon.style.visibility = "hidden";
      closeIcon.style.opacity = "0";
    } else {
      closeIcon.style.display = "none";
      closeIcon.style.visibility = "hidden";
      closeIcon.style.opacity = "0";
    }
  }
  if (hamburgerIcon) {
    hamburgerIcon.style.display = "block";
    hamburgerIcon.style.visibility = "visible";
    hamburgerIcon.style.opacity = "1";
  }
  if (headerSide) {
    if (!alwaysHideNav) {
      headerSide.style.visibility = "visible";
      headerSide.style.opacity = "1";
    } else {
      headerSide.style.visibility = "hidden";
      headerSide.style.opacity = "0";
    }
  }
}
function initializeFloatingAccordion() {
  const menuPanel = document.getElementById("left-nav-menu-panel");
  if (!menuPanel) return;
  const floatingNav = menuPanel.querySelector("#left-nav-menu-content");
  if (!floatingNav) return;
  markFloatingPlaceholderLinks();
  floatingNav.removeEventListener("click", handleFloatingAccordionClick);
  floatingNav.addEventListener("click", handleFloatingAccordionClick);
  restoreFloatingAccordionState();
}
function restoreFloatingAccordionState() {
  const floatingNav = document.getElementById("left-nav-menu-content");
  if (!floatingNav) return;
  const activeMenuItemId = sessionStorage.getItem("vertical-activeMenuItem");
  const activeSubmenuItemId = sessionStorage.getItem("vertical-activeSubmenuItem");
  const activeSubSubmenuItemId = sessionStorage.getItem("vertical-activeSubSubmenuItem");
  const closedMenuItemId = sessionStorage.getItem("vertical-closedMenuItem");
  const closedSubmenuItemId = sessionStorage.getItem("vertical-closedSubmenuItem");
  const closedSubSubmenuItemId = sessionStorage.getItem("vertical-closedSubSubmenuItem");
  if (activeMenuItemId && floatingNav.querySelector(`#${activeMenuItemId}`) && activeMenuItemId !== closedMenuItemId) {
    const menuItem = floatingNav.querySelector(`#${activeMenuItemId}`);
    if (menuItem.hasAttribute("data-placeholder-link") || menuItem.classList.contains("menu-item-left")) {
      menuItem.classList.add("active");
      const childLinks = menuItem.querySelectorAll(".sub-nav-link-side");
      childLinks.forEach((link) => link.setAttribute("tabindex", "0"));
    }
  }
  if (activeSubmenuItemId && floatingNav.querySelector(`#${activeSubmenuItemId}`) && activeSubmenuItemId !== closedSubmenuItemId) {
    const submenuItem = floatingNav.querySelector(`#${activeSubmenuItemId}`);
    if (submenuItem.hasAttribute("data-placeholder-link")) {
      submenuItem.classList.add("active");
      const childLinks = submenuItem.querySelectorAll(".sub-nav-link-side");
      childLinks.forEach((link) => link.setAttribute("tabindex", "0"));
    }
  }
  if (activeSubSubmenuItemId && floatingNav.querySelector(`#${activeSubSubmenuItemId}`) && activeSubSubmenuItemId !== closedSubSubmenuItemId) {
    const subSubmenuItem = floatingNav.querySelector(`#${activeSubSubmenuItemId}`);
    if (subSubmenuItem.hasAttribute("data-placeholder-link")) {
      subSubmenuItem.classList.add("active");
      const childLinks = subSubmenuItem.querySelectorAll(".sub-nav-link-side");
      childLinks.forEach((link) => link.setAttribute("tabindex", "0"));
    }
  }
}
function handleFloatingAccordionClick(event) {
  const clickedElement = event.target.closest(".nav-alt-trigger");
  if (!clickedElement) return;
  const parentItem = clickedElement.closest(".menu-item-left, .submenu-item-left, .sub-submenu-item-left");
  if (!parentItem) return;
  if (parentItem.dataset.animating === "true") return;
  const isMenuItem = parentItem.classList.contains("menu-item-left");
  const isSubmenuItem = parentItem.classList.contains("submenu-item-left");
  const isActive = parentItem.classList.contains("active");
  const isAnimated = document.body.getAttribute("data-enable-submenu-fadein") === "true";
  const isPlaceholderLink = parentItem.hasAttribute("data-placeholder-link");
  if (!isPlaceholderLink && (isSubmenuItem || parentItem.classList.contains("sub-submenu-item-left"))) {
    const clickedLink2 = event.target.closest("a");
    if (clickedLink2 && clickedLink2.getAttribute("href") !== "#") {
      return;
    }
  }
  closeFloatingItemsAtSameOrLowerLevel(isMenuItem, isSubmenuItem);
  if (!isActive) {
    parentItem.dataset.animating = "true";
    parentItem.classList.add("active");
    if (isAnimated) {
      const submenu = parentItem.querySelector(".submenu-left, .sub-submenu-left");
      if (submenu) {
        animateFloatingSubmenu(submenu, true, () => {
          parentItem.dataset.animating = "false";
        });
      } else {
        parentItem.dataset.animating = "false";
      }
    } else {
      parentItem.dataset.animating = "false";
    }
    const childLinks = parentItem.querySelectorAll(".sub-nav-link-side");
    childLinks.forEach((link) => link.setAttribute("tabindex", "0"));
    saveFloatingState(parentItem);
  } else {
    parentItem.dataset.animating = "true";
    if (isAnimated) {
      const submenu = parentItem.querySelector(".submenu-left, .sub-submenu-left");
      if (submenu) {
        animateFloatingSubmenu(submenu, false, () => {
          parentItem.classList.remove("active");
          parentItem.dataset.animating = "false";
        });
      } else {
        parentItem.classList.remove("active");
        parentItem.dataset.animating = "false";
      }
    } else {
      parentItem.classList.remove("active");
      parentItem.dataset.animating = "false";
    }
    sessionStorage.removeItem("vertical-" + parentItem.id);
    const childLinks = parentItem.querySelectorAll(".sub-nav-link-side");
    childLinks.forEach((link) => link.setAttribute("tabindex", "-1"));
  }
  event.preventDefault();
  const clickedLink = event.target.closest("a");
  if (clickedLink && clickedLink.getAttribute("href") !== "#") {
    window.location.href = clickedLink.getAttribute("href");
  }
}
function closeFloatingItemsAtSameOrLowerLevel(isMenuItem, isSubmenuItem) {
  const floatingNav = document.getElementById("left-nav-menu-content");
  if (!floatingNav) return;
  const allItems = floatingNav.querySelectorAll(".menu-item-left, .submenu-item-left, .sub-submenu-item-left");
  const isAnimated = document.body.getAttribute("data-enable-submenu-fadein") === "true";
  allItems.forEach((item) => {
    const isPlaceholderLink = item.hasAttribute("data-placeholder-link");
    if (!isPlaceholderLink && (item.classList.contains("submenu-item-left") || item.classList.contains("sub-submenu-item-left"))) {
      return;
    }
    item.classList.contains("sub-submenu-item-left");
    const isCurrentSubmenuItem = item.classList.contains("submenu-item-left");
    if (isMenuItem || isSubmenuItem && isCurrentSubmenuItem) {
      if (isAnimated && item.classList.contains("active")) {
        const submenu = item.querySelector(".submenu-left, .sub-submenu-left");
        if (submenu) {
          animateFloatingSubmenu(submenu, false);
        }
      }
      item.classList.remove("active");
      sessionStorage.removeItem("vertical-" + item.id);
      const childLinks = item.querySelectorAll(".sub-nav-link-side");
      childLinks.forEach((link) => link.setAttribute("tabindex", "-1"));
    }
  });
}
function animateFloatingSubmenu(submenu, isOpening, callback) {
  if (submenu.dataset.animationTimeout) {
    clearTimeout(parseInt(submenu.dataset.animationTimeout));
  }
  if (isOpening) {
    submenu.style.height = "0";
    submenu.style.overflow = "hidden";
    submenu.style.display = "block";
    submenu.offsetHeight;
    const naturalHeight = submenu.scrollHeight;
    submenu.style.transition = "height 0.3s ease-in-out";
    submenu.style.height = naturalHeight + "px";
    const timeoutId = setTimeout(() => {
      submenu.style.height = "auto";
      submenu.style.transition = "";
      submenu.style.overflow = "";
      submenu.dataset.animationTimeout = "";
      if (callback) callback();
    }, 300);
    submenu.dataset.animationTimeout = timeoutId.toString();
  } else {
    const currentHeight = submenu.scrollHeight;
    submenu.style.height = currentHeight + "px";
    submenu.style.overflow = "hidden";
    submenu.offsetHeight;
    submenu.style.transition = "height 0.3s ease-in-out";
    submenu.style.height = "0";
    const timeoutId = setTimeout(() => {
      submenu.style.display = "none";
      submenu.style.overflow = "hidden";
      submenu.style.transition = "";
      submenu.style.height = "";
      submenu.dataset.animationTimeout = "";
      if (callback) callback();
    }, 300);
    submenu.dataset.animationTimeout = timeoutId.toString();
  }
}
function saveFloatingState(item) {
  if (item.classList.contains("menu-item-left")) {
    sessionStorage.setItem("vertical-activeMenuItem", item.id);
  } else if (item.classList.contains("submenu-item-left")) {
    sessionStorage.setItem("vertical-activeSubmenuItem", item.id);
  } else if (item.classList.contains("sub-submenu-item-left")) {
    sessionStorage.setItem("vertical-activeSubSubmenuItem", item.id);
  }
}
document.addEventListener("DOMContentLoaded", initializeLeftNavFloatingMenu);
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  const themeEditorEvents = [
    "shopify:section:load",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect",
    "shopify:section:reorder"
  ];
  themeEditorEvents.forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.target.closest("header") || event.target.querySelector("header") || event.target.closest('[class*="header"]') || event.target.querySelector('[class*="header"]') || event.target.querySelector(".left-nav-hide-trigger")) {
        cleanupLeftNavFloatingMenu();
        setTimeout(() => {
          initializeLeftNavFloatingMenu();
        }, 100);
      }
    });
  });
  document.addEventListener("shopify:editor:settings:update", () => {
    cleanupLeftNavFloatingMenu();
    setTimeout(() => {
      initializeLeftNavFloatingMenu();
    }, 150);
  });
}
function cleanupLeftNavFloatingMenu() {
  if (window.leftNavFloatingMenuInitialized) {
    const floatingMenu = document.getElementById("left-nav-floating-menu");
    if (floatingMenu) {
      floatingMenu.remove();
    }
    if (window.hamburgerObserver) {
      window.hamburgerObserver.disconnect();
      window.hamburgerObserver = null;
    }
    window.leftNavFloatingMenuInitialized = false;
  }
}
function initMegaMenu() {
  let blockSelected = false;
  const enableSubmenuFadeIn = window.DOMHelper.getAttribute(document.body, "data-enable-submenu-fadein") === "true";
  const isShopifyDesignMode = typeof Shopify !== "undefined" && Shopify.designMode;
  const submenuCloseTimeouts = /* @__PURE__ */ new WeakMap();
  let hideTimeout = null;
  let currentlyShowingItem = null;
  function isPointerWithinHeaderNavBand(event) {
    if (!event) return true;
    const navBand = document.querySelector("#header-inline .navigation-wrapper, #header-center .navigation-wrapper, .navigation-wrapper");
    if (!navBand) return true;
    const navRect = navBand.getBoundingClientRect();
    return event.clientY <= navRect.bottom + 2;
  }
  function clearSubmenuCloseTimeout(item) {
    const timeout = submenuCloseTimeouts.get(item);
    if (timeout) {
      clearTimeout(timeout);
      submenuCloseTimeouts.delete(item);
    }
  }
  function showStandardSubmenu(item) {
    const triggerLink = window.DOMHelper.safeQuery("[data-nav-link]", item);
    clearSubmenuCloseTimeout(item);
    window.DOMHelper.addClass(item, "submenu-open");
    if (triggerLink) {
      triggerLink.setAttribute("aria-expanded", "true");
    }
  }
  function hideStandardSubmenu(item) {
    const triggerLink = window.DOMHelper.safeQuery("[data-nav-link]", item);
    clearSubmenuCloseTimeout(item);
    window.DOMHelper.removeClass(item, "submenu-open");
    if (triggerLink) {
      triggerLink.setAttribute("aria-expanded", "false");
    }
  }
  function scheduleStandardSubmenuHide(item, delay = 90) {
    clearSubmenuCloseTimeout(item);
    const timeout = setTimeout(() => {
      const submenu = window.DOMHelper.safeQuery(".submenu", item);
      const triggerLink = window.DOMHelper.safeQuery("[data-nav-link]", item);
      const keepOpen = item.matches(":hover") || submenu && submenu.matches(":hover") || triggerLink && triggerLink.matches(":hover");
      if (!keepOpen) {
        hideStandardSubmenu(item);
      }
    }, delay);
    submenuCloseTimeouts.set(item, timeout);
  }
  function initializeMegaMenu() {
    window.DOMHelper.safeQueryAll(".menu-item").forEach((item) => {
      const megaMenu = window.DOMHelper.safeQuery(".mega-menu", item);
      const submenu = window.DOMHelper.safeQuery(".submenu", item);
      const triggerLink = window.DOMHelper.safeQuery("[data-nav-link]", item);
      const hoverTarget = triggerLink || item;
      if (submenu && !megaMenu) {
        hoverTarget.addEventListener("mouseenter", function(event) {
          if (!isPointerWithinHeaderNavBand(event)) {
            return;
          }
          showStandardSubmenu(item);
        });
        hoverTarget.addEventListener("mouseleave", function(event) {
          if (event.relatedTarget && submenu.contains(event.relatedTarget)) {
            return;
          }
          scheduleStandardSubmenuHide(item, 90);
        });
        submenu.addEventListener("mouseenter", function() {
          showStandardSubmenu(item);
        });
        submenu.addEventListener("mouseleave", function(event) {
          if (event.relatedTarget && hoverTarget.contains(event.relatedTarget)) {
            return;
          }
          scheduleStandardSubmenuHide(item, 90);
        });
      }
      hoverTarget.addEventListener("mouseenter", function(event) {
        if (!blockSelected || !isShopifyDesignMode) {
          if (!isPointerWithinHeaderNavBand(event)) {
            return;
          }
          if (hideTimeout) {
            clearTimeout(hideTimeout);
            hideTimeout = null;
          }
          showMegaMenu(item);
        }
      });
      hoverTarget.addEventListener("mouseleave", function(event) {
        if (!blockSelected || !isShopifyDesignMode) {
          if (hideTimeout) {
            clearTimeout(hideTimeout);
            hideTimeout = null;
          }
          if (megaMenu && event.relatedTarget && megaMenu.contains(event.relatedTarget)) {
            return;
          }
          hideMegaMenu(item);
        }
      });
      if (megaMenu) {
        megaMenu.addEventListener("mouseenter", () => {
          if (!blockSelected || !isShopifyDesignMode) {
            if (hideTimeout) {
              clearTimeout(hideTimeout);
              hideTimeout = null;
            }
            showMegaMenu(item);
          }
        });
        megaMenu.addEventListener("mouseleave", (event) => {
          if (!blockSelected || !isShopifyDesignMode) {
            hideTimeout = setTimeout(() => {
              if (!isMouseOverItemOrMegaMenu(item)) {
                hideMegaMenu(item);
              }
            }, 15);
          }
        });
      }
    });
  }
  function isMouseOverItemOrMegaMenu(item) {
    const megaMenu = window.DOMHelper.safeQuery(".mega-menu", item);
    if (!megaMenu) return false;
    const mouseX = window.lastMouseX || 0;
    const mouseY = window.lastMouseY || 0;
    const itemRect = item.getBoundingClientRect();
    const isOverItem = mouseX >= itemRect.left && mouseX <= itemRect.right && mouseY >= itemRect.top && mouseY <= itemRect.bottom;
    const megaMenuRect = megaMenu.getBoundingClientRect();
    const isOverMegaMenu = mouseX >= megaMenuRect.left && mouseX <= megaMenuRect.right && mouseY >= megaMenuRect.top && mouseY <= megaMenuRect.bottom;
    return isOverItem || isOverMegaMenu;
  }
  document.addEventListener("mousemove", (e) => {
    window.lastMouseX = e.clientX;
    window.lastMouseY = e.clientY;
  });
  function showMegaMenu(item) {
    const megaMenu = window.DOMHelper.safeQuery(".mega-menu", item);
    if (megaMenu) {
      if (currentlyShowingItem && currentlyShowingItem !== item) {
        hideMegaMenu(currentlyShowingItem);
      }
      currentlyShowingItem = item;
      window.DOMHelper.getHeader("center");
      window.DOMHelper.safeQuery(".header-container");
      const megaMenuGrid = window.DOMHelper.safeQuery(".mega-menu-grid", megaMenu);
      const megaMenuImage = window.DOMHelper.safeQuery(".mega-menu-image", megaMenu);
      const megaMenuImages = window.DOMHelper.safeQueryAll(".mega-menu-image .image-wrapper", megaMenu);
      const megaMenuLinks = window.DOMHelper.safeQueryAll(".mega-menu-links .mega-menu-item", megaMenu);
      const numImages = megaMenuImages.length;
      const numLinks = megaMenuLinks.length;
      if (numLinks === 1 && numImages >= 2 || numLinks === 2 && numImages >= 1 || numLinks > 2) {
        window.DOMHelper.setStyle(megaMenu, "top", "100%");
        window.DOMHelper.setStyle(megaMenuGrid, "gridTemplateColumns", numImages > 1 ? "1fr 1fr" : numImages === 1 ? "2fr 1fr" : "1fr");
        if (megaMenuImage) {
          window.DOMHelper.setStyle(megaMenuImage, "gridTemplateColumns", numImages > 1 ? "1fr 1fr" : numImages === 1 ? "1fr auto" : "0");
        }
        window.DOMHelper.setStyle(window.DOMHelper.safeQuery(".mega-menu-links", megaMenu), "gridTemplateColumns", numLinks > 4 ? "repeat(4, 1fr)" : `repeat(${numLinks}, 1fr)`);
        window.DOMHelper.setStyle(megaMenu, "display", "block");
        if (typeof window.initializeImageLoading === "function") {
          requestAnimationFrame(() => {
            window.initializeImageLoading(megaMenu);
          });
        }
        if (enableSubmenuFadeIn) {
          window.DOMHelper.addClass(megaMenu, "mega-menu-fade-in");
          requestAnimationFrame(() => {
            window.DOMHelper.addClass(megaMenu, "show");
          });
        }
      }
    }
  }
  function hideMegaMenu(item) {
    const megaMenu = window.DOMHelper.safeQuery(".mega-menu", item);
    if (megaMenu) {
      if (currentlyShowingItem === item) {
        currentlyShowingItem = null;
      }
      if (enableSubmenuFadeIn) {
        window.DOMHelper.removeClass(megaMenu, "show");
        const transitionDuration = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue("--header-transition-duration") || "0.2"
        ) * 1e3;
        setTimeout(() => {
          if (!blockSelected && currentlyShowingItem !== item) {
            window.DOMHelper.removeClass(megaMenu, "mega-menu-fade-in");
            window.DOMHelper.setStyle(megaMenu, "display", "none");
          }
        }, transitionDuration);
      } else if (!blockSelected) {
        window.DOMHelper.setStyle(megaMenu, "display", "none");
      }
    }
  }
  function closeAllMegaMenus() {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }
    currentlyShowingItem = null;
    window.DOMHelper.safeQueryAll(".mega-menu").forEach((megaMenu) => {
      if (enableSubmenuFadeIn) {
        window.DOMHelper.removeClass(megaMenu, "show");
        const transitionDuration = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue("--header-transition-duration") || "0.2"
        ) * 1e3;
        setTimeout(() => {
          if (!blockSelected) {
            window.DOMHelper.removeClass(megaMenu, "mega-menu-fade-in");
            window.DOMHelper.setStyle(megaMenu, "display", "none");
          }
        }, transitionDuration);
      } else if (!blockSelected) {
        window.DOMHelper.setStyle(megaMenu, "display", "none");
      }
    });
  }
  initializeMegaMenu();
  if (isShopifyDesignMode) {
    document.addEventListener("shopify:section:load", initializeMegaMenu);
    document.addEventListener("shopify:section:reorder", initializeMegaMenu);
    document.addEventListener("shopify:section:select", (event) => {
      blockSelected = true;
      closeAllMegaMenus();
      const block = event.target.closest(".menu-item");
      if (block) {
        showMegaMenu(block);
        const megaMenu = window.DOMHelper.safeQuery(".mega-menu", block);
        if (megaMenu) {
          window.DOMHelper.setStyle(megaMenu, "display", "block");
          window.DOMHelper.addClass(megaMenu, "show");
        }
      }
    });
    document.addEventListener("shopify:section:deselect", (event) => {
      blockSelected = false;
      const block = event.target.closest(".menu-item");
      if (block) {
        hideMegaMenu(block);
      }
    });
    document.addEventListener("shopify:block:select", (event) => {
      blockSelected = true;
      const block = event.target.closest(".menu-item");
      if (block) {
        showMegaMenu(block);
        const megaMenu = window.DOMHelper.safeQuery(".mega-menu", block);
        if (megaMenu) {
          window.DOMHelper.setStyle(megaMenu, "display", "block");
          window.DOMHelper.addClass(megaMenu, "show");
        }
      }
    });
    document.addEventListener("shopify:block:deselect", (event) => {
      blockSelected = false;
      const block = event.target.closest(".menu-item");
      if (block) {
        hideMegaMenu(block);
      }
    });
  }
}
if (typeof window.ModuleManager !== "undefined") {
  window.ModuleManager.register("MegaMenu", initMegaMenu, ["DOMHelper"]);
} else {
  document.addEventListener("DOMContentLoaded", () => {
    initMegaMenu();
  });
}
document.addEventListener("DOMContentLoaded", () => {
  document.body.getAttribute("data-enable-submenu-fadein") === "true";
  const isShopifyDesignMode = typeof Shopify !== "undefined" && Shopify.designMode;
  function isPointerWithinHeaderNavBand(event) {
    if (!event) return true;
    const navBand = document.querySelector("#header-inline .navigation-wrapper, #header-center .navigation-wrapper, .navigation-wrapper");
    if (!navBand) return true;
    const navRect = navBand.getBoundingClientRect();
    return event.clientY <= navRect.bottom + 2;
  }
  function toggleMenuClasses(item, action) {
    document.getElementById("header-center");
    const headers = [
      document.getElementById("header-center"),
      document.getElementById("header-inline"),
      document.getElementById("header-vertical"),
      document.getElementById("header-center-mobile")
    ].filter(Boolean);
    headers.forEach((header) => {
      header.setAttribute("data-menu-hovered", action === "add" ? "true" : "false");
    });
    const hoverEvent = new CustomEvent("menuHover", {
      detail: {
        isHovered: action === "add",
        source: "menu-hover"
      }
    });
    window.dispatchEvent(hoverEvent);
  }
  function initializeMenus() {
    const menuItems = document.querySelectorAll(".menu-item");
    menuItems.forEach((item) => {
      const triggerLink = item.querySelector("[data-nav-link]");
      const hoverTarget = triggerLink || item;
      hoverTarget.addEventListener("mouseenter", (event) => {
        if (!isPointerWithinHeaderNavBand(event)) {
          return;
        }
        toggleMenuClasses(item, "add");
      });
      hoverTarget.addEventListener("mouseleave", (event) => {
        const isSearchOpen = document.body.hasAttribute("data-search-open");
        if (!isSearchOpen && (!event.relatedTarget || !item.contains(event.relatedTarget))) {
          toggleMenuClasses(item, "remove");
        }
      });
    });
  }
  function resetMenuState() {
    const headerCenter = document.getElementById("header-center");
    if (headerCenter) {
      headerCenter.setAttribute("data-menu-hovered", "false");
    }
    const hoverEvent = new CustomEvent("menuHover", {
      detail: {
        isHovered: false,
        source: "menu-reset"
      }
    });
    window.dispatchEvent(hoverEvent);
  }
  initializeMenus();
  document.addEventListener("searchClosed", resetMenuState);
  if (isShopifyDesignMode) {
    document.addEventListener("shopify:section:load", (event) => {
      if (event.target.contains(document.getElementById("header-center"))) {
        cleanupMenuHandlers();
        setTimeout(() => {
          initializeMenus();
        }, 50);
      }
    });
    document.addEventListener("shopify:section:select", (event) => {
      if (event.target.contains(document.getElementById("header-center"))) {
        resetMenuState();
      }
    });
    document.addEventListener("shopify:section:deselect", (event) => {
      if (event.target.contains(document.getElementById("header-center"))) {
        resetMenuState();
      }
    });
    document.addEventListener("shopify:block:select", (event) => {
      const menuItem = event.target.closest(".menu-item");
      if (menuItem) {
        toggleMenuClasses(menuItem, "add");
      }
    });
    document.addEventListener("shopify:block:deselect", (event) => {
      const menuItem = event.target.closest(".menu-item");
      if (menuItem) {
        toggleMenuClasses(menuItem, "remove");
      }
    });
    document.addEventListener("shopify:editor:settings:update", () => {
      cleanupMenuHandlers();
      setTimeout(() => {
        initializeMenus();
      }, 100);
    });
  }
  function cleanupMenuHandlers() {
    const menuItems = document.querySelectorAll(".menu-item");
    menuItems.forEach((item) => {
      const newItem = item.cloneNode(true);
      if (item.parentNode) {
        item.parentNode.replaceChild(newItem, item);
      }
    });
  }
});
function getThemeSettings() {
  let headerLayout = document.body.dataset.headerLayout || document.body.getAttribute("data-header-layout");
  if (!headerLayout) {
    if (document.getElementById("header-inline")) {
      headerLayout = "inline";
    } else if (document.getElementById("header-center")) {
      headerLayout = "center";
    } else if (document.getElementById("header-vertical")) {
      headerLayout = "left";
    } else {
      headerLayout = "inline";
    }
  }
  return {
    headerLayout,
    predictiveSearchEnabled: JSON.parse(document.body.dataset.predictiveSearch || "false"),
    showArticles: JSON.parse(document.body.dataset.showArticles || "false"),
    showPages: JSON.parse(document.body.dataset.showPages || "false"),
    showCollections: JSON.parse(document.body.dataset.showCollections || "false"),
    enableFadeIn: document.body.getAttribute("data-enable-submenu-fadein") === "true",
    transparentBackground: document.body.dataset.transparentBackground === "true"
  };
}
class ElementCache {
  constructor() {
    this.elements = /* @__PURE__ */ new Map();
  }
  get(id) {
    if (!this.elements.has(id)) {
      this.elements.set(id, document.getElementById(id));
    }
    return this.elements.get(id);
  }
  query(selector) {
    if (!this.elements.has(selector)) {
      this.elements.set(selector, document.querySelector(selector));
    }
    return this.elements.get(selector);
  }
  clear() {
    this.elements.clear();
  }
}
class BaseSearchHandler {
  constructor(settings, cache) {
    this.settings = settings;
    this.cache = cache;
    this.hadResults = false;
    this.eventListeners = [];
    this.elements = {
      searchLink: this.cache.get("search-link"),
      searchInput: this.cache.get("search-input"),
      clearButton: this.cache.get("clear-search"),
      searchButton: this.cache.get("search-button"),
      resultsContainer: this.cache.get("predictive-search-results"),
      searchBar: this.cache.get("search-bar"),
      headerCenter: this.cache.get("header-center")
    };
  }
  /**
   * Add event listener with cleanup tracking
   */
  addEventListener(element, event, handler, options) {
    if (element) {
      element.addEventListener(event, handler, options);
      this.eventListeners.push({ element, event, handler, options });
    }
  }
  /**
   * Clean up all event listeners
   */
  cleanup() {
    this.eventListeners.forEach(({ element, event, handler, options }) => {
      element.removeEventListener(event, handler, options);
    });
    this.eventListeners = [];
  }
  /**
   * Toggle search button text
   */
  toggleSearchButtonText(isOpen) {
    const { searchLink } = this.elements;
    if (!searchLink) return;
    if (!searchLink.dataset.searchText) {
      searchLink.dataset.searchText = searchLink.textContent.trim();
    }
    const closeText = searchLink.dataset.closeText || document.body.dataset.closeText || "Close";
    searchLink.textContent = isOpen ? closeText : searchLink.dataset.searchText;
  }
  /**
   * Toggle search button text with spans
   */
  toggleSearchButtonSpans(isOpen) {
    const { searchLink } = this.elements;
    if (!searchLink) return;
    const searchText = searchLink.querySelector(".search-text");
    const closeText = searchLink.querySelector(".close-text");
    if (searchText && closeText) {
      searchText.classList.toggle("hidden", isOpen);
      closeText.classList.toggle("hidden", !isOpen);
    }
  }
  /**
   * Toggle header background - updated to work with HeaderTransparencyManager
   */
  toggleHeaderBackground(show) {
    const { headerCenter } = this.elements;
    if (!headerCenter) return;
    const event = new CustomEvent("searchToggle", {
      detail: { isOpen: show }
    });
    window.dispatchEvent(event);
  }
  /**
   * Clear search results
   */
  clearResults() {
    const { resultsContainer } = this.elements;
    if (resultsContainer) {
      resultsContainer.classList.add("hidden");
      resultsContainer.innerHTML = "";
    }
  }
  /**
   * Dispatch search events
   */
  dispatchSearchEvent(eventName) {
    const eventMap = {
      open: () => {
        document.body.setAttribute("data-search-open", "true");
        document.dispatchEvent(new CustomEvent("searchOpened"));
      },
      close: () => {
        if (document.body.hasAttribute("data-search-open")) {
          document.dispatchEvent(new CustomEvent("searchClosed"));
        }
      }
    };
    if (eventMap[eventName]) {
      eventMap[eventName]();
    }
  }
}
class LeftHeaderSearch extends BaseSearchHandler {
  constructor(settings, cache) {
    super(settings, cache);
    this.init();
  }
  init() {
    if (!this.elements.searchLink) return;
    this.bindSearchToggle();
    this.bindInputHandlers();
    this.bindClearButton();
    this.bindDocumentClick();
    this.initializeButtonStates();
  }
  bindSearchToggle() {
    this.addEventListener(this.elements.searchLink, "click", (e) => {
      e.preventDefault();
      this.toggleSearch();
    });
  }
  toggleSearch() {
    const { searchInput, clearButton, searchButton } = this.elements;
    if (!searchInput || !clearButton || !searchButton) return;
    const isHidden = searchInput.classList.contains("hidden");
    if (isHidden) {
      this.openSearch();
    } else {
      this.closeSearch();
    }
  }
  openSearch() {
    const { searchInput, clearButton, searchButton, resultsContainer } = this.elements;
    searchInput.classList.remove("hidden");
    searchInput.style.width = "170px";
    clearButton.classList.remove("hidden");
    searchButton.classList.remove("hidden");
    const hasValue = searchInput.value.length > 0;
    this.updateButtonStates(hasValue);
    if (hasValue && this.hadResults && resultsContainer) {
      resultsContainer.classList.remove("hidden");
    }
    this.toggleSearchButtonText(true);
  }
  closeSearch() {
    const { searchInput, clearButton, searchButton, resultsContainer } = this.elements;
    searchInput.classList.add("hidden");
    searchInput.style.width = "0";
    clearButton.classList.add("hidden");
    searchButton.classList.add("hidden");
    this.hadResults = resultsContainer && !resultsContainer.classList.contains("hidden");
    if (resultsContainer) {
      resultsContainer.classList.add("hidden");
    }
    this.toggleSearchButtonText(false);
  }
  bindInputHandlers() {
    this.addEventListener(this.elements.searchInput, "input", () => {
      const hasValue = this.elements.searchInput.value.length > 0;
      this.updateButtonStates(hasValue);
    });
  }
  bindClearButton() {
    this.addEventListener(this.elements.clearButton, "click", (e) => {
      e.preventDefault();
      if (this.elements.searchInput.value.length > 0) {
        this.elements.searchInput.value = "";
        this.updateButtonStates(false);
        this.clearResults();
      }
    });
  }
  bindDocumentClick() {
    this.addEventListener(document, "click", (e) => {
      const { searchInput, clearButton, searchButton, searchLink, resultsContainer } = this.elements;
      if (searchInput && !searchInput.classList.contains("hidden") && !this.isClickInsideSearch(e.target)) {
        this.closeSearch();
      }
    });
  }
  isClickInsideSearch(target) {
    const { searchInput, clearButton, searchButton, searchLink, resultsContainer } = this.elements;
    const elements = [searchInput, clearButton, searchButton, searchLink, resultsContainer].filter(Boolean);
    return elements.some((element) => element.contains(target));
  }
  updateButtonStates(hasValue) {
    const { clearButton, searchButton } = this.elements;
    const activeClass = "search-button--active";
    const inactiveClass = "search-button--inactive";
    [clearButton, searchButton].forEach((button) => {
      if (button) {
        button.classList.toggle(activeClass, hasValue);
        button.classList.toggle(inactiveClass, !hasValue);
      }
    });
  }
  initializeButtonStates() {
    this.updateButtonStates(false);
  }
}
class CenterInlineHeaderSearch extends BaseSearchHandler {
  constructor(settings, cache) {
    super(settings, cache);
    this.init();
  }
  init() {
    if (!this.elements.searchLink) return;
    this.bindSearchToggle();
    this.bindInputHandlers();
    this.bindClearButton();
    this.bindDocumentClick();
    this.initializeSearchBar();
  }
  initializeSearchBar() {
    const { searchBar } = this.elements;
    if (searchBar) {
      searchBar.classList.add("hidden");
      searchBar.classList.remove("show");
    }
  }
  bindSearchToggle() {
    this.addEventListener(this.elements.searchLink, "click", (e) => {
      e.preventDefault();
      this.toggleSearch();
    });
  }
  toggleSearch() {
    const { searchBar } = this.elements;
    if (!searchBar) return;
    const isHidden = searchBar.classList.contains("hidden");
    if (isHidden) {
      this.openSearch();
    } else {
      this.closeSearch();
    }
  }
  openSearch() {
    const { searchBar } = this.elements;
    const { enableFadeIn } = this.settings;
    searchBar.classList.remove("show");
    searchBar.classList.remove("hidden");
    this.toggleSearchButtonSpans(true);
    this.dispatchSearchEvent("open");
    if (enableFadeIn) {
      requestAnimationFrame(() => {
        searchBar.classList.add("show");
      });
    }
  }
  closeSearch() {
    const { searchBar, resultsContainer } = this.elements;
    const { enableFadeIn } = this.settings;
    this.toggleSearchButtonSpans(false);
    if (enableFadeIn && searchBar) {
      searchBar.classList.remove("show");
      document.body.removeAttribute("data-search-open");
      document.dispatchEvent(new CustomEvent("searchClosed"));
      const headerTransitionDuration = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue("--header-transition-duration") || "0.2"
      ) * 1e3;
      setTimeout(() => {
        searchBar.classList.add("hidden");
      }, headerTransitionDuration);
    } else if (searchBar) {
      searchBar.classList.add("hidden");
      document.body.removeAttribute("data-search-open");
      document.dispatchEvent(new CustomEvent("searchClosed"));
    }
    this.hadResults = resultsContainer && !resultsContainer.classList.contains("hidden");
    if (resultsContainer) {
      resultsContainer.classList.add("hidden");
    }
  }
  bindInputHandlers() {
    this.addEventListener(this.elements.searchInput, "input", () => {
      const hasValue = this.elements.searchInput.value.length > 0;
      this.updateButtonStates(hasValue);
    });
  }
  bindClearButton() {
    this.addEventListener(this.elements.clearButton, "click", (e) => {
      e.preventDefault();
      if (this.elements.searchInput.value.length > 0) {
        this.elements.searchInput.value = "";
        this.updateButtonStates(false);
        this.clearResults();
      }
    });
  }
  bindDocumentClick() {
    this.addEventListener(document, "click", (e) => {
      const { searchBar, searchLink } = this.elements;
      if (searchBar && !searchBar.classList.contains("hidden") && !this.isClickInsideSearch(e.target)) {
        this.closeSearch();
      }
    });
  }
  isClickInsideSearch(target) {
    const { searchBar, searchLink, resultsContainer } = this.elements;
    const elements = [searchBar, searchLink, resultsContainer].filter(Boolean);
    return elements.some((element) => element.contains(target));
  }
  updateButtonStates(hasValue) {
    const { clearButton, searchButton } = this.elements;
    const activeClass = "search-button--active";
    const inactiveClass = "search-button--inactive";
    [clearButton, searchButton].forEach((button) => {
      if (button) {
        button.classList.toggle(activeClass, hasValue);
        button.classList.toggle(inactiveClass, !hasValue);
      }
    });
  }
}
class SearchManager {
  constructor() {
    this.settings = getThemeSettings();
    this.cache = new ElementCache();
    this.handler = null;
    this.init();
  }
  init() {
    try {
      this.createHandler();
    } catch (error) {
    }
  }
  createHandler() {
    const { headerLayout } = this.settings;
    switch (headerLayout) {
      case "left":
        this.handler = new LeftHeaderSearch(this.settings, this.cache);
        break;
      case "inline":
      case "center":
        this.handler = new CenterInlineHeaderSearch(this.settings, this.cache);
        break;
    }
  }
  destroy() {
    if (this.handler && typeof this.handler.cleanup === "function") {
      this.handler.cleanup();
    }
    this.cache.clear();
  }
}
let searchManagerInstance = null;
function addSearchFunctionality() {
  try {
    if (searchManagerInstance) {
      searchManagerInstance.destroy();
    }
    searchManagerInstance = new SearchManager();
  } catch (error) {
  }
}
window.addEventListener("beforeunload", () => {
  if (searchManagerInstance) {
    searchManagerInstance.destroy();
  }
});
function addPredictiveSearchFunctionality() {
  const settings = getThemeSettings();
  if (settings.predictiveSearchEnabled) {
    let showLoading2 = function(container) {
      container.innerHTML = loadingTemplate;
      container.classList.remove("hidden");
    }, displayError2 = function(container, error) {
      container.innerHTML = errorTemplate.replace('<span id="error-message"></span>', `<span id="error-message">${error.message}</span>`);
      container.classList.remove("hidden");
    }, debounce3 = function(func, wait, immediate) {
      let timeout;
      return function() {
        const context = this;
        const args = arguments;
        const later = function() {
          timeout = null;
          {
            func.apply(context, args);
          }
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };
    var showLoading = showLoading2, displayError = displayError2, debounce2 = debounce3;
    const templatesContainer = document.getElementById("predictive-search-templates");
    if (!templatesContainer) {
      return;
    }
    const searchInputs = document.getElementsByClassName("search-input");
    const resultsContainers = document.getElementsByClassName("predictive-search-results");
    const showArticles = settings.showArticles;
    const showPages = settings.showPages;
    const showCollections = settings.showCollections;
    let lastRequestTimestamp = 0;
    const loadingTemplate = templatesContainer.querySelector("#loading-template").innerHTML;
    const errorTemplate = templatesContainer.querySelector("#error-template").innerHTML;
    templatesContainer.querySelector("#no-results-template").innerHTML;
    templatesContainer.querySelector("#products-template").innerHTML;
    templatesContainer.querySelector("#articles-template").innerHTML;
    templatesContainer.querySelector("#pages-template").innerHTML;
    templatesContainer.querySelector("#collections-template").innerHTML;
    for (let i = 0; i < searchInputs.length; i++) {
      const searchInput = searchInputs[i];
      const resultsContainer = resultsContainers[i];
      if (!searchInput || !resultsContainer) {
        continue;
      }
      searchInput.addEventListener("input", debounce3(() => {
        const searchTerm = searchInput.value;
        if (searchTerm.length > 2) {
          const currentRequestTimestamp = Date.now();
          lastRequestTimestamp = currentRequestTimestamp;
          showLoading2(resultsContainer);
          const resourceTypes = ["product"];
          if (showArticles) {
            resourceTypes.push("article");
          }
          if (showPages) {
            resourceTypes.push("page");
          }
          if (showCollections) {
            resourceTypes.push("collection");
          }
          window.ShopifyAPIHelper.predictiveSearch(searchTerm, {
            "resources[type]": resourceTypes.join(","),
            "resources[limit]": 10,
            "resources[options][unavailable_products]": "last",
            "resources[options][fields]": "title,product_type,vendor,tag"
          }).then((text) => {
            if (currentRequestTimestamp === lastRequestTimestamp) {
              const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
              resultsContainer.innerHTML = resultsMarkup;
              resultsContainer.classList.remove("hidden");
            }
          }).catch((error) => {
            if (currentRequestTimestamp === lastRequestTimestamp) {
              displayError2(resultsContainer, error);
            }
          });
        } else {
          resultsContainer.innerHTML = "";
          resultsContainer.classList.add("hidden");
        }
      }, 250));
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  addSearchFunctionality();
  addPredictiveSearchFunctionality();
});
document.addEventListener("shopify:section:load", (event) => {
  if (event.target && event.target.id === "shopify-section-header") {
    addSearchFunctionality();
    addPredictiveSearchFunctionality();
  }
});
document.addEventListener("shopify:section:select", (event) => {
  if (event.target && event.target.id === "shopify-section-header") {
    addSearchFunctionality();
    addPredictiveSearchFunctionality();
  }
});
document.addEventListener("shopify:section:deselect", (event) => {
});
document.addEventListener("shopify:section:reorder", (event) => {
  if (event.target && event.target.id === "shopify-section-header") {
    addSearchFunctionality();
    addPredictiveSearchFunctionality();
  }
});
document.addEventListener("shopify:block:select", (event) => {
  if (event.target.closest("header") || event.target.querySelector("header") || event.target.closest('[class*="header"]') || event.target.querySelector('[class*="header"]') || event.target.closest("#shopify-section-header") || event.target.id === "shopify-section-header") {
    setTimeout(() => {
      addSearchFunctionality();
      addPredictiveSearchFunctionality();
    }, 100);
  }
});
document.addEventListener("shopify:block:deselect", (event) => {
});
function initHideAnnouncement() {
  let announcementScrollHandler = null;
  function setupAnnouncementBarBehavior() {
    if (announcementScrollHandler) {
      window.removeEventListener("scroll", announcementScrollHandler);
      announcementScrollHandler = null;
    }
    const announcementBarContainer = window.DOMHelper.safeQuery(".announcement-bar-container");
    const headerContainer = window.DOMHelper.safeQuery(".header-container, .header-container--left");
    if (!announcementBarContainer || !headerContainer) {
      return;
    }
    const hideOnScroll = window.DOMHelper.getAttribute(announcementBarContainer, "data-hide-on-scroll") === "true";
    const isFixedHeader = window.DOMHelper.getAttribute(document.body, "data-fixed-header") === "true";
    const announcementHeight = 36;
    if (!hideOnScroll || !isFixedHeader) {
      try {
        window.DOMHelper.setStyle(headerContainer, "transform", "");
        window.DOMHelper.removeClass(headerContainer, "announcement-hidden");
      } catch (error) {
        console.warn("Error resetting announcement bar state:", error);
      }
      return;
    }
    let lastScrollTop = window.scrollY;
    let isHidden = false;
    const scrollThreshold = 50;
    const showThreshold = 100;
    function setInitialState() {
      try {
        const currentScrollTop = window.scrollY;
        if (currentScrollTop <= scrollThreshold) {
          isHidden = false;
          window.DOMHelper.setStyle(headerContainer, "transform", "translate3d(0, 0, 0)");
          window.DOMHelper.removeClass(headerContainer, "announcement-hidden");
        } else {
          isHidden = true;
          window.DOMHelper.setStyle(headerContainer, "transform", `translate3d(0, -${announcementHeight}px, 0)`);
          window.DOMHelper.addClass(headerContainer, "announcement-hidden");
        }
        lastScrollTop = currentScrollTop;
      } catch (error) {
        console.warn("Error setting initial announcement state:", error);
      }
    }
    setInitialState();
    function handleScroll() {
      try {
        const currentScrollTop = window.scrollY;
        const scrollDistance = Math.abs(currentScrollTop - lastScrollTop);
        if (scrollDistance < 3) return;
        if (currentScrollTop <= scrollThreshold) {
          if (isHidden) {
            isHidden = false;
            window.DOMHelper.addClass(document.body, "announcement-animating");
            window.DOMHelper.setStyle(headerContainer, "transform", "translate3d(0, 0, 0)");
            window.DOMHelper.removeClass(headerContainer, "announcement-hidden");
            setTimeout(() => {
              try {
                window.DOMHelper.removeClass(document.body, "announcement-animating");
                window.DOMHelper.dispatchEvent("announcement:visible");
              } catch (error) {
                console.warn("Error in announcement visible callback:", error);
              }
            }, 300);
          }
        } else {
          if (currentScrollTop > lastScrollTop && !isHidden) {
            isHidden = true;
            window.DOMHelper.addClass(document.body, "announcement-animating");
            window.DOMHelper.setStyle(headerContainer, "transform", `translate3d(0, -${announcementHeight}px, 0)`);
            window.DOMHelper.addClass(headerContainer, "announcement-hidden");
            setTimeout(() => {
              try {
                window.DOMHelper.removeClass(document.body, "announcement-animating");
                window.DOMHelper.dispatchEvent("announcement:hidden");
              } catch (error) {
                console.warn("Error in announcement hidden callback:", error);
              }
            }, 300);
          } else if (currentScrollTop < lastScrollTop && isHidden && currentScrollTop <= showThreshold) {
            isHidden = false;
            window.DOMHelper.addClass(document.body, "announcement-animating");
            window.DOMHelper.setStyle(headerContainer, "transform", "translate3d(0, 0, 0)");
            window.DOMHelper.removeClass(headerContainer, "announcement-hidden");
            setTimeout(() => {
              try {
                window.DOMHelper.removeClass(document.body, "announcement-animating");
                window.DOMHelper.dispatchEvent("announcement:visible");
              } catch (error) {
                console.warn("Error in announcement visible callback:", error);
              }
            }, 300);
          }
        }
        lastScrollTop = currentScrollTop;
      } catch (error) {
        console.warn("Error in announcement scroll handler:", error);
      }
    }
    announcementScrollHandler = handleScroll;
    window.addEventListener("scroll", announcementScrollHandler, { passive: true });
  }
  setupAnnouncementBarBehavior();
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    const themeEditorEvents = [
      "shopify:section:load",
      "shopify:section:select",
      "shopify:section:deselect",
      "shopify:block:select",
      "shopify:block:deselect",
      "shopify:section:reorder"
    ];
    themeEditorEvents.forEach((eventName) => {
      document.addEventListener(eventName, (event) => {
        if (event.target.closest(".announcement-bar-container") || event.target.querySelector(".announcement-bar-container") || event.target.closest("header") || event.target.querySelector("header")) {
          setTimeout(() => {
            setupAnnouncementBarBehavior();
          }, 100);
        }
      });
    });
    document.addEventListener("shopify:editor:settings:update", () => {
      setTimeout(() => {
        setupAnnouncementBarBehavior();
      }, 150);
    });
  }
}
if (typeof window.ModuleManager !== "undefined") {
  window.ModuleManager.register("HideAnnouncement", initHideAnnouncement, ["DOMHelper"]);
} else {
  document.addEventListener("DOMContentLoaded", () => {
    initHideAnnouncement();
  });
}
function initializeAnnouncementBarRotation() {
  let announcementBarContainer = document.querySelector(".announcement-bar-container");
  if (!announcementBarContainer) {
    return;
  }
  let announcements = document.querySelectorAll(".announcement-item");
  let announcementDuration = (announcementBarContainer.dataset.announcementDuration || 10) * 1e3;
  let currentIndex = 0;
  let interval;
  let isTransitioning = false;
  function showNextAnnouncement() {
    if (announcements.length <= 1 || isTransitioning) {
      return;
    }
    isTransitioning = true;
    const currentAnnouncement = announcements[currentIndex];
    currentAnnouncement.classList.remove("active");
    currentIndex = (currentIndex + 1) % announcements.length;
    const nextAnnouncement = announcements[currentIndex];
    setTimeout(() => {
      nextAnnouncement.classList.add("active");
      isTransitioning = false;
    }, 200);
  }
  function startAnnouncementRotation() {
    clearInterval(interval);
    if (announcements.length > 1) {
      interval = setInterval(showNextAnnouncement, announcementDuration);
    }
  }
  function pauseAnnouncementRotation() {
    clearInterval(interval);
  }
  function resetAnnouncements() {
    announcements = document.querySelectorAll(".announcement-item");
    currentIndex = 0;
    announcements.forEach((announcement) => announcement.classList.remove("active"));
    if (announcements.length > 0) {
      announcements[0].classList.add("active");
    }
  }
  function updateAnnouncementDuration() {
    announcementDuration = (announcementBarContainer.dataset.announcementDuration || 10) * 1e3;
  }
  resetAnnouncements();
  startAnnouncementRotation();
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      if (event.target.contains(announcementBarContainer)) {
        announcementBarContainer = event.target.querySelector(".announcement-bar-container");
        updateAnnouncementDuration();
        resetAnnouncements();
        startAnnouncementRotation();
      }
    });
    document.addEventListener("shopify:section:select", (event) => {
      if (event.target.contains(announcementBarContainer)) {
        updateAnnouncementDuration();
        resetAnnouncements();
        startAnnouncementRotation();
      }
    });
    document.addEventListener("shopify:block:select", (event) => {
      const blockId = event.detail.blockId;
      const selectedAnnouncement = document.querySelector(`#block-${blockId} .announcement-item`);
      if (selectedAnnouncement) {
        announcements.forEach((announcement) => announcement.classList.remove("active"));
        selectedAnnouncement.classList.add("active");
        currentIndex = Array.from(announcements).indexOf(selectedAnnouncement);
        pauseAnnouncementRotation();
      }
    });
    document.addEventListener("shopify:block:deselect", startAnnouncementRotation);
    document.addEventListener("shopify:block:reorder", () => {
      resetAnnouncements();
      startAnnouncementRotation();
    });
    document.addEventListener("shopify:block:destroy", () => {
      resetAnnouncements();
      startAnnouncementRotation();
    });
  }
}
document.addEventListener("DOMContentLoaded", initializeAnnouncementBarRotation);
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", initializeAnnouncementBarRotation);
  document.addEventListener("shopify:section:reorder", initializeAnnouncementBarRotation);
}
class HeaderNavigation {
  constructor() {
    this.init();
  }
  init() {
    this.header = document.querySelector("header[data-hide-on-scroll]");
    if (!this.header) return;
    this.nav = this.header.querySelector(".navigation-wrapper");
    this.collectionHeader = document.querySelector(".collection-header-wrapper");
    if (!this.nav) return;
    this.lastScrollTop = 0;
    this.scrollThreshold = 50;
    this.setupScrollListener();
  }
  setupScrollListener() {
    let ticking = false;
    let lastScrollTime2 = 0;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const SCROLL_THROTTLE2 = isSafari ? 200 : 150;
    const scrollHandler = () => {
      const now = Date.now();
      if (now - lastScrollTime2 < SCROLL_THROTTLE2) {
        return;
      }
      if (!ticking) {
        const scheduleUpdate = window.requestIdleCallback || window.requestAnimationFrame;
        scheduleUpdate(() => {
          this.handleScroll();
          ticking = false;
          lastScrollTime2 = Date.now();
        });
        ticking = true;
      }
    };
    if (window.ultraScrollCoordinator) {
      window.ultraScrollCoordinator.subscribe("header-navigation", scrollHandler, {
        priority: "high",
        // Header navigation has high priority
        throttle: SCROLL_THROTTLE2
      });
    } else {
      if (window.globalThrottleManager) {
        window.globalThrottleManager.onScroll("header-center", scrollHandler);
      } else {
        window.addEventListener("scroll", scrollHandler, { passive: true });
      }
    }
  }
  handleScroll() {
    if (document.body.hasAttribute("data-search-open")) return;
    const currentScroll = window.pageYOffset;
    if (currentScroll > this.lastScrollTop && currentScroll > this.scrollThreshold) {
      this.nav.classList.add("hidden-nav");
      if (this.collectionHeader) {
        this.collectionHeader.classList.add("hidden-background");
      }
    } else if (currentScroll < this.lastScrollTop) {
      this.nav.classList.remove("hidden-nav");
      if (this.collectionHeader) {
        this.collectionHeader.classList.remove("hidden-background");
      }
    }
    this.lastScrollTop = currentScroll;
  }
}
function initHeaderNavigation() {
  new HeaderNavigation();
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeaderNavigation);
} else {
  initHeaderNavigation();
}
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.querySelector("header[data-hide-on-scroll]")) {
      initHeaderNavigation();
    }
  });
  document.addEventListener("shopify:section:select", (event) => {
    if (event.target.querySelector("header[data-hide-on-scroll]")) {
      initHeaderNavigation();
    }
  });
  document.addEventListener("shopify:block:select", (event) => {
    if (event.target.closest("header[data-hide-on-scroll]")) {
      initHeaderNavigation();
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  const headerLayout = document.body.dataset.headerLayout;
  if (headerLayout === "left") {
    return;
  }
  const submenuItems = document.querySelectorAll(".submenu-item");
  function animateSubSubmenu(subSubMenu, isOpening) {
    const animationDuration = 300;
    if (subSubMenu.dataset.animationTimeout) {
      clearTimeout(parseInt(subSubMenu.dataset.animationTimeout));
    }
    if (isOpening) {
      subSubMenu.style.height = "0px";
      subSubMenu.style.display = "block";
      subSubMenu.style.opacity = "0";
      subSubMenu.style.visibility = "visible";
      subSubMenu.style.overflow = "hidden";
      subSubMenu.style.transition = `height ${animationDuration}ms ease-in-out, opacity ${animationDuration}ms ease-in-out`;
      subSubMenu.offsetHeight;
      requestAnimationFrame(() => {
        const scrollHeight = subSubMenu.scrollHeight;
        subSubMenu.style.height = `${scrollHeight}px`;
        subSubMenu.style.opacity = "1";
      });
      const timeoutId = setTimeout(() => {
        subSubMenu.style.height = "auto";
        subSubMenu.style.overflow = "visible";
        subSubMenu.style.transition = "";
        subSubMenu.dataset.animationTimeout = "";
      }, animationDuration);
      subSubMenu.dataset.animationTimeout = timeoutId.toString();
    } else {
      const scrollHeight = subSubMenu.scrollHeight;
      subSubMenu.style.height = `${scrollHeight}px`;
      subSubMenu.style.opacity = "1";
      subSubMenu.style.display = "block";
      subSubMenu.style.visibility = "visible";
      subSubMenu.style.overflow = "hidden";
      subSubMenu.style.position = "relative";
      subSubMenu.style.transition = `height ${animationDuration}ms ease-in-out, opacity ${animationDuration}ms ease-in-out`;
      subSubMenu.offsetHeight;
      requestAnimationFrame(() => {
        subSubMenu.style.height = "0px";
        subSubMenu.style.opacity = "0";
      });
      const timeoutId = setTimeout(() => {
        subSubMenu.style.height = "";
        subSubMenu.style.display = "none";
        subSubMenu.style.opacity = "";
        subSubMenu.style.visibility = "hidden";
        subSubMenu.style.transition = "";
        subSubMenu.style.overflow = "";
        subSubMenu.style.position = "";
        subSubMenu.dataset.animationTimeout = "";
      }, animationDuration);
      subSubMenu.dataset.animationTimeout = timeoutId.toString();
    }
  }
  submenuItems.forEach((item) => {
    const subSubMenu = item.querySelector(".sub-submenu");
    const link = item.querySelector("a");
    const linkHref = link ? link.getAttribute("href") : "";
    const isPlaceholderLink = !linkHref || linkHref === "#" || linkHref === "";
    if (subSubMenu) {
      if (isPlaceholderLink) {
        item.setAttribute("data-placeholder-link", "true");
        item.classList.remove("expanded");
        subSubMenu.style.display = "none";
        subSubMenu.style.opacity = "0";
        subSubMenu.style.visibility = "hidden";
        subSubMenu.style.height = "0";
        subSubMenu.style.overflow = "hidden";
        subSubMenu.style.position = "relative";
        item.addEventListener("click", function(event) {
          if (event.target.closest(".sub-submenu a")) {
            return;
          }
          if (isPlaceholderLink) {
            event.preventDefault();
            event.stopPropagation();
          }
          const isExpanded = item.classList.contains("expanded");
          const parentMenu = item.closest(".submenu, .mega-menu");
          if (parentMenu) {
            const siblings = parentMenu.querySelectorAll(".submenu-item.expanded");
            siblings.forEach((sibling) => {
              if (sibling !== item && sibling.parentElement === item.parentElement) {
                sibling.classList.remove("expanded");
                const siblingSub = sibling.querySelector(".sub-submenu");
                if (siblingSub) {
                  animateSubSubmenu(siblingSub, false);
                }
              }
            });
          }
          if (isExpanded) {
            item.classList.remove("expanded");
            animateSubSubmenu(subSubMenu, false);
          } else {
            item.classList.add("expanded");
            animateSubSubmenu(subSubMenu, true);
          }
        });
      } else {
        item.removeAttribute("data-placeholder-link");
        item.classList.remove("expanded");
        subSubMenu.style.display = "";
        subSubMenu.style.opacity = "";
        subSubMenu.style.visibility = "";
        subSubMenu.style.height = "";
        subSubMenu.style.overflow = "";
        subSubMenu.style.transition = "";
      }
    }
  });
});
document.addEventListener("DOMContentLoaded", () => {
  initializeHeaderSpace();
});
function initializeHeaderSpace() {
  if (window.headerSpaceInitialized) {
    cleanupHeaderSpace();
  }
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    const updateHeaderSpaceWithCleanup = () => {
      cleanupHeaderSpace();
      updateHeaderSpace();
    };
    document.addEventListener("shopify:section:load", updateHeaderSpaceWithCleanup);
    document.addEventListener("shopify:section:unload", () => {
      setTimeout(updateHeaderSpaceWithCleanup, 100);
    });
    document.addEventListener("shopify:section:select", updateHeaderSpaceWithCleanup);
    document.addEventListener("shopify:section:deselect", updateHeaderSpaceWithCleanup);
    document.addEventListener("shopify:block:select", updateHeaderSpaceWithCleanup);
    document.addEventListener("shopify:block:deselect", updateHeaderSpaceWithCleanup);
    document.addEventListener("shopify:section:reorder", updateHeaderSpaceWithCleanup);
    document.addEventListener("shopify:editor:settings:update", () => {
      cleanupHeaderSpace();
      requestAnimationFrame(updateHeaderSpace);
    });
    const headerContainer = document.getElementById("header-container");
    if (headerContainer) {
      const observer = new MutationObserver(() => {
        updateHeaderSpace();
      });
      observer.observe(headerContainer, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ["style", "class"]
      });
      window.headerMutationObserver = observer;
    }
  }
  updateHeaderSpace();
  window.headerSpaceInitialized = true;
}
function cleanupHeaderSpace() {
  document.documentElement.style.removeProperty("--main-top-margin");
  document.documentElement.style.removeProperty("--header-height");
  document.documentElement.style.removeProperty("--collection-details-top-margin");
  if (window.headerMutationObserver) {
    window.headerMutationObserver.disconnect();
    window.headerMutationObserver = null;
  }
  window.headerSpaceInitialized = false;
}
window.addEventListener("resize", updateHeaderSpace);
function updateHeaderSpace() {
  const isTransparent = document.body.getAttribute("data-transparent-background") === "true";
  const headerLayout = document.body.getAttribute("data-header-layout");
  const isVerticalLayout = headerLayout === "left";
  const headerContainer = document.getElementById("header-container");
  const main = document.getElementById("main");
  if (!headerContainer || !main) {
    cleanupHeaderSpace();
    return;
  }
  const headerHeight = headerContainer.offsetHeight;
  document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
  if (isVerticalLayout) {
    handleVerticalLayout(isTransparent, headerHeight, main);
  } else {
    handleNonVerticalLayout(isTransparent, headerHeight);
  }
}
function handleVerticalLayout(isTransparent, headerHeight, main) {
  const firstTemplateSection = main.querySelector('[id^="shopify-section-template"]');
  const firstGroupSection = main.querySelector(".shopify-section-group-collection-header-group, .shopify-section-group-header-group");
  const disableSpaceElement = (firstTemplateSection == null ? void 0 : firstTemplateSection.querySelector(".disable-main-header-space")) || (firstGroupSection == null ? void 0 : firstGroupSection.querySelector(".disable-main-header-space"));
  const shouldDisableSpace = !!disableSpaceElement;
  const announcementBar2 = document.querySelector(".announcement-bar-container");
  const hasAnnouncementBar = announcementBar2 && announcementBar2.querySelector(".announcement-item") && !announcementBar2.hasAttribute("data-hidden-by-settings");
  const announcementOffset = hasAnnouncementBar ? 36 : 0;
  if (isTransparent || shouldDisableSpace) {
    if (shouldDisableSpace) {
      const negativeMargin = -headerHeight + announcementOffset;
      document.documentElement.style.setProperty("--main-top-margin", `${negativeMargin}px`);
    } else {
      document.documentElement.style.removeProperty("--main-top-margin");
    }
  } else {
    document.documentElement.style.removeProperty("--main-top-margin");
  }
}
function handleNonVerticalLayout(isTransparent, headerHeight) {
  const main = document.getElementById("main");
  if (!main) {
    cleanupHeaderSpace();
    return;
  }
  const firstTemplateSection = main.querySelector('[id^="shopify-section-template"]');
  const firstGroupSection = main.querySelector(".shopify-section-group-collection-header-group, .shopify-section-group-header-group");
  const disableSpaceElement = (firstTemplateSection == null ? void 0 : firstTemplateSection.querySelector(".disable-main-header-space")) || (firstGroupSection == null ? void 0 : firstGroupSection.querySelector(".disable-main-header-space"));
  const shouldDisableSpace = !!disableSpaceElement;
  if (!shouldDisableSpace) {
    cleanupHeaderSpace();
    return;
  }
  const announcementBar2 = document.querySelector(".announcement-bar-container");
  const hasAnnouncementBar = announcementBar2 && announcementBar2.querySelector(".announcement-item") && !announcementBar2.hasAttribute("data-hidden-by-settings");
  const announcementOffset = hasAnnouncementBar ? 36 : 0;
  const negativeMargin = -headerHeight + announcementOffset;
  document.documentElement.style.setProperty("--main-top-margin", `${negativeMargin}px`);
}
class MobileDrawerManager {
  constructor() {
    this.drawerInstance = null;
    this.isInitialized = false;
    this.initializationAttempts = 0;
    this.maxAttempts = 5;
    this.listeners = /* @__PURE__ */ new Set();
    this.selectors = {
      drawer: "[data-mobile-drawer]",
      hamburgerButton: "#hamburger-button",
      expandButtons: ".mobile-expand-button",
      navLinks: ".main-mobile-nav-link[data-submenu], .mobile-nav-link[data-submenu]"
    };
    this.animationDuration = 300;
    this.init();
  }
  /**
   * Check if drawer is currently open
   * @returns {boolean} Whether drawer is open
   */
  isDrawerOpen() {
    const drawerElement = window.DOMHelper.safeQuery(this.selectors.drawer);
    if (this.drawerInstance && this.drawerInstance.isOpen) return true;
    if (drawerElement && window.DOMHelper.hasClass(drawerElement, "active")) return true;
    return false;
  }
  /**
   * Clean up all event listeners
   */
  cleanupListeners() {
    this.listeners.forEach(({ element, type, handler }) => {
      if (element) {
        element.removeEventListener(type, handler);
      }
    });
    this.listeners.clear();
  }
  /**
   * Add event listener with tracking for cleanup
   * @param {Element} element - Element to add listener to
   * @param {string} type - Event type
   * @param {Function} handler - Event handler
   */
  addListener(element, type, handler) {
    if (!element) return;
    element.addEventListener(type, handler);
    this.listeners.add({ element, type, handler });
  }
  /**
   * Toggle submenu visibility with animations
   * @param {string} submenuId - ID of submenu to toggle
   * @param {Element} button - Toggle button element
   * @param {Event} event - Click event
   */
  toggleSubMenu(submenuId, button, event) {
    if (event) {
      event.preventDefault();
    }
    const submenu = window.DOMHelper.safeQuery(`#${submenuId}`);
    const icon = button ? window.DOMHelper.safeQuery("svg", button) : null;
    const isAnimated = window.DOMHelper.getAttribute(document.body, "data-animate-dropdown") === "true";
    if (!submenu) return;
    if (isAnimated) {
      this.animateSubmenu(submenu);
    } else {
      window.DOMHelper.toggleClass(submenu, "hidden");
    }
    if (icon) {
      window.DOMHelper.toggleClass(icon, "rotate-45");
    }
  }
  /**
   * Animate submenu opening/closing
   * @param {Element} submenu - Submenu element to animate
   */
  animateSubmenu(submenu) {
    const isHidden = window.DOMHelper.hasClass(submenu, "hidden");
    if (isHidden) {
      window.DOMHelper.removeClass(submenu, "hidden");
      window.DOMHelper.setStyle(submenu, "height", "0px");
      submenu.offsetHeight;
      const scrollHeight = submenu.scrollHeight;
      window.DOMHelper.setStyle(submenu, "height", `${scrollHeight}px`);
      setTimeout(() => {
        window.DOMHelper.setStyle(submenu, "height", "");
      }, this.animationDuration);
    } else {
      const scrollHeight = submenu.scrollHeight;
      window.DOMHelper.setStyle(submenu, "height", `${scrollHeight}px`);
      submenu.offsetHeight;
      window.DOMHelper.setStyle(submenu, "height", "0px");
      setTimeout(() => {
        window.DOMHelper.addClass(submenu, "hidden");
        window.DOMHelper.setStyle(submenu, "height", "");
      }, this.animationDuration);
    }
  }
  /**
   * Handle expand button clicks
   * @param {Event} event - Click event
   */
  handleExpandButton(event) {
    const submenuId = window.DOMHelper.getAttribute(event.currentTarget, "data-submenu-trigger");
    this.toggleSubMenu(submenuId, event.currentTarget, event);
  }
  /**
   * Handle navigation link clicks for submenus
   * @param {Event} event - Click event
   */
  handleNavLink(event) {
    const submenuId = window.DOMHelper.getAttribute(event.currentTarget, "data-submenu");
    const button = window.DOMHelper.safeQuery(".mobile-expand-button", event.currentTarget.parentElement);
    if (submenuId) {
      this.toggleSubMenu(submenuId, button, event);
    }
  }
  /**
   * Handle hamburger button click
   * @param {Event} event - Click event
   */
  handleHamburgerClick(event) {
    event.preventDefault();
    if (this.drawerInstance && typeof this.drawerInstance.open === "function") {
      this.drawerInstance.open();
      setTimeout(() => {
        const drawerElement = window.DOMHelper.safeQuery(this.selectors.drawer);
        if (drawerElement) {
          window.DOMHelper.addClass(drawerElement, "mobile-drawer-full-height");
        }
      }, 50);
    }
  }
  /**
   * Set up viewport height CSS variable for mobile
   */
  setupViewportHeight() {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      window.DOMHelper.setStyle(document.documentElement, "--vh", `${vh}px`);
      const drawerElement = window.DOMHelper.safeQuery(this.selectors.drawer);
      if (drawerElement) {
        window.DOMHelper.addClass(drawerElement, "mobile-drawer-full-height");
      }
    };
    setVh();
    this.addListener(window, "resize", setVh);
    this.addListener(window, "orientationchange", () => {
      setTimeout(setVh, 50);
    });
    this.addListener(document, "visibilitychange", setVh);
  }
  /**
   * Setup event listeners for drawer functionality
   */
  setupEventListeners() {
    this.cleanupListeners();
    const hamburgerButton = window.DOMHelper.safeQuery(this.selectors.hamburgerButton);
    const expandButtons = window.DOMHelper.safeQueryAll(this.selectors.expandButtons);
    const navLinks = window.DOMHelper.safeQueryAll(this.selectors.navLinks);
    if (hamburgerButton) {
      this.addListener(hamburgerButton, "click", (e) => this.handleHamburgerClick(e));
    }
    expandButtons.forEach((button) => {
      this.addListener(button, "click", (e) => this.handleExpandButton(e));
    });
    navLinks.forEach((link) => {
      this.addListener(link, "click", (e) => this.handleNavLink(e));
    });
    const drawerElement = window.DOMHelper.safeQuery(this.selectors.drawer);
    if (drawerElement) {
      this.addListener(drawerElement, "drawer:opened", () => {
        this.ensureFullHeight();
      });
      this.addListener(drawerElement, "drawer:opening", () => {
        this.ensureFullHeight();
      });
    }
  }
  /**
   * Initialize the mobile drawer
   * @returns {boolean} Whether initialization was successful
   */
  init() {
    if (this.isInitialized) {
      return true;
    }
    this.cleanupListeners();
    const mobileDrawerElement = window.DOMHelper.safeQuery(this.selectors.drawer);
    if (!mobileDrawerElement) {
      if (this.initializationAttempts < this.maxAttempts) {
        this.initializationAttempts++;
        setTimeout(() => this.init(), 300);
      }
      return false;
    }
    this.drawerInstance = mobileDrawerElement.drawer;
    if (!this.drawerInstance) {
      if (this.initializationAttempts < this.maxAttempts) {
        this.initializationAttempts++;
        setTimeout(() => this.init(), 300);
      }
      return false;
    }
    const hamburgerButton = window.DOMHelper.safeQuery(this.selectors.hamburgerButton);
    if (!hamburgerButton) {
      if (this.initializationAttempts < this.maxAttempts) {
        this.initializationAttempts++;
        setTimeout(() => this.init(), 300);
      }
      return false;
    }
    this.isInitialized = true;
    this.initializationAttempts = 0;
    this.setupEventListeners();
    this.setupViewportHeight();
    this.setupThemeEditorEvents();
    this.ensureFullHeight();
    window.DOMHelper.dispatchEvent("mobileDrawer:initialized", { instance: this });
    return true;
  }
  /**
   * Ensure drawer takes full height
   */
  ensureFullHeight() {
    const drawerElement = window.DOMHelper.safeQuery(this.selectors.drawer);
    if (drawerElement) {
      window.DOMHelper.addClass(drawerElement, "mobile-drawer-full-height");
    }
  }
  /**
   * Setup theme editor event handlers
   */
  setupThemeEditorEvents() {
    const themeEditorEvents = [
      "shopify:section:load",
      "shopify:section:select",
      "shopify:section:deselect",
      "shopify:block:select",
      "shopify:block:deselect"
    ];
    themeEditorEvents.forEach((eventName) => {
      this.addListener(document, eventName, () => {
        this.isInitialized = false;
        this.initializationAttempts = 0;
        setTimeout(() => {
          this.init();
        }, 50);
      });
    });
  }
  /**
   * Reset the drawer state
   */
  reset() {
    this.isInitialized = false;
    this.initializationAttempts = 0;
    this.cleanupListeners();
    this.drawerInstance = null;
  }
  /**
   * Destroy the mobile drawer manager
   */
  destroy() {
    this.cleanupListeners();
    window.DOMHelper.clearCache();
    this.reset();
  }
  /**
   * Get current drawer state
   * @returns {Object} Current state information
   */
  getState() {
    return {
      isInitialized: this.isInitialized,
      isOpen: this.isDrawerOpen(),
      hasDrawerInstance: !!this.drawerInstance,
      listenerCount: this.listeners.size
    };
  }
}
let mobileDrawerManager = null;
function initializeMobileDrawer() {
  if (!mobileDrawerManager) {
    mobileDrawerManager = new MobileDrawerManager();
  }
  return mobileDrawerManager;
}
function getMobileDrawerManager() {
  return mobileDrawerManager || initializeMobileDrawer();
}
if (typeof window.ModuleManager !== "undefined") {
  window.ModuleManager.register("MobileDrawer", initializeMobileDrawer, ["DOMHelper"]);
} else {
  document.addEventListener("DOMContentLoaded", initializeMobileDrawer);
  document.addEventListener("criticalReady", initializeMobileDrawer);
}
if (typeof window !== "undefined") {
  window.MobileDrawerManager = MobileDrawerManager;
  window.getMobileDrawerManager = getMobileDrawerManager;
  window.setupMobileDrawer = initializeMobileDrawer;
  window.isDrawerOpen = () => {
    const manager = getMobileDrawerManager();
    return manager ? manager.isDrawerOpen() : false;
  };
}
window.CartUI = {
  /**
   * Updates cart count elements in the UI
   * @param {number} count - New cart count
   */
  updateCartCounts: function(count) {
    if (typeof count !== "number") return;
    const cartCountElements = window.DOMHelper.safeQueryAll("[data-cart-count]");
    cartCountElements.forEach((element) => {
      element.textContent = count.toString();
    });
    const drawerCount = window.DOMHelper.safeQuery(".cart-drawer-count");
    if (drawerCount) {
      const strings = getCartStrings();
      const itemText = count === 1 ? strings.item_singular : strings.item_plural;
      drawerCount.textContent = `${count} ${itemText}`;
    }
    window.DOMHelper.safeQueryAll(".cart-count-wrapper").forEach((wrapper) => {
      if (wrapper) {
        window.DOMHelper.setStyle(wrapper, "display", count > 0 ? "inline" : "none");
      }
    });
    window.DOMHelper.safeQueryAll(".cart-count").forEach((element) => {
      if (element) {
        element.textContent = count.toString();
      }
    });
    const drawerHeaderCount = window.DOMHelper.safeQuery(".cart-drawer-header-right-items");
    if (drawerHeaderCount) {
      const strings = getCartStrings();
      const itemText = count === 1 ? strings.item_singular : strings.item_plural;
      drawerHeaderCount.textContent = `${count} ${itemText}`;
    }
    window.DOMHelper.safeQueryAll(".cart-text").forEach((el) => {
      const strings = getCartStrings();
      if (strings && strings.cart) {
        el.textContent = strings.cart;
      }
    });
    window.DOMHelper.safeQueryAll('a[href*="cart"]').forEach((link) => {
      const strings = getCartStrings();
      if (strings && strings.cart_with_count) {
        window.DOMHelper.setAttribute(
          link,
          "aria-label",
          strings.cart_with_count.replace("[count]", count)
        );
      }
    });
  },
  reinitializeCartBehaviors: function() {
    const cartType = window.getCartType();
    window.DOMHelper.safeQueryAll('a[href*="cart"]').forEach((link) => {
      link.removeEventListener("click", window.handleCartClick);
      if (cartType === "drawer") {
        link.addEventListener("click", window.handleCartClick);
      }
    });
    window.DOMHelper.safeQueryAll("[data-add-to-cart]").forEach((button) => {
      window.DOMHelper.setAttribute(button, "data-cart-type", cartType);
    });
  },
  updateDrawerUI(cartData) {
    return __async(this, null, function* () {
      if (cartData.item_count === 0) {
        const cartDrawer = window.DOMHelper.safeQuery("[data-cart-drawer]");
        if (!cartDrawer) return false;
        const text = yield window.ShopifyAPIHelper.getCartHTML("drawer");
        const html = document.createElement("div");
        html.innerHTML = text;
        const newDrawerContent = window.DOMHelper.safeQuery("[data-cart-drawer] .drawer-body", html) || window.DOMHelper.safeQuery(".cart-drawer-form", html) || window.DOMHelper.safeQuery(".cart-drawer-box", html);
        if (newDrawerContent) {
          const targetElement = window.DOMHelper.safeQuery(".drawer-body", cartDrawer) || window.DOMHelper.safeQuery(".cart-drawer-box", cartDrawer);
          if (targetElement) {
            targetElement.innerHTML = newDrawerContent.innerHTML;
            window.addCartDrawerListeners();
          }
        }
        this.updateCartCounts(0);
        return true;
      }
      return false;
    });
  },
  updateDrawerTotals(cartData, totalRow) {
    if (totalRow) {
      const totalSpan = window.DOMHelper.safeQuery("span", totalRow);
      if (totalSpan) {
        const amount = window.DOMHelper.getAttribute(document.body, "data-cart-price-display") === "subtotal" ? cartData.original_total_price : cartData.total_price;
        const currencyCode = totalSpan.textContent.trim().split(" ").pop() || "";
        totalSpan.innerHTML = `${window.formatMoney(amount)} ${currencyCode}`;
      }
    }
  },
  updateLineItemUI(itemElement, cartData) {
    const quantityInput = window.DOMHelper.safeQuery("input[data-quantity-input]", itemElement);
    if (quantityInput) {
      const item = cartData.items.find((item2) => item2.key === window.DOMHelper.getAttribute(itemElement, "data-line-item-key"));
      if (item) {
        quantityInput.value = item.quantity;
      }
    }
    const priceStack = window.DOMHelper.safeQuery(".cart-drawer-item-price-stack", itemElement);
    if (priceStack) {
      const item = cartData.items.find((item2) => item2.key === window.DOMHelper.getAttribute(itemElement, "data-line-item-key"));
      if (item) {
        const currencyCode = priceStack.textContent.trim().split(" ").pop() || "";
        if (item.original_price !== item.final_price) {
          priceStack.innerHTML = `
                        ${window.formatMoney(item.original_line_price)}
                        ${currencyCode}
                        <span class="sale-price">
                            ${window.formatMoney(item.final_line_price)}
                            ${currencyCode}
                        </span>
                    `;
        } else {
          priceStack.innerHTML = `
                        <span>
                            ${window.formatMoney(item.final_line_price)}
                            ${currencyCode}
                        </span>
                    `;
        }
      }
    }
  },
  findTotalRow() {
    const footerRows = window.DOMHelper.safeQueryAll(".cart-drawer-footer-row");
    return Array.from(footerRows).find((row) => {
      const heading = window.DOMHelper.safeQuery("h3", row);
      return heading && (heading.textContent.trim().includes("Subtotal") || heading.textContent.trim().includes("Total"));
    });
  },
  updateFreeShippingMessage: function(cartData, forceShow = false) {
    window.updateFreeShippingMessage(cartData, forceShow);
  },
  handleRemoveItemUI: function(updatedCart, cartDrawer) {
    return __async(this, null, function* () {
      const shouldClose = yield this.updateDrawerUI(updatedCart);
      if (shouldClose) {
        setTimeout(() => window.closeCartDrawer(), 300);
        return true;
      }
      const totalRow = this.findTotalRow();
      this.updateDrawerTotals(updatedCart, totalRow);
      this.updateFreeShippingMessage(updatedCart);
      return false;
    });
  },
  handleEmptyCartTransition: function(cartDrawer) {
    return __async(this, null, function* () {
      try {
        this.updateCartCounts(0);
        const emptyCartData = { item_count: 0, total_price: 0 };
        this.updateFreeShippingMessage(emptyCartData, false);
        return true;
      } catch (error) {
        return false;
      }
    });
  }
};
window.CartEvents = {
  /**
   * Dispatches a cart update event
   * @param {import('./cart-types').CartData} cartData - Updated cart data
   */
  dispatchCartUpdate: function(cartData) {
    const event = new CustomEvent("cart:updated", {
      detail: { cart: cartData },
      bubbles: true
    });
    document.dispatchEvent(event);
  },
  /**
   * Registers a callback for cart updates
   * @param {(cartData: import('./cart-types').CartData) => void} callback
   */
  onCartUpdate: function(callback) {
    document.addEventListener("cart:updated", (event) => {
      callback(event.detail.cart);
    });
  }
};
function getCartStrings() {
  const cartStringsElement = window.DOMHelper.getAttribute(document.body, "data-cart-strings");
  return JSON.parse(cartStringsElement);
}
window.getCartStrings = getCartStrings;
function showCartNotification$1(messageKey, type = "error") {
  const strings = getCartStrings();
  const message = strings[messageKey] || messageKey;
  window.showNotification(message, type);
}
window.showCartNotification = showCartNotification$1;
(function() {
  window.showNotification = function(message, type = "error") {
    const existingNotification = window.DOMHelper.safeQuery(".cart-notification");
    if (existingNotification) {
      existingNotification.remove();
    }
    const notification = document.createElement("div");
    notification.className = `cart-notification cart-notification--${type}`;
    notification.innerHTML = `
        <div class="cart-notification__content">
          ${message}
        </div>
      `;
    document.body.appendChild(notification);
    setTimeout(() => {
      window.DOMHelper.addClass(notification, "cart-notification--visible");
    }, 10);
    setTimeout(() => {
      window.DOMHelper.removeClass(notification, "cart-notification--visible");
      setTimeout(() => {
        notification.remove();
      }, 250);
    }, 3e3);
  };
})();
window.formatMoney = function(cents, format = null) {
  var _a;
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || ((_a = window.Shopify) == null ? void 0 : _a.money_format) || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    var parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
window.InventoryService = {
  validateInventory: function(currentQuantity, newQuantity, inventoryData) {
    if (!inventoryData) return true;
    const {
      inventoryQuantity,
      trackQuantity,
      continueSellingWhenOutOfStock
    } = inventoryData;
    if (!trackQuantity || continueSellingWhenOutOfStock) {
      return true;
    }
    return newQuantity <= inventoryQuantity;
  },
  getInventoryData: function(element) {
    if (!element) return null;
    return {
      inventoryQuantity: parseInt(window.DOMHelper.getAttribute(element, "data-inventory-quantity")) || null,
      trackQuantity: window.DOMHelper.getAttribute(element, "data-track-quantity") === "true",
      continueSellingWhenOutOfStock: window.DOMHelper.getAttribute(element, "data-continue-selling-when-out-of-stock") === "true"
    };
  },
  checkAvailability: function(handle, variantId, quantity) {
    return __async(this, null, function* () {
      try {
        const html = yield window.ShopifyAPIHelper.getVariantInventory(handle, variantId);
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const inventoryElement = window.DOMHelper.safeQuery("[data-inventory-data]", tempDiv);
        if (inventoryElement) {
          const inventoryData = JSON.parse(window.DOMHelper.getAttribute(inventoryElement, "data-inventory-data"));
          return this.validateInventory(0, quantity, {
            inventoryQuantity: inventoryData.inventory_quantity,
            trackQuantity: inventoryData.inventory_management === "shopify",
            continueSellingWhenOutOfStock: inventoryData.inventory_policy === "continue"
          });
        }
        return true;
      } catch (error) {
        return true;
      }
    });
  }
};
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load", function(event) {
    if (event.target.id === "shopify-section-cart-drawer") {
      addCartDrawerListeners();
    }
  });
  document.addEventListener("shopify:theme:settings:editor:update", function() {
    var _a, _b;
    const newCartType = window.DOMHelper.getAttribute(document.body, "data-cart-type");
    window.DOMHelper.safeQueryAll('a[href*="cart"]').forEach((link) => {
      link.removeEventListener("click", window.handleCartClick);
      link.addEventListener("click", window.handleCartClick);
    });
    if (newCartType === "page") {
      const cartDrawer = window.DOMHelper.safeQuery(".cart-drawer");
      if (cartDrawer && window.DOMHelper.hasClass(cartDrawer, "cart-drawer--active")) {
        closeCartDrawer();
      }
    }
    const routesRootRaw = ((_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) || "/";
    const routesRoot = routesRootRaw.endsWith("/") ? routesRootRaw : `${routesRootRaw}/`;
    const normalizedCurrentPath = window.location.pathname.replace(/\/+$/, "");
    const normalizedCartPath = `${routesRoot}cart`.replace(/\/+$/, "");
    if (normalizedCurrentPath === normalizedCartPath) {
      window.location.reload();
    }
  });
}
function updateFreeShippingMessage(cartData, forceShow = false) {
  var _a;
  const containers = window.DOMHelper.safeQueryAll(".free-shipping-container");
  const messageElements = window.DOMHelper.safeQueryAll(".free-shipping-message");
  const progressBars = window.DOMHelper.safeQueryAll(".free-shipping-progress-bar");
  if (containers.length === 0) return;
  if (!cartData || typeof cartData.total_price === "undefined") {
    return;
  }
  const FREE_SHIPPING_THRESHOLD = parseFloat(window.DOMHelper.getAttribute(document.body, "data-free-shipping-threshold"));
  if (isNaN(FREE_SHIPPING_THRESHOLD) || FREE_SHIPPING_THRESHOLD <= 0) {
    containers.forEach((container) => {
      window.DOMHelper.removeClass(container, "is-visible");
    });
    return;
  }
  if (cartData.item_count === 0 && !forceShow) {
    containers.forEach((container) => {
      window.DOMHelper.removeClass(container, "is-visible");
    });
    return;
  }
  const cartTotal = cartData.total_price / 100;
  const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - cartTotal);
  const strings = getCartStrings();
  const freeShippingMessage = remaining > 0 ? (_a = strings.free_shipping_spend_more) == null ? void 0 : _a.replace("{{ amount }}", window.formatMoney ? window.formatMoney(remaining * 100) : remaining.toFixed(2)) : strings.free_shipping_congratulations;
  messageElements.forEach((messageEl) => {
    if (messageEl) {
      messageEl.textContent = freeShippingMessage || "";
    }
  });
  progressBars.forEach((progressBar) => {
    if (progressBar) {
      const progress = Math.min(100, (FREE_SHIPPING_THRESHOLD - remaining) / FREE_SHIPPING_THRESHOLD * 100);
      progressBar.style.width = `${progress}%`;
      progressBar.style.transition = "width 0.5s ease";
    }
  });
  containers.forEach((container) => {
    window.DOMHelper.addClass(container, "is-visible");
  });
}
window.updateFreeShippingMessage = updateFreeShippingMessage;
const CartState = /* @__PURE__ */ function() {
  let cartData = null;
  let isUpdateInProgress = false;
  let lastFetchTime = 0;
  const CACHE_DURATION = 2e3;
  const updateQueue = [];
  let isProcessingQueue = false;
  function processUpdateQueue() {
    return __async(this, null, function* () {
      if (isProcessingQueue || updateQueue.length === 0) return;
      isProcessingQueue = true;
      while (updateQueue.length > 0) {
        const update = updateQueue[0];
        try {
          const result = yield update.action();
          update.resolve(result);
        } catch (error) {
          update.reject(error);
        } finally {
          updateQueue.shift();
        }
        yield new Promise((resolve) => setTimeout(resolve, 50));
      }
      isProcessingQueue = false;
    });
  }
  function queueUpdate(action) {
    return new Promise((resolve, reject) => {
      updateQueue.push({ action, resolve, reject });
      processUpdateQueue();
    });
  }
  function isAddOnItem(item) {
    var _a2;
    return ((_a2 = item == null ? void 0 : item.properties) == null ? void 0 : _a2._cart_add_on) === "true";
  }
  function hasVisibleCartItems(data) {
    var _a2;
    return (_a2 = data == null ? void 0 : data.items) == null ? void 0 : _a2.some((item) => !isAddOnItem(item));
  }
  function normalizeCartData(data) {
    return __async(this, null, function* () {
      var _a2;
      if (!((_a2 = data == null ? void 0 : data.items) == null ? void 0 : _a2.length) || hasVisibleCartItems(data)) {
        return data;
      }
      return window.ShopifyAPIHelper.clearCart();
    });
  }
  function updateCartData(newData, skipDispatch = false) {
    return __async(this, null, function* () {
      return queueUpdate(() => __async(this, null, function* () {
        if (isUpdateInProgress) {
          return;
        }
        isUpdateInProgress = true;
        try {
          const normalizedData = yield normalizeCartData(newData);
          cartData = normalizedData;
          lastFetchTime = Date.now();
          const itemCount = normalizedData.item_count || (normalizedData.items ? normalizedData.items.reduce((total, item) => total + item.quantity, 0) : 0);
          yield Promise.all([
            // Update cart counts
            (() => __async(this, null, function* () {
              window.CartUI.updateCartCounts(itemCount);
            }))(),
            // Update free shipping message
            (() => __async(this, null, function* () {
              window.updateFreeShippingMessage(cartData);
            }))()
          ]);
          if (!skipDispatch) {
            window.CartEvents.dispatchCartUpdate(__spreadProps(__spreadValues({}, cartData), {
              item_count: itemCount
            }));
          }
          return cartData;
        } finally {
          isUpdateInProgress = false;
        }
      }));
    });
  }
  return {
    get isUpdateInProgress() {
      return isUpdateInProgress;
    },
    get data() {
      return cartData;
    },
    getCartData(forceFetch = false) {
      return __async(this, null, function* () {
        const now = Date.now();
        if (!forceFetch && cartData && now - lastFetchTime < CACHE_DURATION) {
          return cartData;
        }
        try {
          const freshCartData = yield window.ShopifyAPIHelper.getCart(true);
          cartData = yield normalizeCartData(freshCartData);
          lastFetchTime = Date.now();
          const itemCount = cartData.item_count || (cartData.items ? cartData.items.reduce((total, item) => total + item.quantity, 0) : 0);
          window.CartUI.updateCartCounts(itemCount);
          window.updateFreeShippingMessage(cartData);
          return cartData;
        } catch (error) {
          throw error;
        }
      });
    },
    updateCartData(newData, skipDispatch = false) {
      return __async(this, null, function* () {
        return updateCartData(newData, skipDispatch);
      });
    },
    queueUpdate
  };
}();
const Cart = {
  _processing: false,
  // Track processing state
  checkInventoryAvailable(currentQuantity, newQuantity, inventoryQuantity, trackQuantity, continueSellingWhenOutOfStock) {
    if (trackQuantity && continueSellingWhenOutOfStock !== true && newQuantity > inventoryQuantity) {
      return false;
    }
    return true;
  },
  getInventoryData(element) {
    return {
      currentQuantity: parseInt(window.DOMHelper.safeQuery("input", element).value),
      inventoryQuantity: window.DOMHelper.getAttribute(element, "data-inventory-quantity") ? parseInt(window.DOMHelper.getAttribute(element, "data-inventory-quantity")) : null,
      trackQuantity: window.DOMHelper.getAttribute(element, "data-track-quantity") === "true",
      continueSellingWhenOutOfStock: window.DOMHelper.hasAttribute(element, "data-continue-selling-when-out-of-stock") ? window.DOMHelper.getAttribute(element, "data-continue-selling-when-out-of-stock") === "true" : null
    };
  },
  addItem(_0) {
    return __async(this, arguments, function* (variantId, quantity = 1, properties = {}) {
      var _a, _b;
      if (this._processing) return null;
      this._processing = true;
      try {
        const cart2 = yield window.CartState.getCartData();
        const cartItem = cart2.items.find((item) => item.variant_id === parseInt(variantId));
        const cartQuantity = cartItem ? cartItem.quantity : 0;
        const buttonCacheKey = `add-to-cart-${variantId}`;
        let addToCartButton = (_a = window.DOMHelper.cache) == null ? void 0 : _a.get(buttonCacheKey);
        if (!addToCartButton) {
          addToCartButton = window.DOMHelper.safeQuery(`[data-add-to-cart][data-variant-id="${variantId}"]`);
          if (!addToCartButton) {
            addToCartButton = window.DOMHelper.safeQuery("#add-to-cart-button");
          }
          if (addToCartButton && window.DOMHelper.cache) {
            window.DOMHelper.cache.set(buttonCacheKey, addToCartButton);
          }
        }
        if (addToCartButton) {
          const inventoryData = {
            currentQuantity: cartQuantity,
            inventoryQuantity: parseInt(window.DOMHelper.getAttribute(addToCartButton, "data-inventory-quantity")),
            trackQuantity: window.DOMHelper.getAttribute(addToCartButton, "data-track-quantity") === "true",
            continueSellingWhenOutOfStock: window.DOMHelper.getAttribute(addToCartButton, "data-continue-selling-when-out-of-stock") === "true"
          };
          const isAvailable = this.checkInventoryAvailable(
            inventoryData.currentQuantity,
            cartQuantity + quantity,
            inventoryData.inventoryQuantity,
            inventoryData.trackQuantity,
            inventoryData.continueSellingWhenOutOfStock
          );
          if (!isAvailable) {
            showCartNotification("max_quantity_reached");
            return null;
          }
        }
        const form = window.DOMHelper.safeQuery("#product-form");
        let finalProperties = __spreadValues({}, properties);
        const requestBody = {
          id: variantId,
          quantity: quantity || 1,
          properties: finalProperties
        };
        if (form) {
          const formData = new FormData(form);
          const isGiftCard = formData.get("is_gift_card") === "on";
          const productType = (_b = window.DOMHelper.safeQuery('[name="product-type"]', form)) == null ? void 0 : _b.value;
          const hasGiftCardClass = window.DOMHelper.hasClass(form, "gift-card-form");
          const isGiftCardProduct = window.DOMHelper.safeQuery('[data-product-type="Gift Card"]', form) !== null;
          if (productType === "Gift Card" || hasGiftCardClass || isGiftCardProduct) {
            if (isGiftCard) {
              finalProperties = __spreadProps(__spreadValues({}, finalProperties), {
                "Recipient Name": formData.get("recipient-name") || "",
                "Recipient Email": formData.get("recipient-email") || "",
                "Message": formData.get("gift-message") || ""
              });
            } else {
              finalProperties = __spreadProps(__spreadValues({}, finalProperties), {
                "Recipient Name": "Self Purchase",
                "Recipient Email": "self@purchase.com",
                "Message": ""
              });
            }
          }
          const sellingPlanId = formData.get("selling_plan");
          if (sellingPlanId) {
            requestBody.selling_plan = sellingPlanId;
          }
          const requiresSellingPlan = window.DOMHelper.getAttribute(addToCartButton, "data-requires-selling-plan") === "true";
          if (requiresSellingPlan && !sellingPlanId) {
            showCartNotification("requires_selling_plan");
            return null;
          }
        }
        requestBody.properties = finalProperties;
        const addResponse = yield window.ShopifyAPIHelper.addToCart(requestBody);
        const freshCartData = yield window.ShopifyAPIHelper.getCart(true);
        return yield window.CartState.updateCartData(freshCartData);
      } catch (error) {
        if (error.message && error.message.includes("description")) {
          try {
            const errorData = JSON.parse(error.message);
            showCartNotification(errorData.description || "add_error");
          } catch (e) {
            showCartNotification("add_error");
          }
        } else {
          showCartNotification("add_error");
        }
        throw error;
      } finally {
        this._processing = false;
      }
    });
  },
  updateItemQuantity(key, quantity, inventoryData = null, skipDispatch = false) {
    return __async(this, null, function* () {
      try {
        if (inventoryData) {
          const isAvailable = this.checkInventoryAvailable(
            inventoryData.currentQuantity,
            quantity,
            inventoryData.inventoryQuantity,
            inventoryData.trackQuantity,
            inventoryData.continueSellingWhenOutOfStock
          );
          if (!isAvailable) {
            showCartNotification("max_quantity_reached");
            return null;
          }
        }
        const updatedCart = yield window.ShopifyAPIHelper.changeCartItem(key, quantity);
        if (!skipDispatch) {
          return yield window.CartState.updateCartData(__spreadProps(__spreadValues({}, updatedCart), {
            item_count: updatedCart.items.reduce((total, item) => total + item.quantity, 0)
          }));
        }
        return updatedCart;
      } catch (error) {
        showCartNotification("update_error");
        throw error;
      }
    });
  },
  removeItem(key, skipDispatch = false) {
    return __async(this, null, function* () {
      try {
        const updatedCart = yield this.updateItemQuantity(key, 0, null, skipDispatch);
        return updatedCart;
      } catch (error) {
        showCartNotification("item_not_found");
        throw error;
      }
    });
  },
  getCartData() {
    return __async(this, null, function* () {
      return window.CartState.getCartData();
    });
  },
  clearCart() {
    return __async(this, null, function* () {
      try {
        const clearedCart = yield window.ShopifyAPIHelper.clearCart();
        return yield window.CartState.updateCartData(clearedCart);
      } catch (error) {
        showCartNotification("clear_error");
        throw error;
      }
    });
  },
  updateQuantity(key, newQuantity, inventoryData) {
    return __async(this, null, function* () {
      if (newQuantity < 1) return null;
      try {
        if (inventoryData) {
          const isAvailable = this.checkInventoryAvailable(
            inventoryData.currentQuantity,
            newQuantity,
            inventoryData.inventoryQuantity,
            inventoryData.trackQuantity,
            inventoryData.continueSellingWhenOutOfStock
          );
          if (!isAvailable) {
            showCartNotification("max_quantity_reached");
            return null;
          }
        }
        const updatedCart = yield this.updateItemQuantity(key, newQuantity);
        return updatedCart;
      } catch (error) {
        showCartNotification("update_error");
        throw error;
      }
    });
  },
  validateGiftCardFields(form) {
    const giftCardCheckbox = window.DOMHelper.safeQuery("#is-gift-card", form);
    if (!giftCardCheckbox || !giftCardCheckbox.checked) {
      return true;
    }
    const recipientName = window.DOMHelper.safeQuery("#recipient-name", form);
    const recipientEmail = window.DOMHelper.safeQuery("#recipient-email", form);
    if (!recipientName || !recipientEmail) {
      return true;
    }
    if (!recipientName.value.trim()) {
      showCartNotification("recipient_name_required");
      return false;
    }
    if (!recipientEmail.value.trim() || !recipientEmail.value.includes("@")) {
      showCartNotification("recipient_email_required");
      return false;
    }
    return true;
  },
  removeItemWithAnimation(key, rootItem) {
    return __async(this, null, function* () {
      try {
        const updatedCart = yield this.removeItem(key);
        yield window.CartState.updateCartData(updatedCart);
        window.DOMHelper.addClass(rootItem, "cart-drawer-item--removing");
        window.DOMHelper.setStyle(rootItem, {
          opacity: "0",
          transform: "translateX(20px)"
        });
        yield new Promise((resolve) => setTimeout(resolve, 250));
        rootItem.remove();
        return updatedCart;
      } catch (error) {
        showCartNotification("item_not_found");
        throw error;
      }
    });
  }
};
window.CartState = CartState;
window.Cart = {
  addItem: Cart.addItem,
  removeItem: Cart.removeItem,
  updateQuantity: Cart.updateQuantity,
  getCartData: Cart.getCartData,
  clearCart: Cart.clearCart,
  validateGiftCardFields: Cart.validateGiftCardFields,
  removeItemWithAnimation: Cart.removeItemWithAnimation,
  updateItemQuantity: Cart.updateItemQuantity,
  getInventoryData: Cart.getInventoryData,
  checkInventoryAvailable: Cart.checkInventoryAvailable
};
class CartDrawerManager {
  constructor() {
    this.cartDrawer = null;
    this.eventListeners = [];
    this.isInitialized = false;
    this.focusTrapActive = false;
    this.originalScrollPosition = 0;
    this.isTransitioningToEmpty = false;
    this.isAddOnUpdating = false;
    this.selectors = {
      drawer: "[data-cart-drawer]",
      closeButton: ".drawer-close, .cart-drawer-header-right-close",
      quantityButtons: ".cart-drawer-quantity-selector button",
      removeButtons: ".cart-drawer-remove",
      notesLabels: ".cart-drawer-notes__label",
      notesContainer: ".cart-drawer-notes",
      notesInput: ".cart-drawer-notes__input",
      addOnToggle: "[data-add-on-toggle]",
      drawerOverlay: ".drawer-overlay",
      drawerForm: ".cart-drawer-form, .cart-drawer-box",
      drawerBody: ".drawer-body",
      headerItemCount: ".cart-drawer-header-right-items",
      progressBar: ".free-shipping-progress-bar",
      cartButton: '.nav-link[href*="cart"]',
      cartLinks: 'a[href*="cart"]',
      addToCartForms: 'form[action*="/cart/add"]'
    };
    this.init();
  }
  /**
   * Initialize the cart drawer
   */
  init() {
    try {
      this.cacheElements();
      this.bindEvents();
      this.setupCartEventListeners();
      this.bindShopifyEvents();
      this.isInitialized = true;
    } catch (error) {
    }
  }
  /**
   * Cache DOM elements
   */
  cacheElements() {
    this.cartDrawer = window.DOMHelper.safeQuery(this.selectors.drawer);
  }
  /**
   * Get cart type from body data attribute
   */
  getCartType() {
    return window.DOMHelper.getAttribute(document.body, "data-cart-type", "page");
  }
  /**
   * Check if cart type is drawer
   */
  isDrawerCart() {
    return this.getCartType() === "drawer";
  }
  // =============================================================================
  // DRAWER UI CONTROLS
  // =============================================================================
  /**
   * Open the cart drawer
   */
  openDrawer() {
    return __async(this, null, function* () {
      var _a;
      if (!this.isDrawerCart()) {
        this.redirectToCartPage();
        return;
      }
      if (!this.cartDrawer) {
        this.redirectToCartPage();
        return;
      }
      try {
        if ((_a = this.cartDrawer.drawer) == null ? void 0 : _a.open) {
          this.cartDrawer.drawer.open();
        } else {
          window.DOMHelper.removeClass(this.cartDrawer, "hidden");
          window.DOMHelper.addClass(this.cartDrawer, "cart-drawer--active");
        }
        yield this.initializeDrawerContent();
        this.setupFocusTrap();
        this.handleMobileOverflow(true);
        this.dispatchEvent("theme:cart:open");
      } catch (error) {
        this.redirectToCartPage();
      }
    });
  }
  /**
   * Close the cart drawer
   */
  closeDrawer() {
    var _a;
    if (!this.cartDrawer) return;
    try {
      this.preserveScrollPosition();
      this.removeFocusTrap();
      this.resetCartEmptyingAnimations();
      if ((_a = this.cartDrawer.drawer) == null ? void 0 : _a.close) {
        this.cartDrawer.drawer.close();
      } else {
        window.DOMHelper.addClass(this.cartDrawer, "hidden");
        window.DOMHelper.removeClass(this.cartDrawer, "cart-drawer--active");
      }
      this.restoreFocusToCartButton();
      this.handleMobileOverflow(false);
    } catch (error) {
    }
  }
  /**
   * Initialize drawer content when opened
   */
  initializeDrawerContent() {
    return __async(this, null, function* () {
      var _a;
      try {
        const progressBar = window.DOMHelper.safeQuery(this.selectors.progressBar, this.cartDrawer);
        if (progressBar && ((_a = window.CartState) == null ? void 0 : _a.getCartData)) {
          const cartData = yield window.CartState.getCartData(true);
          if (cartData && window.updateFreeShippingMessage) {
            const shouldForceShow = cartData.item_count > 0;
            window.updateFreeShippingMessage(cartData, shouldForceShow);
          }
        }
        if (window.initializeImageLoading) {
          window.initializeImageLoading(this.cartDrawer);
        }
      } catch (error) {
      }
    });
  }
  /**
   * Redirect to cart page as fallback
   */
  redirectToCartPage() {
    var _a, _b;
    const routesRootRaw = ((_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) || "/";
    const routesRoot = routesRootRaw.endsWith("/") ? routesRootRaw : `${routesRootRaw}/`;
    const cartUrl = window.DOMHelper.getAttribute(window.DOMHelper.safeQuery(this.selectors.cartLinks), "href", `${routesRoot}cart`);
    window.location.href = cartUrl;
  }
  /**
   * Handle mobile body overflow
   */
  handleMobileOverflow(lock) {
    if (window.innerWidth <= 1023) {
      window.DOMHelper.toggleClass(document.body, "overflow-hidden", lock);
    }
  }
  /**
   * Preserve scroll position when closing drawer
   */
  preserveScrollPosition() {
    this.originalScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  }
  /**
   * Restore focus to cart button
   */
  restoreFocusToCartButton() {
    const cartButton = window.DOMHelper.safeQuery(this.selectors.cartButton);
    if (cartButton) {
      cartButton.focus();
      window.scrollTo({
        top: this.originalScrollPosition,
        behavior: "instant"
      });
    }
  }
  // =============================================================================
  // FOCUS TRAP MANAGEMENT
  // =============================================================================
  /**
   * Setup focus trap for accessibility
   */
  setupFocusTrap() {
    if (!this.cartDrawer || this.focusTrapActive) return;
    const focusableElements = window.DOMHelper.safeQueryAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      this.cartDrawer
    );
    if (focusableElements.length === 0) return;
    this.firstFocusable = focusableElements[0];
    this.lastFocusable = focusableElements[focusableElements.length - 1];
    this.focusTrapHandler = (e) => this.handleFocusTrap(e);
    this.cartDrawer.addEventListener("keydown", this.focusTrapHandler);
    this.focusTrapActive = true;
  }
  /**
   * Handle focus trap keydown
   */
  handleFocusTrap(e) {
    if (e.key !== "Tab" && e.keyCode !== 9) return;
    if (e.shiftKey) {
      if (document.activeElement === this.firstFocusable) {
        e.preventDefault();
        this.lastFocusable.focus();
      }
    } else {
      if (document.activeElement === this.lastFocusable) {
        e.preventDefault();
        this.firstFocusable.focus();
      }
    }
  }
  /**
   * Remove focus trap
   */
  removeFocusTrap() {
    if (!this.focusTrapActive || !this.cartDrawer) return;
    this.cartDrawer.removeEventListener("keydown", this.focusTrapHandler);
    this.focusTrapActive = false;
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.focusTrapHandler = null;
  }
  // =============================================================================
  // CART OPERATIONS
  // =============================================================================
  /**
   * Handle quantity change
   */
  handleQuantityChange(e) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f;
      e.preventDefault();
      e.stopPropagation();
      const button = e.currentTarget;
      const rootItem = button.closest(".cart-drawer-item");
      if (!rootItem) return;
      const variantId = window.DOMHelper.getAttribute(rootItem, "data-line-item-key");
      const quantityInput = window.DOMHelper.safeQuery("input", button.parentElement);
      const currentQuantity = Number(quantityInput.value);
      const isIncrease = window.DOMHelper.hasClass(button, "cart-drawer-quantity-selector-plus");
      const newQuantity = isIncrease ? currentQuantity + 1 : currentQuantity - 1;
      if (newQuantity === 0) {
        const removeButton = window.DOMHelper.safeQuery(this.selectors.removeButtons, rootItem);
        if (removeButton) {
          removeButton.click();
        }
        return;
      }
      try {
        this.setItemLoading(rootItem, true);
        const inventoryData = (_b = (_a = window.Cart) == null ? void 0 : _a.getInventoryData) == null ? void 0 : _b.call(_a, rootItem);
        const currentCartData = yield (_d = (_c = window.CartState) == null ? void 0 : _c.getCartData) == null ? void 0 : _d.call(_c, true);
        const willBeEmpty = currentCartData && currentCartData.item_count === 1 && newQuantity === 0;
        const updatedCart = yield (_f = (_e = window.Cart) == null ? void 0 : _e.updateItemQuantity) == null ? void 0 : _f.call(_e, variantId, newQuantity, inventoryData, willBeEmpty);
        if (updatedCart) {
          if (updatedCart.item_count === 0) {
            yield this.transitionToEmptyCart();
          } else {
            yield this.updateCartElements(updatedCart, rootItem);
          }
        }
      } catch (error) {
        quantityInput.value = currentQuantity;
        this.showItemError(rootItem, "update_error");
      } finally {
        setTimeout(() => this.setItemLoading(rootItem, false), 250);
      }
    });
  }
  /**
   * Handle direct quantity input changes (when user types in input field)
   */
  handleQuantityInputChange(e) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      const input = e.currentTarget;
      const rootItem = input.closest(".cart-drawer-item");
      if (!rootItem) return;
      const variantId = window.DOMHelper.getAttribute(rootItem, "data-line-item-key");
      const newQuantity = Number(input.value);
      const originalValue = Number(window.DOMHelper.getAttribute(input, "data-original-value") || input.min || 0);
      if (isNaN(newQuantity) || newQuantity < 0) {
        input.value = originalValue;
        return;
      }
      window.DOMHelper.setAttribute(input, "data-original-value", originalValue);
      if (newQuantity === 0) {
        const removeButton = window.DOMHelper.safeQuery(this.selectors.removeButtons, rootItem);
        if (removeButton) {
          removeButton.click();
        }
        return;
      }
      if (newQuantity === originalValue) {
        return;
      }
      try {
        this.setItemLoading(rootItem, true);
        const inventoryData = (_b = (_a = window.Cart) == null ? void 0 : _a.getInventoryData) == null ? void 0 : _b.call(_a, rootItem);
        const updatedCart = yield (_d = (_c = window.Cart) == null ? void 0 : _c.updateItemQuantity) == null ? void 0 : _d.call(_c, variantId, newQuantity, inventoryData);
        if (updatedCart) {
          window.DOMHelper.setAttribute(input, "data-original-value", newQuantity);
          if (updatedCart.item_count === 0) {
            yield this.transitionToEmptyCart();
          } else {
            yield this.updateCartElements(updatedCart, rootItem);
          }
        }
      } catch (error) {
        input.value = originalValue;
        this.showItemError(rootItem, "update_error");
      } finally {
        setTimeout(() => this.setItemLoading(rootItem, false), 250);
      }
    });
  }
  /**
   * Handle item removal
   */
  handleRemoveItem(e) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      e.preventDefault();
      e.stopPropagation();
      const button = e.currentTarget;
      const rootItem = button.closest(".cart-drawer-item");
      if (!rootItem) return;
      const variantId = window.DOMHelper.getAttribute(rootItem, "data-line-item-key");
      try {
        this.setItemLoading(rootItem, true);
        const currentCartData = yield (_b = (_a = window.CartState) == null ? void 0 : _a.getCartData) == null ? void 0 : _b.call(_a, true);
        const willBeEmpty = currentCartData && currentCartData.item_count === 1;
        const updatedCart = yield (_d = (_c = window.Cart) == null ? void 0 : _c.removeItem) == null ? void 0 : _d.call(_c, variantId);
        if (updatedCart) {
          if (updatedCart.item_count === 0) {
            yield this.transitionToEmptyCart();
          } else {
            window.DOMHelper.addClass(rootItem, "cart-item--removing");
            setTimeout(() => {
              this.updateCartDrawer(updatedCart);
            }, 300);
          }
        } else if (willBeEmpty) {
          yield this.transitionToEmptyCart();
        }
      } catch (error) {
        this.showItemError(rootItem, "remove_error");
      } finally {
        setTimeout(() => this.setItemLoading(rootItem, false), 250);
      }
    });
  }
  /**
   * Handle add-on checkbox toggle
   */
  handleAddOnToggle(e) {
    return __async(this, null, function* () {
      const checkbox = e.currentTarget;
      if (!checkbox) return;
      if (this.isAddOnUpdating) {
        checkbox.checked = !checkbox.checked;
        return;
      }
      const variantId = window.DOMHelper.getAttribute(checkbox, "data-add-on-variant-id");
      const lineKey = window.DOMHelper.getAttribute(checkbox, "data-add-on-line-key");
      const addOnSlot = window.DOMHelper.getAttribute(checkbox, "data-add-on-slot");
      if (!variantId || !addOnSlot) return;
      checkbox.disabled = true;
      this.isAddOnUpdating = true;
      try {
        if (checkbox.checked) {
          const added = yield window.Cart.addItem(Number(variantId), 1, {
            _cart_add_on: "true",
            _cart_add_on_slot: addOnSlot
          });
          if (!added) {
            checkbox.checked = false;
            if (window.showCartNotification) window.showCartNotification("max_quantity_reached");
            return;
          }
          const freshCart = yield window.ShopifyAPIHelper.getCart(true);
          if (freshCart) yield this.updateCartDrawer(freshCart, true);
        } else if (lineKey) {
          const updated = yield window.Cart.removeItem(lineKey);
          if (updated) yield this.updateCartDrawer(updated, true);
        }
      } catch (error) {
        checkbox.checked = !checkbox.checked;
        if (window.showCartNotification) window.showCartNotification("add_error");
      } finally {
        checkbox.disabled = false;
        this.isAddOnUpdating = false;
      }
    });
  }
  /**
   * Handle add to cart form submission and open drawer
   */
  addToCartAndOpenDrawer(form) {
    return __async(this, null, function* () {
      if (!form) return;
      const submitButton = window.DOMHelper.safeQuery('button[type="submit"]', form);
      let originalButtonText = "";
      let addingText = "Adding...";
      let addedText = "Added";
      if (submitButton) {
        originalButtonText = window.DOMHelper.getAttribute(submitButton, "data-add-to-cart-text", submitButton.textContent);
        addingText = window.DOMHelper.getAttribute(submitButton, "data-adding-text", "Adding...");
        addedText = window.DOMHelper.getAttribute(submitButton, "data-added-to-cart-text", "Added");
        submitButton.textContent = addingText;
        window.DOMHelper.setAttribute(submitButton, "disabled", "true");
      }
      try {
        const formData = new FormData(form);
        const variantId = formData.get("id");
        if (!variantId || variantId === "undefined" || variantId === "") {
          console.error("Add to Cart Error: No variant ID found in form. Form data:", formData);
          showCartNotification("add_error");
          return;
        }
        const quantity = parseInt(formData.get("quantity") || "1");
        const properties = {};
        for (const [key, value] of formData.entries()) {
          if (key.startsWith("properties[") && key.endsWith("]")) {
            const propName = key.substring(11, key.length - 1);
            properties[propName] = value;
          }
        }
        const cartData = yield window.Cart.addItem(variantId, quantity, properties);
        if (cartData) {
          yield this.updateCartDrawer(cartData, true);
          if (this.isDrawerCart()) {
            this.openDrawer();
          }
          if (submitButton) {
            submitButton.textContent = addedText;
            setTimeout(() => {
              submitButton.textContent = originalButtonText;
              window.DOMHelper.removeAttribute(submitButton, "disabled");
            }, 2e3);
          }
        } else {
          if (submitButton) {
            submitButton.textContent = originalButtonText;
            window.DOMHelper.removeAttribute(submitButton, "disabled");
          }
          if (window.showCartNotification) {
            window.showCartNotification("add_error");
          }
        }
      } catch (error) {
        if (submitButton) {
          submitButton.textContent = originalButtonText;
          window.DOMHelper.removeAttribute(submitButton, "disabled");
        }
        if (window.showCartNotification) {
          window.showCartNotification("add_error");
        }
      }
    });
  }
  // =============================================================================
  // UI UPDATE METHODS
  // =============================================================================
  /**
   * Update cart drawer content
   */
  updateCartDrawer(cartData, skipDispatch = false) {
    return __async(this, null, function* () {
      var _a, _b;
      if (!this.isDrawerCart() || !this.cartDrawer) return;
      if (this.isTransitioningToEmpty) {
        return;
      }
      if ((_a = window.CartState) == null ? void 0 : _a.isUpdateInProgress) return;
      try {
        if (!cartData || typeof cartData !== "object") return;
        const html = yield window.ShopifyAPIHelper.getCartHTML("drawer");
        const tempDiv = window.DOMHelper.createElement("div", { innerHTML: html });
        const newContent = window.DOMHelper.safeQuery(this.selectors.drawerForm, tempDiv);
        const targetElement = window.DOMHelper.safeQuery(this.selectors.drawerForm, this.cartDrawer);
        if (newContent && targetElement) {
          targetElement.innerHTML = newContent.innerHTML;
          if (window.initializeImageLoading) {
            window.initializeImageLoading(targetElement);
          }
          this.bindDrawerEventListeners();
        }
        this.updateCartCounts(cartData.item_count);
        this.updateHeaderItemCount(cartData.item_count);
        if (!skipDispatch && ((_b = window.CartState) == null ? void 0 : _b.updateCartData)) {
          yield window.CartState.updateCartData(cartData, true);
        }
        if (window.updateFreeShippingMessage) {
          if (cartData.item_count > 0) {
            const isFirstItem = cartData.item_count === 1;
            const drawerIsActive = window.DOMHelper.hasClass(this.cartDrawer, "cart-drawer--active");
            const shouldForceShow = isFirstItem || drawerIsActive;
            setTimeout(() => {
              window.updateFreeShippingMessage(cartData, shouldForceShow);
            }, 50);
          }
        }
      } catch (error) {
        this.showGlobalError("update_error");
      }
    });
  }
  /**
   * Update cart elements for specific item
   */
  updateCartElements(cartData, itemElement) {
    return __async(this, null, function* () {
      var _a;
      if (cartData.item_count === 0) {
        return;
      }
      if ((_a = window.CartUI) == null ? void 0 : _a.updateLineItemUI) {
        window.CartUI.updateLineItemUI(itemElement, cartData);
      }
      if (window.initializeImageLoading) {
        window.initializeImageLoading(itemElement);
      }
    });
  }
  /**
   * Update cart counts in header
   */
  updateCartCounts(itemCount) {
    var _a;
    if ((_a = window.CartUI) == null ? void 0 : _a.updateCartCounts) {
      window.CartUI.updateCartCounts(itemCount);
    }
  }
  /**
   * Update header item count display
   */
  updateHeaderItemCount(itemCount) {
    var _a;
    const headerElement = window.DOMHelper.safeQuery(this.selectors.headerItemCount, this.cartDrawer);
    if (!headerElement) return;
    try {
      const strings = ((_a = window.getCartStrings) == null ? void 0 : _a.call(window)) || {};
      const itemText = itemCount === 1 ? strings.item_singular || "item" : strings.item_plural || "items";
      headerElement.textContent = ` - ${itemCount} ${itemText}`;
    } catch (error) {
    }
  }
  // =============================================================================
  // NOTES HANDLING
  // =============================================================================
  /**
   * Toggle cart notes section
   */
  toggleCartNotes(e) {
    e.preventDefault();
    const notesContainer = e.target.closest(this.selectors.notesContainer);
    const notesInput = window.DOMHelper.safeQuery(this.selectors.notesInput, notesContainer);
    if (!notesContainer || !notesInput) return;
    const isOpen = window.DOMHelper.hasClass(notesContainer, "notes-open");
    const noteId = window.DOMHelper.getAttribute(notesInput, "id");
    this.closeOtherNotes(notesContainer);
    window.DOMHelper.toggleClass(notesContainer, "notes-open", !isOpen);
    try {
      localStorage.setItem(`${noteId}Open`, (!isOpen).toString());
    } catch (error) {
    }
  }
  /**
   * Close other open notes sections
   */
  closeOtherNotes(currentContainer) {
    const allNotes = window.DOMHelper.safeQueryAll(this.selectors.notesContainer);
    allNotes.forEach((note) => {
      if (note !== currentContainer && window.DOMHelper.hasClass(note, "notes-open")) {
        const input = window.DOMHelper.safeQuery(this.selectors.notesInput, note);
        window.DOMHelper.removeClass(note, "notes-open");
        const inputId = window.DOMHelper.getAttribute(input, "id");
        if (inputId) {
          try {
            localStorage.setItem(`${inputId}Open`, "false");
          } catch (error) {
          }
        }
      }
    });
  }
  // =============================================================================
  // ERROR HANDLING AND UI FEEDBACK
  // =============================================================================
  /**
   * Set item loading state with improved fade animations
   */
  setItemLoading(itemElement, isLoading) {
    if (!itemElement) return;
    const quantityInputs = window.DOMHelper.safeQueryAll('input[type="number"]', itemElement);
    const buttons = window.DOMHelper.safeQueryAll("button", itemElement);
    quantityInputs.forEach((input) => {
      input.disabled = isLoading;
    });
    buttons.forEach((button) => {
      button.disabled = isLoading;
    });
    if (isLoading) {
      window.DOMHelper.addClass(itemElement, "cart-drawer-item--loading");
      let spinner = window.DOMHelper.safeQuery(".spinner", itemElement);
      if (!spinner) {
        spinner = window.DOMHelper.createElement("div", {
          className: "spinner"
        });
        itemElement.appendChild(spinner);
        spinner.offsetHeight;
      }
      window.DOMHelper.setStyle(spinner, "opacity", "0");
      window.DOMHelper.setStyle(spinner, "visibility", "visible");
      requestAnimationFrame(() => {
        window.DOMHelper.setStyle(spinner, "opacity", "1");
      });
    } else {
      const spinner = window.DOMHelper.safeQuery(".spinner", itemElement);
      if (spinner) {
        window.DOMHelper.setStyle(spinner, "opacity", "0");
        setTimeout(() => {
          if (spinner && spinner.parentNode) {
            window.DOMHelper.setStyle(spinner, "visibility", "hidden");
            window.DOMHelper.removeElement(spinner);
          }
        }, 350);
      }
      setTimeout(() => {
        window.DOMHelper.removeClass(itemElement, "cart-drawer-item--loading");
      }, 50);
    }
  }
  /**
   * Show error for specific item
   */
  showItemError(itemElement, errorKey) {
    var _a;
    if (!itemElement) return;
    const errorDiv = window.DOMHelper.safeQuery(".cart-item-error", itemElement);
    if (errorDiv) {
      const strings = ((_a = window.getCartStrings) == null ? void 0 : _a.call(window)) || {};
      errorDiv.textContent = strings[errorKey] || "An error occurred";
      window.DOMHelper.setStyle(errorDiv, "display", "block");
      setTimeout(() => {
        window.DOMHelper.setStyle(errorDiv, "display", "none");
      }, 3e3);
    }
  }
  /**
   * Show global error
   */
  showGlobalError(errorKey) {
    var _a;
    const strings = ((_a = window.getCartStrings) == null ? void 0 : _a.call(window)) || {};
    strings[errorKey] || "An error occurred";
    if (window.showCartNotification) {
      window.showCartNotification(errorKey, "error");
    }
  }
  // =============================================================================
  // EVENT MANAGEMENT
  // =============================================================================
  /**
   * Add event listener with cleanup tracking
   */
  addEventListener(element, event, handler, options = {}) {
    if (!element) return;
    element.addEventListener(event, handler, options);
    this.eventListeners.push({ element, event, handler, options });
  }
  /**
   * Remove all tracked event listeners
   */
  removeAllEventListeners() {
    this.eventListeners.forEach(({ element, event, handler, options }) => {
      element == null ? void 0 : element.removeEventListener(event, handler, options);
    });
    this.eventListeners = [];
  }
  /**
   * Dispatch custom event
   */
  dispatchEvent(eventName, detail = {}) {
    window.DOMHelper.dispatchEvent(eventName, detail);
  }
  /**
   * Bind main event listeners
   */
  bindEvents() {
    this.addEventListener(document, "click", (e) => {
      const cartLink = e.target.closest(this.selectors.cartLinks);
      if (cartLink && this.isDrawerCart()) {
        e.preventDefault();
        this.openDrawer();
      }
    });
    this.addEventListener(document, "click", (e) => __async(this, null, function* () {
      const submitButton = e.target.closest(`${this.selectors.addToCartForms} button[type="submit"]`);
      if (submitButton) {
        e.preventDefault();
        const form = submitButton.closest("form");
        yield this.addToCartAndOpenDrawer(form);
      }
    }));
    if (this.cartDrawer) {
      this.addEventListener(this.cartDrawer, "click", (e) => {
        if (e.target === this.cartDrawer) {
          this.closeDrawer();
        }
      });
    }
    this.bindDrawerEventListeners();
  }
  /**
   * Bind drawer-specific event listeners
   */
  bindDrawerEventListeners() {
    if (!this.cartDrawer) return;
    const closeButton = window.DOMHelper.safeQuery(this.selectors.closeButton, this.cartDrawer);
    if (closeButton) {
      this.addEventListener(closeButton, "click", () => this.closeDrawer());
    }
    const quantityButtons = window.DOMHelper.safeQueryAll(this.selectors.quantityButtons, this.cartDrawer);
    quantityButtons.forEach((button) => {
      this.addEventListener(button, "click", (e) => this.handleQuantityChange(e));
    });
    const quantityInputs = window.DOMHelper.safeQueryAll('.cart-drawer-quantity-selector input[type="number"]', this.cartDrawer);
    quantityInputs.forEach((input) => {
      this.addEventListener(input, "change", (e) => this.handleQuantityInputChange(e));
      this.addEventListener(input, "blur", (e) => this.handleQuantityInputChange(e));
    });
    const removeButtons = window.DOMHelper.safeQueryAll(this.selectors.removeButtons, this.cartDrawer);
    removeButtons.forEach((button) => {
      this.addEventListener(button, "click", (e) => this.handleRemoveItem(e));
    });
    const addOnToggles = window.DOMHelper.safeQueryAll(this.selectors.addOnToggle, this.cartDrawer);
    addOnToggles.forEach((toggle) => {
      this.addEventListener(toggle, "change", (e) => this.handleAddOnToggle(e));
    });
    const notesLabels = window.DOMHelper.safeQueryAll(this.selectors.notesLabels);
    notesLabels.forEach((label) => {
      this.addEventListener(label, "click", (e) => this.toggleCartNotes(e));
    });
    const drawerOverlay = window.DOMHelper.safeQuery(this.selectors.drawerOverlay, this.cartDrawer);
    if (drawerOverlay) {
      this.addEventListener(drawerOverlay, "click", () => this.closeDrawer());
    }
  }
  /**
   * Setup cart event listeners
   */
  setupCartEventListeners() {
    var _a;
    if ((_a = window.CartEvents) == null ? void 0 : _a.onCartUpdate) {
      window.CartEvents.onCartUpdate((cartData) => {
        if (this.cartDrawer) {
          this.updateCartDrawer(cartData, true);
        }
      });
    }
  }
  /**
   * Bind Shopify theme editor events
   */
  bindShopifyEvents() {
    if (typeof Shopify === "undefined" || !Shopify.designMode) return;
    const shopifyEvents = [
      "shopify:section:load",
      "shopify:section:select",
      "shopify:theme:settings:editor:update"
    ];
    shopifyEvents.forEach((eventName) => {
      this.addEventListener(document, eventName, (event) => {
        this.handleShopifyEvent(event);
      });
    });
  }
  /**
   * Handle Shopify theme editor events
   */
  handleShopifyEvent(event) {
    var _a, _b, _c;
    const isCartDrawerSection = ((_a = event.target) == null ? void 0 : _a.id) === "shopify-section-cart-drawer";
    switch (event.type) {
      case "shopify:section:load":
      case "shopify:section:select":
        if (isCartDrawerSection) {
          this.reinitialize();
        }
        break;
      case "shopify:theme:settings:editor:update":
        if ((_c = (_b = this.cartDrawer) == null ? void 0 : _b.drawer) == null ? void 0 : _c.setupResponsiveWidth) {
          this.cartDrawer.drawer.setupResponsiveWidth();
        }
        break;
    }
  }
  /**
   * Reinitialize the cart drawer
   */
  reinitialize() {
    var _a;
    this.cleanup();
    this.init();
    if ((_a = window.CartUI) == null ? void 0 : _a.reinitializeCartBehaviors) {
      window.CartUI.reinitializeCartBehaviors();
    }
  }
  /**
   * Cleanup all resources
   */
  cleanup() {
    this.removeFocusTrap();
    this.removeAllEventListeners();
    this.isInitialized = false;
  }
  /**
   * Destroy the cart drawer manager
   */
  destroy() {
    this.cleanup();
    this.cartDrawer = null;
  }
  // =============================================================================
  // CART EMPTYING ANIMATIONS
  // =============================================================================
  /**
   * Animate cart emptying with coordinated fade-out effects
   */
  animateCartEmptying() {
    return __async(this, null, function* () {
      if (!this.cartDrawer) return;
      return new Promise((resolve) => {
        try {
          this.dispatchEvent("theme:cart:emptying:start");
          window.DOMHelper.addClass(this.cartDrawer, "cart-drawer--emptying");
          const items = window.DOMHelper.safeQueryAll(".cart-drawer-item", this.cartDrawer);
          items.forEach((item, index) => {
            setTimeout(() => {
              window.DOMHelper.addClass(item, "cart-drawer-item--emptying");
            }, index * 50);
          });
          const itemCount = items.length;
          const staggerDuration = itemCount * 50;
          const longestSectionDuration = 500;
          const totalDuration = staggerDuration + longestSectionDuration + 50;
          setTimeout(() => {
            this.dispatchEvent("theme:cart:emptying:complete");
            resolve();
          }, totalDuration);
        } catch (error) {
          this.dispatchEvent("theme:cart:emptying:error", { error });
          resolve();
        }
      });
    });
  }
  /**
   * Reset cart emptying animations
   */
  resetCartEmptyingAnimations() {
    if (!this.cartDrawer) return;
    this.isTransitioningToEmpty = false;
    window.cartDrawerTransitioning = false;
    window.DOMHelper.removeClass(this.cartDrawer, "cart-drawer--emptying");
    window.DOMHelper.removeClass(this.cartDrawer, "cart-drawer--transitioning-to-empty");
    window.DOMHelper.removeClass(this.cartDrawer, "cart-drawer--empty-visible");
    const items = window.DOMHelper.safeQueryAll(".cart-drawer-item--emptying", this.cartDrawer);
    items.forEach((item) => {
      window.DOMHelper.removeClass(item, "cart-drawer-item--emptying");
    });
  }
  /**
   * Show empty cart state with transition instead of immediately closing
   */
  transitionToEmptyCart() {
    return __async(this, null, function* () {
      var _a, _b;
      if (!this.cartDrawer) return;
      try {
        this.isTransitioningToEmpty = true;
        window.cartDrawerTransitioning = true;
        this.dispatchEvent("theme:cart:transitioning:start");
        yield this.animateCartEmptying();
        const html = yield window.ShopifyAPIHelper.getCartHTML("drawer");
        const tempDiv = window.DOMHelper.createElement("div", { innerHTML: html });
        let newContent = window.DOMHelper.safeQuery(this.selectors.drawerForm, tempDiv);
        if (!newContent) {
          newContent = window.DOMHelper.safeQuery(".cart-drawer-form", tempDiv) || window.DOMHelper.safeQuery(".cart-drawer-box", tempDiv) || window.DOMHelper.safeQuery("[data-cart-drawer] .drawer-body", tempDiv) || window.DOMHelper.safeQuery(".drawer-body", tempDiv);
        }
        let targetElement = window.DOMHelper.safeQuery(this.selectors.drawerForm, this.cartDrawer);
        if (!targetElement) {
          targetElement = window.DOMHelper.safeQuery(".drawer-body", this.cartDrawer) || window.DOMHelper.safeQuery(".cart-drawer-box", this.cartDrawer);
        }
        if (newContent && targetElement) {
          window.DOMHelper.addClass(this.cartDrawer, "cart-drawer--transitioning-to-empty");
          targetElement.innerHTML = newContent.innerHTML;
          if (window.initializeImageLoading) {
            window.initializeImageLoading(targetElement);
          }
          this.bindDrawerEventListeners();
          if ((_a = window.CartUI) == null ? void 0 : _a.handleEmptyCartTransition) {
            yield window.CartUI.handleEmptyCartTransition(this.cartDrawer);
          } else {
            this.updateCartCounts(0);
            if (window.updateFreeShippingMessage) {
              const emptyCartData = { item_count: 0, total_price: 0 };
              window.updateFreeShippingMessage(emptyCartData, false);
            }
          }
          if ((_b = window.CartState) == null ? void 0 : _b.updateCartData) {
            const emptyCartData = {
              item_count: 0,
              total_price: 0,
              items: [],
              items_subtotal_price: 0,
              original_total_price: 0,
              total_weight: 0
            };
            yield window.CartState.updateCartData(emptyCartData, true);
          }
          setTimeout(() => {
            window.DOMHelper.addClass(this.cartDrawer, "cart-drawer--empty-visible");
          }, 50);
          setTimeout(() => {
            this.dispatchEvent("theme:cart:transitioning:complete");
            this.isTransitioningToEmpty = false;
            window.cartDrawerTransitioning = false;
            this.closeDrawer();
          }, 2e3);
        } else {
          this.isTransitioningToEmpty = false;
          window.cartDrawerTransitioning = false;
          setTimeout(() => this.closeDrawer(), 200);
        }
      } catch (error) {
        this.dispatchEvent("theme:cart:transitioning:error", { error });
        this.isTransitioningToEmpty = false;
        window.cartDrawerTransitioning = false;
        setTimeout(() => this.closeDrawer(), 200);
      }
    });
  }
}
let cartDrawerInstance = null;
const initCartDrawer = () => {
  try {
    if (cartDrawerInstance) {
      cartDrawerInstance.destroy();
    }
    cartDrawerInstance = new CartDrawerManager();
    return cartDrawerInstance;
  } catch (error) {
    return null;
  }
};
if (typeof window.ModuleManager !== "undefined") {
  window.ModuleManager.register("CartDrawer", initCartDrawer, ["DOMHelper"]);
} else {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartDrawer);
  } else {
    initCartDrawer();
  }
}
window.CartDrawer = {
  open: () => cartDrawerInstance == null ? void 0 : cartDrawerInstance.openDrawer(),
  close: () => cartDrawerInstance == null ? void 0 : cartDrawerInstance.closeDrawer(),
  update: (cartData, skipDispatch) => cartDrawerInstance == null ? void 0 : cartDrawerInstance.updateCartDrawer(cartData, skipDispatch),
  getType: () => (cartDrawerInstance == null ? void 0 : cartDrawerInstance.getCartType()) || "page",
  reinitialize: () => cartDrawerInstance == null ? void 0 : cartDrawerInstance.reinitialize()
};
window.openCartDrawer = () => cartDrawerInstance == null ? void 0 : cartDrawerInstance.openDrawer();
window.closeCartDrawer = () => cartDrawerInstance == null ? void 0 : cartDrawerInstance.closeDrawer();
window.updateCartDrawer = (cartData, skipDispatch) => cartDrawerInstance == null ? void 0 : cartDrawerInstance.updateCartDrawer(cartData, skipDispatch);
window.getCartType = () => (cartDrawerInstance == null ? void 0 : cartDrawerInstance.getCartType()) || "page";
window.addEventListener("beforeunload", () => {
  if (cartDrawerInstance) {
    cartDrawerInstance.destroy();
  }
});
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
      caretWrapper: this.querySelector(".collection-sort-caret-wrapper")
    };
    this.elements.button.addEventListener("click", this.openSelector.bind(this));
    this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.querySelectorAll("a").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.classList.remove("show");
    if (this.elements.caretWrapper) {
      this.elements.caretWrapper.classList.remove("flipped");
    }
    setTimeout(() => {
      this.elements.panel.setAttribute("hidden", true);
    }, 200);
    document.removeEventListener("click", this.handleClickOutside);
  }
  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") {
      return;
    }
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
      form.submit();
    }
    this.hidePanel();
  }
  openSelector() {
    this.elements.button.focus();
    const isPanelHidden = this.elements.panel.hasAttribute("hidden");
    if (isPanelHidden) {
      this.elements.panel.removeAttribute("hidden");
      setTimeout(() => {
        this.elements.panel.classList.add("show");
      }, 10);
      if (this.elements.caretWrapper) {
        this.elements.caretWrapper.classList.add("flipped");
      }
    } else {
      this.hidePanel();
    }
    this.elements.button.setAttribute("aria-expanded", (!isPanelHidden).toString());
    document.addEventListener("click", this.handleClickOutside);
  }
  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("localization-form", LocalizationForm);
class CartPage {
  constructor() {
    this.form = window.DOMHelper.safeQuery('form[action*="/cart"]');
    this.isAddOnUpdating = false;
    this.bindEvents();
    this.initializeCart();
  }
  initializeCart() {
    return __async(this, null, function* () {
      const cartData = yield window.Cart.getCartData();
      window.updateFreeShippingMessage(cartData);
      this.syncAddOnControls(cartData);
      window.CartEvents.onCartUpdate((cartData2) => {
        this.updateCartUI(cartData2, true);
      });
    });
  }
  getAddOnLineItem(cartData, slot, variantId) {
    return cartData.items.find(
      (item) => {
        var _a, _b;
        return String(item.variant_id) === String(variantId) && ((_a = item.properties) == null ? void 0 : _a._cart_add_on) === "true" && ((_b = item.properties) == null ? void 0 : _b._cart_add_on_slot) === String(slot);
      }
    );
  }
  syncAddOnControls(cartData) {
    const addOnToggles = window.DOMHelper.safeQueryAll("[data-cart-page-add-on-toggle]");
    addOnToggles.forEach((toggle) => {
      const slot = window.DOMHelper.getAttribute(toggle, "data-add-on-slot");
      const variantId = window.DOMHelper.getAttribute(toggle, "data-add-on-variant-id");
      const lineItem = this.getAddOnLineItem(cartData, slot, variantId);
      toggle.checked = Boolean(lineItem);
      if (lineItem) {
        window.DOMHelper.setAttribute(toggle, "data-add-on-line-key", lineItem.key);
      } else {
        toggle.removeAttribute("data-add-on-line-key");
      }
    });
  }
  updateCartUI(cartData, skipDispatch = false) {
    return __async(this, null, function* () {
      const currentItems = window.DOMHelper.safeQueryAll(".cart-item");
      currentItems.forEach((itemElement) => {
        const key = window.DOMHelper.getAttribute(itemElement, "data-key");
        const itemStillExists = cartData.items.some((item) => item.key === key);
        if (!itemStillExists) {
          window.DOMHelper.setStyle(itemElement, {
            opacity: "0",
            transform: "translateX(20px)"
          });
          setTimeout(() => {
            itemElement.remove();
          }, 300);
        }
      });
      cartData.items.forEach((item) => {
        const wrapper = window.DOMHelper.safeQuery(`.cart-item[data-key="${item.key}"]`);
        if (wrapper) {
          const input = window.DOMHelper.safeQuery("[data-quantity-input]", wrapper);
          const priceElement = window.DOMHelper.safeQuery("[data-line-price]", wrapper);
          if (input) input.value = item.quantity;
          if (priceElement) {
            const currencyCode = priceElement.textContent.trim().split(" ").pop() || cart.currency.iso_code;
            if (item.original_price !== item.final_price) {
              priceElement.innerHTML = `
                            ${window.formatMoney(item.original_line_price)} ${currencyCode}
                            <br>
                            <span>${window.formatMoney(item.final_line_price)} ${currencyCode}</span>
                        `;
            } else {
              priceElement.innerHTML = `${window.formatMoney(item.final_line_price)} ${currencyCode}`;
            }
          }
        }
      });
      if (cartData.item_count === 0) {
        if (window.cartDrawerTransitioning) {
          return;
        }
        window.location.reload();
        return;
      }
      const subtotalElement = window.DOMHelper.safeQuery("[data-cart-subtotal]");
      const totalElement = window.DOMHelper.safeQuery("[data-cart-total]");
      if (subtotalElement) {
        subtotalElement.textContent = window.formatMoney(cartData.items_subtotal_price);
      }
      if (totalElement) {
        totalElement.textContent = window.formatMoney(cartData.total_price);
      }
      window.updateFreeShippingMessage(cartData);
      window.CartUI.updateCartCounts(cartData.item_count);
      this.syncAddOnControls(cartData);
      if (!skipDispatch) {
        window.CartEvents.dispatchCartUpdate(cartData);
      }
    });
  }
  bindEvents() {
    window.DOMHelper.safeQueryAll("[data-quantity-change]").forEach((button) => {
      button.addEventListener("click", (e) => this.handleQuantityChange(e));
    });
    window.DOMHelper.safeQueryAll("[data-quantity-input]").forEach((input) => {
      input.addEventListener("change", (e) => this.handleQuantityInputChange(e));
      input.addEventListener("blur", (e) => this.handleQuantityInputChange(e));
    });
    window.DOMHelper.safeQueryAll("[data-remove-item]").forEach((button) => {
      button.addEventListener("click", (e) => this.handleRemoveItem(e));
    });
    window.DOMHelper.safeQueryAll("[data-cart-page-add-on-toggle]").forEach((toggle) => {
      toggle.addEventListener("change", (e) => this.handleAddOnToggle(e));
    });
    window.DOMHelper.safeQueryAll(".cart-notes-expandable .cart-notes__label").forEach((label) => {
      label.addEventListener("click", (e) => this.toggleNote(e));
    });
  }
  handleAddOnToggle(e) {
    return __async(this, null, function* () {
      const checkbox = e.currentTarget;
      if (!checkbox) return;
      if (this.isAddOnUpdating) {
        checkbox.checked = !checkbox.checked;
        return;
      }
      const variantId = window.DOMHelper.getAttribute(checkbox, "data-add-on-variant-id");
      const lineKey = window.DOMHelper.getAttribute(checkbox, "data-add-on-line-key");
      const addOnSlot = window.DOMHelper.getAttribute(checkbox, "data-add-on-slot");
      if (!variantId || !addOnSlot) return;
      checkbox.disabled = true;
      this.isAddOnUpdating = true;
      try {
        if (checkbox.checked) {
          const added = yield window.Cart.addItem(Number(variantId), 1, {
            _cart_add_on: "true",
            _cart_add_on_slot: addOnSlot
          });
          if (!added) {
            checkbox.checked = false;
            if (window.showCartNotification) window.showCartNotification("max_quantity_reached");
            return;
          }
          const freshCart = yield window.ShopifyAPIHelper.getCart(true);
          if (freshCart) yield this.updateCartUI(freshCart, true);
        } else if (lineKey) {
          const updated = yield window.Cart.removeItem(lineKey);
          if (updated) yield this.updateCartUI(updated, true);
        }
      } catch (error) {
        checkbox.checked = !checkbox.checked;
        if (window.showCartNotification) window.showCartNotification("add_error");
      } finally {
        checkbox.disabled = false;
        this.isAddOnUpdating = false;
      }
    });
  }
  handleQuantityChange(e) {
    return __async(this, null, function* () {
      e.preventDefault();
      const button = e.currentTarget;
      const wrapper = button.closest(".cart-item");
      const key = window.DOMHelper.getAttribute(wrapper, "data-key");
      const input = window.DOMHelper.safeQuery("[data-quantity-input]", wrapper);
      const currentQuantity = parseInt(input.value);
      const isIncrease = window.DOMHelper.getAttribute(button, "data-quantity-change") === "increase";
      const newQuantity = isIncrease ? currentQuantity + 1 : currentQuantity - 1;
      if (newQuantity < 1) {
        this.handleRemoveItem({ currentTarget: window.DOMHelper.safeQuery("[data-remove-item]", wrapper) });
        return;
      }
      try {
        window.DOMHelper.addClass(wrapper, "loading");
        const inventoryData = {
          currentQuantity,
          inventoryQuantity: window.DOMHelper.getAttribute(wrapper, "data-inventory-quantity") ? parseInt(window.DOMHelper.getAttribute(wrapper, "data-inventory-quantity")) : null,
          trackQuantity: window.DOMHelper.getAttribute(wrapper, "data-track-quantity") === "true",
          continueSellingWhenOutOfStock: window.DOMHelper.getAttribute(wrapper, "data-continue-selling-when-out-of-stock") === "true"
        };
        if (inventoryData.trackQuantity && !inventoryData.continueSellingWhenOutOfStock && inventoryData.inventoryQuantity !== null && newQuantity > inventoryData.inventoryQuantity) {
          window.showCartNotification("max_quantity_reached");
          window.DOMHelper.removeClass(wrapper, "loading");
          return;
        }
        const updatedCart = yield window.Cart.updateItemQuantity(key, newQuantity, inventoryData);
        if (updatedCart) {
          yield this.updateCartUI(updatedCart);
        }
      } catch (error) {
        window.showCartNotification("update_error");
      } finally {
        window.DOMHelper.removeClass(wrapper, "loading");
      }
    });
  }
  handleQuantityInputChange(e) {
    return __async(this, null, function* () {
      const input = e.currentTarget;
      const wrapper = input.closest(".cart-item");
      if (!wrapper) return;
      const key = window.DOMHelper.getAttribute(wrapper, "data-key");
      const newQuantity = Number(input.value);
      const originalValue = Number(window.DOMHelper.getAttribute(input, "data-original-value") || input.min || 0);
      if (isNaN(newQuantity) || newQuantity < 0) {
        input.value = originalValue;
        return;
      }
      window.DOMHelper.setAttribute(input, "data-original-value", originalValue);
      if (newQuantity === 0) {
        const removeButton = window.DOMHelper.safeQuery("[data-remove-item]", wrapper);
        if (removeButton) {
          removeButton.click();
        }
        return;
      }
      if (newQuantity === originalValue) {
        return;
      }
      try {
        window.DOMHelper.addClass(wrapper, "loading");
        const inventoryData = {
          currentQuantity: originalValue,
          inventoryQuantity: window.DOMHelper.getAttribute(wrapper, "data-inventory-quantity") ? parseInt(window.DOMHelper.getAttribute(wrapper, "data-inventory-quantity")) : null,
          trackQuantity: window.DOMHelper.getAttribute(wrapper, "data-track-quantity") === "true",
          continueSellingWhenOutOfStock: window.DOMHelper.getAttribute(wrapper, "data-continue-selling-when-out-of-stock") === "true"
        };
        const updatedCart = yield window.Cart.updateItemQuantity(key, newQuantity, inventoryData);
        if (updatedCart) {
          window.DOMHelper.setAttribute(input, "data-original-value", newQuantity);
          yield this.updateCartUI(updatedCart);
        }
      } catch (error) {
        input.value = originalValue;
        window.showCartNotification("update_error");
      } finally {
        window.DOMHelper.removeClass(wrapper, "loading");
      }
    });
  }
  handleRemoveItem(e) {
    return __async(this, null, function* () {
      e.preventDefault();
      const button = e.currentTarget;
      const wrapper = button.closest(".cart-item");
      const key = window.DOMHelper.getAttribute(wrapper, "data-key");
      try {
        window.DOMHelper.addClass(wrapper, "loading");
        const updatedCart = yield window.Cart.removeItem(key);
        if (updatedCart) {
          if (updatedCart.item_count === 0) {
            if (window.cartDrawerTransitioning) {
              return;
            }
            window.location.reload();
            return;
          }
          window.DOMHelper.setStyle(wrapper, {
            opacity: "0",
            transform: "translateX(20px)"
          });
          setTimeout(() => {
            wrapper.remove();
            this.updateCartUI(updatedCart);
          }, 300);
        }
      } catch (error) {
        window.showCartNotification("error_removing");
      }
    });
  }
  toggleNote(e) {
    const notesContainer = e.currentTarget.closest(".cart-notes-expandable");
    window.DOMHelper.toggleClass(notesContainer, "notes-open");
    const textarea = window.DOMHelper.safeQuery(".cart-notes__input", notesContainer);
    if (window.DOMHelper.hasClass(notesContainer, "notes-open")) {
      textarea.focus();
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const template = document.body.getAttribute("data-template");
  if (template === "cart") {
    new CartPage();
  }
});
class CartNotesDrawer {
  constructor() {
    this.init();
  }
  init() {
    const orderNotesDrawerEl = window.DOMHelper.safeQuery("[data-order-notes-drawer]");
    if (orderNotesDrawerEl) {
      const checkOrderDrawer = () => {
        if (orderNotesDrawerEl.drawer) {
          this.orderNotesDrawer = orderNotesDrawerEl.drawer;
          this.setupOrderNotesDrawer();
        } else {
          setTimeout(checkOrderDrawer, 50);
        }
      };
      checkOrderDrawer();
    }
    const giftNotesDrawerEl = window.DOMHelper.safeQuery("[data-gift-notes-drawer]");
    if (giftNotesDrawerEl) {
      const checkGiftDrawer = () => {
        if (giftNotesDrawerEl.drawer) {
          this.giftNotesDrawer = giftNotesDrawerEl.drawer;
          this.setupGiftNotesDrawer();
        } else {
          setTimeout(checkGiftDrawer, 50);
        }
      };
      checkGiftDrawer();
    }
  }
  setupOrderNotesDrawer() {
    const trigger = window.DOMHelper.safeQuery("[data-order-notes-trigger]");
    const drawerTextarea = window.DOMHelper.safeQuery("textarea", this.orderNotesDrawer.drawerElement);
    const formTextarea = window.DOMHelper.safeQuery('textarea[name="note"]');
    const saveButton = window.DOMHelper.safeQuery(".drawer-close", this.orderNotesDrawer.drawerElement);
    if (trigger) {
      trigger.addEventListener("click", () => {
        this.orderNotesDrawer.open();
      });
    }
    if (saveButton && drawerTextarea && formTextarea) {
      drawerTextarea.value = formTextarea.value;
      saveButton.addEventListener("click", () => {
        formTextarea.value = drawerTextarea.value;
        this.orderNotesDrawer.close();
      });
    }
  }
  setupGiftNotesDrawer() {
    const trigger = window.DOMHelper.safeQuery("[data-gift-notes-trigger]");
    const drawerTextarea = window.DOMHelper.safeQuery("textarea", this.giftNotesDrawer.drawerElement);
    const formTextarea = window.DOMHelper.safeQuery('textarea[name="attributes[Gift Message]"]');
    const saveButton = window.DOMHelper.safeQuery(".drawer-close", this.giftNotesDrawer.drawerElement);
    if (trigger) {
      trigger.addEventListener("click", () => {
        this.giftNotesDrawer.open();
      });
    }
    if (saveButton && drawerTextarea && formTextarea) {
      drawerTextarea.value = formTextarea.value;
      saveButton.addEventListener("click", () => {
        formTextarea.value = drawerTextarea.value;
        this.giftNotesDrawer.close();
      });
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  new CartNotesDrawer();
});
document.addEventListener("DOMContentLoaded", () => {
  const productTabLists = document.querySelectorAll(".product-tab-list");
  productTabLists.forEach((tabList) => {
    const tabs = tabList.querySelectorAll(".product-tab");
    let activeTab = tabList.querySelector(".product-tab.active");
    tabList.addEventListener("mouseover", (e) => {
      if (e.target.classList.contains("product-tab")) {
        if (activeTab) {
          activeTab.classList.remove("active");
        }
      }
    });
    tabList.addEventListener("mouseout", () => {
      if (activeTab) {
        activeTab.classList.add("active");
      }
    });
    tabs.forEach((tab) => {
      tab.addEventListener("click", function() {
        if (activeTab) {
          activeTab.classList.remove("active");
        }
        this.classList.add("active");
        activeTab = this;
      });
    });
  });
});
let sizeGuideDrawer = null;
document.addEventListener("DOMContentLoaded", () => {
  const drawerElement = document.querySelector("[data-sizeguide-drawer]");
  if (!drawerElement) return;
  sizeGuideDrawer = window.Drawer && new window.Drawer({ element: drawerElement });
  if (!sizeGuideDrawer) {
    return;
  }
  document.querySelectorAll("[data-sizeguide-drawer-trigger]").forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const sizeguideUrl = trigger.getAttribute("data-sizeguide-popup-url");
      openSizeguideDrawer(sizeguideUrl);
    });
  });
  window.addEventListener("resize", () => {
    if (sizeGuideDrawer && sizeGuideDrawer.isOpen) {
      adjustGridLayout();
    }
  });
});
function adjustGridLayout() {
  const drawerElement = document.querySelector("[data-sizeguide-drawer]");
  if (!drawerElement) return;
  const grids = drawerElement.querySelectorAll(".grid");
  const isMobile = window.innerWidth < 768;
  grids.forEach((grid) => {
    const columnCount = grid.children.length;
    if (isMobile) {
      grid.style.cssText = `
                display: grid;
                width: 100%;
                min-width: 0;
                grid-template-columns: repeat(${columnCount}, 1fr);
            `;
      grid.querySelectorAll(".size-guide__cell").forEach((cell) => {
        cell.style.cssText = `
                    min-width: 0;
                    word-break: break-word;
                    white-space: normal;
                `;
      });
    } else {
      grid.style.cssText = `
                display: grid;
                width: 100%;
                grid-template-columns: 90px repeat(${columnCount - 1}, 1fr);
            `;
      grid.querySelectorAll(".size-guide__cell").forEach((cell) => {
        cell.style.cssText = "";
      });
    }
  });
}
function openSizeguideDrawer(sizeguideUrl) {
  if (!sizeGuideDrawer) return;
  sizeGuideDrawer.open();
  window.ShopifyAPIHelper.getPage(sizeguideUrl).then((html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const sizeGuideSections = tempDiv.querySelectorAll('[id^="SizeGuide-"]');
    if (sizeGuideSections.length > 0) {
      const wrapper = document.createElement("div");
      wrapper.style.paddingBottom = "40px";
      wrapper.setAttribute("class", "sizeguide-content-wrapper");
      sizeGuideSections.forEach((section, index) => {
        if (index > 0) {
          wrapper.appendChild(document.createElement("div")).style.marginTop = "2rem";
        }
        const parentDiv = section.closest(".w-padding");
        const title = parentDiv ? parentDiv.querySelector("h2") : null;
        if (title) {
          const titleClone = title.cloneNode(true);
          wrapper.appendChild(titleClone);
        }
        const sizeGuideClone = section.cloneNode(true);
        wrapper.appendChild(sizeGuideClone);
      });
      sizeGuideDrawer.setContent(wrapper);
      adjustGridLayout();
    }
  });
}
window.SwatchStore = {
  _data: /* @__PURE__ */ new Map(),
  /**
   * Initializes the store with swatch data from the DOM
   * @method
   */
  init() {
    document.querySelectorAll("script.swatch-data").forEach((script) => {
      try {
        const data = JSON.parse(script.textContent);
        this._data.set(data.id, data);
      } catch (e) {
      }
    });
  },
  /**
   * Adds or updates a product's swatch data in the store
   * @method
   * @param {Object} data - Product swatch data
   */
  add(data) {
    this._data.set(data.id, data);
  },
  /**
   * Retrieves all products sharing the same swatch identifier
   * @method
   * @param {number|string} productId - ID of the product to find relations for
   * @returns {Array} Array of related products excluding the source product
   */
  getRelatedProducts(productId) {
    const product = this._data.get(parseInt(productId));
    if (!(product == null ? void 0 : product.swatchIdentifier)) return [];
    return Array.from(this._data.values()).filter(
      (p) => p.swatchIdentifier === product.swatchIdentifier && p.id !== product.id
    );
  },
  /**
   * Returns all products in the store
   * @method
   * @returns {Array} Array of all product swatch data
   */
  getAllProducts() {
    return Array.from(this._data.values());
  }
};
document.addEventListener("DOMContentLoaded", () => {
  window.SwatchStore.init();
});
function updateSwatches(container) {
  return __async(this, null, function* () {
    const productId = container.dataset.productId;
    if (!productId) return;
    const relatedProducts = window.SwatchStore.getRelatedProducts(productId);
    const product = window.SwatchStore._data.get(parseInt(productId));
    if (!product) return;
    const activeSwatchClass = product.swatchType === "image" ? "variant-swatch-image" : "text-swatch";
    const swatchWrapper = container.querySelector("div");
    const nonActiveSwatches = swatchWrapper.querySelectorAll(`:not(.${activeSwatchClass}.active)`);
    nonActiveSwatches.forEach((swatch) => swatch.remove());
    relatedProducts.forEach((related) => {
      if (swatchWrapper.querySelector(`[data-product-id="${related.id}"]`)) return;
      const swatch = document.createElement("a");
      swatch.href = related.url;
      swatch.className = related.swatchType === "image" ? "variant-swatch-image" : "text-swatch";
      swatch.setAttribute("data-product-id", related.id);
      swatch.setAttribute("title", related.title);
      swatch.setAttribute("role", "button");
      swatch.setAttribute("aria-label", `${related.title} - ${related.swatchColor}`);
      swatch.setAttribute("tabindex", "0");
      if (related.swatchType === "image") {
        if (related.swatchImage) {
          const picture = document.createElement("picture");
          const img = document.createElement("img");
          img.src = related.swatchImage;
          img.alt = related.title;
          img.className = "w-full h-full object-cover";
          picture.appendChild(img);
          swatch.appendChild(picture);
        }
      } else {
        swatch.textContent = related.swatchColor;
      }
      swatchWrapper.appendChild(swatch);
    });
  });
}
function bindSwatchEventHandlers(container) {
  if (container.dataset.swatchHandlersBound) return;
  container.dataset.swatchHandlersBound = "true";
  const swatchType = container.dataset.swatchType;
  const activeSwatchClass = swatchType === "image" ? "variant-swatch-image" : "text-swatch";
  let activeSwatchElement = container.querySelector(`.${activeSwatchClass}.active`);
  container.addEventListener("mouseover", (e) => {
    if ((e.target.classList.contains("variant-swatch-image") || e.target.classList.contains("text-swatch")) && !e.target.classList.contains("active")) {
      if (activeSwatchElement) {
        activeSwatchElement.classList.remove("active");
      }
    }
  });
  container.addEventListener("mouseout", () => {
    if (activeSwatchElement) {
      activeSwatchElement.classList.add("active");
    }
  });
  container.addEventListener("click", function(e) {
    const swatch = e.target.closest(".variant-swatch-image, .text-swatch");
    if (!swatch) return;
    e.preventDefault();
    if (activeSwatchElement) {
      activeSwatchElement.classList.remove("active");
    }
    swatch.classList.add("active");
    activeSwatchElement = swatch;
    const href = swatch.getAttribute("href");
    setTimeout(() => {
      window.location.href = href;
    }, 300);
  });
}
function initializeSwatches() {
  document.querySelectorAll("script.swatch-data").forEach((script) => {
    try {
      const data = JSON.parse(script.textContent);
      window.SwatchStore.add(data);
    } catch (e) {
    }
  });
  document.querySelectorAll(".swatch-container").forEach((container) => {
    updateSwatches(container);
    bindSwatchEventHandlers(container);
  });
}
window.initializeSwatches = initializeSwatches;
document.addEventListener("theme:ajaxinate:updated", () => {
  initializeSwatches();
});
document.addEventListener("DOMContentLoaded", () => {
  initializeSwatches();
});
document.addEventListener("DOMContentLoaded", () => {
  function attachPaginationListeners() {
    document.querySelectorAll('a[data-pagination="true"]').forEach((link) => {
      link.addEventListener("click", function(event) {
        event.preventDefault();
        const url = this.href;
        window.ShopifyAPIHelper.safeFetch(url).then((response) => response.text()).then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newComments = doc.querySelector("#comments-container").innerHTML;
          document.querySelector("#comments-container").innerHTML = newComments;
          window.scrollTo(0, document.querySelector("#comments").offsetTop);
          attachPaginationListeners();
        }).catch(() => {
        });
      });
    });
  }
  attachPaginationListeners();
});
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
window.updateProductGrid = function() {
  const $productGrid = $("#product-grid, #collection-grid, .product-grid, .collection-grid").first();
  if ($productGrid.length === 0) {
    return;
  }
  const isQuickView = $productGrid.attr("data-view-mode") === "quick";
  $(".col-span-full.inner-grid-image-container").remove();
  if (isQuickView) {
    return;
  }
  const $productCards = $productGrid.children().not(".col-span-full");
  const columns = parseInt($productGrid.data("columns") || $productGrid.attr("data-columns") || 3);
  const targetIndices = [columns * 2, columns * 6];
  const gridWidth = $productGrid.width();
  const $innerGridImages = $(".inner-grid-image");
  $innerGridImages.each(function(index) {
    const $innerGridImage = $(this);
    const imageUrl = $innerGridImage.data("url");
    const imageLink = $innerGridImage.data("link") || "#";
    const blockIndex = parseInt($innerGridImage.data("index")) - 1;
    const aspectRatio = parseFloat($innerGridImage.data("aspect-ratio")) || 1;
    if (imageUrl && blockIndex < targetIndices.length) {
      const targetIndex = targetIndices[blockIndex];
      if ($productCards.length >= targetIndex) {
        const imageHeight = Math.round(gridWidth / aspectRatio);
        const $imageContainer = $("<div>").addClass("col-span-full inner-grid-image-container").css({
          height: `${imageHeight}px`,
          "background-color": "#f0f0f0",
          "grid-column": "1 / -1"
        });
        const $link = $("<a>").attr("href", imageLink).css({
          display: "block",
          height: "100%"
        });
        const $image = $("<img>").attr("src", imageUrl).attr("alt", "Inner Grid Image").addClass("w-full h-full object-cover");
        $link.append($image);
        $imageContainer.append($link);
        $productCards.eq(targetIndex - 1).after($imageContainer);
      }
    }
  });
};
$(document).ready(() => {
  window.updateProductGrid();
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    $(document).on("shopify:section:load", window.updateProductGrid);
  }
  $(window).on("resize", debounce(window.updateProductGrid, 250));
  document.addEventListener("collection:grid:update", () => {
    window.updateProductGrid();
  });
  document.addEventListener("collection:updated", () => {
    window.updateProductGrid();
  });
  document.addEventListener("theme:collection:updated", () => {
    window.updateProductGrid();
  });
});
let isAddingToCart = false;
function initializeProductCards$1() {
  const productCards = document.querySelectorAll(".product-card-container:not(.initialized)");
  if (productCards.length === 0) {
    return;
  }
  productCards.forEach(setupProductCard);
}
function setupProductCard(productCard) {
  if (!productCard.querySelector(".variant-options")) {
    return;
  }
  const circlePlusBtn = productCard.querySelector(".circle-plus-btn");
  const variantOptions = productCard.querySelector(".variant-options");
  if (!variantOptions) {
    return;
  }
  const addToCartBtn = variantOptions.querySelector(".product-card-add-to-cart");
  if (!addToCartBtn) {
    return;
  }
  const selectedOptions = {};
  const animateDropdown = productCard.dataset.animateDropdown === "true";
  const i18n = {
    selectOptions: productCard.dataset.i18nSelectOptions,
    addToCart: productCard.dataset.i18nAddToCart,
    unavailable: productCard.dataset.i18nUnavailable,
    soldOut: productCard.dataset.i18nSoldOut,
    addedToCart: productCard.dataset.i18nAddedToCart,
    loading: productCard.dataset.i18nLoading,
    errorAdding: productCard.dataset.i18nErrorAdding,
    maxQuantityReached: productCard.dataset.i18nMaxQuantityReached
  };
  let productJson, variantsInventory;
  try {
    productJson = JSON.parse(productCard.dataset.productJson);
    variantsInventory = JSON.parse(productCard.dataset.variantsInventory);
  } catch (error) {
    return;
  }
  const hasVariants = productJson.variants.length > 1;
  if (circlePlusBtn) {
    circlePlusBtn.style.display = hasVariants ? "block" : "none";
  }
  updateAddToCartButton();
  if (circlePlusBtn) {
    circlePlusBtn.setAttribute("aria-expanded", "false");
    circlePlusBtn.setAttribute("aria-controls", variantOptions.id);
  }
  variantOptions.setAttribute("aria-hidden", "true");
  function updateAddToCartButton() {
    const allOptionsSelected = productJson.options.every((option) => {
      const normalizedOption = option.toLowerCase().replace(/\s+/g, "-");
      return selectedOptions[normalizedOption];
    });
    if (!allOptionsSelected) {
      disableAddToCartButton(i18n.selectOptions);
      return;
    }
    const variant = findMatchingVariant(selectedOptions);
    if (!variant) {
      disableAddToCartButton(i18n.unavailable);
      return;
    }
    if (variant.available) {
      enableAddToCartButton(variant);
    } else {
      disableAddToCartButton(i18n.soldOut);
    }
  }
  function enableAddToCartButton(variant) {
    addToCartBtn.disabled = false;
    addToCartBtn.textContent = i18n.addToCart;
    addToCartBtn.classList.remove("disabled");
    addToCartBtn.dataset.variantId = variant.id;
    const inventoryVariant = variantsInventory.find((v) => v.id === variant.id);
    if (inventoryVariant) {
      addToCartBtn.dataset.inventoryQuantity = inventoryVariant.inventory_quantity.toString();
      addToCartBtn.dataset.trackQuantity = (inventoryVariant.inventory_management === "shopify").toString();
      addToCartBtn.dataset.continueSellingWhenOutOfStock = (inventoryVariant.inventory_policy === "continue").toString();
    } else {
      addToCartBtn.dataset.inventoryQuantity = "5";
      addToCartBtn.dataset.trackQuantity = "true";
      addToCartBtn.dataset.continueSellingWhenOutOfStock = "false";
    }
    addToCartBtn.setAttribute("aria-disabled", "false");
  }
  function disableAddToCartButton(text) {
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = text;
    addToCartBtn.classList.add("disabled");
    delete addToCartBtn.dataset.variantId;
    addToCartBtn.setAttribute("aria-disabled", "true");
  }
  function findMatchingVariant(selectedOptions2) {
    return productJson.variants.find((variant) => {
      return productJson.options.every((option, index) => {
        const optionName = option.toLowerCase().replace(/\s+/g, "-");
        const variantOptionValue = variant[`option${index + 1}`];
        const selectedOptionValue = selectedOptions2[optionName];
        return variantOptionValue === selectedOptionValue;
      });
    });
  }
  if (circlePlusBtn) {
    circlePlusBtn.addEventListener("click", (e) => {
      var _a, _b;
      e.preventDefault();
      e.stopPropagation();
      const currentActiveVariantOptions = (_a = window.GlobalClickHandlers) == null ? void 0 : _a.getActiveVariantOptions();
      if (currentActiveVariantOptions && currentActiveVariantOptions !== variantOptions) {
        closeVariantOptions(currentActiveVariantOptions);
      }
      if (!variantOptions.classList.contains("active")) {
        variantOptions.classList.add("active");
        openVariantOptions(variantOptions, circlePlusBtn, animateDropdown);
        (_b = window.GlobalClickHandlers) == null ? void 0 : _b.setActiveVariantOptions(variantOptions);
      }
    });
  }
  productCard.addEventListener("click", (e) => {
    if (e.target.closest(".option-value")) {
      const optionValue = e.target.closest(".option-value");
      e.preventDefault();
      const option = optionValue.dataset.option;
      const value = optionValue.dataset.value;
      variantOptions.querySelectorAll(`.option-value[data-option="${option}"]`).forEach((el) => {
        el.classList.remove("selected");
        el.setAttribute("aria-selected", "false");
      });
      optionValue.classList.add("selected");
      optionValue.setAttribute("aria-selected", "true");
      selectedOptions[option] = value;
      updateAddToCartButton();
    } else if (e.target.closest(".product-card-add-to-cart")) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = addToCartBtn.dataset.variantId;
      if (variantId && !isAddingToCart) {
        addToCart(variantId, addToCartBtn, i18n, variantOptions);
      }
    }
  });
  productCard.classList.add("initialized");
}
function addToCart(variantId, addToCartBtn, i18n, variantOptions) {
  if (isAddingToCart) {
    return;
  }
  isAddingToCart = true;
  const originalText = addToCartBtn.textContent;
  setButtonLoading(addToCartBtn, i18n.loading);
  window.Cart.addItem(variantId, 1).then((updatedCart) => {
    window.CartUI.updateCartCounts(updatedCart.item_count);
    if (typeof window.updateCartDrawer === "function") {
      return window.updateCartDrawer(updatedCart);
    }
    return Promise.resolve();
  }).then(() => {
    var _a, _b;
    const autoNavigate = document.body.getAttribute("data-auto-open-cart-drawer") === "true";
    const cartType = window.getCartType ? window.getCartType() : "page";
    if (autoNavigate) {
      if (cartType === "drawer" && typeof window.openCartDrawer === "function") {
        window.openCartDrawer();
      } else {
        const routesRootRaw = ((_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) || "/";
        const routesRoot = routesRootRaw.endsWith("/") ? routesRootRaw : `${routesRootRaw}/`;
        window.location.href = `${routesRoot}cart`;
      }
    }
    setButtonAdded(addToCartBtn, i18n.addedToCart);
    setTimeout(() => {
      var _a2;
      closeVariantOptions(variantOptions);
      (_a2 = window.GlobalClickHandlers) == null ? void 0 : _a2.clearActiveVariantOptions();
      setButtonNormal(addToCartBtn, originalText);
      isAddingToCart = false;
    }, 2e3);
  }).catch((error) => {
    setButtonNormal(addToCartBtn, originalText);
    isAddingToCart = false;
    if (window.showCartNotification) {
      window.showCartNotification("error_adding");
    }
  });
}
function setButtonLoading(button, loadingText) {
  button.disabled = true;
  button.textContent = loadingText;
  button.classList.add("loading");
  button.setAttribute("aria-disabled", "true");
}
function setButtonAdded(button, addedText) {
  button.disabled = false;
  button.textContent = addedText;
  button.classList.remove("loading");
  button.classList.add("added");
  button.setAttribute("aria-disabled", "false");
}
function setButtonNormal(button, text) {
  button.disabled = false;
  button.textContent = text;
  button.classList.remove("loading", "added");
  button.setAttribute("aria-disabled", "false");
}
function openVariantOptions(variantOptions, plusBtn, animate) {
  variantOptions.style.display = "block";
  variantOptions.setAttribute("aria-hidden", "false");
  variantOptions.querySelectorAll(".option-value, .product-card-add-to-cart").forEach((element) => {
    element.setAttribute("tabindex", "0");
  });
  if (animate) {
    variantOptions.style.transition = "transform 0.3s ease-in-out";
    variantOptions.style.transform = "translateY(100%)";
    setTimeout(() => {
      variantOptions.style.transform = "translateY(0)";
    }, 10);
  } else {
    variantOptions.style.transition = "none";
    variantOptions.style.transform = "translateY(0)";
  }
  if (plusBtn) {
    plusBtn.style.display = "none";
    plusBtn.setAttribute("aria-expanded", "true");
  }
}
function closeVariantOptions(variantOptions) {
  const productCard = variantOptions.closest(".product-card-container");
  if (!productCard) {
    return;
  }
  const plusBtn = productCard.querySelector(".circle-plus-btn");
  const animate = productCard.dataset.animateDropdown === "true";
  variantOptions.querySelectorAll(".option-value, .product-card-add-to-cart").forEach((element) => {
    element.setAttribute("tabindex", "-1");
  });
  if (animate) {
    variantOptions.style.transition = "transform 0.3s ease-in-out";
    variantOptions.style.transform = "translateY(100%)";
    setTimeout(() => {
      variantOptions.style.display = "none";
      variantOptions.classList.remove("active");
      variantOptions.setAttribute("aria-hidden", "true");
      if (plusBtn) {
        plusBtn.style.display = "";
        plusBtn.setAttribute("aria-expanded", "false");
      }
    }, 300);
  } else {
    variantOptions.style.transition = "none";
    variantOptions.style.transform = "translateY(100%)";
    variantOptions.style.display = "none";
    variantOptions.classList.remove("active");
    variantOptions.setAttribute("aria-hidden", "true");
    if (plusBtn) {
      plusBtn.style.display = "";
      plusBtn.setAttribute("aria-expanded", "false");
    }
  }
}
window.closeVariantOptions = closeVariantOptions;
document.addEventListener("DOMContentLoaded", initializeProductCards$1);
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load", initializeProductCards$1);
  document.addEventListener("shopify:section:select", initializeProductCards$1);
}
window.initializeProductCards = initializeProductCards$1;
class AnnouncementBar {
  constructor() {
    this.currentIndex = 0;
    this.interval = null;
    this.announcements = [];
    this.container = null;
    this.duration = 10;
    this.isTransitioning = false;
    this.editorTimeout = null;
    this.init();
  }
  init() {
    try {
      this.container = document.querySelector(".announcement-bar-container");
      if (!this.container) return;
      this.duration = parseInt(this.container.dataset.announcementDuration || 10) * 1e3;
      this.setupAnnouncements();
      this.setupMarquees();
      this.setupCountdowns();
      this.startRotation();
      this.setupDesignModeHandlers();
    } catch (error) {
      console.warn("Announcement bar initialization failed:", error);
    }
  }
  setupAnnouncements() {
    this.announcements = Array.from(document.querySelectorAll(".announcement-item"));
    this.announcements.forEach((item) => {
      item.classList.remove("active");
      item.style.opacity = "0";
      item.style.visibility = "hidden";
    });
    if (this.announcements.length > 0) {
      this.showAnnouncement(0);
    }
    const marqueeItems = this.announcements.filter((item) => item.classList.contains("marquee-item"));
    if (marqueeItems.length === 1 && this.announcements.length === 1) {
      marqueeItems[0].classList.add("active");
      marqueeItems[0].style.opacity = "1";
      marqueeItems[0].style.visibility = "visible";
    }
  }
  showAnnouncement(index) {
    if (this.isTransitioning || index >= this.announcements.length) return;
    this.isTransitioning = true;
    if (this.currentIndex < this.announcements.length) {
      const currentItem = this.announcements[this.currentIndex];
      currentItem.classList.remove("active");
      currentItem.style.opacity = "0";
      currentItem.style.visibility = "hidden";
      const currentMarquee = currentItem.querySelector(".marquee-content");
      if (currentMarquee) {
        currentMarquee.style.animationPlayState = "paused";
      }
    }
    const newItem = this.announcements[index];
    newItem.classList.add("active");
    newItem.style.opacity = "1";
    newItem.style.visibility = "visible";
    const newMarquee = newItem.querySelector(".marquee-content");
    if (newMarquee) {
      newMarquee.style.animationPlayState = "running";
    }
    this.currentIndex = index;
    setTimeout(() => {
      this.isTransitioning = false;
    }, 200);
  }
  nextAnnouncement() {
    if (this.announcements.length <= 1) return;
    const nextIndex = (this.currentIndex + 1) % this.announcements.length;
    this.showAnnouncement(nextIndex);
  }
  startRotation() {
    this.stopRotation();
    if (this.announcements.length > 1) {
      this.interval = setInterval(() => {
        this.nextAnnouncement();
      }, this.duration);
    }
  }
  stopRotation() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
  setupMarquees() {
    try {
      const marquees = document.querySelectorAll(".marquee-item");
      marquees.forEach((marquee) => {
        const content = marquee.querySelector(".marquee-content");
        if (!content) return;
        const originalText = content.querySelector(".marquee-text");
        if (!originalText) return;
        const text = originalText.textContent;
        const classes = originalText.className;
        const speed = parseInt(marquee.dataset.marqueeSpeed) || 20;
        const direction = marquee.dataset.marqueeDirection || "right";
        const spacing = parseInt(marquee.dataset.marqueeSpacing) || 20;
        content.innerHTML = "";
        const containerWidth = marquee.offsetWidth || 300;
        let textWidth = originalText.offsetWidth;
        if (!textWidth || textWidth === 0) {
          const tempText = document.createElement("span");
          tempText.className = classes;
          tempText.textContent = text + " ";
          tempText.style.position = "absolute";
          tempText.style.visibility = "hidden";
          tempText.style.whiteSpace = "nowrap";
          document.body.appendChild(tempText);
          textWidth = tempText.offsetWidth || 100;
          document.body.removeChild(tempText);
        }
        const copies = Math.ceil(containerWidth * 8 / textWidth) + 12;
        for (let i = 0; i < copies; i++) {
          const span = document.createElement("span");
          span.className = classes;
          span.textContent = text + " ";
          span.style.padding = `0 ${spacing}px`;
          content.appendChild(span);
        }
        const totalWidth = textWidth * copies;
        const totalDistance = totalWidth + containerWidth;
        const duration = Math.max(1, totalDistance / speed);
        content.style.animation = `marquee-scroll ${duration}s linear infinite`;
        if (direction === "right") {
          content.style.animationDirection = "reverse";
        } else {
          content.style.animationDirection = "normal";
        }
        if (marquee.classList.contains("active")) {
          content.style.animationPlayState = "running";
        } else {
          content.style.animationPlayState = "paused";
        }
        const textElement = content.querySelector(".marquee-text");
        if (textElement) {
          textElement.style.opacity = "1";
          textElement.style.visibility = "visible";
        }
      });
    } catch (error) {
      console.warn("Marquee setup failed:", error);
    }
  }
  setupCountdowns() {
    const countdowns = document.querySelectorAll(".countdown-timer-block");
    countdowns.forEach((block) => {
      const endDate = block.dataset.endDate;
      const endTime = block.dataset.endTime;
      const timezone = block.dataset.timezone;
      if (!endDate || !endTime) return;
      const [year, month, day] = endDate.split("-").map(Number);
      const [hours, minutes] = endTime.split(":").map(Number);
      let targetDate = new Date(year, month - 1, day, hours, minutes, 0);
      if (timezone) {
        const offsetMatch = timezone.match(/([+-])(\d{2}):(\d{2})/);
        if (offsetMatch) {
          const sign = offsetMatch[1] === "+" ? 1 : -1;
          const offsetHours = parseInt(offsetMatch[2]);
          const offsetMinutes = parseInt(offsetMatch[3]);
          const totalOffsetMinutes = (offsetHours * 60 + offsetMinutes) * sign;
          const localOffset = -targetDate.getTimezoneOffset();
          const diffMinutes = localOffset - totalOffsetMinutes;
          targetDate = new Date(targetDate.getTime() + diffMinutes * 6e4);
        }
      }
      block.targetDate = targetDate;
      this.updateCountdown(block);
      if (!block.countdownInterval) {
        block.countdownInterval = setInterval(() => {
          this.updateCountdown(block);
        }, 1e3);
      }
    });
  }
  updateCountdown(block) {
    if (!block.targetDate) return;
    const now = /* @__PURE__ */ new Date();
    const diff = block.targetDate - now;
    if (diff <= 0) {
      this.updateCountdownDisplay(block, 0, 0, 0, 0);
      if (block.countdownInterval) {
        clearInterval(block.countdownInterval);
        block.countdownInterval = null;
      }
      return;
    }
    const days = Math.floor(diff / (1e3 * 60 * 60 * 24));
    const hours = Math.floor(diff % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60));
    const minutes = Math.floor(diff % (1e3 * 60 * 60) / (1e3 * 60));
    const seconds = Math.floor(diff % (1e3 * 60) / 1e3);
    this.updateCountdownDisplay(block, days, hours, minutes, seconds);
  }
  updateCountdownDisplay(block, days, hours, minutes, seconds) {
    const els = {
      days: block.querySelector(".days"),
      hours: block.querySelector(".hours"),
      minutes: block.querySelector(".minutes"),
      seconds: block.querySelector(".seconds")
    };
    if (els.days) els.days.textContent = String(days).padStart(2, "0");
    if (els.hours) els.hours.textContent = String(hours).padStart(2, "0");
    if (els.minutes) els.minutes.textContent = String(minutes).padStart(2, "0");
    if (els.seconds) els.seconds.textContent = String(seconds).padStart(2, "0");
  }
  setupDesignModeHandlers() {
    if (typeof Shopify === "undefined" || !Shopify.designMode) return;
    document.addEventListener("shopify:section:load", (event) => {
      if (event.target.dataset.sectionType === "announcement-bar") {
        setTimeout(() => {
          this.init();
        }, 100);
      }
    });
    document.addEventListener("shopify:section:unload", (event) => {
      if (event.target.dataset.sectionType === "announcement-bar") {
        this.destroy();
      }
    });
    document.addEventListener("shopify:section:select", (event) => {
      if (event.target.dataset.sectionType === "announcement-bar") {
        this.stopRotation();
        setTimeout(() => {
          this.setupMarquees();
          this.setupCountdowns();
        }, 100);
      }
    });
    document.addEventListener("shopify:section:deselect", (event) => {
      if (event.target.dataset.sectionType === "announcement-bar") {
        this.startRotation();
      }
    });
    document.addEventListener("shopify:section:reorder", (event) => {
      if (event.target.dataset.sectionType === "announcement-bar") {
        setTimeout(() => {
          this.init();
        }, 100);
      }
    });
    document.addEventListener("shopify:block:select", (event) => {
      const block = document.querySelector(`#block-${event.detail.blockId}`);
      if (block) {
        this.stopRotation();
        const item = block.querySelector(".announcement-item");
        if (item) {
          const index = this.announcements.indexOf(item);
          if (index !== -1) {
            this.showAnnouncement(index);
          }
        }
        setTimeout(() => {
          if (block.querySelector(".marquee-item")) {
            this.setupMarquees();
          }
          if (block.querySelector(".countdown-timer-block")) {
            this.setupCountdowns();
          }
        }, 100);
      }
    });
    document.addEventListener("shopify:block:deselect", (event) => {
      this.startRotation();
    });
    document.addEventListener("shopify:block:update", (event) => {
      const block = document.querySelector(`#block-${event.detail.blockId}`);
      if (block && block.querySelector(".marquee-item")) {
        setTimeout(() => {
          this.init();
        }, 100);
      }
    });
    document.addEventListener("shopify:block:reorder", (event) => {
      setTimeout(() => {
        this.init();
      }, 100);
    });
    document.addEventListener("shopify:block:destroy", (event) => {
      setTimeout(() => {
        this.init();
      }, 100);
    });
    this.setupRealTimeEditorHandlers();
  }
  setupRealTimeEditorHandlers() {
    this.currentMarqueeTexts = /* @__PURE__ */ new Map();
    this.updateMarqueeTexts();
    this.editorPollInterval = setInterval(() => {
      if (typeof Shopify !== "undefined" && Shopify.designMode) {
        this.checkForMarqueeChanges();
      }
    }, 500);
    document.addEventListener("shopify:block:select", (event) => {
      const block = document.querySelector(`#block-${event.detail.blockId}`);
      if (block && block.querySelector(".marquee-item")) {
        setTimeout(() => {
          this.setupMarquees();
          this.setupCountdowns();
          this.updateMarqueeTexts();
        }, 100);
      }
    });
    document.addEventListener("shopify:block:deselect", () => {
      setTimeout(() => {
        this.setupMarquees();
        this.setupCountdowns();
        this.updateMarqueeTexts();
      }, 100);
    });
  }
  updateMarqueeTexts() {
    this.currentMarqueeTexts.clear();
    const marquees = document.querySelectorAll(".marquee-item");
    marquees.forEach((marquee, index) => {
      const textElement = marquee.querySelector(".marquee-text");
      if (textElement) {
        this.currentMarqueeTexts.set(index, textElement.textContent);
      }
    });
  }
  checkForMarqueeChanges() {
    const marquees = document.querySelectorAll(".marquee-item");
    let hasChanges = false;
    marquees.forEach((marquee, index) => {
      const textElement = marquee.querySelector(".marquee-text");
      if (textElement) {
        const currentText = textElement.textContent;
        const storedText = this.currentMarqueeTexts.get(index);
        if (storedText !== currentText) {
          hasChanges = true;
          this.currentMarqueeTexts.set(index, currentText);
        }
      }
    });
    if (hasChanges) {
      this.setupMarquees();
    }
  }
  findBlockIdFromInput(input) {
    var _a;
    let element = input;
    while (element && !((_a = element.id) == null ? void 0 : _a.startsWith("block-"))) {
      element = element.closest('[id^="block-"]');
      if (!element) break;
    }
    if (element && element.id) {
      return element.id.replace("block-", "");
    }
    return null;
  }
  destroy() {
    this.stopRotation();
    this.announcements = [];
    if (this.editorTimeout) {
      clearTimeout(this.editorTimeout);
      this.editorTimeout = null;
    }
    if (this.editorPollInterval) {
      clearInterval(this.editorPollInterval);
      this.editorPollInterval = null;
    }
    const countdowns = document.querySelectorAll(".countdown-timer-block");
    countdowns.forEach((block) => {
      if (block.countdownInterval) {
        clearInterval(block.countdownInterval);
        block.countdownInterval = null;
      }
    });
  }
}
let announcementBar = null;
function initAnnouncementBar() {
  if (announcementBar) {
    announcementBar.destroy();
  }
  announcementBar = new AnnouncementBar();
}
document.addEventListener("DOMContentLoaded", initAnnouncementBar);
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.dataset.sectionType === "announcement-bar") {
      setTimeout(initAnnouncementBar, 100);
    }
  });
  document.addEventListener("shopify:section:reorder", (event) => {
    if (event.target.dataset.sectionType === "announcement-bar") {
      setTimeout(initAnnouncementBar, 100);
    }
  });
}
class NoticePopup {
  constructor() {
    this.popupId = "notice-popup";
    this.popup = document.getElementById(this.popupId);
    if (!this.popup) {
      return;
    }
    this.isThemeEditor = Shopify.designMode || false;
    this.closeButton = this.popup.querySelector(".close-button");
    this.popupButton = this.popup.querySelector("#popup-button");
    this.daysUntilPopupShowsAgain = this.popup.dataset.daysUntilPopupShowsAgain || 7;
    this.popupDelay = this.popup.dataset.popupDelay || 0;
    this.popupShownInSession = sessionStorage.getItem(`${this.popupId}-shown`) === "true";
    this.init();
  }
  init() {
    this.updatePopupVisibility();
    this.bindEvents();
    this.bindEditorEvents();
  }
  showPopup() {
    this.popup.style.display = "flex";
    setTimeout(() => {
      this.popup.classList.add("opacity-100");
    }, 10);
    sessionStorage.setItem(`${this.popupId}-shown`, "true");
  }
  hidePopup() {
    this.popup.classList.remove("opacity-100");
    setTimeout(() => {
      this.popup.style.display = "none";
    }, 300);
  }
  setCookie() {
    if (this.daysUntilPopupShowsAgain > 0) {
      const expires = /* @__PURE__ */ new Date();
      expires.setTime(expires.getTime() + this.daysUntilPopupShowsAgain * 24 * 60 * 60 * 1e3);
      const cookieValue = `${this.popupId}=closed; expires=${expires.toUTCString()}; path=/`;
      document.cookie = cookieValue;
    }
  }
  cookieExists() {
    return document.cookie.split(";").some((item) => item.trim().startsWith(`${this.popupId}=`));
  }
  updatePopupVisibility() {
    if (this.isThemeEditor) {
      this.hidePopup();
    } else if (this.daysUntilPopupShowsAgain === "0" && !this.popupShownInSession) {
      setTimeout(() => this.showPopup(), this.popupDelay * 1e3);
    } else if (!this.cookieExists()) {
      setTimeout(() => this.showPopup(), this.popupDelay * 1e3);
    } else {
      this.hidePopup();
    }
  }
  bindEvents() {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.hidePopup();
        if (this.daysUntilPopupShowsAgain !== "0") {
          this.setCookie();
        }
      });
    }
    if (this.popupButton) {
      this.popupButton.addEventListener("click", () => {
        this.hidePopup();
        if (this.daysUntilPopupShowsAgain !== "0") {
          this.setCookie();
        }
      });
    }
  }
  bindEditorEvents() {
    var _a;
    if (!this.isThemeEditor || !((_a = window.Shopify) == null ? void 0 : _a.designMode)) return;
    document.addEventListener("shopify:section:select", (event) => {
      if (event.detail.sectionId === this.popup.dataset.sectionId) {
        this.showPopup();
      }
    });
    document.addEventListener("shopify:section:deselect", (event) => {
      if (event.detail.sectionId === this.popup.dataset.sectionId) {
        this.hidePopup();
      }
    });
    document.addEventListener("shopify:section:load", (event) => {
      if (event.detail.sectionId === this.popup.dataset.sectionId) {
        this.popup = document.getElementById(this.popupId);
        if (this.popup) {
          this.closeButton = this.popup.querySelector(".close-button");
          this.popupButton = this.popup.querySelector("#popup-button");
          this.bindEvents();
          this.showPopup();
        }
      }
    });
    document.addEventListener("shopify:block:select", (event) => {
      if (this.popup && event.detail.sectionId === this.popup.dataset.sectionId) {
        this.showPopup();
      }
    });
  }
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new NoticePopup());
} else {
  new NoticePopup();
}
document.addEventListener("DOMContentLoaded", () => {
  let productRecommendationsSection = document.querySelector(".product-recommendations");
  function calculateExpectedHeight() {
    const viewportWidth = window.innerWidth;
    const section = document.querySelector(".product-recommendations");
    if (!section) return 0;
    let productsPerRow;
    const grid = section.querySelector(".product-grid");
    if (grid) {
      if (viewportWidth < 640) {
        productsPerRow = grid.classList.contains("grid-cols-1") ? 1 : 2;
      } else if (viewportWidth < 768) {
        productsPerRow = 2;
      } else {
        const gridClass = Array.from(grid.classList).find((cls) => cls.startsWith("lg:grid-cols-"));
        productsPerRow = gridClass ? parseInt(gridClass.split("-").pop()) : 4;
      }
    } else {
      productsPerRow = viewportWidth < 768 ? 2 : 4;
    }
    const productWidth = (viewportWidth - 40 * (productsPerRow - 1)) / productsPerRow;
    const productHeight = productWidth * 1.2 + 100;
    const rowsNeeded = Math.ceil(8 / productsPerRow);
    return productHeight * rowsNeeded + 60;
  }
  function createPlaceholder() {
    if (!productRecommendationsSection) return;
    const height = calculateExpectedHeight();
    const placeholder = document.createElement("div");
    placeholder.className = "recommendations-placeholder";
    placeholder.style.cssText = `
            height: ${height}px;
            width: 100%;
            position: relative;
            visibility: hidden;
        `;
    productRecommendationsSection.appendChild(placeholder);
  }
  function removePlaceholder() {
    const placeholder = document.querySelector(".recommendations-placeholder");
    if (placeholder) {
      placeholder.remove();
    }
  }
  function initializeImageLoading() {
    const images = document.querySelectorAll(".image-loading");
    images.forEach((img) => {
      img.onload = function() {
        img.classList.add("image-loaded");
      };
      if (img.complete) {
        img.onload();
      }
    });
  }
  function fetchRecommendations() {
    if (!productRecommendationsSection) {
      return;
    }
    const url = productRecommendationsSection.dataset.url;
    if (url) {
      createPlaceholder();
      window.ShopifyAPIHelper.safeFetch(url).then((response) => response.text()).then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const recommendations = tempDiv.querySelector(".product-recommendations");
        if (recommendations) {
          removePlaceholder();
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          initializeProductCards();
          initializeAllCarousels();
          initializeImageLoading();
          if (typeof window.initializeSwatches === "function") {
            window.initializeSwatches();
          }
          setTimeout(() => {
            if (typeof AOS !== "undefined") {
              AOS.refresh();
            }
          }, 10);
        } else {
          removePlaceholder();
          productRecommendationsSection.innerHTML = `<p>${JSON.parse(document.body.dataset.noRelatedProducts)}</p>`;
        }
      }).catch((error) => {
        if (productRecommendationsSection) {
          productRecommendationsSection.style.display = "none";
        }
      });
    }
  }
  function initializeAllCarousels() {
    const carousels = document.querySelectorAll('[id^="carousel-"]');
    carousels.forEach((carousel) => {
      const sectionId = carousel.id.replace("carousel-", "");
      initializeCarousel(sectionId);
    });
  }
  function setupObserver() {
    if (productRecommendationsSection) {
      const handleIntersection = (entries, observer2) => {
        if (entries[0].isIntersecting) {
          observer2.unobserve(productRecommendationsSection);
          fetchRecommendations();
        }
      };
      const observer = new IntersectionObserver(handleIntersection, { rootMargin: "200px 0px 200px 0px" });
      observer.observe(productRecommendationsSection);
    }
  }
  if (productRecommendationsSection) {
    if (Shopify && Shopify.designMode) {
      fetchRecommendations();
    } else {
      setupObserver();
    }
  }
  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(".product-recommendations");
    if (section) {
      productRecommendationsSection = section;
      fetchRecommendations();
      setupObserver();
    }
  });
  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target.querySelector(".product-recommendations");
    if (section) {
      section.innerHTML = "";
    }
  });
  document.addEventListener("shopify:section:select", (event) => {
    const section = event.target.querySelector(".product-recommendations");
    if (section) {
      productRecommendationsSection = section;
      fetchRecommendations();
    }
  });
  document.addEventListener("shopify:section:deselect", (event) => {
    const section = event.target.querySelector(".product-recommendations");
    if (section) {
      productRecommendationsSection = section;
      fetchRecommendations();
    }
  });
  document.addEventListener("shopify:block:select", (event) => {
    const section = event.target.closest(".product-recommendations");
    if (section) {
      productRecommendationsSection = section;
      fetchRecommendations();
    }
  });
  document.addEventListener("shopify:block:deselect", (event) => {
    const section = event.target.closest(".product-recommendations");
    if (section) {
      productRecommendationsSection = section;
      fetchRecommendations();
    }
  });
  document.addEventListener("shopify:section:rerender", (event) => {
    const section = event.target.querySelector(".product-recommendations");
    if (section) {
      productRecommendationsSection = section;
      fetchRecommendations();
    }
  });
  if (Shopify && Shopify.designMode) {
    document.addEventListener("shopify:theme_editor:ready", () => {
      if (productRecommendationsSection) {
        fetchRecommendations();
      }
    });
  }
});
document.addEventListener("DOMContentLoaded", () => {
  let complementaryProductsSection = document.querySelector(".complementary-products");
  function calculateExpectedHeight() {
    const viewportWidth = window.innerWidth;
    const section = document.querySelector(".complementary-products");
    if (!section) return 0;
    let productsPerRow;
    const grid = section.querySelector(".product-grid");
    if (grid) {
      if (viewportWidth < 640) {
        productsPerRow = grid.classList.contains("grid-cols-1") ? 1 : 2;
      } else if (viewportWidth < 768) {
        productsPerRow = 2;
      } else {
        const gridClass = Array.from(grid.classList).find((cls) => cls.startsWith("lg:grid-cols-"));
        productsPerRow = gridClass ? parseInt(gridClass.split("-").pop()) : 5;
      }
    } else {
      productsPerRow = viewportWidth < 768 ? 2 : 5;
    }
    const productWidth = (viewportWidth - 40 * (productsPerRow - 1)) / productsPerRow;
    const productHeight = productWidth * 1.2 + 100;
    const rowsNeeded = Math.ceil(10 / productsPerRow);
    return productHeight * rowsNeeded + 60;
  }
  function createPlaceholder() {
    if (!complementaryProductsSection) return;
    const height = calculateExpectedHeight();
    const placeholder = document.createElement("div");
    placeholder.className = "complementary-placeholder";
    placeholder.style.cssText = `
            height: ${height}px;
            width: 100%;
            position: relative;
            visibility: hidden;
        `;
    complementaryProductsSection.appendChild(placeholder);
  }
  function removePlaceholder() {
    const placeholder = document.querySelector(".complementary-placeholder");
    if (placeholder) {
      placeholder.remove();
    }
  }
  function initializeAllCarousels() {
    const carousels = document.querySelectorAll('[id^="carousel-"]');
    carousels.forEach((carousel) => {
      const sectionId = carousel.id.replace("carousel-", "");
      if (typeof initializeCarousel === "function") {
        initializeCarousel(sectionId);
      }
    });
  }
  function showComplementaryProducts(section) {
    section.style.opacity = "0";
    section.style.display = "";
    setTimeout(() => {
      section.style.transition = "opacity 0.5s ease-in-out";
      section.style.opacity = "1";
    }, 10);
  }
  function initializeImageLoading() {
    const images = document.querySelectorAll(".image-loading");
    images.forEach((img) => {
      img.onload = function() {
        img.classList.add("image-loaded");
      };
      if (img.complete) {
        img.onload();
      }
    });
  }
  function fetchComplementaryProducts() {
    if (!complementaryProductsSection) {
      return;
    }
    const url = complementaryProductsSection.dataset.url;
    if (url) {
      createPlaceholder();
      window.ShopifyAPIHelper.safeFetch(url).then((response) => response.text()).then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const recommendations = tempDiv.querySelector(".complementary-products");
        if (recommendations && (recommendations.querySelector(".product-card-container") || recommendations.querySelector(".placeholder-image"))) {
          removePlaceholder();
          complementaryProductsSection.innerHTML = recommendations.innerHTML;
          initializeProductCards();
          initializeAllCarousels();
          initializeImageLoading();
          showComplementaryProducts(complementaryProductsSection);
          if (typeof window.initializeSwatches === "function") {
            window.initializeSwatches();
          }
          setTimeout(() => {
            if (typeof AOS !== "undefined") {
              AOS.refresh();
            }
          }, 10);
          const parentSection = complementaryProductsSection.closest(".product-section-layout");
          if (parentSection) {
            const contentDiv = parentSection.querySelector(".content");
            if (contentDiv) {
              contentDiv.classList.add("content-border");
            }
          }
        } else {
          removePlaceholder();
          complementaryProductsSection.style.display = "none";
          const parentSection = complementaryProductsSection.closest(".product-section-layout");
          if (parentSection) {
            const contentDiv = parentSection.querySelector(".content");
            if (contentDiv) {
              contentDiv.classList.remove("content-border");
            }
          }
        }
      }).catch(() => {
        removePlaceholder();
        complementaryProductsSection.style.display = "none";
        const parentSection = complementaryProductsSection.closest(".product-section-layout");
        if (parentSection) {
          const contentDiv = parentSection.querySelector(".content");
          if (contentDiv) {
            contentDiv.classList.remove("content-border");
          }
        }
      });
    }
  }
  if (complementaryProductsSection) {
    fetchComplementaryProducts();
  }
  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(".complementary-products");
    if (section) {
      complementaryProductsSection = section;
      fetchComplementaryProducts();
    }
  });
  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target.querySelector(".complementary-products");
    if (section) {
      removePlaceholder();
      section.innerHTML = "";
      const parentSection = section.closest(".product-section-layout");
      if (parentSection) {
        const contentDiv = parentSection.querySelector(".content");
        if (contentDiv) {
          contentDiv.classList.remove("content-border");
        }
      }
    }
  });
  document.addEventListener("shopify:section:select", (event) => {
    const section = event.target.querySelector(".complementary-products");
    if (section) {
      complementaryProductsSection = section;
      fetchComplementaryProducts();
    }
  });
  document.addEventListener("shopify:section:deselect", (event) => {
    const section = event.target.querySelector(".complementary-products");
    if (section) {
      complementaryProductsSection = section;
      fetchComplementaryProducts();
    }
  });
  document.addEventListener("shopify:block:select", (event) => {
    const section = event.target.closest(".complementary-products");
    if (section) {
      complementaryProductsSection = section;
      fetchComplementaryProducts();
    }
  });
  document.addEventListener("shopify:block:deselect", (event) => {
    const section = event.target.closest(".complementary-products");
    if (section) {
      complementaryProductsSection = section;
      fetchComplementaryProducts();
    }
  });
  document.addEventListener("shopify:section:rerender", (event) => {
    const section = event.target.querySelector(".complementary-products");
    if (section) {
      complementaryProductsSection = section;
      fetchComplementaryProducts();
    }
  });
  if (Shopify && Shopify.designMode) {
    document.addEventListener("shopify:theme_editor:ready", () => {
      if (complementaryProductsSection) {
        fetchComplementaryProducts();
      }
    });
  }
});
function initializeSlideshowFromElement(slideshowElement) {
  if (window.window.DOMHelper.hasClass(slideshowElement, "initialized")) {
    return;
  }
  let slideIndex = 1;
  let prevButton;
  let nextButton;
  let autoplayInterval;
  const autoplaySpeed = window.DOMHelper.getAttribute(slideshowElement, "data-autoplay-speed");
  const autoplayDelay = 8e3;
  let userInteractionTimeout;
  let isTransitioning = false;
  const slideAnimation = window.DOMHelper.getAttribute(slideshowElement, "data-slide-animation");
  const showArrows = window.DOMHelper.getAttribute(slideshowElement, "data-show-arrows") === "true";
  const showDots = window.DOMHelper.getAttribute(slideshowElement, "data-show-dots") === "true";
  function plusSlides(n, reverse = false) {
    if (isTransitioning) {
      return;
    }
    isTransitioning = true;
    const slides = window.DOMHelper.safeQueryAll(".slideshow-slide", slideshowElement);
    if (slides.length <= 1) {
      isTransitioning = false;
      return;
    }
    const currentSlide2 = slides[slideIndex - 1];
    let nextSlideIndex = slideIndex + n;
    if (nextSlideIndex > slides.length) {
      nextSlideIndex = 1;
    }
    if (nextSlideIndex < 1) {
      nextSlideIndex = slides.length;
    }
    const nextSlide = slides[nextSlideIndex - 1];
    if (slideAnimation === "slide") {
      window.DOMHelper.addClass(currentSlide2, reverse ? "slideshow-slide-out-reverse" : "slideshow-slide-out");
      window.DOMHelper.setStyle(nextSlide, "display", "block");
      window.DOMHelper.addClass(nextSlide, reverse ? "slideshow-slide-in-reverse" : "slideshow-slide-in");
    } else if (slideAnimation === "fade") {
      window.DOMHelper.addClass(currentSlide2, "slideshow-fade-out");
      window.DOMHelper.setStyle(nextSlide, "display", "block");
      window.DOMHelper.addClass(nextSlide, "slideshow-fade-in");
    } else if (slideAnimation === "instant") {
      window.DOMHelper.setStyle(currentSlide2, "display", "none");
      window.DOMHelper.setStyle(nextSlide, "display", "block");
    }
    window.DOMHelper.removeClass(currentSlide2, "active");
    window.DOMHelper.addClass(nextSlide, "active");
    setTimeout(() => {
      window.DOMHelper.removeClass(currentSlide2, ["slideshow-slide-out", "slideshow-slide-out-reverse", "slideshow-fade-out"]);
      window.DOMHelper.removeClass(nextSlide, ["slideshow-slide-in", "slideshow-slide-in-reverse", "slideshow-fade-in"]);
      window.DOMHelper.setStyle(currentSlide2, "display", "none");
      isTransitioning = false;
    }, 500);
    slideIndex = nextSlideIndex;
    updateDots();
    window.DOMHelper.dispatchEvent("slideChange", {
      activeSlide: nextSlide
    }, slideshowElement);
  }
  function showSlides(n) {
    let i;
    const slides = window.DOMHelper.safeQueryAll(".slideshow-slide", slideshowElement);
    if (slides.length <= 1) {
      window.DOMHelper.setStyle(slides[0], "display", "block");
      window.DOMHelper.addClass(slides[0], "active");
      updateDots();
      return;
    }
    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
      window.DOMHelper.setStyle(slides[i], "display", "none");
      window.DOMHelper.removeClass(slides[i], ["slideshow-fade-in", "slideshow-fade-out", "slideshow-slide-in", "slideshow-slide-out", "slideshow-slide-in-reverse", "slideshow-slide-out-reverse"]);
    }
    window.DOMHelper.setStyle(slides[slideIndex - 1], "display", "block");
    window.DOMHelper.addClass(slides[slideIndex - 1], "active");
    updateDots();
    window.DOMHelper.dispatchEvent("slideChange", {
      activeSlide: slides[slideIndex - 1]
    }, slideshowElement);
  }
  function resetAutoplay() {
    clearInterval(autoplayInterval);
    clearTimeout(userInteractionTimeout);
    const slides = window.DOMHelper.safeQueryAll(".slideshow-slide", slideshowElement);
    if (autoplaySpeed !== "disabled" && slides.length > 1) {
      userInteractionTimeout = setTimeout(() => {
        autoplayInterval = setInterval(() => {
          plusSlides(1);
        }, parseInt(autoplaySpeed));
      }, autoplayDelay);
    }
  }
  function pauseAutoplay() {
    clearInterval(autoplayInterval);
    clearTimeout(userInteractionTimeout);
  }
  function prevButtonHandler(event) {
    event.preventDefault();
    plusSlides(-1, true);
    resetAutoplay();
  }
  function nextButtonHandler(event) {
    event.preventDefault();
    plusSlides(1);
    resetAutoplay();
  }
  window.currentSlide = function(n) {
    const slides = window.DOMHelper.safeQueryAll(".slideshow-slide", slideshowElement);
    const currentIndex = slideIndex;
    let newIndex = n;
    if (newIndex > slides.length) {
      newIndex = 1;
    }
    if (newIndex < 1) {
      newIndex = slides.length;
    }
    if (newIndex === currentIndex) {
      return;
    }
    const reverse = newIndex < currentIndex;
    const increment = newIndex - currentIndex;
    plusSlides(increment, reverse);
    resetAutoplay();
  };
  function updateDots() {
    if (!showDots) {
      return;
    }
    const dots = window.DOMHelper.safeQueryAll(".slideshow-dot", slideshowElement);
    for (let i = 0; i < dots.length; i++) {
      window.DOMHelper.removeClass(dots[i], "active");
    }
    if (dots.length > 0) {
      window.DOMHelper.addClass(dots[slideIndex - 1], "active");
    }
  }
  function keyboardNavigationHandler(event) {
    if (event.key === "ArrowLeft") {
      plusSlides(-1, true);
      resetAutoplay();
    } else if (event.key === "ArrowRight") {
      plusSlides(1);
      resetAutoplay();
    }
  }
  showSlides(slideIndex);
  if (autoplaySpeed !== "disabled" && window.DOMHelper.safeQueryAll(".slideshow-slide", slideshowElement).length > 1) {
    autoplayInterval = setInterval(() => {
      plusSlides(1);
    }, parseInt(autoplaySpeed));
  }
  if (showArrows) {
    prevButton = window.DOMHelper.safeQuery(".prev", slideshowElement);
    nextButton = window.DOMHelper.safeQuery(".next", slideshowElement);
    if (prevButton) {
      prevButton.removeEventListener("click", prevButtonHandler);
      prevButton.addEventListener("click", prevButtonHandler);
    }
    if (nextButton) {
      nextButton.removeEventListener("click", nextButtonHandler);
      nextButton.addEventListener("click", nextButtonHandler);
    }
  }
  document.addEventListener("keydown", keyboardNavigationHandler);
  window.DOMHelper.addClass(slideshowElement, "initialized");
  slideshowElement.pauseAutoplay = pauseAutoplay;
  slideshowElement.resetAutoplay = resetAutoplay;
}
function initializeAllSlideshows() {
  const slideshows = window.DOMHelper.safeQueryAll(".slideshow-container");
  slideshows.forEach((slideshow) => {
    initializeSlideshowFromElement(slideshow);
  });
}
document.addEventListener("DOMContentLoaded", initializeAllSlideshows);
if (Shopify.designMode) {
  document.addEventListener("shopify:block:select", (event) => {
    const blockId = event.detail.blockId;
    const sectionId = event.detail.sectionId;
    const cleanedSectionId = sectionId.replace("template--", "");
    const slideshowSelector = `[id*="${cleanedSectionId}"] .slideshow-container`;
    const slideshow = window.DOMHelper.safeQuery(slideshowSelector);
    if (slideshow) {
      const blocks = window.DOMHelper.safeQueryAll(".slideshow-slide", slideshow);
      for (let i = 0; i < blocks.length; i++) {
        if (window.DOMHelper.getAttribute(blocks[i], "id") === `block-${blockId}`) {
          currentSlide(i + 1);
          slideshow.pauseAutoplay();
          break;
        }
      }
    }
  });
  document.addEventListener("shopify:block:deselect", (event) => {
    const sectionId = event.detail.sectionId;
    const cleanedSectionId = sectionId.replace("template--", "");
    const slideshowSelector = `[id*="${cleanedSectionId}"] .slideshow-container`;
    const slideshow = window.DOMHelper.safeQuery(slideshowSelector);
    if (slideshow) {
      slideshow.resetAutoplay();
    }
  });
  document.addEventListener("shopify:section:unload", () => {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  });
}
function initializeSlideshowAltColorTrigger() {
  const blocks = window.DOMHelper.safeQueryAll(".global-alt-color");
  const nav = window.DOMHelper.safeQuery(".slideshow-navigation");
  const dots = window.DOMHelper.safeQuery(".slideshow-dots");
  if (blocks.length === 0 || !nav && !dots) {
    return;
  }
  function updateClasses(activeBlock2) {
    const useAltColor = window.DOMHelper.getAttribute(activeBlock2, "data-use-alt-color") === "true";
    if (nav) {
      if (useAltColor) {
        window.DOMHelper.addClass(nav, "alt-color-trigger");
      } else {
        window.DOMHelper.removeClass(nav, "alt-color-trigger");
      }
    }
    if (dots) {
      if (useAltColor) {
        window.DOMHelper.addClass(dots, "alt-color-trigger");
      } else {
        window.DOMHelper.removeClass(dots, "alt-color-trigger");
      }
    }
  }
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "data-use-alt-color") {
        updateClasses(mutation.target);
      }
    });
  });
  blocks.forEach((block) => {
    observer.observe(block, {
      attributes: true,
      // Monitor attribute changes
      attributeFilter: ["data-use-alt-color"]
      // Only monitor this specific attribute
    });
  });
  const activeBlock = window.DOMHelper.safeQuery(".slideshow-slide.active .global-alt-color");
  if (activeBlock) {
    updateClasses(activeBlock);
  }
  const slideshows = window.DOMHelper.safeQueryAll(".slideshow-container");
  slideshows.forEach((slideshow) => {
    slideshow.addEventListener("slideChange", (event) => {
      const activeBlock2 = window.DOMHelper.safeQuery(".global-alt-color", event.detail.activeSlide);
      if (activeBlock2) {
        updateClasses(activeBlock2);
      }
    });
  });
}
function reinitializeSlideshowAltColorTrigger() {
  initializeSlideshowAltColorTrigger();
  initializeAllSlideshows();
}
document.addEventListener("shopify:section:load", reinitializeSlideshowAltColorTrigger);
document.addEventListener("shopify:section:select", reinitializeSlideshowAltColorTrigger);
document.addEventListener("shopify:section:deselect", reinitializeSlideshowAltColorTrigger);
document.addEventListener("shopify:section:reorder", reinitializeSlideshowAltColorTrigger);
document.addEventListener("shopify:block:select", reinitializeSlideshowAltColorTrigger);
document.addEventListener("shopify:block:deselect", reinitializeSlideshowAltColorTrigger);
document.addEventListener("shopify:block:reorder", reinitializeSlideshowAltColorTrigger);
document.addEventListener("shopify:block:destroy", reinitializeSlideshowAltColorTrigger);
document.addEventListener("DOMContentLoaded", initializeSlideshowAltColorTrigger);
function scrollSectionIntoView(sectionId) {
  const section = window.DOMHelper.safeQuery(`[id^="shopify-section-${sectionId}"]`);
  if (section) {
    section.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}
function scrollSlideIntoView(slideId) {
  const slide = window.DOMHelper.safeQuery(`#block-${slideId}`);
  if (slide) {
    slide.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}
function pauseSlideshowAutoplay(sectionId) {
  const slideshow = window.DOMHelper.safeQuery(`[id^="shopify-section-${sectionId}"] .slideshow-container`);
  if (slideshow && slideshow.pauseAutoplay) {
    slideshow.pauseAutoplay();
  }
}
function resumeSlideshowAutoplay(sectionId) {
  const slideshow = window.DOMHelper.safeQuery(`[id^="shopify-section-${sectionId}"] .slideshow-container`);
  if (slideshow && slideshow.resetAutoplay) {
    slideshow.resetAutoplay();
  }
}
if (Shopify && Shopify.designMode) {
  document.addEventListener("shopify:section:unload", (event) => {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    const sectionId = window.DOMHelper.getAttribute(event.target, "data-section-id");
    const slideshow = window.DOMHelper.safeQuery(`[id^="shopify-section-${sectionId}"] .slideshow-container`);
    if (slideshow) {
      window.DOMHelper.removeClass(slideshow, "initialized");
    }
  });
  [
    "shopify:section:load",
    "shopify:section:reorder",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect",
    "shopify:block:reorder",
    "shopify:block:destroy"
  ].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      initializeAllSlideshows();
      initializeSlideshowAltColorTrigger();
      if (eventName === "shopify:section:select") {
        const sectionId = event.detail.sectionId || event.target && window.DOMHelper.getAttribute(event.target, "data-section-id");
        scrollSectionIntoView(sectionId);
        pauseSlideshowAutoplay(sectionId);
      }
      if (eventName === "shopify:section:deselect") {
        const sectionId = event.detail.sectionId || event.target && window.DOMHelper.getAttribute(event.target, "data-section-id");
        resumeSlideshowAutoplay(sectionId);
      }
      if (eventName === "shopify:block:select") {
        const blockId = event.detail.blockId;
        const sectionId = event.detail.sectionId;
        scrollSlideIntoView(blockId);
        window.currentSlide && window.currentSlide(Array.from(window.DOMHelper.safeQueryAll(".slideshow-slide")).findIndex((slide) => window.DOMHelper.getAttribute(slide, "id") === `block-${blockId}`) + 1);
        pauseSlideshowAutoplay(sectionId);
      }
      if (eventName === "shopify:block:deselect") {
        const sectionId = event.detail.sectionId;
        resumeSlideshowAutoplay(sectionId);
      }
    });
  });
}
function initializeVideoHandling() {
  const videoWrappers = document.querySelectorAll(".video-wrapper");
  videoWrappers.forEach((wrapper, index) => {
    const videoWithPoster = wrapper.querySelector("video");
    const backupImage = wrapper.querySelector(".backup-image");
    const link = wrapper.dataset.link;
    if (videoWithPoster && backupImage) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            videoWithPoster.poster = backupImage.src;
            observer.unobserve(entry.target);
          }
        });
      });
      videoWithPoster.onerror = function() {
        wrapper.innerHTML = `<img src="${backupImage.src}" class="w-full h-full object-cover">`;
      };
      observer.observe(videoWithPoster);
    }
    if (link) {
      wrapper.style.cursor = "pointer";
      wrapper.addEventListener("click", function(e) {
        if (e.target === this || e.target.tagName !== "VIDEO") {
          window.location.href = link;
        }
      });
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initializeVideoHandling();
});
document.addEventListener("shopify:section:load", (event) => {
  initializeVideoHandling();
});
(function() {
  const activeCarousels = /* @__PURE__ */ new Map();
  function initializeCarousel2(sectionId) {
    if (!window.DOMHelper) {
      setTimeout(() => initializeCarousel2(sectionId), 100);
      return;
    }
    if (activeCarousels.has(sectionId)) {
      const cleanup2 = activeCarousels.get(sectionId);
      cleanup2();
      activeCarousels.delete(sectionId);
    }
    const carousel = window.DOMHelper.safeQuery(`#carousel-${sectionId} .carousel-items`);
    const prevButton = window.DOMHelper.safeQuery(`#carousel-prev-${sectionId}`);
    const nextButton = window.DOMHelper.safeQuery(`#carousel-next-${sectionId}`);
    if (!carousel || !prevButton || !nextButton) {
      return;
    }
    let scrollPerClick;
    let sliderScrollPosition = 0;
    const isInfiniteCarousel = window.DOMHelper.getAttribute(carousel, "data-infinite") === "true";
    let cachedScrollWidth = 0;
    let cachedOffsetWidth = 0;
    let cacheTime = 0;
    const CACHE_DURATION = 1e3;
    const browserInfo = function() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
      const isIE = /msie|trident/.test(userAgent);
      return { isSafari, isIE };
    }();
    let scrollThrottleTimeout;
    let lastScrollTime2 = 0;
    const SCROLL_THROTTLE2 = browserInfo.isSafari ? 300 : browserInfo.isIE ? 400 : 150;
    function calculateScrollPerClick() {
      const firstItem = window.DOMHelper.safeQuery(".carousel-item", carousel);
      const isMobile = window.innerWidth <= 768;
      const mobileSpacingEnabled = window.DOMHelper.getAttribute(carousel, "data-mobile-spacing") === "true";
      const mobileGapFromData = parseInt(window.DOMHelper.getAttribute(carousel, "data-mobile-gap") || "", 10);
      const spacingValue = isMobile ? Number.isNaN(mobileGapFromData) ? mobileSpacingEnabled ? 2 : 0 : mobileGapFromData : parseInt(window.DOMHelper.getAttribute(carousel, "data-spacing") || "16", 10);
      const desktopProductsPerPage = parseInt(window.DOMHelper.getAttribute(carousel, "data-products-per-page") || "4", 10);
      const desktopItemsToShow = Math.max(2, Math.min(5, desktopProductsPerPage));
      const mobileItemsPerPage = parseInt(window.DOMHelper.getAttribute(carousel, "data-mobile-items-per-page") || "2", 10);
      const mobileItemsToShow = Math.max(1, Math.min(2, mobileItemsPerPage));
      const itemsToShow = isMobile ? mobileItemsToShow : desktopItemsToShow;
      carousel.style.setProperty("--desktop-items-count", desktopItemsToShow);
      carousel.style.setProperty("--desktop-item-width", 100 / desktopItemsToShow + "%");
      carousel.style.setProperty("--mobile-items-count", mobileItemsToShow);
      carousel.style.setProperty("--mobile-item-width", 100 / mobileItemsToShow + "%");
      window.getComputedStyle(carousel);
      window.DOMHelper.safeQuery(".carousel-item", carousel);
      const itemsPerClick = itemsToShow;
      scrollPerClick = firstItem ? (firstItem.offsetWidth + spacingValue) * itemsPerClick : 0;
      const now = Date.now();
      cachedScrollWidth = carousel.scrollWidth;
      cachedOffsetWidth = carousel.offsetWidth;
      cacheTime = now;
    }
    function updateButtonState() {
      const now = Date.now();
      const cacheDuration = browserInfo.isSafari ? 2e3 : browserInfo.isIE ? 3e3 : CACHE_DURATION;
      if (now - cacheTime > cacheDuration) {
        cachedScrollWidth = carousel.scrollWidth;
        cachedOffsetWidth = carousel.offsetWidth;
        cacheTime = now;
      }
      if (isInfiniteCarousel) {
        prevButton.disabled = false;
        nextButton.disabled = false;
        return;
      }
      prevButton.disabled = sliderScrollPosition <= 0;
      nextButton.disabled = sliderScrollPosition >= cachedScrollWidth - cachedOffsetWidth;
    }
    const scheduleUpdate = (callback) => {
      if ("requestIdleCallback" in window) {
        requestIdleCallback(callback, { timeout: 100 });
      } else {
        setTimeout(callback, 0);
      }
    };
    function throttledUpdateButtonState() {
      const now = Date.now();
      if (now - lastScrollTime2 < SCROLL_THROTTLE2) {
        if (scrollThrottleTimeout) clearTimeout(scrollThrottleTimeout);
        scrollThrottleTimeout = setTimeout(() => {
          sliderScrollPosition = carousel.scrollLeft;
          scheduleUpdate(() => updateButtonState());
          lastScrollTime2 = Date.now();
        }, SCROLL_THROTTLE2);
        return;
      }
      sliderScrollPosition = carousel.scrollLeft;
      scheduleUpdate(() => updateButtonState());
      lastScrollTime2 = now;
    }
    let userScrollTimeout;
    function handleUserScroll() {
      if (browserInfo.isSafari) {
        window.DOMHelper.addClass(carousel, "scrolling");
        clearTimeout(userScrollTimeout);
        userScrollTimeout = setTimeout(() => {
          window.DOMHelper.removeClass(carousel, "scrolling");
        }, 150);
      }
      if (!browserInfo.isIE) {
        throttledUpdateButtonState();
      }
    }
    let isScrolling = false;
    let observer = null;
    const initializeScrollBehavior = () => {
      if (isScrolling) return;
      isScrolling = true;
      calculateScrollPerClick();
      updateButtonState();
      if (window.ultraScrollCoordinator) {
        window.ultraScrollCoordinator.subscribe(`carousel-${sectionId}`, handleUserScroll, {
          priority: "normal",
          // Carousels have normal priority vs header (high priority)
          throttle: browserInfo.isSafari ? 400 : browserInfo.isIE ? 500 : 300
          // Browser-specific throttling
        });
      } else {
        carousel.addEventListener("scroll", handleUserScroll, { passive: true });
      }
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    };
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            initializeScrollBehavior();
          }
        });
      }, {
        root: null,
        rootMargin: "50px",
        // Start initializing 50px before carousel comes into view
        threshold: 0.1
      });
      observer.observe(carousel);
    } else {
      initializeScrollBehavior();
    }
    function browserOptimizedScroll(targetPosition) {
      if (browserInfo.isSafari) {
        window.DOMHelper.addClass(carousel, "scrolling");
        carousel.scrollTo({ left: targetPosition, behavior: "smooth" });
        setTimeout(() => {
          window.DOMHelper.removeClass(carousel, "scrolling");
        }, 500);
      } else if (browserInfo.isIE) {
        carousel.scrollLeft = targetPosition;
      } else {
        carousel.scrollTo({ left: targetPosition, behavior: "smooth" });
      }
    }
    prevButton.addEventListener("click", () => {
      const maxScrollPosition = Math.max(carousel.scrollWidth - carousel.offsetWidth, 0);
      if (isInfiniteCarousel && sliderScrollPosition <= 0) {
        sliderScrollPosition = maxScrollPosition;
      } else {
        sliderScrollPosition = Math.max(sliderScrollPosition - scrollPerClick, 0);
      }
      browserOptimizedScroll(sliderScrollPosition);
      const updateTimeout = browserInfo.isIE ? 100 : browserInfo.isSafari ? 300 : 200;
      setTimeout(updateButtonState, updateTimeout);
    });
    nextButton.addEventListener("click", () => {
      const maxScrollPosition = Math.max(carousel.scrollWidth - carousel.offsetWidth, 0);
      if (isInfiniteCarousel && sliderScrollPosition >= maxScrollPosition) {
        sliderScrollPosition = 0;
      } else {
        sliderScrollPosition = Math.min(sliderScrollPosition + scrollPerClick, maxScrollPosition);
      }
      browserOptimizedScroll(sliderScrollPosition);
      const updateTimeout = browserInfo.isIE ? 100 : browserInfo.isSafari ? 300 : 200;
      setTimeout(updateButtonState, updateTimeout);
    });
    const resizeHandler = debounce(() => {
      calculateScrollPerClick();
      cacheTime = 0;
      updateButtonState();
    }, 250);
    window.addEventListener("resize", resizeHandler);
    const cleanup = function() {
      if (scrollThrottleTimeout) clearTimeout(scrollThrottleTimeout);
      if (userScrollTimeout) clearTimeout(userScrollTimeout);
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      window.removeEventListener("resize", resizeHandler);
      if (window.ultraScrollCoordinator) {
        window.ultraScrollCoordinator.unsubscribe(`carousel-${sectionId}`);
      } else {
        carousel.removeEventListener("scroll", handleUserScroll);
      }
      window.DOMHelper.removeClass(carousel, "scrolling");
    };
    activeCarousels.set(sectionId, cleanup);
    return cleanup;
  }
  window.initializeCarousel = initializeCarousel2;
  document.addEventListener("DOMContentLoaded", () => {
    const carousels = window.DOMHelper.safeQueryAll('[id^="carousel-"]');
    carousels.forEach((carousel) => {
      const sectionId = window.DOMHelper.getAttribute(carousel, "id").replace("carousel-", "");
      initializeCarousel2(sectionId);
    });
  });
  document.addEventListener("shopify:section:load", (event) => {
    const sectionId = window.DOMHelper.getAttribute(event.target, "id").replace("shopify-section-", "");
    initializeCarousel2(sectionId);
  });
  document.addEventListener("shopify:section:select", (event) => {
    const sectionId = window.DOMHelper.getAttribute(event.target, "id").replace("shopify-section-", "");
    initializeCarousel2(sectionId);
  });
  document.addEventListener("shopify:section:deselect", (event) => {
    const sectionId = window.DOMHelper.getAttribute(event.target, "id").replace("shopify-section-", "");
    initializeCarousel2(sectionId);
  });
})();
(function() {
  const activeSectionCleanups = /* @__PURE__ */ new Map();
  function normalizeTabIndex(rawIndex, totalTabs) {
    if (!Number.isFinite(rawIndex) || totalTabs <= 0) {
      return 0;
    }
    const normalized = Math.max(1, Math.min(totalTabs, rawIndex));
    return normalized - 1;
  }
  function activateTab(sectionRoot, targetTab, shouldFocus = false) {
    if (!sectionRoot || !targetTab) {
      return;
    }
    const tabs = Array.from(sectionRoot.querySelectorAll('[role="tab"][data-tab-target]'));
    const panels = Array.from(sectionRoot.querySelectorAll('[role="tabpanel"][data-tab-panel]'));
    if (!tabs.length || !panels.length) {
      return;
    }
    const targetPanelId = targetTab.getAttribute("data-tab-target");
    tabs.forEach((tab) => {
      const isActive = tab === targetTab;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });
    panels.forEach((panel) => {
      const isActive = panel.getAttribute("data-tab-panel") === targetPanelId;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
      panel.setAttribute("aria-hidden", isActive ? "false" : "true");
    });
    if (shouldFocus) {
      targetTab.focus();
    }
    const carouselId = targetTab.getAttribute("data-carousel-id");
    if (carouselId && typeof window.initializeCarousel === "function") {
      requestAnimationFrame(() => {
        window.initializeCarousel(carouselId);
      });
    }
  }
  function handleTabKeydown(event, sectionRoot) {
    const activeTab = event.target.closest('[role="tab"][data-tab-target]');
    if (!activeTab || !sectionRoot.contains(activeTab)) {
      return;
    }
    const tabs = Array.from(sectionRoot.querySelectorAll('[role="tab"][data-tab-target]'));
    if (!tabs.length) {
      return;
    }
    const currentIndex = tabs.indexOf(activeTab);
    let nextIndex = currentIndex;
    if (event.key === "ArrowRight") {
      nextIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === "ArrowLeft") {
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (event.key === "Home") {
      nextIndex = 0;
    } else if (event.key === "End") {
      nextIndex = tabs.length - 1;
    } else {
      return;
    }
    event.preventDefault();
    activateTab(sectionRoot, tabs[nextIndex], true);
  }
  function initializeTabbedCarouselSection(sectionRoot) {
    if (!sectionRoot) {
      return;
    }
    const sectionId = sectionRoot.getAttribute("data-section-id");
    if (!sectionId) {
      return;
    }
    if (activeSectionCleanups.has(sectionId)) {
      const existingCleanup = activeSectionCleanups.get(sectionId);
      existingCleanup();
      activeSectionCleanups.delete(sectionId);
    }
    const tabs = Array.from(sectionRoot.querySelectorAll('[role="tab"][data-tab-target]'));
    if (!tabs.length) {
      return;
    }
    const defaultActiveIndex = normalizeTabIndex(
      parseInt(sectionRoot.getAttribute("data-default-active-index") || "1", 10),
      tabs.length
    );
    const clickHandler = (event) => {
      const targetTab = event.target.closest('[role="tab"][data-tab-target]');
      if (!targetTab || !sectionRoot.contains(targetTab)) {
        return;
      }
      event.preventDefault();
      activateTab(sectionRoot, targetTab);
    };
    const keydownHandler = (event) => {
      handleTabKeydown(event, sectionRoot);
    };
    sectionRoot.addEventListener("click", clickHandler);
    sectionRoot.addEventListener("keydown", keydownHandler);
    activateTab(sectionRoot, tabs[defaultActiveIndex]);
    const cleanup = () => {
      sectionRoot.removeEventListener("click", clickHandler);
      sectionRoot.removeEventListener("keydown", keydownHandler);
    };
    activeSectionCleanups.set(sectionId, cleanup);
  }
  function initializeAllTabbedCarousels(container = document) {
    const sectionRoots = container.querySelectorAll("[data-tabbed-carousel-root]");
    sectionRoots.forEach((sectionRoot) => {
      initializeTabbedCarouselSection(sectionRoot);
    });
  }
  function getSectionIdFromEventTarget(target) {
    if (!target) {
      return null;
    }
    const sectionElement = target.closest('[id^="shopify-section-"]');
    if (!sectionElement) {
      return null;
    }
    return sectionElement.id.replace("shopify-section-", "");
  }
  function activateTabForBlock(blockId) {
    if (!blockId) {
      return;
    }
    const allTabButtons = Array.from(document.querySelectorAll("[data-tab-block-id]"));
    const targetTab = allTabButtons.find((tabButton) => tabButton.getAttribute("data-tab-block-id") === blockId);
    if (!targetTab) {
      return;
    }
    const sectionRoot = targetTab.closest("[data-tabbed-carousel-root]");
    activateTab(sectionRoot, targetTab, true);
  }
  function getEditorBlockId(eventTarget) {
    if (!eventTarget) {
      return null;
    }
    const blockElement = eventTarget.closest('[id^="shopify-block-"]') || eventTarget;
    const blockElementId = blockElement.id || "";
    if (blockElementId.startsWith("shopify-block-")) {
      return blockElementId.replace("shopify-block-", "");
    }
    return null;
  }
  document.addEventListener("DOMContentLoaded", () => {
    initializeAllTabbedCarousels(document);
  });
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      requestAnimationFrame(() => {
        initializeAllTabbedCarousels(event.target);
      });
    });
    document.addEventListener("shopify:section:select", (event) => {
      requestAnimationFrame(() => {
        initializeAllTabbedCarousels(event.target);
      });
    });
    document.addEventListener("shopify:section:unload", (event) => {
      const sectionId = getSectionIdFromEventTarget(event.target);
      if (!sectionId || !activeSectionCleanups.has(sectionId)) {
        return;
      }
      const cleanup = activeSectionCleanups.get(sectionId);
      cleanup();
      activeSectionCleanups.delete(sectionId);
    });
    document.addEventListener("shopify:block:select", (event) => {
      const blockId = getEditorBlockId(event.target);
      activateTabForBlock(blockId);
    });
  }
})();
function isValidSelectorId(sectionId) {
  const invalidChars = /[^a-zA-Z0-9_-]/;
  return !invalidChars.test(sectionId) && sectionId.length < 100;
}
function initAccordion(section) {
  const accordionTitles = section.querySelectorAll(".expanded-content-title, .help-center-expanded-content-title");
  accordionTitles.forEach((title) => {
    title.addEventListener("click", toggleAccordion);
    title.addEventListener("keydown", function(event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggleAccordion.call(this);
      }
    });
  });
  function toggleAccordion() {
    const accordionItem = this.closest(".expanded-content-item, .help-center-expanded-content-item");
    const content = this.nextElementSibling;
    const icon = this.querySelector(".svg-container");
    const isExpanded = this.getAttribute("aria-expanded") === "true";
    const allItems = section.querySelectorAll(".expanded-content-item, .help-center-expanded-content-item");
    allItems.forEach((item) => {
      if (item !== accordionItem) {
        const itemTitle = item.querySelector(".expanded-content-title, .help-center-expanded-content-title");
        const itemContent = item.querySelector(".expanded-content-content, .help-center-expanded-content-content");
        const itemIcon = itemTitle.querySelector(".svg-container");
        item.classList.remove("expanded");
        itemTitle.setAttribute("aria-expanded", "false");
        itemContent.style.maxHeight = "0px";
        if (itemIcon) itemIcon.querySelector(".caret-icon").style.transform = "";
      }
    });
    if (!isExpanded) {
      accordionItem.classList.add("expanded");
      this.setAttribute("aria-expanded", "true");
      content.style.maxHeight = `${content.scrollHeight + 10}px`;
      if (icon) icon.querySelector(".caret-icon").style.transform = "";
    } else {
      accordionItem.classList.remove("expanded");
      this.setAttribute("aria-expanded", "false");
      content.style.maxHeight = "0px";
      if (icon) icon.querySelector(".caret-icon").style.transform = "";
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll('[id^="expanded-content-"], [id^="shopify-section-template-help-center"]');
  sections.forEach((section) => {
    initAccordion(section);
  });
});
document.addEventListener("shopify:section:load", (event) => {
  const sectionId = event.detail.sectionId;
  if (!isValidSelectorId(sectionId)) {
    return;
  }
  const section = document.querySelector(`#shopify-section-${sectionId}`);
  if (section) {
    initAccordion(section);
  }
});
window.addEventListener("resize", () => {
  const expandedItems = document.querySelectorAll(".expanded-content-item.expanded, .help-center-expanded-content-item.expanded");
  expandedItems.forEach((item) => {
    const content = item.querySelector(".expanded-content-content, .help-center-expanded-content-content");
    content.style.maxHeight = `${content.scrollHeight + 10}px`;
  });
});
function initHelpCenterAccordion(container = document) {
  if (!container || typeof container.querySelectorAll !== "function") {
    return;
  }
  const expandableItems = container.querySelectorAll(".help-center-expanded-content-item");
  if (!expandableItems.length) return;
  expandableItems.forEach((item) => {
    const title = item.querySelector(".help-center-expanded-content-title");
    const content = item.querySelector(".help-center-expanded-content-content");
    if (!title || !content) return;
    if (!content.id) {
      content.id = `accordion-content-${Math.random().toString(36).substr(2, 9)}`;
    }
    title.setAttribute("role", "button");
    title.setAttribute("aria-expanded", "false");
    title.setAttribute("tabindex", "0");
    title.setAttribute("aria-controls", content.id);
    function toggleAccordion() {
      const isExpanded = item.classList.contains("expanded");
      const siblings = item.parentElement.querySelectorAll(".help-center-expanded-content-item");
      siblings.forEach((sibling) => {
        if (sibling !== item) {
          const siblingTitle = sibling.querySelector(".help-center-expanded-content-title");
          const siblingContent = sibling.querySelector(".help-center-expanded-content-content");
          const siblingIcon = sibling.querySelector(".svg-container");
          sibling.classList.remove("expanded");
          siblingTitle == null ? void 0 : siblingTitle.setAttribute("aria-expanded", "false");
          if (siblingContent) siblingContent.style.maxHeight = "0";
          if (siblingIcon) siblingIcon.style.transform = "rotate(0deg)";
        }
      });
      item.classList.toggle("expanded");
      title.setAttribute("aria-expanded", !isExpanded);
      requestAnimationFrame(() => {
        if (!isExpanded) {
          content.style.maxHeight = `${content.scrollHeight + 10}px`;
        } else {
          content.style.maxHeight = "0";
        }
      });
      const caretIcon = title.querySelector(".svg-container");
      if (caretIcon) {
        caretIcon.style.transform = isExpanded ? "rotate(180deg)" : "rotate(0deg)";
      }
    }
    const newTitle = title.cloneNode(true);
    title.parentNode.replaceChild(newTitle, title);
    newTitle.addEventListener("click", toggleAccordion);
    newTitle.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggleAccordion();
      }
    });
    if (Shopify.designMode) {
      document.addEventListener("shopify:block:select", (event) => {
        if (event.target.contains(item)) {
          if (!item.classList.contains("expanded")) {
            toggleAccordion();
          }
        }
      });
      document.addEventListener("shopify:block:deselect", (event) => {
        if (event.target.contains(item)) {
          if (item.classList.contains("expanded")) {
            toggleAccordion();
          }
        }
      });
    }
  });
  function updateExpandedHeights() {
    if (!container || typeof container.querySelectorAll !== "function") {
      return;
    }
    const expandedItems = container.querySelectorAll(".help-center-expanded-content-item.expanded");
    expandedItems.forEach((item) => {
      const content = item.querySelector(".help-center-expanded-content-content");
      if (content) {
        requestAnimationFrame(() => {
          content.style.maxHeight = `${content.scrollHeight + 10}px`;
        });
      }
    });
  }
  let resizeTimeout;
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateExpandedHeights, 100);
  }
  window.removeEventListener("resize", handleResize);
  window.addEventListener("resize", handleResize);
}
function initializeSidebarBehavior(container = document) {
  const sidebar = container.querySelector(".sticky-sidebar");
  if (!sidebar) return;
  function updateSidebarPosition() {
    const links = sidebar.getElementsByTagName("a");
    let linksHeight = 0;
    Array.from(links).forEach((link) => {
      linksHeight += link.offsetHeight;
    });
    sidebar.style.height = `${linksHeight}px`;
    let topOffset = 20;
    const announcementBar2 = document.querySelector(".announcement-bar");
    const headerCenter = document.querySelector("#header-center");
    const headerRight = document.querySelector("#header-right");
    const headerCenterMobile = document.querySelector("#header-center-mobile");
    if (announcementBar2) {
      topOffset += announcementBar2.offsetHeight;
    }
    if (window.innerWidth <= 1023 && headerCenterMobile) {
      topOffset += headerCenterMobile.offsetHeight;
    } else {
      if (headerCenter) {
        topOffset += headerCenter.offsetHeight;
      }
      if (headerRight) {
        topOffset += headerRight.offsetHeight;
      }
    }
    sidebar.style.top = `${topOffset}px`;
    Array.from(links).forEach((link) => {
      link.removeEventListener("click", handleLinkClick);
      link.addEventListener("click", handleLinkClick);
    });
    return topOffset;
  }
  function handleLinkClick(event) {
    var _a;
    event.preventDefault();
    const target = container.querySelector(this.getAttribute("href"));
    if (!target) return;
    const targetRect = target.getBoundingClientRect();
    const targetTop = targetRect.top + window.pageYOffset;
    const headerHeight = ((_a = document.querySelector(".header-container")) == null ? void 0 : _a.offsetHeight) || 0;
    const announcementBar2 = document.querySelector(".announcement-bar");
    const announcementHeight = (announcementBar2 == null ? void 0 : announcementBar2.offsetHeight) || 0;
    const totalOffset = headerHeight + announcementHeight + 20;
    const finalScrollPosition = targetTop - totalOffset;
    window.scrollTo({
      top: Math.max(0, finalScrollPosition),
      behavior: "smooth"
    });
  }
  function updateActiveSidebarLink() {
    const topOffset = parseInt(sidebar.style.top) || 0;
    const fromTop = window.scrollY + topOffset;
    const links = Array.from(sidebar.getElementsByTagName("a"));
    links.forEach((link, i) => {
      const section = container.querySelector(link.getAttribute("href"));
      const nextSection = links[i + 1] ? container.querySelector(links[i + 1].getAttribute("href")) : null;
      if (section && section.offsetTop <= fromTop && (!nextSection || nextSection.offsetTop > fromTop)) {
        link.style.color = "rgb(var(--heading-color))";
      } else {
        link.style.color = "var(--heading-color-lightened)";
      }
    });
  }
  window.removeEventListener("scroll", updateActiveSidebarLink);
  window.removeEventListener("resize", updateSidebarPosition);
  updateSidebarPosition();
  updateActiveSidebarLink();
  window.addEventListener("scroll", updateActiveSidebarLink);
  window.addEventListener("resize", updateSidebarPosition);
  return () => {
    window.removeEventListener("scroll", updateActiveSidebarLink);
    window.removeEventListener("resize", updateSidebarPosition);
  };
}
function initializeHelpCenter(container = document) {
  initHelpCenterAccordion(container);
  initializeSidebarBehavior(container);
}
document.addEventListener("DOMContentLoaded", () => {
  initializeHelpCenter();
  const templateSidebarSections = document.querySelectorAll('section[id*="template-sidebar"], section[id*="sidebar"]');
  templateSidebarSections.forEach((section) => {
    initializeHelpCenter(section);
  });
});
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    requestAnimationFrame(() => {
      initializeHelpCenter(event.target);
    });
  });
  document.addEventListener("shopify:section:select", (event) => {
    requestAnimationFrame(() => {
      initializeHelpCenter(event.target);
    });
  });
  document.addEventListener("shopify:section:deselect", (event) => {
    requestAnimationFrame(() => {
      initializeHelpCenter(event.target);
    });
  });
  document.addEventListener("shopify:block:select", (event) => {
    requestAnimationFrame(() => {
      const section = event.target.closest("section");
      if (section) {
        initializeHelpCenter(section);
      }
    });
  });
  document.addEventListener("shopify:block:deselect", (event) => {
    requestAnimationFrame(() => {
      const section = event.target.closest("section");
      if (section) {
        initializeHelpCenter(section);
      }
    });
  });
}
(function() {
  let currentSectionIndex = 0;
  let isTransitioning = false;
  let startY;
  let sections;
  let fullPageDiv;
  let blockSelected = false;
  function initializeLandingPage() {
    sections = document.querySelectorAll(".landing-page-option-2");
    fullPageDiv = document.querySelector("#fullpage");
    if (sections.length > 0 && fullPageDiv) {
      sections[0].style.transition = "none";
      sections[0].classList.add("active");
      sections[0].style.transform = "translateY(0)";
      sections[0].offsetHeight;
      setTimeout(() => {
        sections[0].style.transition = "";
      }, 50);
      document.documentElement.classList.add("landing-page-option-2-active");
      document.body.classList.add("landing-page-option-2-active");
      window.addEventListener("wheel", handleScroll, { passive: false });
      window.addEventListener("touchstart", handleTouchStart, { passive: false });
      window.addEventListener("touchmove", handleScroll, { passive: false });
      updateStyles();
      const observer = new MutationObserver(updateStyles);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  function updateStyles() {
    document.querySelectorAll(".lp2-title").forEach((title) => {
      const section = title.closest(".landing-page-option-2");
      const useAltColor = section.dataset.useAltColor === "true";
      title.classList.toggle("alt-nav-link", useAltColor);
    });
  }
  function handleScroll(event) {
    if (!fullPageDiv || !fullPageDiv.contains(event.target) || blockSelected) {
      return;
    }
    event.preventDefault();
    if (isTransitioning) {
      return;
    }
    let nextSectionIndex;
    const deltaY = event.type === "touchmove" ? startY - event.touches[0].clientY : event.deltaY;
    if (deltaY > 0) {
      nextSectionIndex = Math.min(currentSectionIndex + 1, sections.length - 1);
    } else {
      nextSectionIndex = Math.max(currentSectionIndex - 1, 0);
    }
    if (nextSectionIndex !== currentSectionIndex) {
      transitionToSection(nextSectionIndex, deltaY > 0);
    }
  }
  function transitionToSection(nextSectionIndex, movingDown) {
    isTransitioning = true;
    if (movingDown) {
      sections[currentSectionIndex].style.zIndex = 1;
      sections[nextSectionIndex].style.zIndex = 2;
      sections[nextSectionIndex].classList.add("active");
    } else {
      sections[currentSectionIndex].classList.remove("active");
      sections[nextSectionIndex].style.zIndex = 1;
      sections[currentSectionIndex].style.zIndex = 2;
    }
    setTimeout(() => {
      currentSectionIndex = nextSectionIndex;
      isTransitioning = false;
      window.dispatchEvent(new Event("scroll"));
      updateStyles();
    }, 1300);
  }
  function handleTouchStart(event) {
    startY = event.touches[0].clientY;
  }
  document.addEventListener("DOMContentLoaded", initializeLandingPage);
  setTimeout(initializeLandingPage, 100);
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      initializeLandingPage();
    });
    document.addEventListener("shopify:section:select", (event) => {
      const sectionContainer = event.target;
      const section = sectionContainer.querySelector(".landing-page-option-2");
      if (section) {
        const index = Array.from(sections).indexOf(section);
        if (index !== -1) {
          currentSectionIndex = index;
          updateStyles();
        }
      }
    });
    document.addEventListener("shopify:block:select", (event) => {
      blockSelected = true;
      const block = event.target;
      const section = block.closest(".landing-page-option-2");
      if (section) {
        const index = Array.from(sections).indexOf(section);
        if (index !== -1) {
          currentSectionIndex = index;
          sections.forEach((s, i) => {
            if (i === index) {
              s.classList.add("active");
              s.style.transform = "translateY(0)";
            } else {
              s.classList.remove("active");
              s.style.transform = i < index ? "translateY(-100%)" : "translateY(100%)";
            }
          });
          updateStyles();
        }
      }
    });
    document.addEventListener("shopify:block:deselect", (event) => {
      blockSelected = false;
    });
  }
})();
class CustomerAddresses {
  constructor() {
    this.init();
  }
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      this.bindEvents();
      this.initializeCountrySelectors();
    });
  }
  bindEvents() {
    const deleteButtons = document.querySelectorAll(".address-delete");
    deleteButtons.forEach((button) => {
      button.addEventListener("click", (evt) => {
        evt.preventDefault();
        const target = button.dataset.target;
        const confirmMessage = button.dataset.confirmMessage || "Are you sure you wish to delete this address?";
        if (confirm(confirmMessage)) {
          if (window.Shopify && window.Shopify.postLink) {
            window.Shopify.postLink(target, {
              parameters: { _method: "delete" }
            });
          } else {
            window.ShopifyAPIHelper.safeFetch(target, {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": "XMLHttpRequest"
              },
              body: "_method=delete"
            }).then((response) => {
              if (response.ok) {
                window.location.reload();
              }
            });
          }
        }
      });
    });
    const editButtons = document.querySelectorAll(".address-edit-toggle");
    editButtons.forEach((button) => {
      button.addEventListener("click", (evt) => {
        evt.preventDefault();
        const formId = button.dataset.formId;
        const editAddress = document.getElementById(`edit_address_${formId}`);
        const isExpanded = button.getAttribute("aria-expanded") === "true";
        if (editAddress) {
          editAddress.style.display = editAddress.style.display === "none" ? "block" : "none";
          button.setAttribute("aria-expanded", !isExpanded);
          button.focus();
        }
      });
    });
  }
  initializeCountrySelectors() {
    if (window.Shopify && window.Shopify.CountryProvinceSelector) {
      const newCountrySelect = document.getElementById("address_country_new");
      if (newCountrySelect) {
        new window.Shopify.CountryProvinceSelector(
          "address_country_new",
          "address_province_new",
          { hideElement: "address_province_container_new" }
        );
      }
      const existingAddressSelects = document.querySelectorAll('[id^="address_country_"]:not(#address_country_new)');
      existingAddressSelects.forEach((select) => {
        const addressId = select.id.replace("address_country_", "");
        if (addressId !== "new") {
          new window.Shopify.CountryProvinceSelector(
            `address_country_${addressId}`,
            `address_province_${addressId}`,
            { hideElement: `address_province_container_${addressId}` }
          );
        }
      });
    }
    this.initializeSelect2();
  }
  initializeSelect2() {
    if (typeof $ !== "undefined" && $.fn.select2) {
      $(".address-country-select").select2({
        width: "100%",
        minimumResultsForSearch: 5,
        templateResult: function(data) {
          if ($(data.element).parent().find("option[value='" + $(data.element).val() + "']").index() !== $(data.element).index()) {
            return null;
          }
          return data.text;
        }
      });
    } else {
      const countrySelects = document.querySelectorAll(".address-country-select");
      countrySelects.forEach((select) => {
        select.style.width = "100%";
        select.style.padding = "0.5rem";
        select.style.border = "1px solid #ccc";
        select.style.borderRadius = "4px";
      });
    }
  }
}
new CustomerAddresses();
window.jQuery = jQuery$1;
window.$ = jQuery$1;
select2(jQuery$1);
window.AOS = AOS$1;
document.addEventListener("criticalReady", () => {
  $("select").select2({
    minimumResultsForSearch: Infinity,
    width: "resolve"
  });
});
